var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 1146",
    width: 1300,
    height: 728,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h2048v1146h-2048z",
    fill: "#EEF1EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h2048v1146h-2048zm338 171-15 15v2l-4 2-10 9-8 5-3 1v2l-6 2-11 4-14 4-18 2-11 1 1 5 10 9 30 30 2-1v-2l3-1 10-18 5-17 1-6v-9h2l-2 21-7 20-8 14-11 12-8 7-14 8-6 3-21 6-13 1-5 2v1h10l20-3 8-3 9-4 12-7 14-12 10-13 6-11 4-8 5-22 1-15-1-2 5-2 14-11 16-16 7-1h912l-917 1-8 7-4 5 2 5v10l-4 8-6 10-2 6v20l1 2v8l-3 9-3 5-6 4-12 4-10 7-5 6-4 8-3 10-5 5-8 5h-12l-5-1h-15l-10 3-14 9-10 1-9-2-10 10-1 9v456l11 11 6-1 1-1 11 1 14 9 10 3h17l5-1h9l9 4 5 5 2 3 4 13 4 6 9 8 8 4 9 3 8 7 2 4 1 10-1 6v20l5 12 5 7 2 5v10l-1 7 10 10h1366l11-11-2-8v-9l9-14 3-8 1-4v-14l-1-5v-11l4-9 6-5 16-6 8-6 4-5 4-8 4-11 4-5 6-4 5-1h8l5 1h17l9-3 10-6 7-4h9l7 3-9 10-8 12v2l-23 1-15 4-13 6-12 7-13 12-7 9-8 13-6 15-3 14-1 8v9h2l2-12 1-11 4-13 9-18 7-9 3-3v-2l4-2 9-8 12-7 14-5 9-3 6-1h15l-2 2h-11l-10 2-20 8-10 7v2h-3l2 4 39 39h3l1-20 3-16 4-10 4-9 6-12 8-10 9-10 14-14 1-31 1-2h-2l1-237-1-200-22-22-10-14-6-10-5-14-5-20-1-20h-4l-40 40v3l13 8 15 6 10 3 7 1h9l-2-7 4 10-16-1-12-3-10-3-15-8-13-10-9-10-7-10-3-8-3-7-5-23-2-11-2-1v14l3 16 8 19 8 12 9 11 13 10 12 7 15 6 14 3 18 1 9 13 8 9-4 3-9 1-9-4-8-5-8-3-4-1h-14l-6 1h-10l-8-3-6-6-3-10-5-10-4-5-9-6-16-6-7-8-2-5v-11l1-5v-15l-5-15-7-10-1-3v-7l2-6 4 1 12 10 14 9 1 13 3 13 5 12 6 11 4 6 4-1 7-8 27-27 6-5v-3l-24-2-21-5-17-8-10-7-10-8-19-19z",
    fill: "#EEF1EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(135,133)",
    d: "m0 0h1780l1 111v769l-1 1h-1782v-855l1-25zm203 38-15 15v2l-4 2-10 9-8 5-3 1v2l-6 2-11 4-14 4-18 2-11 1 1 5 10 9 30 30 2-1v-2l3-1 10-18 5-17 1-6v-9h2l-2 21-7 20-8 14-11 12-8 7-14 8-6 3-21 6-13 1-5 2v1h10l20-3 8-3 9-4 12-7 14-12 10-13 6-11 4-8 5-22 1-15-1-2 5-2 14-11 16-16 7-1h912l-917 1-8 7-4 5 2 5v10l-4 8-6 10-2 6v20l1 2v8l-3 9-3 5-6 4-12 4-10 7-5 6-4 8-3 10-5 5-8 5h-12l-5-1h-15l-10 3-14 9-10 1-9-2-10 10-1 9v456l11 11 6-1 1-1 11 1 14 9 10 3h17l5-1h9l9 4 5 5 2 3 4 13 4 6 9 8 8 4 9 3 8 7 2 4 1 10-1 6v20l5 12 5 7 2 5v10l-1 7 10 10h1366l11-11-2-8v-9l9-14 3-8 1-4v-14l-1-5v-11l4-9 6-5 16-6 8-6 4-5 4-8 4-11 4-5 6-4 5-1h8l5 1h17l9-3 10-6 7-4h9l7 3-9 10-8 12v2l-23 1-15 4-13 6-12 7-13 12-7 9-8 13-6 15-3 14-1 8v9h2l2-12 1-11 4-13 9-18 7-9 3-3v-2l4-2 9-8 12-7 14-5 9-3 6-1h15l-2 2h-11l-10 2-20 8-10 7v2h-3l2 4 39 39h3l1-20 3-16 4-10 4-9 6-12 8-10 9-10 14-14 1-31 1-2h-2l1-237-1-200-22-22-10-14-6-10-5-14-5-20-1-20h-4l-40 40v3l13 8 15 6 10 3 7 1h9l-2-7 4 10-16-1-12-3-10-3-15-8-13-10-9-10-7-10-3-8-3-7-5-23-2-11-2-1v14l3 16 8 19 8 12 9 11 13 10 12 7 15 6 14 3 18 1 9 13 8 9-4 3-9 1-9-4-8-5-8-3-4-1h-14l-6 1h-10l-8-3-6-6-3-10-5-10-4-5-9-6-16-6-7-8-2-5v-11l1-5v-15l-5-15-7-10-1-3v-7l2-6 4 1 12 10 14 9 1 13 3 13 5 12 6 11 4 6 4-1 7-8 27-27 6-5v-3l-24-2-21-5-17-8-10-7-10-8-19-19z",
    fill: "#769680"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(85,1)",
    d: "m0 0h10l8 3 7 4 4 1h13l10-4 5-3 4-1h12l8 4 10 13v2l3 1 5 5 12 6 17 4 7 8 1 4 25 1 2-6 5-6 8-3 11-2 8-4 10-8 9-12 6-5 6-2h10l7 3 10 5h15l8-3 7-4 4-1h10l7 3 4 2 12 16 8 6 9 4 16 4 6 5 3 7h25l4-8 4-4 17-4 9-4 10-8 8-11 7-6 6-2h10l7 3 8 4 4 1h12l9-3 7-4 4-1h10l7 3 7 6 8 11 7 6 15 6 12 3 6 5 3 6v2h25l2-7 6-6 17-4 12-6 6-5 11-15 6-4 4-1h10l8 3 8 4 4 1h13l8-3 5-3 6-2h10l8 3 7 7 6 9 7 6 12 6 16 4 6 5 2 5v3h26l1-5 7-8 6-2 14-3 10-6 9-9 7-10 7-4 2-1h11l12 5 8 3h13l8-3 8-4 3-1h10l8 3 7 8 7 9 7 6 11 5 15 4 5 3 5 8v2h25l1-5 7-8 16-4 14-7 7-7 8-11 5-4 7-2h9l20 8h13l7-1v-2l12-5h10l8 3 7 8 7 9 7 6 11 5 16 4 5 5 3 4 1 3 25 1 1-6 4-5 6-3 16-4 12-7 7-7 6-9 6-5 6-2h10l9 4 11 4h11l9-1v-2l10-5h12l7 3 7 6 6 9 8 7 7 4 13 4 9 3 5 5 2 4v3l25-1 3-6 7-7 18-4 9-5 9-8 8-11 7-5 4-1h10l7 3 9 4 4 1h12l9-3 9-5h12l7 3 5 4 7 10 8 8 10 5 11 3 8 2 7 8 1 5h26l1-6 1-2h2v-2h2v-2l9-3 13-3 12-8 8-9 4-6 6-5 6-2h10l7 3 9 4 4 1h11l10-3 9-5h12l7 3 5 4 7 10 1 3 4 2 5 4 13 6 8 1 3 13 4 8v2h2l7 8 2 1v2l5 2 5 5 4 5 2 7v522l-4 9-7 7-10 7-8 11-4 12-2 10-7 8-8 2-3-23-2-6-1-9 4-2v3l7-8 1-2h2l1-4 4-6 8-21 2-10v-25l-4-16-3-7-4-9-7-11-7-8v3h2l3 4v2h2l9 16 5 13 3 12v5h-61l1 3v10l-1 4h61l-1 9-1-3h-53l9 11 7 10 5 9-1 2-10-16-11-13-6-6 6 7 8 9 9 14 8 19 2 5 1 7 1 1v14l-6 4-2-20-4-15-8-16-9-13-9-9 2 4 8 8 6 8 7 15 4 16v76l-1 2-4-1-17-8-11-3 6-10 3-8h-6l-1 6-6 8-4 3-4 2-10 1v-15l6-3h2v-2h-7v-1l47-1 1-4-1-1-47-1v-1h7l-4-4-4-2v-14l9 1 7 3 7 8 2 6 6 1-4-9-3-6-5-5 6-1 24-10 3-2-1-11-4-12-6-12-4-6-11-12-8 6-10 4h-7v-8l9-2 8-6 5-8v-14l-5-9-4-3v-2l-4-1-9-2 1 13 5 2 3 3 1 8-3 5-2 2-6 1v-42h7l11 4 8 6 2 1v2l9-9 9-13 6-11 5-15 2-14v-68l-3-17-5-14-9-15-9-11-4-4-3-1-2 4-7 6-7 3-10 1v-23l1-19 6 1 4 5v7l-3 5-5 3h-2l1 12 9-2 7-5 5-9v-14l-3-6-9-8-10-3v-8l11 2 8 4 6 6v2l5-3 8-9 10-15 6-15 3-12 1-8v-67l-2-12-2-7-6-15-11-16-8-9-3-1-5 5-8 6-7 2h-6v-8l11-3 7-6 4-7v-15l-6-9-9-6h-14l-9 5-5 7-2 5v4l13 1 1-6 5-4h8v2l4 1 2 5v7l-5 5-6 1v-10h-31l1-10 5-10 4-5 3-2-2-4-4-3v-2l-6-3v-2l-5-2-12-7-12-5-8-2-13-2h-64l-17 3-10 3-16 8-13 10-6 6h-2l5 5 6 8 3 7 1 9h-64l1-10 5-10 4-4-1-5 4 2-2-4-12-10-15-9-12-5-19-4h-66l-17 3-12 4-17 9-11 9-6 6 4-1 4-5 12-9 16-8 16-4h79l-2 5-5 9-5 14v5 3l-9-8-11-4-1-16-1-2-5 1-1 17-11 4-7 5-5 8-4 13 6-1 2-9 4-6 7-6 8-2v17l-4 3-1 5h-242l1-9 5-8 7-6 7-2v-6l-10 4-5 4h-2l-4-11v-2h2l-1-3-2 2-9-16v-2h77l14 3 10 4 11 6 9 7 7 6v2h3l-7-8-14-10-13-7-16-5-13-2h-64l-17 3-14 5-16 9-13 11-2 4 7 7 5 10 1 10h-170l1-9 5-8 6-5 6-3h2v-6l-15 7h-2l-5-12-2 2-2-6 1-2-6-11v-2h78l17 4 16 8 9 7 11 9-7-8-15-11-10-5-10-4-13-3-8-1h-63l-14 2-11 3-16 8-10 6-7 7-5 4v2l5 5 6 9 2 7v6h-136l-2-8h-3v-22h1l1 5 7 3 8 7 4 8v6h6l-4-13-6-9-6-4-11-4-1-17-6-1v34l-1 7-4 4v4h-17l2-11 6-8 6-4 6-2v-6l-14 7-3 1-8-20-6-10v-2h78l7 2v1l-11-1-2 6-7 15-3 12 5 8 1 4v7l13-1h35l2-7 6-12 3-3-2-4-4-4v-2l4 2 3 4 3 1-7-8-12-9-11-6-12-5-13-3-8-1h-63l-14 2-16 5-18 10-12 11-3 4 5 5 4 5 4 11 1 6h-171l3-13 7-8 9-4h2v-6l-15 7h-3l-6-15-4-8-4-6v-2h78l17 4 11 5 11 7 10 9 4 3-7-8-12-9-12-7-18-6-14-2h-63l-11 2-16 4-16 8-12 9-8 8 6 7 5 8 3 12v1h-65l2-11 4-8 4-5-2-4-5-5-2-4 5 3 6 7h2l1-2-4-2-10-9-10-7-16-7-16-4-8-1h-63l-18 3-14 5-17 10-10 9-4 4 4-2 7-7 10-7 10-5 11-4 9-2h76v3l1-2 2 1-6 12-6 15-2 4-9-6-8-3v6l9 3 6 5 4 8 2 9h-17l-2-8h-2v8h-149v-7l5-12 6-7 2-2-9-9-10-7-12-7-18-6-11-2h-67l-20 4-13 5-13 8-10 8-5 5h-2v2l5-1 2-4 8-7 13-8 12-5 12-3 81-1 10 2 11 3 1 2-15-3h-6l-10 21-4 11-8-6-5-2v-2l-6-1v6l5 2 7 4 3 3 4 10v6h-29v-8h-2l-2 8h-104v31l-10-1-10-5-5-4-7 6-1 2h-2l-2 5-3 1 2-4 9-10 2-1 1-3-8 7-8 10-7 12-5 12-4 16v77l5 19 8 16 9 12 5 6 5 3-4-5-5-5-9-12-7-14-4-17v-83l4-17 8-17h3l-6 12-5 15-2 10 5 2 18 8 6 2h5l7-4 3 1-11 6-5 6-3 5-2 7h6l1-5 4-7 7-5 12-3 1 56v101l-1 122-9-2-8-4-5-6-3-8v-3h-6l3 10 8 12-20 8-14 7-1-3v-81l3-13 3-8 5-10 8-11 9-9 1-2-8 7-10 12-8 16-2 5-2 7-2 10v79l4 17 8 16 7 11 11 12 2 1v-3l9-7 10-4 7-1v9l-12 3-5 4-4 5-2 5v12l3 7 5 5 5 4 10 2v9l-11-2-10-6-7-6-7 7-9 12-5 8-4 10-4 13-2 16-1 44-6 4v-49l2-14 7-21 8-15 6-8 8-7 5-6-5 3-9 10-9 14-6 11-3 7-1-3 8-17 10-14 6-8-52-1-1 2-1-8 61-1v-12l1-4h-62l2-12 5-15 8-15 9-11 3-4-5 5-8 10-5 8-7 18-3 15v19l4 18 6 15 7 11 4 5v2l4 2 3 3-1 8-2 11-1 14-1 2-7-2-6-5-2-4-3-13-5-12-7-8-2-1v-2l-5-2-8-7-3-5-1-4v-8l4-11 1-2h2l1-7v-14l-4-11-4-9v-8l3-9 7-7 9-6 7-8 5-10 4-17 5-5 5-4h3l-1-27-9-5-4-8-4-15-4-8-9-10-8-5v-2l-3-1-5-8-1-3v-9l3-8 5-12v-14l-3-7-5-12v-9l4-10h2v-2h2v-2l9-6 5-5 4-5 5-10 4-16 6-7 7-2v-26l-6-1-6-5-2-4-2-12-7-14-8-9-11-8-4-5-2-6v-9l5-12 3-8v-14l-4-9-3-7-1-3v-8l4-10 8-7 9-7 6-8 3-5 4-15 12-3 10-5 9-8 7-10 5-4z",
    fill: "#7B9D85"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1992,663)",
    d: "m0 0h1l1 6v38l-2 20-4 15-5 12-9 16-1 2 4-3-2 4-9 11-1 1 53 1 1-4 1 10h-61v17h61l-1 12-8 20 1-1 6-14 3-13v-24l-3-14-4-12-1-4 1-2-2-4-2 2-10-14-5-6 4 8-5-4-10 20-1-3 6-12 5-16 2-10 2-18 6 1 8 7 5 18 6 12 8 8 11 8 4 6 2 4v295l-3 9-6 7-10 7-7 8-6 12-2 10-13 3-11 6-7 7-8 11-3 3-4 2h-19l-12-6h-19l-11 6h-19l-6-4-6-7-8-10-11-7-16-4-7-3-6-8v-4h-26l-1 6-7 7-4 2-12 2-14 7-8 8-6 9-6 5-2 1h-18l-13-6h-19l-8 4-3 2h-19l-6-4-6-7-7-9-2-1v-2l-5-2-8-4-17-4-6-5-4-7v-2h-25l-1 6-5 5-4 3-19 5-11 7-7 8-7 9-6 4h-17l-7-3-6-3-13-1-9 2-9 5h-19l-7-4-10-14-7-6-6-3v-2l-7-1-14-3-5-4v-2h-2l-2-4v-4h-26l-1 6-5 6-6 3-14 3-12 6-7 7-6 9-5 5-3 2h-18l-7-3-6-3h-19l-13 6h-19l-8-7-8-11-7-6-8-4-8-3-11-2-7-6-2-4v-4h-26l-1 6-5 6-6 3-11 2-16 8-8 9-6 8-5 4-4 1h-17l-8-5-3-1h-19l-12 6h-18l-6-3-6-7-6-8-7-6-6-3v-2l-6-1-16-4-5-5-3-6v-2h-25l-1 5-6 7-7 3-10 2-9 4-6 4h-2l-2 4-6 7-6 8-5 3h-20l-9-5-4-1h-18l-11 6h-18l-7-4-7-9-7-8-10-6-10-4-12-3-5-4-3-7v-2h-25l-1 5-7 8-16 4-14 7-9 9-7 10-6 4h-18l-11-5-4-1h-17l-12 6h-18l-6-3-7-9-7-8-8-6-9-4-16-4-7-8-1-5-25 1-3 7-4 4-7 3-13 3-11 6-7 7-9 12-7 4h-18l-12-6h-19l-12 6h-19l-8-6-8-11-7-7-11-5-15-4-6-4-4-5-1-4h-25l-3 7-7 6-17 4-8 4-10 9-9 12-4 3-3 1h-18l-12-6h-19l-13 6h-17l-5-3-8-9-5-6v-2l-4-2-10-6-8-3-6-1-5-16-6-9-8-8-9-6-6-10v-11l3-7 5-12v-14l-3-8-4-7-1-4v-8l3-9 4-5 5-4 5-3 8-8 6-12 4-17 8-7 5-1v-25l-5-2-8-7-4-17-5-10-9-10-11-8-4-6-2-6v-8l3-9 4-6 1-5v-14l-5-12-3-7v-10l4-8 8-7 10-8 6-8 4-11 3-13 4-5 9-5 2 3 3 24 5 17 9 19 9 12 9 10 4 3-8-8-10-13-4-7-5-10-5-15-3-15v-10l6-5 3 28 5 16 9 16 7 9 7 8 3 1 2-4 8-6 8-3 8-1v9l-9 2-8 5-5 7-1 3v12l4 8 7 6 6 3 5 1v-14l-6-1-3-5v-9l4-4 6-1v92l-16 5-8 7-4 7-2 7h6l1-6 4-6 8-6 7-2h4l1 137 9 1-1 5-5 5h-7l-5-3-2-2v-11l4-4h5v-13l-8 1-8 6-5 7-1 3v9l2 7 4 6 6 5 3 1h15l8-5 6-8 3-9h8l-2 11-6 10-2 2 1 6-6-3v2l4 2 11 10 13 8 11 5 15 4 7 1h69l16-3 13-5 8-4 14-10 9-9h-3l-1-4-7-10-2-7v-6h8l2 9 6 8 5 4 7 2h8l9-4 7-8 2-5 1-6h9l-2 10-4 8-5 7 2 4-5-2 9 9 14 10 12 6 13 4 12 2h69l15-3 14-5 14-8 13-10 4-6-7 6-8 7-2-1 12-11 2-3-6-7-4-10v-6h-49l-2 11-5 7-1 3h-2l6 17 7 13 4 1v1h-76l8-16 4-10 2-6h-2l1-3 7 6 9 4 4 1v18h7v-48h1v7l3-3 1-5h114l1 2-3 7-3 2h-9l-5-5-3-4h-11l3 10 7 8 6 3h15l7-4 5-6 3-6 1-6h9l-2 10-4 8-5 7 11 11h-3l-9-9h-2l5 5 10 9 13 8 16 6 16 3h69l15-3 12-4 16-9 13-10 4-6-5 3 1-6-5-6-4-10-1-7h9l2 10 8 9 8 3h13l7-4 5-6 3-6 1-6h8l-1 10-5 9-5 7-2 1 4 5 14 11 8 5 7 3 11 4 16 3h69l15-3 11-4 14-7 13-10 7-7-4 2-6 6-2-1 9-9-6-8-4-9-1-8h8l3 10 4 6 9 6h16l9-6 4-5 3-11h8l-1 9-5 10-5 7h-3l6 7 13 10 12 7 21 7 9 1h69l15-3 11-4 15-8 13-10 6-6-4 2-6 6-2-1 9-9-6-8-4-9-1-8h8l3 9 6 9 7 4h16l9-6 5-8 2-8h8l-1 9-5 10-4 4 1 4 5 6-4-2-4-4v-2h-2l3 5 10 9 12 8 8 4 20 6 8 1h68l16-3 14-5 15-9 13-11 3-4-8 7h-3l7-8-2-4-4-5-3-7-1-9h8l3 9 5 8 8 5h13l8-3 5-5 3-4 3-10h8l-1 9-5 10-5 6 7 7h-3l-7-6 7 8 8 6v2l6 2 5 3 7 4 15 5 12 2h69l16-3 14-5 12-7 7-5h2l2-4 7-6 1-2h-3l-2 4-4 4-2-1 7-8-2-4-4-5-4-11v-5h8l3 10 6 8 7 4 4 1h8l7-3 6-4 4-7 2-9h9l-2 11-4 8-5 5 14 14h-3l-12-11-2-1 7 8 12 9 7 4 10 5 17 5 7 1h70l18-4 15-6 15-10 10-9 2-3h-3l-7-10-4-11v-5h8l2 9 7 9 7 4h16l8-5 6-10v-14l-3-6-5-5-10-5-3-1-1 13 6 2 4 5-1 9-5 5h-7l-5-3-2-2v-5h9v-103l6-3 2-3h17l-1 5-4 8-8 6-9 2-2 6 13-4 9-6 4-6 3-9-4-1v-2h23l-1-5-40-1-1-3-6-3v-16l12 3 8 7 3 5 1 4 6 1-4-9-4-6-7-6-6-3 4-1 6 4 7-1 19-8 5-3h2l-3-15-5-13-6-10-9-11-4-4-4 2-5 4-7 3-9 1v-8l10-3 7-5 4-7 1-4v-9l-3-9-7-7-5-2-6-1v12l6 3 3 6-1 8-3 3-6 1-1-1v-38l1-3 14 3 8 6 3 2 8-8v3l-6 6 1 1 9-9 9-14 6-12 4-13 2-13 1-52 4-2z",
    fill: "#7C9C86"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h2048v87l-2-3-3-7-2-4-4-2-5-3v-2l-4-2-5-5v-2h-2l-6-13-1-10h-8l-16-8-6-5-11-15-5-3-4-1h-12l-14 7-5 1h-11l-11-4-5-3-4-1h-10l-9 4-5 6-7 9-7 6-11 6-19 4v2h-2v2h-2l-2 8h-26l-4-8-6-5-14-3-9-4-6-4-9-9-6-9-6-4-4-1h-12l-14 7-4 1h-12l-11-4-5-3-4-1h-10l-7 3-5 4-8 11-9 8-8 4-18 4-7 7-3 6h-25l-5-10-6-3-16-4-6-3-8-6-8-9-4-6-7-5-4-1h-12l-8 4h-2v2l-9 2h-11l-11-4-9-4h-10l-8 3-7 8-4 6-7 7-14 7-16 4-5 5-3 7h-25l-5-8v-2l-4-2-18-5-12-6-8-8-8-11-6-4-4-1h-10l-9 4h-3v2l-7 2h-13l-20-8h-9l-8 3-5 4-8 11-9 8-11 5-16 4-7 8-1 4h-25l-6-10-10-4-12-3-11-6-8-8-7-10-5-4-6-2h-10l-10 4-2 2-7 2h-13l-8-3-12-5h-11l-6 3-5 5-7 9-8 8-12 6-13 3-5 2-5 6-2 5h-26l-4-9-4-3-18-5-10-5-9-8-7-10-6-5-6-2h-10l-10 4-5 3-4 1h-13l-11-4-5-3-4-1h-10l-7 3-5 5-9 12-9 7-13 5-13 3-5 5-3 7h-25l-5-9-4-3-18-5-10-5-9-8-8-11-7-5-4-1h-10l-7 3-8 4-5 1h-12l-9-3-6-4-4-1h-10l-8 3-8 9-7 9-11 8-16 4-8 3-4 5-3 6h-25l-4-8-5-4-19-5-10-6-7-6-8-11-1-3-5-2-6-2h-10l-8 3-4 3-7 2h-15l-10-5-7-3h-10l-9 4-6 7-8 10-11 8-10 3-12 3-5 4-4 8h-25l-4-8-4-4-20-5-10-6-7-6-10-14-8-4h-12l-8 3-7 4-4 1h-13l-8-3-7-4-4-1h-10l-10 5-7 9-7 8-9 6-11 4h-6l-1 9-4 9-6 9-9 8-8 6-4 7-1 4v8l3 8 4 8 1 3v14l-8 20v9l4 9 10 8 8 7 6 9 4 9 2 12 4 6 5 3 4 1v26l-8 4-4 5-4 16-6 12-6 7-10 7h-2v2h-2v2h-2l-3 10v9l5 12 3 7v14l-5 12-3 8v9l4 8 4 4v2l5 2 10 9 5 7 4 11 3 12 2 5 5 2 5 3v27l-7 4-5 5-4 17-7 13-8 8-9 6-5 6-2 7v8l4 9 4 11v14l-2 7h-2l-3 9-1 4v8l3 7 4 5 9 6v2l4 2 7 9 5 12 3 13 5 5 7 4v25l-9 5-3 4-4 17-5 10-8 9-11 8-5 6-2 5v10l3 7 5 12v14l-2 6-5 10-1 4v8l4 9 5 5 10 8 7 8 5 10 4 17 7 6 5 3v25l-8 4-4 4-4 17-6 12-11 11-5 3-5 5-3 7-1 3v8l4 10 3 5 1 4v14l-5 12-3 7v11l6 10 10 7 9 9 6 12 2 11 9 1 14 7 5 4 10 13 5 5 3 1h17l13-6h19l12 6h18l6-3 9-12 8-8 9-5 9-3 12-3 6-7 2-5h25l4 8 5 4 5 2 12 3 12 6 9 9 7 10 6 4h19l12-6h19l12 6h18l7-4 10-13 9-8 11-5 14-3 5-3 3-5 2-5h25l4 8 4 4 19 5 11 6 10 10 6 9 4 3 3 1h18l12-6h17l15 6h18l7-5 7-10 8-8 14-7 16-4 6-7 2-5h25l4 9 6 4 16 4 13 7 8 8 7 10 7 4h18l11-6h18l8 3 5 3h20l7-5 7-10 5-6 11-7 9-3 11-2 7-6 3-7h25l5 10 5 3 20 5v2l6 2 8 7 7 9 5 6 5 2h18l12-6h19l10 5 1 1h17l7-3 6-7 8-10 9-6 13-5 9-2 6-4 3-5 1-4h26l3 8 6 5 13 3 10 4 9 6 8 9 6 8 4 3h19l13-6h19l9 5 4 1h18l5-2 2-4 8-11 9-8 12-5 14-3 6-5 3-8h26l2 8h2l5 5 21 5v2l4 1 8 6 6 7 5 7v2l5 2 2 1h19l12-6 12-1 9 2 7 4 4 1h17l6-4 11-14 7-6 7-4 21-6 4-2 2-4 2-6h25l6 10 4 3 17 4 10 5 3 2v2l4 2 10 13 5 4 2 1h19l8-5 3-1h19l13 6h18l6-4 6-8 7-8 8-6 9-4 12-2 6-4 5-6 1-4h26l3 7 5 5 5 2 16 4 11 7 8 9 6 8 6 4h19l11-6h19l12 6h19l6-4 10-13 9-8 8-4 7-2h6l1-10 8-15 8-8 10-7 4-6 2-7h1v87h-2048z",
    fill: "#EDF1ED"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1762,133)",
    d: "m0 0h153l1 111v769h-1v-39l-5 2-6 6-2 4h-4v10l-9 1h-82l-6-3v2l-13 1h-24v-2l3-1-9-14-5-11-3-10v-4h-2l2-4 3-1v-2l14-8 15-5 12-2h15v-2l-17 1-15 3-14 5-14 8-11 9-23 23h-1382l-27-27-2-1v-2l-5-2-5-4v-2h2v-2l5 2 9 5 15 14 13 13 1373 1 2-4 18-18 17-12 12-6 14-5 19-4h18l-4-6-31-31-5-4-3-3 1 3 8 7 11 12 7 7h-3l-25-25-4 4-8 15-4 13-3 20-2 1 1-23 4-13 9-18 7-9 4-5 8-7 10-7 10-5 11-4 9-3 6-1h16l-2 4h-12l-10 2-20 8-9 6-1 2h-3l7 8 34 34 3 1v-20l3-16 4-10 4-9 6-12 8-10 9-10 14-14 1-31v-2-237l-1-200-22-22-10-14-6-10-5-14-5-20-1-20-4 2-9 10-8 7-21 21-1 3 5 2 10 6 19 7 11 2h8l-2-4 1-3 4 8v3h-16l-12-3-10-3-15-8-13-10-10-11-7-10-3-8-3-7-5-23-2-11v13l3 16 8 19 8 12 8 10 13 10 12 7 15 6 14 3 18 1 8 11 9 11v3l-7 3-9-1-18-10-8-2h-14l-6 1h-10l-8-3-7-7-3-10-5-10-3-3v-2l-14-7-11-4-8-9-2-5v-11l1-5v-15l-5-15-7-10-1-3v-7l3-7 4 1 12 10 14 9 1 2 1 12 3 13 5 12 6 11 3 4v2l3-1 7-8 28-28 5-4 1-3h-13l-16-2-19-5-19-10-14-11-20-20h-1372l-9 9-4 5-4 1-3-3 2-5h2v-2h2v-2l5-5 4-2v-2h1382l28 28 14 9 11 5 11 4 11 2 19 1-1-2-18-1-21-5-12-6-8-6v-2l-4-2-27-27-666-1 6-7 7-7 5 1 1-1h224 2l6 1 1-1h229l-6 7-2 3 10-10 6 1 1-1h222v2l-4 4-9 15-5 15 1 4 3-7 3-1 5-12 6-11 5-7h8l-2-5 10-10-4 1-6 6-5-1-4-5v-2z",
    fill: "#7A9983"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(178,222)",
    d: "m0 0h2l7 9 5 4 10 4 13 1v21l-4 15-5 12-9 14-9 10-5 5-4 5-8 7-4 5v355h2v2h2l1-354 10-9 2-3h2v-2h2l2-4 10-11 5-8 1-3h2l3-10 4-10 3-14 2-26 4 1 6 5 7 8 12 12 2 1-2-6-4-4-2-5 1-6 3-3 4 1-2 8 7 9 1 6-2 5 8 7 2 4-12 8-18 8-9 2-18 3-7 12-11 13-14 14-1 467 4 2 10 10v2h2l11 14 4 6h10l17 2 10 3 16 8 13 9 8 7 10 13 8 15 5 14 2 11 1 18 13 9 10 9 12 12 1367 1 2-4 13-13 10-8 11-7 3-2 3-20 4-13 9-17 4-3 26 26-4-5-10-10-7-8-4-3v-3l3 1 39 39 1 4-18 1-22 5-15 6-10 5-17 13-17 17-1 2h-1373l-22-22-12-9-8-4-1 4 9 6v2l4 2 25 25h1382l26-26 10-7 9-5 8-4 9-3 15-3h17v2l-22 2-15 4-16 8-3 1v2l-5 5h2l5 17 8 15 5 8h-4l5 1h32v-2l6 2h91v-10l4-1 3-5 6-6h4v40h-1782v-358h1v357l1-1v-119l13 13 3 2-1 89 86-1 5-1-6-3v-2l-4-2-8-7-9-10v-2h-2l-7-15-2-6v-4l-10-2-14-7-10-8-10-10v-2h-2l-5-10-2-1v-44l14-8 5-3 11-4 7-2 2-1-26-26-1-134v-259l1-89 2-5 9-10 15-15-16-5-15-8-7-5v-6l1-1-1-3 2-17 6-15 7-11 10-10z",
    fill: "#4E6454"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1666,1)",
    d: "m0 0h10l7 3 9 4 4 1h12l9-3 9-5h12l7 3 5 4 7 10 8 8 10 5 11 3 8 2 7 8 1 5h26l1-6 1-2h2v-2h2v-2l9-3 13-3 12-8 8-9 4-6 6-5 6-2h10l7 3 9 4 4 1h11l10-3 9-5h12l7 3 5 4 7 10 1 3 4 2 5 4 13 6 8 1 3 13 4 8v2h2l7 8 2 1v2l5 2 5 5 4 5 2 7v522l-4 9-7 7-10 7-8 11-4 12-2 10-7 8-8 2-3-23-2-6-1-9 4-2v3l7-8 1-2h2l1-4 4-6 8-21 2-10v-25l-4-16-3-7-4-9-7-11-7-8v3h2l3 4v2h2l9 16 5 13 3 12v5h-61l1 3v10l-1 4h61l-1 9-1-3h-53l9 11 7 10 5 9-1 2-10-16-11-13-6-6 6 7 8 9 9 14 8 19 2 5 1 7 1 1v14l-6 4-2-20-4-15-8-16-9-13-9-9 2 4 8 8 6 8 7 15 4 16v76l-1 2-4-1-17-8-11-3 6-10 3-8h-6l-1 6-6 8-4 3-4 2-10 1v-15l6-3h2v-2h-7v-1l47-1 1-4-1-1-47-1v-1h7l-4-4-4-2v-14l9 1 7 3 7 8 2 6 6 1-4-9-3-6-5-5 6-1 24-10 3-2-1-11-4-12-6-12-4-6-11-12-8 6-10 4h-7v-8l9-2 8-6 5-8v-14l-5-9-4-3v-2l-4-1-9-2 1 13 5 2 3 3 1 8-3 5-2 2-6 1v-42h7l11 4 8 6 2 1v2l9-9 9-13 6-11 5-15 2-14v-68l-3-17-5-14-9-15-9-11-4-4-3-1-2 4-7 6-7 3-10 1v-23l1-19 6 1 4 5v7l-3 5-5 3h-2l1 12 9-2 7-5 5-9v-14l-3-6-9-8-10-3v-8l11 2 8 4 6 6v2l5-3 8-9 10-15 6-15 3-12 1-8v-67l-2-12-2-7-6-15-11-16-8-9-3-1-5 5-8 6-7 2h-6v-8l11-3 7-6 4-7v-15l-6-9-9-6h-14l-9 5-5 7-2 5v4l13 1 1-6 5-4h8v2l4 1 2 5v7l-5 5-6 1v-10h-31l1-10 5-10 4-5 3-2-2-4-4-3v-2l-6-3v-2l-5-2-12-7-12-5-8-2-13-2h-64l-17 3-10 3-16 8-13 10-6 6h-2l5 5 6 8 3 7 1 9h-64l1-10 5-10 4-4-1-5 4 2-2-4-12-10-15-9-12-5-19-4h-66l-17 3-12 4-17 9-11 9-6 6 4-1 4-5 12-9 16-8 16-4h79l-2 5-5 9-5 14v5 3l-9-8-11-4-1-16-1-2-5 1-1 17-11 4-7 5-5 8-4 13 6-1 2-9 4-6 7-6 8-2v17l-4 3-1 5h-242l1-9 5-8 7-6 7-2v-6l-10 4-5 4h-2l-4-11v-2h2l-1-3-2 2-9-16v-2h77l14 3 10 4 11 6 9 7 7 6v2h4v-2l6-1v-2l-3-1-5-5-10-9-11-7-1-2 5 2 13 9 7 6 1-8 1-44-11 2-4-1 8-3 9-2h23l18 4 12 5 8 4v2l4 1v2l8 4v2l4 2 1 3 17-4 18-2 24-1 3-6 7-7 18-4 9-5 9-8 8-11 7-5z",
    fill: "#4C6252"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(762,1)",
    d: "m0 0h10l8 3 8 4 4 1h13l8-3 5-3 6-2h10l8 3 7 7 6 9 7 6 12 6 16 4 6 5 2 5v3h26l1-5 7-8 6-2 14-3 10-6 9-9 7-10 7-4 2-1h11l12 5 8 3h13l8-3 8-4 3-1h10l8 3 7 8 7 9 7 6 11 5 15 4 5 3 5 8v2h25l1-5 7-8 16-4 14-7 7-7 8-11 5-4 7-2h9l20 8h13l7-1v-2l12-5h10l8 3 7 8 7 9 7 6 11 5 16 4 5 5 3 4 1 3 25 1 1-6 4-5 6-3 16-4 12-7 7-7 6-9 6-5 6-2h10l9 4 11 4h11l9-1v-2l10-5h12l7 3 7 6 6 9 8 7 7 4 13 4 9 3 5 5 3 8-23 3-12 2-5-5v-2l-5-2-3-2v-2l-4-1v-2l-6-2-8-4-13-4-11-2h-23l-16 4 14-1v44l-1 9-8-6-14-10h-2l11 7 11 10 6 5v2l-6 1-1 2-7-8-14-10-13-7-16-5-13-2h-64l-17 3-14 5-16 9-13 11-2 4 7 7 5 10 1 10h-170l1-9 5-8 6-5 6-3h2v-6l-15 7h-2l-5-12-2 2-2-6 1-2-6-11v-2h78l17 4 16 8 9 7 11 9-7-8-15-11-10-5-10-4-13-3-8-1h-63l-14 2-11 3-16 8-10 6-7 7-5 4v2l5 5 6 9 2 7v6h-136l-2-8h-3v-22h1l1 5 7 3 8 7 4 8v6h6l-4-13-6-9-6-4-11-4-1-17-6-1v34l-1 7-4 4v4h-17l2-11 6-8 6-4 6-2v-6l-14 7-3 1-8-20-6-10v-2h78l7 2v1l-11-1-2 6-7 15-3 12 5 8 1 4v7l13-1h35l2-7 6-12 3-3-2-4-4-4v-2l4 2 3 4 3 1-7-8-12-9-11-6-12-5-13-3-8-1h-63l-14 2-16 5-18 10-12 11-3 4 5 5 4 5 4 11 1 6h-171l3-13 7-8 9-4h2v-6l-15 7h-3l-6-15-4-8-4-6v-2h78l17 4 11 5 11 7 10 9 4 2 4-2-2-4-12-10-2-1v-2l-6-2-12-7-16-6-17-3h-65l-21 5-10 4-15 8-11 9-9 8-2-1 8-8 10-8 9-6-9 5-11 9-4 2v-53l-6-2v61l-17 1v-62l-17 4-4-1 8-3 10-2h24l20 5 10 5 13 8 10 9v2l18-4 17-2h25l2-7 6-6 17-4 12-6 6-5 11-15 6-4z",
    fill: "#7C9D85"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1992,663)",
    d: "m0 0h1l1 6v38l-2 20-4 15-5 12-9 16-1 2 4-3-2 4-9 11-1 1 53 1 1-4 1 10h-61v17h61l-1 12-8 20 1-1 6-14 3-13v-24l-3-14-4-12-1-4 1-2-2-4-2 2-10-14-5-6 4 8-5-4-10 20-1-3 6-12 5-16 2-10 2-18 6 1 8 7 5 18 6 12 8 8 11 8 4 6 2 4v295l-3 9-6 7-10 7-7 8-6 12-2 10-13 3-11 6-7 7-8 11-3 3-4 2h-19l-12-6h-19l-11 6h-19l-6-4-6-7-8-10-11-7-16-4-7-3-6-8v-4h-26l-1 6-7 7-4 2-12 2-14 7-8 8-6 9-6 5-2 1h-18l-13-6h-19l-8 4-3 2h-19l-6-4-6-7-7-9-2-1v-2l-5-2-8-4-17-4-6-5-4-7v-2h-25l-1 6-5 5-4 3-19 5-11 7-7 8-7 9-6 4h-17l-7-3-6-3-13-1-9 2-9 5h-19l-7-4-10-14-7-6-6-3v-2l-7-1-14-3-5-4v-2h-2l-2-4v-4h-25l-21-2-12-3-2-1-2 4-7 6h-2v2l-16 9-13 5-13 3h-26l-20-5-17-9-10-8-6-5 2-1 7 5v2l4 1v2l5 2 16 8 18 5 5 1v-62l18 1v61l17-4 2-1-10 3h-3l-1-41 1-12 7 6 16 11 19 9-16-8-11-7-11-9-7-8 1-2 8 8 13 10 14 8 16 6 14 3 12 1h50l18-3 18-6 6-1v-2l5-3h3v-2h3v-2l9-6 9-8 2-3h2v3l-8 7-3 3 6-5h2v46l-1 7h-4l10 2v-61h18v61l5-1v-44l1-10 8 6 7 5-14-12-4-4 1-2 13 12 4 2v2l5 2 16 8 13 5 14 3 13 1h48l19-3 19-6 12-7 10-7 12-10 1-2 3 1-7 7 3-1v53l6 2v-61l18-1v62l5-1v-54l4 2 10 8-5-5-12-11 1-3 13 13 11 8 17 8 15 5 10 2 17 1h43l16-2 23-7 12-7 10-7 10-9 3-3h2l-3 6v55l6 1v-61h18v61l8-2h-3v-62l6-4 7-8 1-2h62l2 1v-5l-61-1-1-18h62l-2-6h-55l-4 3-2-1 12-12 4-5 1-3h2l2-6 6-10 3-7 5-23 1-12v-39l-4 4h-2v45l-2 14-4 13-9 17-8 10-8 9h-2v-3l-4-1-6-5-7-3-10-2v-71l6-3 2-3h17l-1 5-4 8-8 6-9 2-2 6 13-4 9-6 4-6 3-9-4-1v-2h23l-1-5-40-1-1-3-6-3v-16l12 3 8 7 3 5 1 4 6 1-4-9-4-6-7-6-6-3 4-1 6 4 7-1 19-8 5-3h2l-3-15-5-13-6-10-9-11-4-4-4 2-5 4-7 3-9 1v-8l10-3 7-5 4-7 1-4v-9l-3-9-7-7-5-2-6-1v12l6 3 3 6-1 8-3 3-6 1-1-1v-38l1-3 14 3 8 6 3 2 8-8v3l-6 6 1 1 9-9 9-14 6-12 4-13 2-13 1-52 4-2z",
    fill: "#7D9D86"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1892,1)",
    d: "m0 0h10l7 3 9 4 4 1h11l10-3 9-5h12l7 3 5 4 7 10 1 3 4 2 5 4 13 6 8 1 3 13 4 8v2h2l7 8 2 1v2l5 2 5 5 4 5 2 7v454l-2-3-3-7-5-5-11-8-7-9-5-11-3-14-5-6-8-4-3 24-4 14-6 15-9 16-2 3h-2l-2 4-2 3h-2l-2 4-7 6 2-4 8-9 4-5 5-8h2l1-5 6-11 5-19 2-21v-43l-2-19-4-15-7-16-9-14-9-10-5-5v-2l4 2 7 7 9 12-6-9-7-8v-1h54l2-5h-62l1-18h61l-1-4-55-1 6-8 5-6-2-2 5-9 6-10 6-19 2-10 1-14v-44l-1-14-7-24-9-17-11-14-8-7v-2l4 2 10 10 11 16-5-9-8-10-4-4v-2h53l2-6h-61v-17h61l-1-6h-63l-6-8-8-6v-61l1-2-6-1v62h-18v-62l-6 2v54l-7-6-11-8 5 4 12 11 5 4v2h-3l-7-8-9-7-15-9-14-6-15-4-6-1h-67l-18 4-17 7-4 1v2l-9 5-11 9-7 7h-2l2-4 10-9 11-8 14-8 14-6 16-4 23-3h25l1-6 1-2h2v-2h2v-2l9-3 13-3 12-8 8-9 4-6 6-5z",
    fill: "#7C9D86"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(126,126)",
    d: "m0 0h1796v894h-1796zm9 7-1 1-1 25v855h1782l1-1v-769l-1-111z",
    fill: "#B5C6B6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(85,1)",
    d: "m0 0h10l8 3 7 4 4 1h13l10-4 5-3 4-1h12l8 4 10 13v2l3 1 5 5 12 6 17 4 7 8 1 4 25 1 2-6 5-6 8-3 11-2 8-4 10-8 9-12 6-5 6-2h10l7 3 10 5h15l8-3 7-4 4-1h10l7 3 4 2 12 16 8 6 9 4 16 4 6 5 3 7 25 1h4l4-7 7-3 10-2 8-3h2v-2l11-8 5-6 3-5h2l2-4 5-3h14l2 1v2l5 1 6 3 5 1h10l9-2 12-6h12l4 2 11 14 5 5 5 4 17 7 9 2 3 1 5 8-21 3-5 1-5-5-10-8-16-9-9-4-14-4-7-1h-17l-17 3-12 4-19 11-14 12 1 2 17 6 15 8 16 12 9 9h-3l-12-11-11-7-16-8-16-5-11-2h-66l-21 5-13 5-13 8-10 8-9 8-2-1 7-7 14-11 7-5-12 7-11 10h-2v-53h3l-9-2v61h-17v-61l-8 2h2v54l-7-6-12-9-17-9h-1l15 8 8 5v2l5 2v2l4 2 6 5 2 4-4-2-11-10-10-7-19-9-19-5-8-1h-63l-18 4-9 3-10 4-11 7-10 8-7 7h-2v2h-2l2-4 12-11 15-10-8 4-12 9-4 4h-2v-53l-6-2v62l-17-1v-61l-6 1v64l-6 4-8 9h-63l-1 6h62v17h-62l2 6h54l-6 7-12 18v1l9-13 1 2-11 18-5 14-4 20v62l3 17 6 16 4 8 7 11v2h2l7 9 6 6v2h-2l1 6v14l-4 4h-57l5 18 8 16 9 13h-3l-4-5v-2h-2v-3h-2l-1-5h-2l-6-14-5-21v-20l4-17 6-16 3-5h2l2-5 8-10 3-3-2-12-2-21-1-1v-26l-6-1-6-5-2-4-2-12-7-14-8-9-11-8-4-5-2-6v-9l5-12 3-8v-14l-4-9-3-7-1-3v-8l4-10 8-7 9-7 6-8 3-5 4-15 12-3 10-5 9-8 7-10 5-4z",
    fill: "#7C9D85"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(289,946)",
    d: "m0 0 5 2 8 6 28 28h1388l6-5 7-8 12-12h2l4 14 7 14 7 11v1h-340v-3l7-8-5 5-7 6h-232l2 4 12 11v2h-740l-1-4 12-12-185-1 2-5 7-11 3-8 3-9 1-7-2-2-3 9-6 15-7 12-4 3 2-4 8-14 5-14 3-10-5-2z",
    fill: "#7C9C86"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1896,286)",
    d: "m0 0h2l1 18v431l-1 21 8-7 7-6 1 228 2 2v40h-1v-39l-5 2-6 6-2 4h-4v10l-9 1h-82l-6-3v2l-13 1h-24v-2l3-1-9-14-5-11-3-10v-4h-2l2-4 3-1v-2l14-8 15-5 12-2h15v-2l-17 1-15 3-14 5-14 8-11 9-23 23h-1382l-27-27-2-1v-2l-5-2-5-4v-2h2v-2l5 2 9 5 15 14 13 13 1373 1 2-4 18-18 17-12 12-6 14-5 19-4h18l-4-6-31-31-5-4-3-3 1 3 8 7 11 12 7 7h-3l-25-25-4 4-8 15-4 13-3 20-2 1 1-23 4-13 9-18 7-9 4-5 8-7 10-7 10-5 11-4 9-3 6-1h16l-2 4h-12l-10 2-20 8-9 6-1 2h-3l7 8 31 31 4 5-5 5-4 5 3 3-1 4-2 5v11l4 9 7 6 4 2 2-6 3-7-4-1-3-3v-10l5-4 2-1 9 1 3 3v3l12-5 7-4h2l2-4 6-5 7-8 1-3h2l1-5h2l1-6 3-10 1-1v-17l-3-3-16-9-20-7 3-2 12 3 12 5 13 8-4-4-7-4-9-5-18-6 2-4 22-22h2l-1-487-18-18v-2l-4-2-4-5 15-4 16-8z",
    fill: "#7D9E87"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(49,699)",
    d: "m0 0 2 3 3 24 5 17 9 19 9 12 9 10 4 3-8-8-10-13-4-7-5-10-5-15-3-15v-10l6-5 3 28 5 16 9 16 7 9 7 8 3 1 2-4 8-6 8-3 8-1v9l-9 2-8 5-5 7-1 3v12l4 8 7 6 6 3 5 1v-14l-6-1-3-5v-9l4-4 6-1v92l-16 5-8 7-4 7-2 7h6l1-6 4-6 8-6 7-2h4v106l-12 3-6 3-7 6-1 2-4-1-9-10-8-12-5-9-6-18-2-17-1-3-4 4 2 15 7 21 10 17 8 10 5 5 3 4-4-2-7-7-9-12-8-13-6-14 6 15 9 15 12 15h-55l-1 6h62l-1 17h-61l2 9v-2l62-1 7 9 4 2v2l3 1v63l6 1v-61h17v61l10-2h-4v-54l7 6 6 3 10 7 16 8 13 4 4 2-5 2-3 1-1 3-5 2v2l-14 8-11 5-13 4-16 2h-8l-21-4-11-5-7-3-11-7-13-12-8-9-9-14-7-19-2-10v-23l4-17 6-15 10-14 8-9-2-16-1-2-1-15-1-2v-24l-5-2-8-7-4-17-5-10-9-10-11-8-4-6-2-6v-8l3-9 4-6 1-5v-14l-5-12-3-7v-10l4-8 8-7 10-8 6-8 4-11 3-13 4-5z",
    fill: "#B4C5B5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1993,895)",
    d: "m0 0h1v40l-2 18-4 17-7 14-5 9h-2l-1 4-11 12-3 4 5-3 54 1 1-3 1 9h-62l1 2v16h62l-1 6h-55l-9-1-2 5-8 8-4 1v62l7-1-3 2-9 1v-61h-18v61l-9-1 3-1-1-55 4-5-8 7-9 8-9 6-11 6-23 7-16 2h-43l-17-1-17-4-19-8-12-7-13-12-5-5 2 4 11 10 5 5-5-2-11-9v53h5v1l-10 1v-62l-2 1h-16v61l-9-1 3-1-1-52h-3l7-7-2-1-2 4-13 11-16 10-10 4-17 5-15 2h-48l-18-2-15-4-16-7-12-7v-2l-5-2-12-11 6 7 11 9 1 2-4-2-9-7-2-2-1 9-1 43h5v1l-10 1v-61l-3 1h-11l-4-1v61l-10-1-3-2 7 1 1-53-9 7-2-1 12-11h2v-3l-5 5-10 9-5 3h-2v2h-3v2l-5 3h-3v2l-24 8-18 3h-50l-18-2-17-5-16-8-13-9-13-12 6 8 12 10 14 8 16 7-4 1-21-10-20-15-1 12v39l16-5 3 1-15 5-10 1v-61h-15l-3-1v62h-5l-1-1v-54-3l4-5h-2l-2 4-11 10-10 7-19 9-17 5-14 2h-52l-16-2-17-5-16-8-16-11-10-10-2-1 7 8 9 8h-3l-8-7-1 52 7-1-3 2-10 1v-61l-4 1h-11l-3-1v61l-9-1 4-1v-53l-14 11-2-1 11-9 6-7-7 7-8 6h-2v2l-11 7-5 1v2l-18 6-13 3-9 1h-50l-18-2-16-5-17-8-15-10-11-11-2-1 5 6 10 8v2l4 2 9 6-2 1-13-9-8-7-1 32v3 19h-6v-61h-17v61l-10-1 4-1-1-52-20 15-4 1 4-4 14-10 9-9 1-2h-2l-2 4-7 7-14 10-12 7-20 6-9 2-9 1h-51l-16-2-17-5-17-8-11-7-14-13v3l4 2 10 9 10 7 3 3-6-2-12-9-7-6-1 52 3 1-9 1v-61h-17v61l-10-1 4-1-1-56 3-1-1-2-9 9-5 2v2l-4 1v2h-3v2l-10 5h-2v2l-9 3h-3v2l-20 4-9 1h-51l-15-2-17-5-17-8-14-10-11-10 5 8-3-1-1 53-1 1h-5v-61l-2 1h-13l-2-1v61l-10-1 4-1v-25h3l-3-3v-25l-11 9-2-1 10-9 5-4 1-3h-2l-2 4-3 3h-2l-2 4-5 2v2l-7 5h-3v2h-3v2l-10 3v2h-5v2l-22 5-9 1h-51l-21-3-17-6-15-8-12-9-10-9v-2h-2l1 3 8 7 4 5-4-2-5-5-1 53 8-1-3 2-11 1v-61l-3 1h-11l-3-1v61l-9-1 3-1-1-62-2-1v-2l-5-2-6-8h-62l1 7-2-4-1-10h61v-14l1-3h-62l1-6 54-1-7-7-10-15-8-16-2-5 1-4 5 13 5 9 7 11 11 13 4 3-4-4v-2l-3-1-10-13-8-14-7-21-2-15 6-5 3 21 4 13 7 14 9 13 8 9 3 1 2-4 9-7 10-3h5l1 31 9 1-1 5-5 5h-7l-5-3-2-2v-11l4-4h5v-13l-8 1-8 6-5 7-1 3v9l2 7 4 6 6 5 3 1h15l8-5 6-8 3-9h8l-2 11-6 10-2 2 1 6-6-3v2l4 2 11 10 13 8 11 5 15 4 7 1h69l16-3 13-5 8-4 14-10 9-9h-3l-1-4-7-10-2-7v-6h8l2 9 6 8 5 4 7 2h8l9-4 7-8 2-5 1-6h9l-2 10-4 8-5 7 2 4-5-2 9 9 14 10 12 6 13 4 12 2h69l15-3 14-5 14-8 13-10 4-6-7 6-8 7-2-1 12-11 2-3-6-7-4-10v-6h-49l-2 11-5 7-1 3h-2l6 17 7 13 4 1v1h-76l8-16 4-10 2-6h-2l1-3 7 6 9 4 4 1v18h7v-48h1v7l3-3 1-5h114l1 2-3 7-3 2h-9l-5-5-3-4h-11l3 10 7 8 6 3h15l7-4 5-6 3-6 1-6h9l-2 10-4 8-5 7 11 11h-3l-9-9h-2l5 5 10 9 13 8 16 6 16 3h69l15-3 12-4 16-9 13-10 4-6-5 3 1-6-5-6-4-10-1-7h9l2 10 8 9 8 3h13l7-4 5-6 3-6 1-6h8l-1 10-5 9-5 7-2 1 4 5 14 11 8 5 7 3 11 4 16 3h69l15-3 11-4 14-7 13-10 7-7-4 2-6 6-2-1 9-9-6-8-4-9-1-8h8l3 10 4 6 9 6h16l9-6 4-5 3-11h8l-1 9-5 10-5 7h-3l6 7 13 10 12 7 21 7 9 1h69l15-3 11-4 15-8 13-10 6-6-4 2-6 6-2-1 9-9-6-8-4-9-1-8h8l3 9 6 9 7 4h16l9-6 5-8 2-8h8l-1 9-5 10-4 4 1 4 5 6-4-2-4-4v-2h-2l3 5 10 9 12 8 8 4 20 6 8 1h68l16-3 14-5 15-9 13-11 3-4-8 7h-3l7-8-2-4-4-5-3-7-1-9h8l3 9 5 8 8 5h13l8-3 5-5 3-4 3-10h8l-1 9-5 10-5 6 7 7h-3l-7-6 7 8 8 6v2l6 2 5 3 7 4 15 5 12 2h69l16-3 14-5 12-7 7-5h2l2-4 7-6 1-2h-3l-2 4-4 4-2-1 7-8-2-4-4-5-4-11v-5h8l3 10 6 8 7 4 4 1h8l7-3 6-4 4-7 2-9h9l-2 11-4 8-5 5 14 14h-3l-12-11-2-1 7 8 12 9 7 4 10 5 17 5 7 1h70l18-4 15-6 15-10 10-9 2-3h-3l-7-10-4-11v-5h8l2 9 7 9 7 4h16l8-5 6-10v-14l-3-6-5-5-10-5-3-1-1 13 6 2 4 5-1 9-5 5h-7l-5-3-2-2v-5h9v-32l10 1 10 5 4 4 3 1v3l7-6 11-14 9-19 4-15 1-9 1-45z",
    fill: "#4E6554"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(537,1)",
    d: "m0 0h10l7 3 8 4 4 1h12l9-3 7-4 4-1h10l7 3 7 6 8 11 7 6 15 6 12 3 6 5 3 6v3l-23 3-12 2-4-5-9-7-15-9-16-5-9-2h-24l-17 4 11-2 9-1v62l2-1h15v-61l8 1-2 1v53l11-9 12-8 2 1-11 8-11 9-4 5 12-11 10-7 14-8 24-7 6-1h65l17 3 16 6 12 7 6 3v2l5 2 12 11-2 4-4-1-8-8-15-10-12-6-13-4-14-2h-63l-11 2-16 4-16 8-12 9-8 8 6 7 5 8 3 12v1h-65l2-11 4-8 4-5-2-4-5-5-2-4 5 3 6 7h2l1-2-4-2-10-9-10-7-16-7-16-4-8-1h-63l-18 3-14 5-17 10-10 9-4 4 4-2 7-7 10-7 10-5 11-4 9-2h76v3l1-2 2 1-6 12-6 15-2 4-9-6-8-3v6l9 3 6 5 4 8 2 9h-17l-2-8h-2v8h-149v-7l5-12 6-7 2-2-9-9-10-7-12-7-18-6-11-2h-67l-20 4-13 5-13 8-10 8-5 5h-2v2l5-1 2-4 8-7 13-8 12-5 12-3 81-1 10 2 11 3 1 2-15-3h-6l-10 21-4 11-8-6-5-2v-2l-6-1v6l5 2 7 4 3 3 4 10v6h-29v-8h-2l-2 8h-104v31l-10-1-10-5-5-4-7 6-1 2h-2l-2 5-3 1 2-4 9-10 2-1 1-3-8 7-8 10-7 12-5 12-4 16-1 66h-1l-1-51-4 3-1-1v-10l4-20 5-14 9-15 1-2-9 13-1-2 9-14 7-9 3-3-53-1-1 2-1-8h62l-1-4v-10l1-3h-62l1-9 1 3 62-1 9-10 5-2v-64l6-1v61h15l2 1v-62l9 1-3 1v53l11-9 14-9 4-1-4 4-11 7-14 12-3 4h2v-2l8-7 7-6 10-7 12-6 8-3 16-4 6-1h63l17 3 15 5 15 8 11 8 11 10v-3l-4-2-6-5v-2l-5-2v-2l-5-2-9-5-14-7 3-1 16 8 11 7 11 10 1-53-6 1 3-2 9-1v61h17v-61l9 1 7 2-4 1-6-2v53l11-9 10-7 6-2-4 4-13 9-12 11 8-6 9-8 16-10 13-5 21-5h66l19 4 15 6 9 5 12 8 12 11-4-5-9-8-15-10-15-7-12-4-2-3 11-10 14-9 14-7 16-4 8-1h17l15 3 12 4 19 11 13 11v2l12-2 15-2-4-5v-2l-12-2-12-5-8-4v-2l-5-2-10-13-3-3v-2l-4-1h-12l-15 7-6 1h-10l-9-3-7-3v-2h-16l-6 4-1 2h-2l-2 5-7 8-8 6h-2v2l-10 4-13 3-4 2-3 5 14 2v1h-9l-10-1 3-9 5-5 17-4 9-4 10-8 8-11 7-6z",
    fill: "#526857"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(809,1055)",
    d: "m0 0 4 2 10 10 18 11 13 6 16 5 18 2h50l15-2 16-5 5-2h4v-2l8-4 6-4h2v-2l6-4 11-10v3l-9 9-7 5 9-6 4-4h2v54l5 1v-61h18v61l9-2h-3v-53l8 6 2 1-14-13v-2l4 2 9 9 15 10 16 8 22 6 11 1h52l14-2 17-5 19-9 12-9 10-9 1-2h2l-2 4-2 3 1 1v37l-1 17-11-2-13-5-14-8v-2l-4-1v-2l-4-2-3-1 10 8 13 8 11 5 17 4h26l19-5 16-8 5-3h2v-2l4-1 1-3 5-4 1-2 14 3 21 2-3 9-7 6-17 4-12 6-7 7-6 9-5 5-3 2h-18l-7-3-6-3h-19l-13 6h-19l-8-7-8-11-7-6-8-4-8-3-11-2-7-6-2-4v-4h-26l-1 6-5 6-6 3-11 2-16 8-8 9-6 8-5 4-4 1h-17l-8-5-3-1h-19l-12 6h-18l-6-3-6-7-6-8-7-6-6-3v-2l-6-1-16-4-5-5-3-6v-2h-25l-1 5-6 7-7 3-10 2-9 4-6 4h-2l-2 4-6 7-6 8-5 3h-20l-9-5-4-1h-18l-11 6h-18l-7-4-7-9-7-8-10-6-10-4-12-3-5-4-4-9v-1l5-1 20-2 10-2 8 8 15 10 14 6h7l14 3v-61h17v61h6l-1-19-1-3h2v-33l20 15h1l-10-7v-2l-4-2-11-10z",
    fill: "#7B9B84"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(762,1)",
    d: "m0 0h10l8 3 8 4 4 1h13l8-3 5-3 6-2h10l8 3 7 7 6 9 7 6 12 6 16 4 6 5 2 5v3h26l23 3 11 2 7-7 8-6 3 1-14 11-2 2 19 8 16 10 14 12 4 4v2l-4-2-10-10-13-9-17-8-19-5-6-1h-66l-21 5-20 9-10 7 10-6h2v2l2 1-10 6-10 9-4 5 5 5 4 5 4 11 1 6h-171l3-13 7-8 9-4h2v-6l-15 7h-3l-6-15-4-8-4-6v-2h78l17 4 11 5 11 7 10 9 4 2 4-2-2-4-12-10-2-1v-2l-6-2-12-7-16-6-17-3h-65l-21 5-10 4-15 8-11 9-9 8-2-1 8-8 10-8 9-6-9 5-11 9-4 2v-53l-6-2v61l-17 1v-62l-17 4-4-1 8-3 10-2h24l20 5 10 5 13 8 10 9v2l18-4 17-2h25l2-7 6-6 17-4 12-6 6-5 11-15 6-4z",
    fill: "#506656"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1778,150)",
    d: "m0 0h22l9 5 10 7 7 6 9 12 6 12 3 11 8 3 10 4 12 7 14 14 8 13 2 4v34l-2 2h-3l-1 3-9 5-8 4-16 4h-4l-6-7-4-6 1-3 8 12 4 1 12-3 10-4h2v-2l13-7h2l-2-21-6-15-7-11-6-7-5-4-3 1-7 9-8 5-6 2h-14l1 17 4 18 4 9 6 12 9 12 25 25v438l-2 5-3-1v-237l-1-200-22-22-10-14-6-10-5-14-5-20-1-20-4 2-9 10-8 7-21 21-1 3 5 2 10 6 19 7 11 2h8l-2-4 1-3 4 8v3h-16l-12-3-10-3-15-8-13-10-10-11-7-10-3-8-3-7-5-23-2-11v13l3 16 8 19 8 12 8 10 13 10 12 7 15 6 14 3 18 1 8 11 9 11v3l-7 3-9-1-18-10-8-2h-14l-6 1h-10l-8-3-7-7-3-10-5-10-3-3v-2l-14-7-11-4-8-9-2-5v-11l1-5v-15l-5-15-7-10-1-3v-7l3-7 4 1 12 10 14 9 1 2 1 12 3 13 5 12 6 11 3 4v2l3-1 7-8 28-28 5-4 1-3h-13l-16-2-19-5-19-10-14-11-20-20h-1372l-9 9-4 5-4 1-3-3 2-5h2v-2h2v-2l5-5 4-2v-2h1382l28 28 14 9 11 5 11 4 11 2 19 1-1-2-18-1v-1h18v-10l4-10h2v-3l8-7 3-2-2-4-9-9-8-5v-2l-10-3-18-5z",
    fill: "#4A5C4F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(112 1e3)",
    d: "m0 0h8v13l-6 2-2 2v11l3 3 3 1h7l4-4 2-5h-9v-1h346l-1 7-3 1-1 41h-7v-18l-7-1-9-5-4-4-1 2h2l-3 12-10 19h71l-8-14-5-14v-3h2l1-4 5-9 2-8h49l3 12 8 12-12 12 8-7 6-5v3l-5 6-15 11-16 8-9 3-15 3h-69l-16-3-16-6-15-10-12-11-2-3 4 1-1-3 7-9 3-8 1-6-8-1v6l-4 8-7 7-8 3h-8l-8-3-8-7-4-8v-6h-8l3 13 7 10 1 3 3 1-11 11-16 11-15 6-12 3-7 1h-69l-9-2-16-4-15-8-13-10-8-7v-2l4 1v-1l1-4 6-9 2-5 2-8h-8l-2 9-6 8-5 4-4 2h-15l-7-4-6-7-2-3-1-6v-9l4-8 8-7z",
    fill: "#B3C4B4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1915,28)",
    d: "m0 0h4v62l2-1h13l3 1v-62l6 1-1 63 5 2 7 7 2 5 63-1 1 1v6h-61v17h61l-1 7-54-1 7 8 10 14 2 6-3-3-12-17-10-10-2-1 5 5 10 11 9 14 5 10 7 24 1 14v44l-2 20-5 17-4 9-7 12-1 4 1 2-9 11-2 2 54 1 1 5h-61v16l-1 2h62l-1 6h-54l8 9 5 7-1 2-13-16-7-6 7 8 9 10 6 9 7 15 5 15 2 11 1 13v43l-2 21-5 19-8 16h-2l-2 5-4 6h-2l-2 4-7 8h1l6-7h2l2-4 2-3h2l2-5 9-16 6-15 4-18 2-19 9 4 6 7 4 17 6 11 5 6 14 10 4 6 2 7v68l-4 9-7 7-10 7-8 11-4 12-2 10-7 8-8 2-3-23-2-6-1-9 4-2v3l7-8 1-2h2l1-4 4-6 8-21 2-10v-25l-4-16-3-7-4-9-7-11-7-8v3h2l3 4v2h2l9 16 5 13 3 12v5h-61l1 3v10l-1 4h61l-1 9-1-3h-53l9 11 7 10 5 9-1 2-10-16-11-13-6-6 6 7 8 9 9 14 8 19 2 5 1 7 1 1v14l-6 4-2-20-4-15-8-16-9-13-9-9 2 4 8 8 6 8 7 15 4 16v76l-1 2-4-1-17-8-11-3 6-10 3-8h-6l-1 6-6 8-4 3-4 2-10 1v-15l6-3h2v-2h-7v-1l47-1 1-4-1-1-47-1v-1h7l-4-4-4-2v-14l9 1 7 3 7 8 2 6 6 1-4-9-3-6-5-5 6-1 24-10 3-2-1-11-4-12-6-12-4-6-11-12-8 6-10 4h-7v-8l9-2 8-6 5-8v-14l-5-9-4-3v-2l-4-1-9-2 1 13 5 2 3 3 1 8-3 5-2 2-6 1v-42h7l11 4 8 6 2 1v2l9-9 9-13 6-11 5-15 2-14v-68l-3-17-5-14-9-15-9-11-4-4-3-1-2 4-7 6-7 3-10 1v-23l1-19 6 1 4 5v7l-3 5-5 3h-2l1 12 9-2 7-5 5-9v-14l-3-6-9-8-10-3v-8l11 2 8 4 6 6v2l5-3 8-9 10-15 6-15 3-12 1-8v-67l-2-12-2-7-6-15-11-16-8-9-3-1-5 5-8 6-7 2h-6v-8l11-3 7-6 4-7v-15l-6-9-9-6h-14l-9 5-5 7-2 5v4l13 1 1-6 5-4h8v2l4 1 2 5v7l-5 5-6 1v-10h-31l1-10 5-10 4-5 3-2-2-4-4-3v-2l-6-3v-2l-5-2-12-7-12-5-8-2-9-1v-1h6v-2l6-2 16 6 16 9 11 8 8 8v2h3v-2l-3-1v-2l-4-2-10-9-7-5 2-1 11 8 6 6v-52h-5l4-2z",
    fill: "#506756"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(987,1)",
    d: "m0 0h11l12 5 8 3h13l8-3 8-4 3-1h10l8 3 7 8 7 9 7 6 11 5 15 4 5 3 5 8v2h25l23 3 11 3v-2l11-9 13-8 11-5 14-4 6-1h22l4 2h-6v61l-18 1v-61l-6 1 1 37v17l-8-6-13-10-5-2 11 7 10 9 8 7v2l-4-2-10-10-12-8-16-8-16-5-11-2h-66l-18 4-12 4-5 3h-3l1 3 4-1 2 1-15 9-10 9-5 4v2l5 5 6 9 2 7v6h-136l-2-8h-3v-22h1l1 5 7 3 8 7 4 8v6h6l-4-13-6-9-6-4-11-4-1-17-6-1v34l-1 7-4 4v4h-17l2-11 6-8 6-4 6-2v-6l-14 7-3 1-8-20-6-10v-2h78l7 2v1l-11-1-2 6-7 15-3 12 5 8 1 4v7l13-1h35l2-7 6-12 3-3-2-4-4-4v-2l4 2 3 4 3 1-7-8-12-9-11-6-12-5-13-3-8-1h-63l-14 2-16 5-8 4h-3v-2l-11 7-2-1 11-8 20-9 21-5h66l19 4 17 7 12 7 10 8 9 9 2 1-7-8-14-11-13-8-14-6-6-2 5-6 11-8-5 2-12 11-11-2-23-3 1-6 7-8 6-2 14-3 10-6 9-9 7-10 7-4z",
    fill: "#4A5F4F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(347,174)",
    d: "m0 0h912l9 1v1l-926 1-8 7-3 4 2 5v10l-4 8-6 10-2 6v20l1 2v8l-3 9-3 5-5 4-16 6-9 7-6 9-4 13-5 5-5 4-4 2h-12l-5-1h-15l-10 3-14 9-10 1-9-2-9 9-1 9v456l10 10 6-1 1-1 11 1 14 9 10 3h17l5-1h9l9 4 5 5 3 4 4 13 4 6 8 7 8 4 9 3 8 7 3 5 1 10-1 6v20l5 12 5 7 2 5v10l-1 7 9 9h1366l10-10-2-8v-9l9-14 3-8 1-4v-14l-1-5v-11l4-9 7-6 16-6 8-6 5-7 6-16 5-6 6-4 5-1h8l5 1h17l9-3 10-6 7-4h9l8 3-6 8-7 9-5 8-23 2-15 4-13 6-12 7-13 12-6 8-8 13-6 15-3 14-2 17h2l1-12h1v10l-1 3-10 6-8 6-13 12-7 8h-1367l-19-19-17-12-1-18-3-14-6-15-8-14-10-12-13-10-12-7-15-6-10-2-11-1h-10l-9-12-6-7v-2h-2l-7-8-7-6v-467l18-18 9-12 5-9h18v1l-13 1-4 1h9l20-3 8-3 9-4 12-7 14-12 9-12 6-11 4-8 5-22 1-17 13-9 12-11 10-10z",
    fill: "#8DA794"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(240,931)",
    d: "m0 0h15l17 3 17 7 15 9v2l4 2 25 25h1382l26-26 10-7 9-5 8-4 9-3 15-3h17v2l-22 2-15 4-16 8-3 1v2l-5 5h2l5 17 8 15 5 8h-4l5 1h32v-2l6 2h91v-10l4-1 3-5 6-6h4v40h-715l-6-7-8-7-1-4h233l6-5 5-6 2 1-8 9v1h339l-9-14-6-14-2-7v-4l-8 7-11 11-6 7-2 1h-1388l-31-31-18-11-10-4-17-3-14-1z",
    fill: "#7A9C84"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(150,276)",
    d: "m0 0 4 5h-2v5l15 9 12 5 11 3-6 7-16 16-3 4-1 4-1 90v259l1 133 26 26-4 3-12 3-12 6-10 6h-2v44l3 1 4 7v3h2l7 8 10 9 7 4 5 3 15 5 4 13 5 9v3h2l7 9 8 8 6 4v2l5 1 4 3h-6l-2 1h-86v-89l-8-7-6-6-1 117h34v1h-35l-1-385 1-231h1v232l8-7 6-5 7-8 3-4-8 8h-1v-200-2-46l7-2 4-4v-9l-7-8-4-4z",
    fill: "#7B9C85"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1992,663)",
    d: "m0 0h1l1 6v38l-2 20-4 15-5 12-9 16-1 2 4-3-2 4-9 11-1 1 53 1 1-4 1 10h-61v17h61l-1 12-8 20 1-1 6-14 3-13v-24l-3-14-4-12-1-4 1-2-2-4-2 2-10-14-5-6 4 8-5-4-10 20-1-3 6-12 5-16 2-10 2-18 6 1 8 7 5 18 6 12 8 8 11 8 4 6 2 4v72l-5 9-7 6-8 6-5 6-5 8-3 9-3 12-4 5-9 4h-1l-3-23-4-16-3-9-7-13-7-11-10-11-5-6-2-1 7 8 9 10 10 17 5 12 4 14 2 20-6 8-1 45-2 14-4 13-9 17-8 10-8 9h-2v-3l-4-1-6-5-7-3-10-2v-71l6-3 2-3h17l-1 5-4 8-8 6-9 2-2 6 13-4 9-6 4-6 3-9-4-1v-2h23l-1-5-40-1-1-3-6-3v-16l12 3 8 7 3 5 1 4 6 1-4-9-4-6-7-6-6-3 4-1 6 4 7-1 19-8 5-3h2l-3-15-5-13-6-10-9-11-4-4-4 2-5 4-7 3-9 1v-8l10-3 7-5 4-7 1-4v-9l-3-9-7-7-5-2-6-1v12l6 3 3 6-1 8-3 3-6 1-1-1v-38l1-3 14 3 8 6 3 2 8-8v3l-6 6 1 1 9-9 9-14 6-12 4-13 2-13 1-52 4-2z",
    fill: "#516857"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1825,844)",
    d: "m0 0h16l-2 4h-12l-10 2-20 8-9 6-1 2h-3l7 8 31 31 4 5-5 5-4 5 3 3-1 4-2 5v11l4 9 7 6 4 2 2-6 3-7-4-1-3-3v-10l5-4 2-1 9 1 3 3v3l12-5 7-4h2l2-4 6-5 7-8 1-3h2l1-5h2l1-6 3-10 1-1v-18h2v33l-3 5-7 11-9 10-11 8-9 5-15 5-5 16-8 13-9 10-12 9-9 3v2l-13 1h-24v-2l3-1-9-14-5-11-3-10v-4h-2l2-4 3-1v-2l14-8 15-5 12-2h15v-2l-17 1-15 3-14 5-14 8-11 9-23 23h-1382l-27-27-2-1v-2l-5-2-5-4v-2h2v-2l5 2 9 5 15 14 13 13 1373 1 2-4 18-18 17-12 12-6 14-5 19-4h18l-4-6-31-31-5-4-3-3 1 3 8 7 11 12 7 7h-3l-25-25-4 4-8 15-4 13-3 20-2 1 1-23 4-13 9-18 7-9 4-5 8-7 10-7 10-5 11-4 9-3z",
    fill: "#4E6453"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(695,1025)",
    d: "m0 0h411l3 11 2 7-4-4-2-7v-5h-48l-1 2v-3h-8l-1 7-2 5-6 7-7 4h-16l-10-7-5-9-1-7h-8l4 14 7 9v3l-8 8 7-6 2-2 3 1-10 10-13 9-16 8-15 4-7 1h-69l-16-3-11-4-10-5-13-9-9-8-2-4h3l2-4 6-10 3-12h-8l-1 9-6 8-6 5-3 1h-13l-8-3-7-7-3-6v-7l-9 1h-48l-2 10-5 10 6 18 5 8 2 6 11-3h5l-1 2-17 3-76-1 6-6 8-17 3-9 5 2 10 5 3 1v-6l-8-2-9-8-3-6v-8h15l3 6 3 2 1 40h6l-1-23 1-19 3 1 2-5z",
    fill: "#92A497"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 510)",
    d: "m0 0 5 4 10 14 3 5 3 7 5 16 1 6v25l-4 16-7 17-4 5-1 3h-2l-2 4-7 8v-3h-3l3 14 1 1 3 22 7-2 6-7 4-17 4-8 8-10 11-8 6-7 2-6h1v155l-2-1-3-6-5-5-10-8-8-9-6-15-3-12-7-6-6-2-1 18-4 17-6 16-3 5v2l9-20 5 4-4-5 1-3 10 12 5 8 2-2 3 5-1 4 4 11 3 10 1 7v24l-4 16-7 15-2-1 7-17 2-5 2-12h-61v-17h61l-2-6h-54l12-16-5 4 2-4 10-18 6-16 3-15 1-14v-38l-1-5-4 4-1 52-3 17-3 9-7 14-10 14-9 9-1-3 7-7-5 4-4 3-8-7-9-3-7-2-1 3v-59l10-2 8-5 5-7 2-6h6l-3 10-5 7 15 5 16 8v-78l-4-16-8-16-8-10-7-7 1-3 11 11 10 15 7 16 3 12 2 19 3-3h2l-1-14-1-1-1-7-4-10-7-15-9-14-11-12-2-4 7 6 10 11 10 16-5-10-10-13-4-4v-2h53l2-6h-61v-17h61l-4-17-6-15-7-12v-2h-2l-3-4v-2h-2z",
    fill: "#B4C5B5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1149,1025)",
    d: "m0 0h409l5 16-1 2-4-7-2-8h-48v-2h-8l-1 7-3 6-4 5-7 4-4 1h-13l-9-6-6-9-1-8h-8l3 12 5 8 3 3-2 5-4 5 7-7h2l-2 4-11 10-13 8-10 5-17 5-8 1h-68l-16-3-16-6-10-6-9-7-10-9v-3h2l6 7-4-5-1-4 6-7 4-11 1-5h-8l-1 8-6 9-9 6h-16l-9-6-6-9-1-8-8 1h-49l-1 9-3 5-1-2 3-8v-4h-4l-3 9-4 7-5 4-9 3v6l8-3 10-5 6 18 7 12 3 2h-75l9-19 3-8 1-6 10 6 8 3-1-6-8-3-7-7-3-7-1-7h16l2 5 1 1 1-6h2v48h6v-46h2l1 4 4-6z",
    fill: "#B5C6B6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(85,1)",
    d: "m0 0h10l8 3 7 4 4 1h13l10-4 5-3 4-1h12l8 4 10 13v2l3 1 5 5 12 6 17 4 7 8 1 4 25 1 2-6 5-6 8-3 11-2 8-4 10-8 9-12 6-5 6-2h10l7 3 10 5h15l8-3 7-4 4-1h10l7 3 4 2 12 16 8 6 9 4 16 4 6 5 3 7v2l-23 3-12 2-2-4-6-4v-2l-5-2-10-6-12-5-14-4-5-1h-22l-17 4-15 6-11 7-11 9-1 2-11-2-6-1h-61l-16 4-10 2 2-2 3-2 3-1-9-8-2-1v-2l-4-1-12-7-16-5-10-2h-22l-13 3h-5v-2l-2 1 1 2-9 4-12 7-8 6-12 11-10 13-1 3h-3l1 3-6 14-4 16v22l5 21 6 14 6 9v2h2l7 8 2 2-1 8-4 27-7-2-6-5-2-4-2-12-7-14-8-9-11-8-4-5-2-6v-9l5-12 3-8v-14l-4-9-3-7-1-3v-8l4-10 8-7 9-7 6-8 3-5 4-15 12-3 10-5 9-8 7-10 5-4z",
    fill: "#7B9C85"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 245)",
    d: "m0 0 7 2 6 5 5 16 4 10 6 9 11 9 7 6 4 8v231l-2-3-3-7-5-5-11-8-7-9-5-11-3-14-5-6-8-4-3 24-4 14-6 15-9 16-2 3h-2l-2 4-2 3h-2l-2 4-7 6 2-4 8-9 4-5 5-8h2l1-5 6-11 5-19 2-21v-43l-2-19-4-15-7-16-9-14-9-10-5-5v-2l4 2 7 7 9 12-6-9-7-8v-1h54l2-5h-62l1-18h61l-1-4-55-1 2-2 52 1-7-21 1-2 4 7-4-10-7-12-11-13 1-10z",
    fill: "#7C9D85"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(53,509)",
    d: "m0 0h2l-2 4-9 11-8 15-5 15-3 12h62v17h-62l2 6h53l-3 5-9 12-8 14-4 10 8-16 7-11 11-13 5-4 2 2-16 16-7 11-7 16-4 13-2 14v48l3-3h2v-44l2-16 5-16 5-10 8-12 12-13 7 6 10 6 10 2 1 1v85h-8v2l8 2v72l-16 5-9 7-1 2-4-1-10-11-11-18-6-16-2-10-2-21-4 4v10l3 15 5 15 6 12 7 10 9 11 5 5-1 2-12-12-12-17-8-17-5-17-3-24-1-3v-24l1-2 2-20 3-13-3-1-6-7-9-13-6-14-4-15-1-6v-19l3-15 8-20 10-14z",
    fill: "#B2C3B3"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(60,937)",
    d: "m0 0 2 4 2 17 4 13 7 14 9 13 8 9 3 1 2-4 9-7 10-3h5l1 31 9 1-1 5-5 5h-7l-5-3-2-2v-11l4-4h5v-13l-8 1-8 6-5 7-1 3v9l2 7 4 6 6 5 3 1h15l8-5 6-8 3-9h8l-2 11-6 10-2 2 1 6-6-3v2l4 2 11 10 13 8 11 5 15 4 7 1h69l16-3 13-5 8-4 14-10 9-9h-3l-1-4-7-10-2-7v-6h8l2 9 6 8 5 4 7 2h8l9-4 7-8 2-5 1-6h9l-2 10-4 8-5 7 2 4-5-2 9 9 14 10 12 6 13 4 12 2h69l15-3 14-5 14-8 13-10 4-6-7 6-8 7-2-1 12-11 2-3-6-7-4-10v-6h-49l-2 11-5 7-1 3h-2l6 17 7 13 4 1v1h-76l8-16 4-10 2-6h-2l1-3 7 6 9 4 4 1v18h7v-48h1v7l3-3 1-5h114l1 2-3 7-3 2h-9l-5-5-3-4h-11l3 10 7 8 6 3h15l7-4 5-6 3-6 1-6h9l-2 10-4 8-5 7 11 11h-3l-9-9h-2l5 5 10 9 13 8 16 6 16 3h69l15-3 12-4 16-9 13-10 5-5 2-1 3 3-7 8-11 9-9 6-9 5-20 6-9 2-9 1h-51l-16-2-17-5-17-8-11-7-14-13v3l4 2 10 9 10 7 3 3-6-2-12-9-7-6-1 52 3 1-9 1v-61h-17v61l-10-1 4-1-1-56 3-1-1-2-9 9-5 2v2l-4 1v2h-3v2l-10 5h-2v2l-9 3h-3v2l-20 4-9 1h-51l-15-2-17-5-17-8-14-10-11-10 5 8-3-1-1 53-1 1h-5v-61l-2 1h-13l-2-1v61l-10-1 4-1v-25h3l-3-3v-25l-11 9-2-1 10-9 5-4 1-3h-2l-2 4-3 3h-2l-2 4-5 2v2l-7 5h-3v2h-3v2l-10 3v2h-5v2l-22 5-9 1h-51l-21-3-17-6-15-8-12-9-10-9v-2h-2l1 3 8 7 4 5-4-2-5-5-1 53 8-1-3 2-11 1v-61l-3 1h-11l-3-1v61l-9-1 3-1-1-62-2-1v-2l-5-2-6-8h-62l1 7-2-4-1-10h61v-14l1-3h-62l1-6 54-1-7-7-10-15-8-16-2-5 1-4 5 13 5 9 7 11 11 13 4 3-4-4v-2l-3-1-10-13-8-14-7-21-2-15z",
    fill: "#4F6555"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(220,237)",
    d: "m0 0 4 1 6 5 7 8 12 12 2 1-2-6-4-4-2-5 1-6 3-3 4 1-2 8 7 9 1 6-2 5 8 7 2 4-12 8-18 8-9 2-18 3-7 12-11 13-14 14-1 467 4 2 10 10v2h2l11 14 4 6h10l17 2 10 3 16 8 13 9 8 7 10 13 8 15 5 14 2 11 1 18 13 9 10 9 12 12 1367 1 2-4 13-13 10-8 11-7 3-2 3-20 4-13 9-17 4-3 26 26-4-5-10-10-7-8-4-3v-3l3 1 39 39 1 4-18 1-22 5-15 6-10 5-17 13-17 17-1 2h-1373l-22-22-12-9-14-7-7-3-13-4-15-3-17-1 1-5 8-7 26-26 5-6h3l9 14 4 10 3 9 3 16v7h2l-2-21-4-15-8-16-7-9v-2h-2l-5-6-2-1v-2l-4-2-14-9-10-4-17-4-10-2-9-1 8 18 5 20 2 15v10l-1 2h-2l-2-25-4-17-8-19-6-9-8-10-20-20v-472l10-9 2-3h2v-2h2l2-4 10-11 5-8 1-3h2l3-10 4-10 3-14z",
    fill: "#DCE4DD"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(842,133)",
    d: "m0 0h920l4 2 4 6 5 1 7-7 4 1-10 10 2 3-1 2h-8l-2 4-8 14-5 12-2 3v-2l-2 1-3 7-2-1 1-7 5-14 10-16 3-1v-2l-168 1-54-1-1 2-6-1-11 11v-3l8-8h-171l-57-1-1 2-6-1-2 1v-2l-73 1h-98l-53-1-1 2-3-3 3-4h2l2-4h2v-2h2l1-3h-222l-15-1z",
    fill: "#799A83"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1957,811)",
    d: "m0 0 4 2 11 12 8 11 6 11 4 9 5 17 2 11 2 16 9-4 4-6 3-13 4-10 7-9 8-7 6-4 4-5 3-6h1v156l-2-3-4-8-9-7-8-7-6-9-4-9-4-15-4-5-8-3-3 24-3 13 2-3 11 13 6 10 6 15 4 16 1 11v9l-3 16-6 16-5 9h-2l-1 4-4 5-2 3h-2l-2 4-6 5-4 2-14 9-16 7-14 2v-62l6-4 7-8 1-2h62l2 1v-5l-61-1-1-18h62l-2-6h-55l-4 3-2-1 12-12 4-5 1-3h2l2-6 6-10 3-7 5-23 1-12v-39l-5 4 2-4 3-4-2-20-6-20-11-20-9-11-8-8z",
    fill: "#7B9D85"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(248,150)",
    d: "m0 0h36l11 18 4 13 1 4 1 5 2 1-14 11-9 5-12 4-12 2h-16v2l20-1 16-4 13-5 16-11 8-7 2-3h2l1-2 5 6-8 7-12 9-5 1v2l-13 6-18 5-18 2h-11l2 5 8 7 31 31v-3h4l10-18 5-17 2-15h2v13l-2 10-6 18-8 14-11 12-9 8-14 8-6 3-19 5-19 1v-2l9-2 13-2 10-3 16-8 8-5-3-5-7-6 2-7-3-7-5-6 2-8-4 1-2 3 1 7 2 4 4 3v5l-4-2-17-17-4-5-6-3v18l-3 19-4 12-4 9-1 2h-2l-1 5-7 9-9 10-1 2h-2v2l-5 5-8 7-1 470h-1v-116h-2v-2h-2v124h-1v-479l6-7h2l2-4 5-5 5-4 9-11 7-10 4-7 6-16 2-9 1-21-4 1-12-2-10-5-9-10v-2l-6 4-7 7-7 11-6 15-2 17h-2v-29l3-3 3-6 7-10 11-11 16-9 10-3 4-1 5-16 6-10 6-8 9-9 14-9z",
    fill: "#4C6252"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1869,222)",
    d: "m0 0 4 2 6 5 8 11 7 14 2 6 1 7v14l-13 7h-2v2l-14 6-13 2-7-9-1-1 7 10 4 2 6-2 16-5 7-4 5-3 1-2 4-1-1 4-8 6-15 7-14 4 7 6 7 8 12 12v487l-8 7-17 17-1 2 9 2 13 5 9 5 7 5v2l-5-2-12-7-18-6-2 1 19 7 17 10 1 2v17l-3 8-3 9h-2l-1 5h-2l-1 4-7 8-7 6-4 4-15 7h-3l-3-5-9-1-6 4v10l3 3 3 1-2 7-3 6-5-2-7-6-4-9v-11l3-6-1-4-2-3 9-9 3-1v-20l3-16 4-10 4-9 6-12 8-10 9-10 14-14 1-30 3-4 1-3v-438l-27-27-9-14-7-14-4-15-1-6v-17l14-1 9-4 7-5z",
    fill: "#7C9D86"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(299,149)",
    d: "m0 0h51 2l6 1 1-1h229l-6 7-3 4 11-11 6 1 1-1h226l-6 7-3 4 11-11h5l3 2v-2h229l-2 4-10 10-719 1-8 7-16 16-4 2-5-17-8-15-4-5v-2z",
    fill: "#4E6554"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(126,126)",
    d: "m0 0h1796v894h-1796v-629l2-1 1 352-1 276h1792v-890h-1792v261h-1l-1-146z",
    fill: "#91A296"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(49,699)",
    d: "m0 0 2 3 3 24 5 17 9 19 9 12 9 10 4 3-8-8-10-13-4-7-5-10-5-15-3-15v-10l6-5 3 28 5 16 9 16 7 9 7 8 3 1 2-4 8-6 8-3 8-1v9l-9 2-8 5-5 7-1 3v12l4 8 7 6 6 3 5 1v-14l-6-1-3-5v-9l4-4 6-1v42l-10-1-11-6-2-2-4 1-3 3h-2l-2 4h-2l-1 4-5 6-1-2 8-11 8-8h-2l-8 8-7 9-6 12-5 12-3 14-1 11-1 50-6 4v-57l3-17 5-16h-2l-1 5-2 8h-2l-1 2-9-10-9-15-6-15-3-14 1-3 61 1-1-4v-10l1-3h-62l1-10 6-18 9-16 7-9-5 5-6 8-7 15-4 13-2 10v19l3 15 3 10 6 12 1 4h2l8 11 5 5-1 8-2 10-1 13-1 3-6-1-8-7-4-17-5-10-9-10-11-8-4-6-2-6v-8l3-9 4-6 1-5v-14l-5-12-3-7v-10l4-8 8-7 10-8 6-8 4-11 3-13 4-5z",
    fill: "#546B5A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1065,149)",
    d: "m0 0 5 1 1-1h224 2l6 1 1-1h229l-6 7-2 3 10-10 6 1 1-1h222v2l-4 4-9 15-5 15 1 4 3-7h2l-2 12-5-3-27-27-666-1 6-7z",
    fill: "#4E6554"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1953,364)",
    d: "m0 0 4 1 7 7 10 14 6 12 5 15 2 13v68l-2 14-3 10-8 16-7 10-9 10-4 3-1-3-8-6-11-4-7-1v-165l13-3 9-6z",
    fill: "#B4C5B5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(55,961)",
    d: "m0 0h1l2 8 7 16 10 15 9 10v1h-55l-1 6h62l-1 17h-61l2 9v-2l62-1 7 9 4 2v2l3 1v63l6 1v-61h17v61l10-2h-4v-54l7 6 6 3 10 7 16 8 13 4 4 2-5 2-3 1-1 3-5 2v2l-14 8-11 5-13 4-16 2h-8l-21-4-11-5-7-3-11-7-13-12-8-9-9-14-7-19-2-10v-23l4-17 6-15 2 1 6-10z",
    fill: "#7B9D85"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(289,946)",
    d: "m0 0 5 2 8 6 28 28 4 1 151 1-5 7 7-7h470l-5 5-6 7-2 1h-466l-3-1-2 1h-187l2-5 7-11 3-8 3-9 1-7-2-2-3 9-6 15-7 12-4 3 2-4 8-14 5-14 3-10-5-2z",
    fill: "#4E6554"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 925)",
    d: "m0 0 9 3 5 6 6 21 7 11 9 8 8 6 4 6 2 6v67l-3 9-6 7-10 7-7 8-6 12-2 10-13 3-11 6-7 7-8 11-3 3-4 2h-19l-12-6h-19l-11 6h-19l-6-4-6-7-8-10-11-7-16-4-7-3-6-8-1-5 25-3 13-4 4 1-3 2 2 3-4-1 14 11 16 8 11 4 17 3 18-1 15-4 13-5 7-4h3v-2l10-7 9-8 4-5 5-6 1-3h2l2-6 4-9 4-10 3-16v-9l-2-17-7-21-6-11-12-15-3 3 2-10 2-11z",
    fill: "#7B9D85"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1892,1)",
    d: "m0 0h10l7 3 9 4 4 1h11l10-3 9-5h12l7 3 5 4 7 10 1 3 4 2 5 4 13 6 8 1 3 13 4 8v2h2l7 8 2 1v2l5 2 5 5 4 5 2 7v64l-3 12-7 7-11 8-7 9-4 10-4 16-8 7-6 1-4-29-1-6 3-1 3-5h-2l2-4 6-8 1 2-5 8 8-11 3-5-1-5 2-5 1 3-1 2h2l1-5 4-13 2-17-1-17-5-18-1-4h2v-3h-2l-1 2-10-16-11-13-5-4v-2l-5-2-14-9-13-5-18-4h-21l-17 4-3 1 3 2-5 2-3-1 2-1-5 1-12 7h-2v2l-6 4-6 5-1 2-11-2-24-3 3-9h2v-2h2v-2l9-3 13-3 12-8 8-9 4-6 6-5z",
    fill: "#7B9C85"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1914,245)",
    d: "m0 0h1l1 495v231l-3 1-1-228-12 12h-2v-452l-1-22 1-20 15-15z",
    fill: "#75957F"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(49,925)",
    d: "m0 0 2 2 1 15 2 6 1 12-10 11-9 14-6 17-3 13v23l4 16 6 15 10 14 9 10 9 8 7 5 5 3 10 4 7 3 21 4 19-1 15-4 12-5 13-7 3-1v-2l5-3 5-5 9 1 5 1 20 2-2 8-8 7-17 4-8 4-10 9-9 12-4 3-3 1h-18l-12-6h-19l-13 6h-17l-5-3-8-9-5-6v-2l-4-2-10-6-8-3-6-1-5-16-6-9-8-8-9-6-6-10v-11l3-7 5-12v-14l-3-8-4-7-1-4v-8l3-9 4-5 5-4 5-3 8-8 6-12 4-17 8-7z",
    fill: "#7B9C85"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1621,1025)",
    d: "m0 0h184l3 6v2h3l1 11 1 30h5v-32l1-9 3-2 2-5h16l-3 12-7 8-2 2-8 3-1 5 9-3 9-5 9 23 5 7v2h-73l8-15 5-13 1-5 11 7 7 2-2-6-7-3-8-8-2-4-1-8h-6l4 12 1 4-4-4-3-10v-2h-48l-9-1-1 9-6 9-8 5-4 1h-8l-8-3-7-6-5-10v-5h-8l3 12 5 8 3 3-2 5-9 10-15 9-13 5-9 2h-84l3-3 1 1 9-17 4-14 12 7 6 2v-6l-4-1-6-3-5-5-3-4-2-11h16l3 6 1-5h2v47h6v-40l5-5 1-3h16l-2 11-5 7-6 4-7 3v5l10-4 5-3 5-6 4-10 2-7z",
    fill: "#B3C4B5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1929 1e3)",
    d: "m0 0 6 1 10 6 5 7 1 3v14l-6 10-9 6h-16l-9-6-6-8-1-9h-8l3 12 6 10 2 4h3l-2 4-7 7-15 10-7 4-18 6-11 2h-70l-15-3-14-5-9-5-11-8-10-9-1-3 4 2 11 10-4-5-9-9 7-8 5-15h48l4 12 2 2-3-7-1-7h6l3 9 3 5 5 5 8 4 1 1v5l-9-2-8-6-5 15-8 15-1 1 72 1-7-11-8-20-9 6-8 1v-5l5-3 5-2 7-8 3-11-15-1-2 6-3 1-1 41-5 1-1-1-1-41h-3l-3-5v-3h122v1h-9l2 6 5 3h7l4-4 1-9-3-4-6-3v-8z",
    fill: "#B4C5B5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(537,1)",
    d: "m0 0h10l7 3 8 4 4 1h12l9-3 7-4 4-1h10l7 3 7 6 8 11 7 6 15 6 12 3 6 5 3 6v3l-23 3-12 2-4-5-9-7-15-9-16-5-9-2h-24l-17 4 11-2 9-1v62l2-1h15v-61l8 1-2 1v53l11-9 12-8 2 1-11 8-11 9-4 5 12-11 10-7 14-8 24-7 6-1h65l17 3 16 6 12 7 6 3v2l5 2 12 11-2 4-4-1-8-8-15-10-12-6-13-4-14-2h-63l-11 2-16 4-16 8-12 9-8 8 6 7 5 8 3 12v1h-65l2-11 4-8 4-5-2-4-5-5-2-4 5 3 6 7h2l1-2-4-2-10-9-10-7-16-7-16-4-8-1h-63l-18 3-14 5-10 6-5 1-4 3-2-1 8-7 2-2 5-4 11-5 19-5 6-1h66l19 4 15 6 9 5 12 8 12 11-4-5-9-8-15-10-15-7-12-4-2-3 11-10 14-9 14-7 16-4 8-1h17l15 3 12 4 19 11 13 11v2l12-2 15-2-4-5v-2l-12-2-12-5-8-4v-2l-5-2-10-13-3-3v-2l-4-1h-12l-15 7-6 1h-10l-9-3-7-3v-2h-16l-6 4-1 2h-2l-2 5-7 8-8 6h-2v2l-10 4-13 3-4 2-3 5 14 2v1h-9l-10-1 3-9 5-5 17-4 9-4 10-8 8-11 7-6z",
    fill: "#4E6554"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(133,656)",
    d: "m0 0h1v357l1-1v-119l13 13 3 2-1 89 86-1 5-1-6-3v-2l-4-2-8-7-9-10v-2h-2l-7-15-2-6v-4l-10-2-14-7-10-8-10-10v-2h-2l-6-11v-5l3 4 6 10 9 10 8 7 15 8 13 4 5 16 6 11 11 12 7 6 14 8v2l31-1 9-13 7-16 4-13 4 3-1 7-3 9-4 10-9 14h186l-6 7-7 8h6v1l-5 1h-327z",
    fill: "#7B9C84"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(150,276)",
    d: "m0 0 4 5h-2v5l15 9 12 5 11 3-6 7-16 16-3 4-1 4-1 90v259l1 133 26 26-4 3-12 3-10 5-3-1v-6l-9-10-2-2v-162l7 5-7-7v-55l10-10-7 6-3 2v-200-2-46l7-2 4-4v-9l-7-8-4-4z",
    fill: "#4E6554"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(242,151)",
    d: "m0 0 4 1-16 10-11 11-7 11-5 13-3 8-9 2-16 8-8 6-9 9-6 9-4 8h-2l1 91 10 10 1 2v9l-7 6h-5l1 46 1 2h-2l1 199 8-8 2 1-24 24-4-1v-233l1-1 1-232 6 4v2l4 2 5 4 7 6 4 5-4-2-6-6v66l5-9 8-10 10-9 10-7 13-5 5-1 5-15 8-13 10-11 12-9z",
    fill: "#7D9F87"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(535,6)",
    d: "m0 0h14l2 1v2l5 1 6 3 5 1h10l9-2 12-6h12l4 2 11 14 5 5 5 4 17 7 9 2 3 1 5 8-21 3-5 1-5-5-10-8-16-9-9-4-14-4-7-1h-17l-17 3-12 4-19 11-14 12 1 2 17 6 15 8 16 12 9 9h-3l-12-11-11-7-16-8-16-5-11-2h-66l-21 5-13 5-13 8-10 8-9 8-2-1 7-7 14-11 7-5-12 7-11 10h-2v-53h3l-9-2v61h-17v-61l-8 2h2v54l-7-6-12-9-17-9-15-4 1-4 12-10 14-8 18-6 10-2h22l16 4 13 5 11 6 6 4 8 8v2l18-4 17-2h25 4l4-7 7-3 10-2 8-3h2v-2l11-8 5-6 3-5h2l2-4z",
    fill: "#7B9C85"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(582,1025)",
    d: "m0 0h113l-1 5-2 3h-2l-1 22v19h-6l-1-2v-38l-4-2-2-3v-3h-15l1 8 5 8 8 6 6 2v6l-6-1-12-7-2 9-8 17-5 5 74 1 17-3-8 1-7 1-5-9-5-10-4-14 6-12 2-7h48l2 6 4 10 5 6-1 5 4-2-2 5-9 8-13 8-9 5-16 5-11 2h-69l-16-3-16-6-10-6-10-8-8-7-1-3 4 1 9 9-4-5-6-7 8-11 3-12-8-1-1 9-6 8-6 5-3 1h-15l-7-4-7-8-2-6v-4l12-1 5 8 2 1h9l3-1z",
    fill: "#B5C6B6"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(112 1e3)",
    d: "m0 0h8v13l-6 2-2 2v11l3 3 3 1h7l4-4 2-5h-9v-1h145l-2 10-5 10 1 8 4 10 2 4v3h-2l4 7v2l3-1 1 2h-85l-16-5-12-6-12-9-4-4-2-4 1-4 6-9 2-5 2-8h-8l-2 9-6 8-5 4-4 2h-15l-7-4-6-7-2-3-1-6v-9l4-8 8-7z",
    fill: "#B5C6B6"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1743,207)",
    d: "m0 0 2 1 5 25 4 15 3 5 2 5 8 11 9 10 13 9 13 7 16 5 6 1 16 1-4-10 2 7h-9l-14-3-16-6-12-7-3-2 1-4 40-40 3 1 1 20 5 20 5 14 10 16 9 11 19 19 1 201-1 236 2 1-1 1-1 31-21 21-10 13-8 15-5 15-2 5-2 12-1 20-5-1-9-10-30-30v-2h3l2-4 9-6 18-6 1-1 10-2h12l1-2h-15l-12 3-10 3-16 8-10 8-4 4h-2l-2 4-6 7-6 10-4 10-3 6-2 8-2 17-1 6h-2v-9l3-18 6-17 7-12 8-11 9-9 13-9 8-4 9-4 15-4 23-1 2-5 8-11 12-14 5-6v-464l-11-11-2-4-10-12-5-8-18-1-17-4-16-7-12-8-11-9-10-13-8-14-6-16-2-13z",
    fill: "#CDD6CF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1896,286)",
    d: "m0 0h2l1 18v431l-1 21-11 11h-2l-1-437-18-18v-2l-4-2-4-5 15-4 16-8z",
    fill: "#4E6453"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1106,1025)",
    d: "m0 0h43l-2 1-2 5-3 2v-5h-2v46h-6v-48h-2v7l-4-3v-4l-15 1 2 10 8 9 9 4v6l-10-3-7-5-4 13-9 18h71l-6-9-6-15-1-7-5 4-6 3-7 1v-6l12-6 4-5 3-7 2-6 5 1-1 7-2 6 3-7 1-6h49l2 7 4 9 6 8-9 9 7-6 2-2 3 1-9 9-14 10-19 9-12 3-7 1h-69l-12-2-13-4-12-6-6-4-9-7-9-8v-2h3l2-4 6-10 4-11h48l3 12 2 2-3-7z",
    fill: "#B3C4B4"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1845,813)",
    d: "m0 0h9l8 3-6 8-7 9-5 8-23 2-15 4-13 6-12 7-13 12-6 8-8 13-6 15-3 14-2 17h2l1-12h1v10l-1 3-10 6-8 6-13 12-7 8h-1367l-11-11 1-3 7 8 3 3h1366l10-10-2-8v-9l9-14 3-8 1-4v-14l-1-5v-11l4-9 7-6 16-6 8-6 5-7 6-16 5-6 6-4 5-1h8l5 1h17l9-3 10-6z",
    fill: "#8EA794"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 700)",
    d: "m0 0 6 1 8 7 5 18 6 12 8 8 11 8 4 6 2 4v72l-5 9-7 6-8 6-5 6-5 8-3 9-3 12-4 5-9 4h-1l-3-23-4-16-3-9-7-13-7-11-10-11v-3h54l1 6-8 20 1-1 6-14 3-13v-24l-3-14-4-12-1-4 1-2-2-4-2 2-10-14-5-6 4 8-5-4-10 20-1-3 6-12 5-16 2-10z",
    fill: "#7B9D85"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1980,194)",
    d: "m0 0h2v83l-4 16-7 14-8 11-10 10-6-7-8-4-11-3v8l7 1 7 4 7 7 2 5v14l-6 10-9 6h-7l-1-2v-10l8-5 1-3v-7l-5-5-4-1v19h-1v-146l2-1 11 3 8 7 4 7v3h6l-7-14 1-4 18-7 10-6z",
    fill: "#B2C3B4"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(85,6)",
    d: "m0 0h12l2 1v2l5 1 6 3h21l15-7h11l6 4 8 9 6 7 3 3 3 1v2l5 1 9 4 13 3 5 5 2 4-24 3v2l-13 4-3-1 5-2v-2h3l-9-8-2-1v-2l-4-1-12-7-16-5-10-2h-22l-13 3h-5v-2l-2 1 1 2-9 4-12 7-8 6-12 11-10 13-1 3h-3l1 3-6 14-4 16v22l5 21 6 14 6 9v2h2l7 8 2 2-1 8-3 19h-2v3l-5-2-5-7-1-8-1-1v-6h-2l-4-8v-3h-2l-4-6-14-11-2-1-1-5h-2v-11l3-8h2l2-10v-20l-7-14v-12l4-6 14-11 6-7 6-12 3-8 14-5h2v-2l8-5 8-9 7-9z",
    fill: "#7B9C84"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 473)",
    d: "m0 0 9 4 6 7 4 17 6 11 5 6 14 10 4 6 2 7v68l-4 9-7 7-10 7-8 11-4 12-2 10-7 8-8 2-3-23-2-6-1-9 4-2v3l7-8 1-2h2l1-4 4-6 8-21 2-10v-25l-4-16-3-7-4-9-7-11-7-8v3h2l3 4v2h2l9 16 5 13 1 11h-54l4-5 2-5 3-4h2l2-5 9-16 6-15 4-18z",
    fill: "#7A9B84"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(880,61)",
    d: "m0 0h63l18 3 13 5 8 4 12 8 12 11v2l-4-1-4-5-2-1 7 8-2 4-6 10-3 11h-49l-2-11-5-8 3-12 10-21h10l-6-1-78-1 9 16 5 14v2l10-6 4-2h3v6l-11 6-6 8-2 10-1 1h-55l-2-6-4-11-6-7v-2l-3-1 6-7 10-9 14-8 16-6 9-2z",
    fill: "#B1C3B3"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(937,1026)",
    d: "m0 0h5l-1 11 3-10h48l4 13 7 9v3l-8 8 7-6 2-2 3 1-10 10-13 9-16 8-15 4-7 1h-69l-16-3-11-4-10-5-13-9-9-8-2-4h3l2-4 6-10 4-11h48l3 11 4 6-1 9-5 13-7 12h-8l-16-5-11-5 6 4 18 6 5 1h80l-4-5-8-19-1-7-11 7-7 1v-6l9-4 5-4 4-8 2-7z",
    fill: "#B4C5B5"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(220,237)",
    d: "m0 0 4 1 6 5 7 8 12 12 2 1-2-6-4-4-2-5 1-6 3-3 4 1-2 8 7 9 1 6-2 5 8 7 2 4-12 8-18 8-9 2-18 3-7 12-11 13-14 14-1 467 4 2 10 10v2h2l11 14 4 6h10l17 2 10 3 16 8 13 9 8 7 10 13 8 15 5 14 2 11 1 17-2 1-2-1-2 2-13-7-17-5-15-3-17-1 1-5 8-7 26-26 5-6h3l9 14 4 10 3 9 3 16v7h2l-2-21-4-15-8-16-7-9v-2h-2l-5-6-2-1v-2l-4-2-14-9-10-4-17-4-10-2-9-1 8 18 5 20 2 15v10l-1 2h-2l-2-25-4-17-8-19-6-9-8-10-20-20v-472l10-9 2-3h2v-2h2l2-4 10-11 5-8 1-3h2l3-10 4-10 3-14z",
    fill: "#EDF0ED"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1262,1055)",
    d: "m0 0 7 6 12 10 17 10 16 6 14 3 12 1h50l18-3 18-6 6-1v-2l5-3h3v-2h3v-2l9-6 9-8 2-3h2v3l-8 7-3 3 6-5h2v46l-1 7h-4l10 2v-61h18v61l17-4 7-1-1 2-19 5h-26l-9-2-15-5-13-7-10-8-6-5v-2l-16 4-14 1-5 1h-24l-21-2-12-3-2-1-2 4-7 6h-2v2l-16 9-13 5-13 3h-26l-20-5-17-9-10-8-6-5 2-1 7 5v2l4 1v2l5 2 16 8 18 5 5 1v-62l18 1v61l17-4 2-1-10 3h-3l-1-41 1-12 7 6 16 11 19 9-16-8-11-7-11-9-7-8z",
    fill: "#7A9B83"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(94,366)",
    d: "m0 0 4 2 9 6 10 3 4 1v109l-9-2-8-4-5-6-3-8v-3h-6l3 10 8 12-20 8-14 7-1-3v-81l3-13 3-8 5-10 8-11z",
    fill: "#B2C4B4"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(79,157)",
    d: "m0 0 2 1-6 12-5 15-2 10 5 2 18 8 6 2h5l7-4 3 1-11 6-5 6-3 5-2 7h6l1-5 4-7 7-5 12-3 1 56-1 50-12 3-10 6-3 3-4-2-5-5-8-10-7-12-5-16-1-6v-83l4-17 8-17z",
    fill: "#B2C4B4"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(874,474)",
    d: "m0 0h39l7 18 4 12v2h2l1-5 9-27h39v16h-8v50h8v15h-38v-15h8l-1-42-10 30-4 10-1 1h-9l-5-12-10-30-1 43h8v15h-38v-15h8v-50h-8z",
    fill: "#020101"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(178,222)",
    d: "m0 0h2l7 9 5 4 10 4 13 1v21l-4 15-5 12-9 14-9 10-5 5-4 5-8 7-4 5v479l27 27 3 4v2h2l5 9 4 8 4 10 3 13v21h-2l-1-20-2-10-2-4v-5h-2l-7-14-7-9v3l-13 4-10 4h-2l-3 3-11 7h-2v-6l16-10 13-5 7-2 2-1-26-26-1-134v-259l1-89 2-5 9-10 15-15-16-5-15-8-7-5v-6l1-1-1-3 2-17 6-15 7-11 10-10z",
    fill: "#7C9E86"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(270,65)",
    d: "m0 0 20 4 3 3-15-3h-6l-10 21-4 11-8-6-5-2v-2l-6-1v6l5 2 7 4 3 3 4 10v6h-29v-8h-2l-2 8h-72l-1-1-2-10-4-8-5-6v-3h2l2-4 8-7 13-8 12-5 12-3z",
    fill: "#B1C2B3"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1101,66)",
    d: "m0 0h78l17 4 16 8 9 7 11 9-5 5-5 7-4 15h-106l1-9 5-8 6-5 6-3h2v-6l-15 7h-2l-5-12-2 2-2-6 1-2-6-11z",
    fill: "#B3C4B4"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(649,66)",
    d: "m0 0h78l17 4 11 5 11 7 10 9 4 4-6 5-5 10-3 11h-106l3-13 7-8 9-4h2v-6l-15 7h-3l-6-15-4-8-4-6z",
    fill: "#B1C3B3"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1327,66)",
    d: "m0 0h77l14 3 10 4 11 6 9 7 7 6v2l2 1-8 9-4 12-1 5h-106l1-9 5-8 7-6 7-2v-6l-10 4-5 4h-2l-4-11v-2h2l-1-3-2 2-9-16z",
    fill: "#B1C3B2"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(416,66)",
    d: "m0 0h76v3l1-2 2 1-6 12-6 15-2 4-9-6-8-3v6l9 3 6 5 4 8 2 9h-17l-2-8h-2v8h-86l-2-11-5-9-4-5-2-2 8-7 11-9 12-6 11-4z",
    fill: "#B2C3B3"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(94,594)",
    d: "m0 0 4 2 8 6 8 3 7 2v85h-8v2l8 2v17l-12-3-10-9-4-10h25v-7l-47 1-1 5 20 1 1 8 6 10 4 4-7 1-16 6-11 6 3 16-1 4-3-7-2-11v-82l4-17 8-16 7-9z",
    fill: "#B4C5B5"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(30,135)",
    d: "m0 0h54l-6 7-12 18v1l9-13 1 2-11 18-5 14-4 20v62l3 17 6 16 4 8 7 11v2h2l7 9 6 6v2h-2l1 6v14l-4 4h-57l5 18 8 16 9 13h-3l-4-5v-2h-2v-3h-2l-1-5h-2l-6-14-5-21v-20l4-17 6-16 3-5h2l2-5 8-10 3-3-2-12-2-21-1-1v-25l4-27 1-8-4-6-8-11-8-15-4-13z",
    fill: "#7C9D86"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1777,66)",
    d: "m0 0h80l19 5 12 6 11 8 4 3v2l4 2v2l2 1-5 5-5 8-3 13h-72l-3-7-2-1-1-11-1-28-5-1v28l-1 12-5 5-1 3h-15l2-11 6-9 7-4 4-1v-5l-5 1-9 5-7 9-1-2 2-3-2-9-5-13 1-2 6 12 2 5-7-18-5-8-2 2z",
    fill: "#B3C4B4"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(468,1025)",
    d: "m0 0h114l1 2-3 7-3 2h-9l-5-5-3-4h-11l3 10 7 8 6 3h15l7-4 5-6 3-6 1-6h9l-2 10-4 8-5 7 11 11h-3l-9-9h-2l5 5 10 9 13 8 16 6 16 3h69l15-3 12-4 16-9 13-10 5-5 2-1 3 3-7 8-11 9-9 6-9 5-20 6-9 2-9 1h-51l-16-2-17-5-17-8-11-7-14-13v3l4 2 10 9 10 7 3 3-6-2-12-9-7-6-1 52 3 1-9 1v-61h-17v61l-10-1 4-1-1-56 3-1 1-4-4-1-4-2-11 11-5 2 14-14-6-8-4-10v-6h-49l-2 11-5 7-1 3h-2l6 17 7 13 4 1v1h-76l8-16 4-10 2-6h-2l1-3 7 6 9 4 4 1v18h7v-48h1v7l3-3z",
    fill: "#4D6353"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(240,931)",
    d: "m0 0h15l17 3 17 7 15 9v2l4 2 25 25h1382l26-26 10-7 9-5 8-4 9-3 15-3h17v2l-22 2-15 4-16 8-3 1v2l-5 5h2l5 17 8 15 5 8h-6l-7-10-5-9-5-15v-4l-8 7-11 11-6 7-2 1h-1388l-31-31-18-11-10-4-17-3-14-1z",
    fill: "#DDE5DE"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1957,811)",
    d: "m0 0 4 2 11 12 8 11 6 11 4 9 5 17 2 11 2 16 9-4 4-6 3-13 4-10 7-9 8-7 6-4 4-5 3-6h1v156l-2-3-4-8-9-7-8-7-6-9-4-9-4-15-4-5-8-3-3 24-5 17-8 18-8 12-9 10-5 6-4 1 6-7 10-11 1-3h2l2-6 6-10 3-7 5-23 1-12v-39l-5 4 2-4 3-4-2-20-6-20-11-20-9-11-8-8z",
    fill: "#EDF1ED"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(284,151)",
    d: "m0 0 4 2 8 13 5 12 2 6v5l6-5h2l2-4 16-16 2-1h1387l29 29 2 1v2l4 2 13 8 18 5 6 1 18 1 1 3h-19l-14-3-15-6-11-6-10-8-25-25-1382-1v2l-5 5-4 2v2h-2v2h-2l-1 3h-2v2l-5 5-11 9-14 9-21 7-6 1h-20v-2l23-2 15-4 8-4 16-12-2-5h-2l-1-10-5-12-8-12z",
    fill: "#EEF1EE"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(576,474)",
    d: "m0 0h29l9 15 16 27 1-27h-9v-15h38v15l-7 1-1 65h-18l-17-29-10-16-1 30h9v15l-1 1h-38v-16h8v-50h-8z",
    fill: "#030302"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1268,474)",
    d: "m0 0h28l7 10 9 16 9 15 1 2v-27l-8-1v-15h38v16h-8v66h-18l-9-16-18-30-1-2-1 32h9v16h-39v-16h9v-50h-8z",
    fill: "#020202"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(992,474)",
    d: "m0 0h46l11 3 6 5 3 7 1 8-4 9-6 4-5 2 9 3 6 5 3 9v7l-3 9-5 6-8 4-5 1h-50v-17h8v-49h-8z",
    fill: "#050504"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1921,97)",
    d: "m0 0h14l9 6 6 8 1 2v15l-6 9-6 5-6 2h-5v8l13-3 8-6 4-2 1-3 5 3 10 12 9 14 5 13 3 12 1 7v67l-3 17-6 16-9 14-9 11-4 4h-2l2-4 8-8 10-16 5-14 2-9 1-83-3 5-16 8-11 4 1 4 5 10v3h-6l-5-10-7-6-12-3h-1v-78l7-3 3-3v-7l-2-5-3-1v-2l-10 2-3 4-1 4h-13l-1-5 4-8 5-6z",
    fill: "#B4C5B5"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1743,957)",
    d: "m0 0h2l4 14 7 14 7 11v1h-340v-3l9-10h238l44-1 7-3 12-13z",
    fill: "#4E6554"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(751,609)",
    d: "m0 0h53l8 2 6 4 5 10v7l-3 9-9 7 6 3 2 3 1 5v16h7v16h-29l-1-28-3-5-2-1-11-1v19h6v16h-36v-16h8v-50h-8z",
    fill: "#020201"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1557,61)",
    d: "m0 0h66l19 4 16 7 15 10 11 10-1 3-3-1v4l-6 8-3 9-1 6h-90v-5l3-3h2v-17l-10 4-7 8-2 5-2 7h-6l2-10 4-8 4-5 8-5 9-2v-17l3-2 4 1 1 2v16l9 2 8 6 3 2-1-1 1-9 7-16 5-8-79 1-16 4-16 8-9 7-5 4-3 4-4-1 10-10 10-7 15-8 16-5z",
    fill: "#B1C2B2"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1079,474)",
    d: "m0 0h55l10 4 6 9 1 10-3 8-7 6-2 1 6 4 2 5v19h7v15h-28l-1-26-2-5-3-2-11-1v19h6v16h-37v-16h9v-51h-8z",
    fill: "#030202"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(299,149)",
    d: "m0 0h51 2l6 1 1-1h229l-6 7-3 4 11-11 6 1 6 4 7 8v1l-278 1-8 7-16 16-4 2-5-17-8-15-4-5v-2z",
    fill: "#4E6554"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(127,390)",
    d: "m0 0h1l1 352-1 276h1696v2h-1698v-629z",
    fill: "#90A295"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1546,66)",
    d: "m0 0h79l-2 5-5 9-5 14v5 3l-9-8-11-4-1-16-1-2-5 1-1 17-11 4-7 5-5 8-4 13 6-1 2-9 4-6 7-6 8-2v17l-4 3-1 5h-72l-3-12-6-10-5-5 4-2 4-5 12-9 16-8z",
    fill: "#B2C3B3"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1237,28)",
    d: "m0 0h5l-1 62 4-1h14v-61l6 1 1 54 7-7h2v-2l11-7 2 1-12 9-10 9-2 3 9-9 14-10 16-8 9-3 17-4h66l16 3 19 7 14 8 13 11 5 5v3h-3l-1 2-7-8-14-10-13-7-16-5-13-2h-64l-17 3-14 5-16 9-13 11-2 4 7 7 5 10 1 10h-64l1-9 4-9 7-8h2l-3-5-9-8-15-10-15-6-13-3-8-1h-63l-14 2-11 3-6 3-6 1-4 1 1-5 11-5 16-5 11-2h66l18 4 13 5 12 6 13 9 11 11 2 1-6-7-11-9-15-10 2-1 10 6 10 8 6 5v-53l-2-1z",
    fill: "#4E6454"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1182,474)",
    d: "m0 0h57v16h-7l5 18 6 19 3 13h7v16h-36v-16h8l-3-9v-2h-23l-2 10h7v17h-37v-17h8l1-5 6-21 6-19 1-5h-7z",
    fill: "#040403"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1232,609)",
    d: "m0 0h58v16h-8l7 24 7 23v3h8v16h-36v-16h7l-3-10h-22l-3 10h7v16h-36v-16l7-1 6-21 5-15 4-13h-8z",
    fill: "#020201"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1191,1088)",
    d: "m0 0 3 1-5 2 4 6-4-2-3-1 10 8 13 8 11 5 17 4h26l19-5 16-8 5-3h2v-2l4-1 1-3 5-4 1-2 14 3 21 2-3 9-7 6-17 4-12 6-7 7-6 9-5 5-3 2h-18l-7-3-6-3h-19l-13 6h-19l-8-7-8-11-7-6-8-4-8-3-11-2-7-6-2-4v-5l4-1 20-2z",
    fill: "#7B9D85"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(506,1090)",
    d: "m0 0 4 1 4 5-4-2v1l8 7 7 5 16 7 13 4 16 2 17-1 20-6 12-6 4-3h3v-2l4-1v-2l5-2v-2l3-3-6 5-2-1 4-4-1-2 8 1 12 3 20 2-1 6-7 8-16 4-14 7-9 9-7 10-6 4h-18l-11-5-4-1h-17l-12 6h-18l-6-3-7-9-7-8-8-6-9-4-16-4-7-8-1-6 4-1 21-2z",
    fill: "#7C9E86"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1529,1087)",
    d: "m0 0 6 1 16 5 17 2 9 1-3 8-5 5-7 3-15 4-11 7-7 8-7 9-6 4h-17l-7-3-6-3-13-1-9 2-9 5h-19l-7-4-10-14-7-6-6-3v-2l-7-1-14-3-5-4v-2h-2l-3-9 5-1 14-1 13-3h3l5 5 8 7 10 6 14 6 9 3 7 1h26l19-5 16-8 10-7h2v-2l5-4-12-5z",
    fill: "#7B9D85"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(49,473)",
    d: "m0 0h1l3 23 2 12-8 9-9 13-8 20-3 15v19l4 18 6 15 7 11 4 5v2l4 2 3 3-1 8-2 11-1 14-1 2-7-2-6-5-2-4-3-13-5-12-7-8-2-1v-2l-5-2-8-7-3-5-1-4v-8l4-11 1-2h2l1-7v-14l-4-11-4-9v-8l3-9 7-7 9-6 7-8 5-10 4-17 5-5 5-4z",
    fill: "#7A9C84"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(278,1091)",
    d: "m0 0 4 2 9 8 10 7 12 5 8 3 12 3 8 1h12l15-3 15-5 14-7 9-7 5-4 1-3 11 2 5 1 20 2-4 9-4 4-7 3-13 3-11 6-7 7-9 12-7 4h-18l-12-6h-19l-12 6h-19l-8-6-8-11-7-7-11-5-15-4-6-4-4-5-2-6 25-3z",
    fill: "#7B9D85"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(730,1091)",
    d: "m0 0 4 2 10 9 15 9 17 6 17 3h11l17-3 14-5 13-7 4-1v-2h3v-2l10-8 10 1 23 3v6l-6 7-7 3-10 2-9 4-6 4h-2l-2 4-6 7-6 8-5 3h-20l-9-5-4-1h-18l-11 6h-18l-7-4-7-9-7-8-10-6-10-4-12-3-5-4-4-9v-1l5-1 20-2z",
    fill: "#7B9D85"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(956,1091)",
    d: "m0 0h2l5 5 10 8 9 6 4 1v2l6 1 19 5 7 1h11l17-3 15-5 16-9 13-11 3-1 14 3 18 2-3 9-6 5-4 2-11 2-16 8-8 9-6 8-5 4-4 1h-17l-8-5-3-1h-19l-12 6h-18l-6-3-6-7-6-8-7-6-6-3v-2l-6-1-16-4-5-5-4-9 5-1 15-1z",
    fill: "#7B9D85"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2047,382)",
    d: "m0 0h1v159l-2-3-3-7-5-5-11-8-7-9-5-11-3-14-5-6-8-4v-28l9-4 3-4 5-18 5-10 9-10 11-8z",
    fill: "#EDF1EE"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1915,28)",
    d: "m0 0h4v62l2-1h13l3 1v-62l6 1-1 63 5 2 7 7 2 5 63-1 1 1v6h-61v17h61l-1 7-54-1 7 8 10 14 2 6-3-3-12-17-10-10-2-1 5 5 10 11 9 14 5 10 7 24 1 14v44l-2 20-5 17-4 9-7 12-1 4 1 2-6 7v-3l3-4-5 5-7 8-5 3-2-5 8-8 11-15 7-14 4-13 2-13v-67l-2-12-2-7-6-15-11-16-8-9-3-1-5 5-8 6-7 2h-6v-8l11-3 7-6 4-7v-15l-6-9-9-6h-14l-9 5-5 7-2 5v4l13 1 1-6 5-4h8v2l4 1 2 5v7l-5 5-6 1v-10h-31l1-10 5-10 4-5 3-2-2-4-4-3v-2l-6-3v-2l-5-2-12-7-12-5-8-2-9-1v-1h6v-2l6-2 16 6 16 9 11 8 8 8v2h3v-2l-3-1v-2l-4-2-10-9-7-5 2-1 11 8 6 6v-52h-5l4-2z",
    fill: "#4E6454"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1510)",
    d: "m0 0h158l-2 2-7 3-5 4-8 11-9 8-8 4-18 4-7 7-3 6h-25l-5-10-6-3-16-4-6-3-8-6-8-9-4-6-7-5-6-2z",
    fill: "#EEF1EE"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1058)",
    d: "m0 0h159l-2 2-8 3-5 4-8 11-9 8-11 5-16 4-7 8-1 4h-25l-6-10-10-4-12-3-11-6-8-8-7-10-5-4-8-3z",
    fill: "#EEF1EE"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2047,609)",
    d: "m0 0h1v155l-2-1-3-6-5-5-10-8-8-9-6-15-3-12-7-6-5-2v-26l7-2 6-7 4-17 4-8 8-10 11-8 6-7z",
    fill: "#EDF1ED"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2047,151)",
    d: "m0 0h1v159l-2-1-4-8-11-9-7-6-6-9-4-12-4-13-5-4-5-2-1-1v-25l6-2 6-5 4-16 4-10 8-10 13-10 5-6z",
    fill: "#EDF1ED"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1813,149)",
    d: "m0 0h59l27 1v97l-2-3-6-11-11-12-7-6-11-7-16-5-7-19-9-13-11-11-2-1v-2h-3v-2l-5-1-2-2-4-2z",
    fill: "#4E6554"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1896,904)",
    d: "m0 0h2l1 30v52l-1 10-9 1h-82l-1-3 10-6 11-9 11-15 6-14 2-6 9-3 14-7 9-7 6-5 9-12z",
    fill: "#4E6554"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(160,149)",
    d: "m0 0h79l5 1-5 4-10 7-8 7-7 9-7 12-4 13-20 8-11 8-10 9-7 10-4 7h-1v-68l7 6 2 1-9-9v-24z",
    fill: "#4E6554"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(150,904)",
    d: "m0 0 3 1 4 7v3h2l7 8 10 9 7 4 5 3 15 5 4 13 5 9v3h2l7 9 8 8 6 4v2l5 1 4 3h-6l-2 1h-86z",
    fill: "#4F6655"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(135,133)",
    d: "m0 0h231l-1 2h-20l-2 1 11 11-4 4v-2l-51 1-15 1h-36l-2 1-7-2h-89v25l-7-6-2-1v-2l-4-2-1-1-1 231h-2v-235l1-25z",
    fill: "#76967F"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(774,474)",
    d: "m0 0h38v16h-8l1 39 3 6 4 2h11l4-4 1-3 1-40h-8v-16h38v16h-8v42l-4 12-8 8-9 4-7 1h-13l-12-3-8-6-4-5-4-10v-43h-8z",
    fill: "#040403"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1558,1025)",
    d: "m0 0h63l-4 14-4 6-4 5-11 6h-4l-1-5 11-6 5-5 3-7 1-6-15-1-1 5-4 3-1 40h-6v-47h-2v6l-4-4v-3h-16l4 13 5 5 4 3 7 3v6l-6-1-10-6-1-1-5 15-8 15-4 1h83l15-4 16-8 13-10 4-5h3l-2 4-7 6-4 4-12 8-11 5-13 4-12 2h-69l-15-3-14-5-9-5-7-4v-2l-4-2-10-9-1-3 4 2 4 3-6-7 7-8 3-7 2-7 1-1h47l3 9 2 3-3-11z",
    fill: "#B5C6B6"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1746,1083)",
    d: "m0 0 24 8 13 3 8 1v1h-9l-10-1-8 7 2 4 4 4 9-2 13-3 4-5 1-3h-5v-1h11l-2 7-7 7-4 2-12 2-14 7-8 8-6 9-6 5-2 1h-18l-13-6h-19l-8 4-3 2h-19l-6-4-6-7-7-9-2-1v-2l-5-2-8-4-17-4-6-5-3-6v-5l18-1 13-3h3l4 5 16 12 8 3v2l16 4 17 3h9l14-2 16-5 14-7 12-9 3-3h2v-2l-3 1v-2l-5-1-12-5z",
    fill: "#7B9D85"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(483,474)",
    d: "m0 0h73v28h-14l-4-9v-3h-25v15h16v16h-16v19l24-1 5-15h15v32h-74v-16h8v-50h-8z",
    fill: "#050504"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1929,777)",
    d: "m0 0 9 1 8 7 4 6 1 5v9l-3 8-5 6-10 5h-5v8l12-3 8-5 3-3 4 2 10 11 7 11 5 12 3 11v7l-16 8-12 5h-5l-6-4h-3l8 4 7 7 5 10v3h-6l-5-10-7-6-11-3-1 15 6 2 1 4h40l2 4-1 2h-23v2h5l-3 10-6 8-10 6-11 2v-5l2-2 11-3 5-4 5-9 1-4h-17l-2 4-6 2v-114l7-1 3-5-1-8-2-3-5-2-1-5z",
    fill: "#B5C6B6"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1468,474)",
    d: "m0 0h73v28h-15l-4-11-24-1v15h16v16h-16v19l24-1 4-13 1-2h14v32h-74v-16h9v-51h-8z",
    fill: "#040403"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(842,133)",
    d: "m0 0h469l1 3-5 3-5 5v5l-7 2v-2l-73 1h-98l-53-1-1 2-3-3 3-4h2l2-4h2v-2h2l1-3h-222l-15-1z",
    fill: "#75957F"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(658,609)",
    d: "m0 0h73v29h-14l-3-8-2-4-24-1v16h16v15h-16v19h25l2-9 2-7h14v32h-73v-16h8v-50h-8z",
    fill: "#030202"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(194,813)",
    d: "m0 0 11 1 14 9 10 3h17l5-1h9l9 4 5 5 3 4 4 13 4 6 8 7 8 4 9 3 8 7 3 5 1 10-1 6v20l5 12 5 7 2 5v10l-3 7-7-6-15-11-3-3-1-17-3-14-6-15-8-14-10-12-13-10-12-7-15-6-10-2-11-1h-10l-9-12-6-7v-2h-2l-2-4z",
    fill: "#7A9A83"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1394,609)",
    d: "m0 0h73v29h-14l-3-6-2-6-25-1v16h16v15h-16v19l25-1 4-14 1-1h14v32h-73v-16h8v-50h-8z",
    fill: "#010000"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1718,188)",
    d: "m0 0 4 1 12 10 13 8-1 5-2-4v13l3 16 8 19 8 12 8 10 13 10 12 7 15 6 14 3 18 1 8 11 9 11v3l-7 3-9-1-18-10-8-2h-14l-6 1h-10l-8-3-7-7-3-10-5-10-3-3v-2l-14-7-11-4-8-9-2-5v-11l1-5v-15l-5-15-7-10-1-3v-7z",
    fill: "#799A83"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h155v1l-13 2-11 6-4 1h-13l-8-3-7-4-4-1h-10l-10 5-7 9-7 8-9 6-11 4h-6l-1 9-4 9-6 9-9 8-8 6-4 7-1 4v8l3 8 4 8 1 3v14l-8 20-1 7h-1z",
    fill: "#EDF0ED"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(591,608)",
    d: "m0 0h20l11 6 1-5h19v32h-20l-7-10-5-3h-16l-6 4-5 6-2 5v14l4 8 5 5 7 3h9l7-3 5-4 2-3h23l-2 7-8 11-10 7-10 4-5 1h-12l-7-1-10-4-9-7-6-7-4-7-3-11v-11l2-8 4-9 7-9 8-6 9-4z",
    fill: "#030302"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1155,608)",
    d: "m0 0h20l11 6 1-5h19v32h-21l-2-5-4-5-5-3h-16l-6 4-5 6-2 5v14l3 7 5 5 8 4h9l7-3 5-4 2-3h23l-2 6-6 10-9 7-5 3-8 3-8 1h-9l-7-1-10-4-9-7-6-7-4-7-2-5-1-6v-12l2-7 3-8 7-9 9-7 10-4z",
    fill: "#030302"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1405,472)",
    d: "m0 0h10l13 4 4 3 1-5h19v31h-21l-6-9-4-3-5-1h-11l-7 4-5 6-2 5v15l3 7 8 7 2 1h13l8-4 5-6h23l-3 9-7 9-9 7-11 4-6 1h-13l-12-3-10-6-9-10-4-10-2-8v-10l3-12 5-9 9-9 9-5 5-2z",
    fill: "#020202"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(713,472)",
    d: "m0 0h12l11 4 6 4v-6h18v31h-21l-4-7-5-4-4-2h-12l-9 5-4 6-2 5v12l2 6 4 6 7 5h15l7-4 4-6h23l-1 5-5 9-8 8-11 6-11 2h-13l-14-4-11-8-6-8-5-11-1-7v-8l4-15 7-10 8-7 10-5z",
    fill: "#020202"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1311,133)",
    d: "m0 0h240l-2 4-4 1-2 4-6 7-8 7-6 5 2-4 7-7h-171l-57-1-1 2-2-2v-5l8-8h3z",
    fill: "#799A83"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(49,699)",
    d: "m0 0 2 3 2 25-2 5-8 9-9 14-3 5-4 12-3 8-2 14v12l3 18 6 15v4h2l7 13v2h2l6 8 5 5-1 7-1 19-1 3-6-1-8-7-4-17-5-10-9-10-11-8-4-6-2-6v-8l3-9 4-6 1-5v-14l-5-12-3-7v-10l4-8 8-7 10-8 6-8 4-11 3-13 4-5z",
    fill: "#7B9D85"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1331,61)",
    d: "m0 0h64l17 3 12 4 18 10 13 11 3 3v2h-3v-2l-4-2-9-8-15-9-17-5-6-1-77-1 7 12 2 4h3v3h-2l4 10v3l9-6 8-2v6l-10 5-6 7-2 4-2 9h-56l-3-12-4-8-7-7 2-4 11-10 13-8 11-5 9-3z",
    fill: "#B3C4B4"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(366,133)",
    d: "m0 0 15 1h224v2l-6 5h-2l-2 4-17 17v-3l9-9h-163l-65-1-1 2-6-2 1-3-10-9-1-2 7-1h16z",
    fill: "#7D9F87"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1106,61)",
    d: "m0 0h63l17 3 10 3 14 7 12 9 10 9v2l-4-2-10-9-14-8-8-4-17-4-78-1 6 10 1 6v3h3l4 10v2l14-7h3v6l-11 6-5 6-3 7-1 6h-56l-3-13-6-9-2-4-3-1 2-4 11-10 13-8 8-4 16-5z",
    fill: "#B1C2B2"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(654,61)",
    d: "m0 0h63l18 3 14 5 15 9 10 8 6 6v2l-4-2-7-7-15-10-10-4-17-4-78-1 7 11 5 12 2 5v3l16-7h2v6l-12 6-5 6-3 12-1 1h-55l-2-7-4-10-6-8-3-3 11-11 14-9 12-6 19-5z",
    fill: "#B2C3B3"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(428,61)",
    d: "m0 0h63l18 3 16 6 12 7 11 9 7 6-1 3-3-1-7-8h-2l6 5 3 4-2 4-5 8-4 14h-55l-3-9-4-8-9-6-5-2v-6l5 1 10 5 2 2 5-13 6-14 2-3-1 1-2 1 1-4-76 1-16 4-16 8-11 9-6 6-3-1 12-12 20-12 14-5z",
    fill: "#B1C3B3"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1783,61)",
    d: "m0 0h64l17 3 12 4 16 9 5 3v2l6 3v2l4 2 3 3v2h-3l-5-6-11-8-10-6-15-5-9-2h-80v2l2-2 8 13 5 14-1 4-6-16-1-1 6 17-1 4v1l6-7 9-5 5-1 1 1v5l-12 6-5 8-3 11h-56l-3-12-6-10-6-5v-2l8-7 10-8 12-7 13-5 13-3z",
    fill: "#B3C4B4"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(817,133)",
    d: "m0 0h25l15 1h223l-2 4h-2v2l-4 4h-2l-2 4-10 9-6 6-2-1 11-11 1-2-49 1h-115l-65-1v2l-3-1-1-4 10-10 1-2-2 1h-19z",
    fill: "#7C9E86"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1488,1056)",
    d: "m0 0 7 6 9 7 2 1v2l5 2 16 8 13 5 14 3 13 1h48l19-3 19-6 12-7 10-7 12-10 1-2 3 1-7 7 3-1v53l-11 1-12-4v-2l-9-3-11-8-8-7v-2l-16 4-16 1-2-1-1 4v-2h-24l-21-2-19-5-3-1 8 3-4 5h-2v2l-14 9-12 6-8 1-3 1h-9v-43l1-10 8 6 7 5-14-12-4-4z",
    fill: "#799A83"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1388,1026)",
    d: "m0 0h5l1 2-1 8 3-9h48l4 13 4 6 3 3-2 5-4 5 7-7h2l-2 4-11 10-13 8-10 5-17 5-8 1h-68l-16-3-16-6-10-6-9-7-10-9v-3h2l6 7 11 9 16 8 16 4 80 1-9-16-4-12v-4l-11 7-7 1v-6l10-5 5-5 3-7z",
    fill: "#B4C5B5"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(201,61)",
    d: "m0 0h67l18 4 12 5 16 9 13 12 2 3-6 5-6 12-2 10h-57l-3-12-4-6-7-4-5-3v-6l6 1v2l5 1 7 6 4-10 10-21 1-1 11 1 9 2-11-3-11-2-80 1-15 4-16 8-12 9-4 5h-2l-1 2-2-1v-2l8-7 12-9 10-6 16-6z",
    fill: "#B4C5B5"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1035,1055)",
    d: "m0 0 4 2 9 9 15 10 16 8 22 6 11 1h52l14-2 17-5 19-9 12-9 10-9 1-2h2l-2 4-2 3 1 1v37l-1 17-11-2-13-5-14-8v-2l-4-1-3-5-2-3 3-2-17 5-20 2-4 1h-25l-24-3-10-2-10 9-14 9-14 6-5 1-6-1h-3v-53l8 6 2 1-14-13z",
    fill: "#7C9C85"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(785,1055)",
    d: "m0 0h2l-2 4-9 9-16 11 9-5 11-9 3-2 1 1v52h-15l-14-6-12-8-10-9-3-1-14 3-14 1-5 1h-24l-25-3-13-3-4 5 5-4h2l-1 3h-2v2l-5 2v2l-4 1v2l-9 5-4 2v-2l-12 5-8 3-6-1v-53l5 3 9 8 10 6-8-6-11-9-6-5-2-4 4 2 12 11 13 8 15 7 17 5 16 2h51l14-2 15-4 13-5 9-6 10-7 10-9z",
    fill: "#7C9C85"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(93,364)",
    d: "m0 0h2l-2 4-8 8-7 10-6 12-4 13-1 6v81l1 2 17-9 14-5v-2l-6-8-3-7v-5h6l5 12 5 5 9 4 6 2v55l-7 2-10 4-7 6h-2v3l-4-2-7-7-9-13-8-16-4-13-1-6v-79l2-10 2-7 7-16 8-11 9-10z",
    fill: "#B2C3B3"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(91,358)",
    d: "m0 0 2 3-1 5-8 8-7 9-8 16-2 5-2 7-2 10v79l4 17 8 16 7 11 11 12 2 1v-3l9-7 10-4 7-1v9l-12 3-5 4-4 5-2 5v12l3 7 5 5 5 4 10 2v9l-11-2-10-6-7-6-7 7-9 12-5 8-4 10-4 13-2 16-1 44-6 4v-49l2-14 7-21 8-15 6-8 8-7 5-6-5 3-9 10-9 14-6 11-3 7-1-3 8-17 10-14 6-8-52-1-1 2-1-8 61-1v-12l1-4h-62l1-8 1 2 53-1-8-9-10-15-4-7 1-3 11 18 8 10 8 9 2 1-7-8-9-10-6-9-8-18-4-13-2-12v-63l2-14 6-20 8-15 8-10 9-10z",
    fill: "#4F6655"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1928,551)",
    d: "m0 0 9 1 4 2v2l4 2 5 8 1 2v14l-6 9-5 4-6 3h-6v8l10-2 8-4 7-5 9 9 5 6 8 16 4 12 1 11-6 4-24 10h-3l5 4 4 8 2 7h-6l-5-10-7-6-13-3v-78l7-3 3-5-1-8-3-3-5-2z",
    fill: "#B5C6B6"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1149,1025)",
    d: "m0 0h183l2 8 4 11h-2l-4-8-1-9-49 1v-2h-8l-1 8-6 9-9 6h-16l-9-6-6-9-1-8-8 1h-49l-1 9-3 5-1-2 3-8v-4h-4l-3 9-4 7-5 4-9 3v6l8-3 10-5 6 18 7 12 3 2h-75l9-19 3-8 1-6 10 6 8 3-1-6-8-3-7-7-3-7-1-7h16l2 5 1 1 1-6h2v48h6v-46h2l1 4 4-6z",
    fill: "#7C9B85"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1464,26)",
    d: "m0 0h23l18 4 12 5 8 4v2l4 1v2l8 4v2l4 2 1 3 17-4 18-2h24l24 3 21 6 14 7 15 10 10 9 6 5v2l-4-2-8-8-13-9-11-6-12-5-16-4v2l-2-1 1-2h-70l-15 3-19 7-9 5-11 8-12 11-3 1v-2l8-7 9-8 1-1-13 10-2-1v-52l-5-2v62l-18-1v-61l-16 4-4-1 8-3z",
    fill: "#799A83"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(133,656)",
    d: "m0 0h1v357l1-1v-119l13 13 3 2-1 89 86-1 3-1 6 4 7 8 3 3-1 2-8-7-6-6-4 2-12 11-1 2h-90z",
    fill: "#7D9F87"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1542,149)",
    d: "m0 0h222v2l-4 4-9 15-5 15 1 4 3-7h2l-2 12-5-3-27-27-164-1-9-10-3-2z",
    fill: "#4D6453"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(53,509)",
    d: "m0 0h2l-2 4-9 11-8 15-5 15-3 12h62v17h-62l2 6h53l-3 5-9 12-8 14-4 10 8-16 7-11 11-13 5-4 2 2-16 16-7 11-7 16-4 13-2 14v48l3-3h2v-44h1v56h-1l-1-10-4 4v10l3 15 5 15 6 12 7 10 9 11 5 5-1 2-12-12-12-17-8-17-5-17-3-24-1-3v-24l1-2 2-20 3-13-3-1-6-7-9-13-6-14-4-15-1-6v-19l3-15 8-20 10-14z",
    fill: "#7A9C84"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(93,138)",
    d: "m0 0h2l-1 4-8 7-4 6h2l2-5h2l2-4 7-5 6 5 8 4 10 2v56l-9 3-8 4-4 5-3 8h-6l2-9 4-6 7-6 7-3-6 2-3 2-8-1-19-8-7-4 1-10 6-18 5-9-3 4-6 13-4 17v83l4 17 7 14 9 12 2 4 4 2 2 4-5-2-11-13-9-15-5-13-3-13v-77l4-16 5-12 9-15 11-12z",
    fill: "#B4C5B5"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(49,925)",
    d: "m0 0 2 2 1 17-2-1-1-13-7 5-4 16-4 10h-2l-1 4-8 9-9 6-6 7-1 2v15h2l5 11 1 4v13l-3 9-4 7-1 4v11l1 4h2v2l4 2 13 10 1 4 3 1 1 5h2l4 12 1 4 9 3 12 6 8 6 1 4h2l3 5v2l3 1 4 4 8 2 8-1 14-7h19l16 7h10l8-4 4-5 1-3 5-5 8-6 1-2 10-5 17-4 3-1 4-7h-10l-17-3-2 4-10 8-8 5h-2v2l-8 4-13 4-5 2-11 2h-19l-16-3-10-4-4-1v-2l-5-1-14-8v-2l-4-1v-2l-4-2-7-6-10-13-11-20-4-13-2-11v-16l3-18 4-10 8-16 9-13 6-6 2-5 2 4-1 5-9 10-9 14-6 17-3 13v23l4 16 6 15 10 14 9 10 9 8 7 5 5 3 10 4 7 3 21 4 19-1 15-4 12-5 13-7 3-1v-2l5-3 5-5 9 1 5 1 20 2-2 8-8 7-17 4-8 4-10 9-9 12-4 3-3 1h-18l-12-6h-19l-13 6h-17l-5-3-8-9-5-6v-2l-4-2-10-6-8-3-6-1-5-16-6-9-8-8-9-6-6-10v-11l3-7 5-12v-14l-3-8-4-7-1-4v-8l3-9 4-5 5-4 5-3 8-8 6-12 4-17 8-7z",
    fill: "#465B4B"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1621,1025)",
    d: "m0 0h184l3 6v2h3l1 11 1 30h5v-32l1-9 3-2 2-5h16l-3 12-7 8-2 2-8 3-1 5 9-3 9-5 9 23 5 7v2h-73l8-15 5-13 1-5 11 7 7 2-2-6-7-3-8-8-2-4-1-8h-6l4 12 1 4-4-4-3-10v-2h-48l-9-1-1 9-6 9-8 5-4 1h-8l-8-3-7-6-5-10v-5h-8l-1 3v-2l-47 1-2 1z",
    fill: "#7A9B84"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(492,1027)",
    d: "m0 0h49l3 12 8 12-12 12 8-7 6-5v3l-5 6-15 11-16 8-9 3-15 3h-69l-16-3-16-6-15-10-12-11-2-3 4 1 8 8 15 10 12 5 12 3h80l-8-14-5-14v-3h2l1-4 5-9z",
    fill: "#B4C5B5"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(269,151)",
    d: "m0 0h15l7 10 6 12 2 11 2 2v4l2 1-14 11-9 5-12 4-12 2h-15l-3-17-6-9-7-6-3-3 8-10 10-7h2v-2l16-6z",
    fill: "#7C9E86"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1917,26)",
    d: "m0 0h21l18 4 3 3-7-1-15-4v62h-18v-62l-6 2v54l-7-6-11-8 5 4 12 11 5 4v2h-3l-7-8-9-7-15-9-14-6-15-4-6-1h-67l-18 4-17 7-4 1v2l-9 5-11 9-7 7h-2l2-4 10-9 11-8 14-8 14-6 16-4 23-3h24l24 3 11 3 2-4 9-7h2v-2l16-9 4 1 1-1 1-2 14-4z",
    fill: "#7B9C85"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(787,26)",
    d: "m0 0h23l21 5 16 8v2l4 1 2 1v2l4 1 5 5 5 4 1-2 26-3 5-1h25l23 3 11 2 7-7 8-6 3 1-14 11-2 2 19 8 16 10 14 12 4 4v2l-4-2-10-10-13-9-17-8-19-5-6-1h-66l-21 5-20 9-14 10-12 11-2-1 9-9 13-10 12-7-4 1-11 7-15 12v-54l-6-2v62l-17-1v-61l-16 4-4-1 8-3z",
    fill: "#7B9C85"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1239,26)",
    d: "m0 0h22l4 2h-6v61l-18 1v-61l-6 1 1 37v17l-8-6-13-10-5-2 11 7 10 9 8 7v2l-4-2-10-10-12-8-16-8-16-5-11-2h-66l-18 4-12 4-5 3h-3v2h-3v2l-8 4-10 8-8 8-2-1 12-12 12-9 22-11 15-5 11-2 17-1 1-3v2h25l23 3 11 3v-2l11-9 13-8 11-5 14-4z",
    fill: "#7B9C85"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(561,26)",
    d: "m0 0h24l20 5 10 5 13 8 10 9v2l18-4 17-2h24l25 3 17 5 12 5 9 5 9 6 10 8 6 5 2 5h-2l-4-5-11-9-2-1v-2l-6-2-12-7-16-6-17-3h-65l-21 5-10 4-15 8-11 9-9 8-2-1 8-8 10-8 9-6-9 5-11 9-4 2v-53l-6-2v61l-17 1v-62l-17 4-4-1 8-3z",
    fill: "#799B83"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(267,1025)",
    d: "m0 0 4 1 43 1 5 14 7 9v2l3 1-11 11-16 11-15 6-12 3-7 1h-69l-9-2-16-4-15-8-13-10-8-7v-2l4 1 8 8 13 9 14 6 11 3h81l-4-7v-2h2l-5-11-3-9 1-7 4-8z",
    fill: "#B3C4B4"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(132,1055)",
    d: "m0 0h2l4 5 11 9 14 9 13 6 17 5 16 2h51l19-3 7-2h5v-2h5v-2l6-3h4v-2h3v-2l7-4 3-1v-2l6-4 5-5 3-4h2l-1 4-10 9-1 1 7-6h2l1 27 3 1-1 2-3-2v26l6 1v-61h17v61h8l-3 2-7 1h-12l-17-3-10-3-10-5-9-5-11-9-4-4-15 3-20 2h-24l-25-3-9-3-13-4-16-8-14-10-9-9-3-2z",
    fill: "#7B9B84"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(135,398)",
    d: "m0 0 7 6 7 7 3 1-2 1 1 199 8-8 2 1-24 24h-2z",
    fill: "#7D9F87"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(979,609)",
    d: "m0 0h72v29h-14l-3-8-2-4-23-1v16h15v15h-15v19h11v16h-41v-16h9v-50h-9z",
    fill: "#020101"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(110,26)",
    d: "m0 0h22l21 5 16 8 5 3v2l4 2 8 7-1 2h-2l-3 2 13-4 10-2h61l14 3 19 7 13 7 8 5v2l5 2v2l4 2 6 5 2 4-4-2-11-10-10-7-19-9-19-5-8-1h-63l-18 4-9 3-10 4-11 7-10 8-7 7h-2v2h-2l2-4 12-11 15-10-8 4-12 9-4 4h-2v-53l-6-2v62l-17-1v-61l-15 4h-4v-2z",
    fill: "#7A9B84"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2047,1059)",
    d: "m0 0h1v87h-95v-1l15-2 6-4 10-13 9-8 8-4 7-2h6l1-10 8-15 8-8 10-7 4-6z",
    fill: "#EEF1EE"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1794,933)",
    d: "m0 0h14l2 16 5 9 7 6 4 3-2 4-10 10-11 7-16 6-6 1h-12l-5-5-8-14-5-13-1-8h-2l2-4 3-1v-2l14-8 15-5z",
    fill: "#7C9E86"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(191,844)",
    d: "m0 0 5 5 7 10 3 6v3h2l4 14 1 5v19l-14 2-7 2v2l-7 6h-2l-2 5-4 1-11-11-7-11-5-12-2-8-1-13 3-5 10-6h2l1-3 9-3 11-4h5z",
    fill: "#7C9D86"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1954,818)",
    d: "m0 0 4 2 9 10 9 13 6 14 4 15 1 8v65l-2 14-4 13-9 17-8 10-8 9h-2v-3l-4-1-6-5-7-3-7-2-1-1v-48l12-3 9-5 12 5 14 7 4 3-1 10-7 21 6-13 3-13v-88l-4-15-5-12-8-11-7-8-3-2z",
    fill: "#B4C5B5"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1869,222)",
    d: "m0 0 4 2 6 5 8 11 7 14 2 6 1 7v14l-13 7h-2v2l-14 6-13 2-7-9-5-5-5-13-2-9-1-10v-12l12-1 9-4 7-5z",
    fill: "#7C9E86"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1304,149)",
    d: "m0 0h229l-6 7-2 3 10-10 6 1 5 3 7 7 1 3h-238l-10-11-2-1z",
    fill: "#4E6554"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(936,1025)",
    d: "m0 0h170l3 11 2 7-4-4-2-7v-5h-48l-1 2v-3h-8l-1 7-2 5-6 7-7 4h-16l-10-7-5-9-1-7-8 1h-48l-2 10-2 1 1-8 1-4-5 1-4 12-5 6-6 4-6 1v6l8-3 8-5h2l5 15 7 14 3 3h-82l-15-4-10-4-7-5 2-1 17 8 11 3 8 1 2-5 7-14 4-15 7 6 9 5 5 1 1 18h5l1-1 1-47h1v7h2l2-7z",
    fill: "#7C9E86"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(240,933)",
    d: "m0 0h14l17 3 12 5 7 4v2l8 5-3 14-7 16-9 13h-12l-15-4-9-4-11-8-9-9-1-3 8-6 6-7 3-7 1-5z",
    fill: "#7D9E86"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1309,609)",
    d: "m0 0h69v29h-13l-4-12-7-1v50h9v16h-38v-16h8v-50h-7l-2 9-2 4h-12l-1-1z",
    fill: "#020201"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1777,150)",
    d: "m0 0 19 5 10 4v2l5 2 10 9 5 5-1 3-4 3h-2l-2 4-3 1v3h-2l-3 10-1 10h-24l-18-5-10-6-7-5 2-10 5-12 8-15 5-7z",
    fill: "#7C9E86"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(840,609)",
    d: "m0 0h69v28l-1 1h-12l-4-10v-3h-7v50h8v16h-38v-16h9v-50l-7 1-4 12h-13z",
    fill: "#020201"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1691,26)",
    d: "m0 0h23l20 5 16 8 5 3v2l4 2 8 7h-3v1l-1 2-12 5-15 8-12 9-6 5h-2v-54l-5-1v61l-18 1v-62l-6 1v31l-7-6-16-16 2-1h-4-3l8-5 17-5z",
    fill: "#7B9C84"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1976,399)",
    d: "m0 0 2 1 4 15v90l-4 16-6 12-1-2 4-10 4-15 1-6-5-2-15-7-8-3-9 1 5-5 3-1 2-5 4-9 1-2h-6l-1 5-6 8-8 5-2 1h-7l-1-2v-50l12 2 7 5 4 6 2 4v3h6l-4-10-6-8-1-2 15-5 16-8 2-2-4-16z",
    fill: "#7B9D85"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1196,984)",
    d: "m0 0h235l-6 7-7 6h-231l-2-2z",
    fill: "#4E6554"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(75,845)",
    d: "m0 0 1 2-6 19-2 9 4 1 19 9 11 3-6 8-3 5-2 7h6l1-6 4-6 8-6 7-2h4v50l-10-2-7-4-5-6-2-5v-3h-7l7 14 5 6-13 4-14 6-6 4 3 16 3 8 4 9-1 2-6-10-5-17-1-6v-83l4-16 4-9z",
    fill: "#7B9B84"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(958,984)",
    d: "m0 0h214l11 11-1 2h-235l2-4z",
    fill: "#4E6554"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1163,1026)",
    d: "m0 0 5 1-1 7-2 6 3-7 1-6h49l2 7 4 9 6 8-9 9-1 3-16 10-14 5-9 2-8-1-6-9-6-15-1-7-5 4-6 3-7 1v-6l12-6 4-5 3-7z",
    fill: "#B3C5B5"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1953,364)",
    d: "m0 0 4 5 9 9v2h2l7 12 2 7 1 7 3 14-10 6-11 5-12 4 5 6 5 9v4h-6l-5-10-5-5-7-3-8-2v-56l13-3 9-6z",
    fill: "#B4C5B5"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1914,1056)",
    d: "m0 0h2l-3 6v55l6 1v-61h18v61l19-5 16-7 14-9 4-2-4 5-6 4h-2v2l-17 8-16 5-15 2h-8l-20-4-12-5-12-6-14-11-2-3 4 1v-3h3v-3l-2-1 12-4 12-7 10-7 10-9z",
    fill: "#7A9B83"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1953,818)",
    d: "m0 0 5 5 12 14 7 14 4 13 1 5v88l-4 16-7 13-1-2 5-12 4-15v-5l-7-4-15-7-8-3-8 5-7 2h-5l1 49h-3v-71l6-3 2-3h17l-1 5-4 8-8 6-9 2-2 6 13-4 9-6 4-6 3-9-4-1v-2h23l-1-5-40-1-1-3-6-3v-16l12 3 8 7 3 5 1 4 6 1-4-9-4-6-7-6-6-3 4-1 6 4 7-1 19-8 5-3h2l-3-15-5-13-6-10-9-11-5-6z",
    fill: "#7A9B84"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(766,1026)",
    d: "m0 0h9l2 10 8 9 8 3h13l7-4 5-6 3-6 1-6h8l-1 10-5 9-5 7-2 1 4 5 14 11 8 5 7 3 11 4 16 3h69l15-3 11-4 14-7 13-10 4-2 4-4 6 1-1 3h-2l-12 11-4 1v2l-11 7-5 1v2l-18 6-13 3-9 1h-50l-18-2-16-5-17-8-15-10-11-11-2-1 5 6 10 8v2l4 2 9 6-2 1-13-9-8-7-1 32v3 19h-6v-61h-17v61l-10-1 4-1-1-52-20 15-4 1 4-4 14-10 9-9-1-3h-3-3l1-2-5 3 1-6-5-6-4-10z",
    fill: "#506656"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(270,65)",
    d: "m0 0 20 4 3 3-15-3h-6l-10 21-4 11-8-6-5-2v-2l-6-1v6l5 2 7 4 3 3 4 10v6h-29v-8h-2l-2 8h-17l2-10 6-9 8-5 4-1 1-6-10 4-8 5-3-9-3-8-6-12v-2h-2l2 6-3-3-2-5z",
    fill: "#799A83"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(987,6)",
    d: "m0 0h14l13 7h21l7-2v-2l6-3h14l5 3 12 16 9 6v2l11 3 5 2 10 2 6 7v2l-21 3h-5l-10-9-11-7v-2l-5-1-10-5-13-4-12-2h-18l-15 3-12 4-16 9-13 10-5 4-11-1-15-2 2-5 4-4 15-3 13-7 9-7 8-11 6-5z",
    fill: "#7B9C85"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(535,6)",
    d: "m0 0h14l2 1v2l5 1 6 3 5 1h10l9-2 12-6h12l4 2 11 14 5 5 5 4 17 7 9 2 3 1 5 8-21 3-5 1-5-5-10-8-16-9-9-4-14-4-7-1h-17l-17 3-12 4-19 11-14 12v2l-12-2v-2l-15-1 4-7 7-3 10-2 8-3h2v-2l11-8 5-6 3-5h2l2-4z",
    fill: "#7B9C85"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(315,1026)",
    d: "m0 0h8l2 9 6 8 5 4 7 2h8l9-4 7-8 2-5 1-6h9l-2 10-4 8-5 7 2 4-5-2 9 9 14 10 12 6 13 4 12 2h69l15-3 14-5 14-8 13-10 4-5 4 1 3 2-8 7-6 5h-2v2l-4 1v2h-3v2l-10 5h-2v2l-9 3h-3v2l-20 4-9 1h-51l-15-2-17-5-17-8-14-10-11-10 5 8-3-1-1 53-1 1h-5v-61l-2 1h-13l-2-1v61l-10-1 4-1v-25h3l-3-3v-25l-11 9-2-1 10-9 5-4 1-3-4-1-5-1-2-4-7-10-2-7z",
    fill: "#526958"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1666,6)",
    d: "m0 0h11l14 7 6 1h11l10-3 10-5h12v2l4 2 9 10 7 8 3 1v2h3v2l4 1 12 4 9 2 5 4 2 5-20 3-6 1-9-9-14-9-11-6-16-5-11-2h-18l-16 3-12 5-12 6h-3v2l-14 10-5 6-4-1-6-2-15-2 2-5 4-4 17-4 9-3v-2l10-7 8-11 6-6z",
    fill: "#7C9D86"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1994,734)",
    d: "m0 0 5 5 8 10 3 5 2-2 3 5-1 4 4 11 3 10 1 7v24l-4 16-7 15-2-1 7-17 2-5 2-12h-61v-17h61l-2-6h-54l12-16-5 4 2-4 4-7 4-2 4-5 8-18 5 4-4-5z",
    fill: "#7B9C85"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1213,6)",
    d: "m0 0h13l6 3v2l7 1 1 1h21l7-2v-2l8-3h12v2l5 1 10 14 6 5 5 3v2l11 3 5 2 9 2 6 5 2 4-21 3h-6l-10-9-21-13-14-5-17-3h-16l-20 4-15 7-9 3v2l-6 4-12 10-12-1-14-2 3-6 4-3 16-4 8-4h3v-2l8-6 9-12 6-5z",
    fill: "#7B9D85"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 510)",
    d: "m0 0 5 4 10 14 3 5 3 7 5 16 1 6v25l-4 16-7 17-4 5-1 3h-2l-2 4-7 8v-3l-4 1-3-10-5-13-7-11-8-10-3-3v-2h53l2-6h-61v-17h61l-4-17-6-15-7-12v-2h-2l-3-4v-2h-2z",
    fill: "#7A9B84"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1241,1056)",
    d: "m0 0 18 1v61l17-4 2-1-10 3h-3l-1-41 1-12 7 6 16 11 19 9 8 1v2l-2 1-1 4-5 4h-2v2l-16 9-13 5-13 3h-26l-20-5-17-9-10-8-6-5 2-1 7 5v2l4 1v2l5 2 16 8 18 5 5 1z",
    fill: "#7B9D85"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(763,6)",
    d: "m0 0h10l15 7 6 1h9l9-2 6-2v-2l6-2h12l4 2 11 14 6 5 4 4 13 6 14 3 6 7v2l-20 3-6 1-6-7-10-7-15-9-18-6-11-2h-19l-15 3-8 3-17 8-12 9-9 7-11-1-15-2 2-4 6-5 16-4 7-2v-2l8-5h2l2-4 4-5 6-8 5-3z",
    fill: "#7B9D85"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 950)",
    d: "m0 0h1l2 6 2 2v3l4 2 4 5v3h2v3h2v3h2l7 15 5 17 1 6v25l-4 15-4 10-5 10h-2l-2 6-9 11-10 10-11 7-18 10-18 5-6 1h-21l-16-4-17-6v-2l-6-2-12-8-1-3-4-1-4-4-18 2h-7l4 6 2 2 17 4 9 4v2l5 2 6 5 1 4 4 2 2 6 4 2 5 3 10 1 7-2v-2l10-4h19l10 4 6 3h13l4-3h2l2-4 7-9 9-8 14-7h6v-6l7-14 9-10 11-9 4-3-2 4h1l5-8 1 4-6 8-11 8-7 8-6 12-2 10-13 3-11 6-7 7-8 11-3 3-4 2h-19l-12-6h-19l-11 6h-19l-6-4-6-7-8-10-11-7-16-4-7-3-6-8-1-5 25-3 13-4 4 1-3 2 2 3-4-1 14 11 16 8 11 4 17 3 18-1 15-4 13-5 7-4h3v-2l10-7 9-8 4-5 5-6 1-3h2l2-6 4-9 4-10 3-16v-9l-2-17-7-21-6-11-12-15-3 3 2-10z",
    fill: "#3C4D40"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(93,818)",
    d: "m0 0 2 2-10 10-6 9 5-5 1-3 8-7 2-2 4 1 8 5 8 3 6 1v50l-16 5-1 1h-7l-15-6-14-7 1-9 6-20-4 2 2-5 5-8 8-10z",
    fill: "#B4C5B5"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1101,66)",
    d: "m0 0h73l-5 8-2 6h-2l-2 8-2 9 2 4-1 2-2-4-4-2-9-5-4-1v5l8 3 7 7 3 7 2 8h-51l1-9 5-8 6-5 6-3h2v-6l-15 7h-2l-5-12-2 2-2-6 1-2-6-11z",
    fill: "#799A83"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(790,1057)",
    d: "m0 0h17v61h6l-1-19-1-3h2v-33l20 15 12 5 19 8-5 5-2 4h-2v2h-3v2l-11 6-13 6-16 4-8 1h-11l-17-3-5-2v-1l9 1 10 2z",
    fill: "#7A9B84"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1327,66)",
    d: "m0 0h72l-2 5-7 14-4 14-7-4-9-4-2-1 1 6 8 3 7 7 4 9v6h-50l1-9 5-8 7-6 7-2v-6l-10 4-5 4h-2l-4-11v-2h2l-1-3-2 2-9-16z",
    fill: "#799A83"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(150,672)",
    d: "m0 0 8 6 5 5 1 133 26 26-4 3-12 3-10 5-3-1v-6l-9-10-2-2z",
    fill: "#4E6554"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1014,26)",
    d: "m0 0h21l19 4 2 3-1 1 3 1v-2l9 3 13 8v2l4 2 5 4v2l-4 2-16 7-14 8-10 8-6 4v-53l-6-2v61l-18 1v-62l-3-1z",
    fill: "#7E9F87"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(718,1027)",
    d: "m0 0h48l2 6 4 10 5 6-1 4-3 5-8 7-11 7-12 5h-7l-11 2-5-9-5-10-4-14 6-12z",
    fill: "#B4C5B5"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(949,68)",
    d: "m0 0h15l16 6 14 10 6 8 3 3-2 4-6 10-3 11h-49l-2-11-5-8 3-12z",
    fill: "#B4C5B5"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(831,1027)",
    d: "m0 0h48l3 11 4 6-1 9-5 13-7 12h-8l-16-5-12-6-5-2-10-9-3-3 1-4 6-9z",
    fill: "#B4C5B5"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(71,626)",
    d: "m0 0h2l-1 7-3 13v3l7 4-2 1v2h3v2l21 7-2 5-4 7-1 5 5-1 5-10 6-5 13-4h1v30h-8v2l8 2v17l-12-3-10-9-4-10h25v-7l-47 1-1 5 20 1 1 8 6 10 4 4-7 1-16 6-11 6 3 16-1 4-3-7-2-11v-82l4-17z",
    fill: "#7A9A84"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(875,66)",
    d: "m0 0h78l7 2v1l-11-1-2 6-7 15-3 12 5 8 1 4v7l13-1h35l1 2h-72l-2-8h-3v-22h1l1 5 7 3 8 7 4 8v6h6l-4-13-6-9-6-4-11-4-1-17-6-1v34l-1 7-4 4v4h-17l2-11 6-8 6-4 6-2v-6l-14 7-3 1-8-20-6-10z",
    fill: "#7C9D85"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1953,593)",
    d: "m0 0 12 12 6 8 7 15 4 16v76l-1 2-4-1-17-8-11-3 6-10 3-8h-6l-1 6-6 8-4 3-4 2-10 1v-15l6-3h2v-2h-7v-1l47-1 1-4-1-1-47-1v-1h7l-4-4-4-2v-14l9 1 7 3 7 8 2 6 6 1-4-9-3-6-5-5 6-1 24-10 3-2-1-11-4-12-6-12-4-6-11-12z",
    fill: "#7B9C85"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(468,1025)",
    d: "m0 0h114l1 2-3 7-3 2h-9l-5-5-3-4h-11l-1 2v-3l-8 1h-48l-2 11-5 7-1 3h-2l6 17 7 13 4 1v1h-76l8-16 4-10 2-6h-2l1-3 7 6 9 4 4 1v18h7v-48h1v7l3-3z",
    fill: "#7C9D85"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1833,240)",
    d: "m0 0h2l2 22 4 15 5 10 8 11 4 2 6-2 16-5 7-4 5-3 1-2 4-1-1 4-8 6-15 7-14 4 7 6 7 8 12 12v487l-8 7-17 17-1 2 9 2 13 5 9 5 7 5v2l-5-2-12-7-24-8-9 12-4 8-5 14-2 11-1 17h-2v-19l4-17 6-14 10-15 12-13 16-16v-480l-27-27-9-14-7-14-4-15-1-6z",
    fill: "#EEF1EE"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(213,240)",
    d: "m0 0h2v21l-4 15-5 12-9 14-9 10-5 5-4 5-8 7-4 5v479l27 27 3 4v2h2l5 9 4 8 4 10 3 13v21h-2l-1-20-2-10-2-4v-5h-2l-7-14-7-9v3l-13 4-10 4h-2l-3 3-11 7h-2v-6l16-10 13-5 7-2 2-1-26-26-1-134v-259l1-89 2-5 9-10 15-15h2l2-4 11-15 6-15 2-10z",
    fill: "#DFE6DF"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(60,209)",
    d: "m0 0h1l1 52 2 16 4 14 8 16 9 12 5 6 5 3 2-4 8-6 7-3 9-1 1 51-1 13-9-1-12-6-5-5v-2h-2l-2-6-2-1v-22h2l-7-8-6-7v-2h-2l-8-13-7-15-4-13-2-13v-50z",
    fill: "#4E6454"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1066,609)",
    d: "m0 0h38v16h-8v50h8v16h-38v-16h8v-50h-8z",
    fill: "#040403"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(924,609)",
    d: "m0 0h38v16h-8v50h8v16h-38v-16h8v-50h-8z",
    fill: "#040403"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1777,66)",
    d: "m0 0h74l-9 19-3 8v6 3l-9-8-9-3-1 5 6 2 6 4 6 8 2 11h-16l-3-7-2-1-1-11-1-28-5-1v28l-1 12-5 5-1 3h-15l2-11 6-9 7-4 4-1v-5l-5 1-9 5-7 9-1-2 2-3-2-9-5-13 1-2 6 12 2 5-7-18-5-8-2 2z",
    fill: "#799983"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1564,1026)",
    d: "m0 0h16l3 6 1-5h2v47h6v-40l5-5 1-3h16l-2 11-5 7-6 4-7 3v5l10-4 7-4 4 10 5 12 5 8v2h-76l3-3 1 1 9-17 4-14 12 7 6 2v-6l-4-1-6-3-5-5-3-4z",
    fill: "#7B9B85"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1881,771)",
    d: "m0 0h1v42l-24 24-9 12-8 14-5 15-2 10-1 19 2-1h11l9 3 9 7 6 10-15 8-6 1-3-5-9-1-6 4v10l3 3 3 1-2 7-3 6-5-2-7-6-4-9v-11l3-6-1-4-2-3 9-9 3-1v-20l3-16 4-10 4-9 6-12 8-10 9-10 14-14 1-30 3-4z",
    fill: "#516857"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(71,400)",
    d: "m0 0 1 4-3 13 1 4 19 9 9 3 4 2-7 8-4 11 3 1-3 1h-18l-1 6h42v7l7 1v17l-9-2-8-4-5-6-3-8v-3h-6l3 10 8 12-20 8-14 7-1-3v-81l3-13zm22 34 1 2 4-1z",
    fill: "#7A9A83"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(79,157)",
    d: "m0 0 2 1-6 12-5 15-2 10 5 2 18 8 6 2h5l7-4 3 1-11 6-5 6-3 5-2 7h6l1-5 4-7 7-5 12-3v16l-5 2-3 1-1 3-39 1-1 5 22 1-3 1 5 13 7 7 12 6-2 1-9-4-3-2-9 2-13 5-9 5h-2v2h-2v-81l4-17 8-17z",
    fill: "#7A9A83"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(355,28)",
    d: "m0 0 9 1 7 2-4 1-6-2v53l11-9 10-7 6-2-4 4-13 9-12 11 8-6 9-8 8-5 2 1-9 7 4-2 3-1v2l-10 7-9 9 6 7 5 8 2 5v8h-63v-7l5-12 6-7 7-4h3l1-3v2l3-1h15z",
    fill: "#465A4B"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 498)",
    d: "m0 0h1l2 7 9 10 2 3v3h2v3h2l2 7h2l3 7 5 15 2 10v23l-3 13-4 12-4 9h-2l-1 5h-2l-2 5-7 9-5 6-4-2-1-6 4-2v3l7-8 1-2h2l1-4 4-6 8-21 2-10v-25l-4-16-3-7-4-9-7-11-7-8v3h2l3 4v2h2l9 16 5 13 1 11h-54l4-5 2-5 3-4h2l2-5 9-16 6-15z",
    fill: "#799B83"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(268,1025)",
    d: "m0 0h200l-1 7-3 1-1 41h-7v-18l-7-1-9-5-7-8-4-9-2-2v-4h-48l-9-1v6l-4 8-7 7-8 3h-8l-8-3-8-7-4-8v-6h-8l-1 4v-3h-43z",
    fill: "#B4C6B6"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1466,21)",
    d: "m0 0h19l16 3 10 4 7 3 15 9 11 9 5 5-7 1-5-5v-2l-5-2-3-2v-2l-4-1v-2l-6-2-8-4-13-4-11-2h-23l-16 4 14-1v44l-1 9-8-6-14-10-6-1v-2l-9-3-13-5 5-6 14-10 4-1v-2l-12 7-12 11-11-2v-1l7-1 13-11 15-9 21-8z",
    fill: "#7A9B84"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1957,357)",
    d: "m0 0 4 2 7 7 9 12-6-9-7-8v-1h54l-1 8-7 19-7 11-4 5-1 5-4 4v-3l-1 1 4 19 2 18v26l-3 25-4 14-6 15-9 16-2 3h-2l-2 4-2 3h-2l-2 4-7 6 2-4 8-9 4-5 5-8h2l1-5 6-11 5-19 2-21v-43l-2-19-4-15-7-16-9-14-9-10-5-5z",
    fill: "#B1C2B2"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(303,206)",
    d: "m0 0 3 1-1 15-5 22-8 16-8 11-8 9-10 8-15 9-13 4-5 2-16 2h-10l1-2 4-1 13-1 24-7 14-8 10-8 9-9 9-14 5-12 4-12 2-21h-2v9l-3 14-4 10-9 17-4 1 1 3-4-2-35-35-4-3v-2l25-2 13-3 19-7 6-1v-2z",
    fill: "#EDF0ED"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1957,132)",
    d: "m0 0 4 2 10 10 11 16 4 7 6 15v7h2l3 15 2 17v24l-3 25-1 10 11 13 10 18 1 8-2-3-2-4 5 17v2h-52l2-4 7-9-2-2 5-9 6-10 6-19 2-10 1-14v-44l-1-14-7-24-9-17-11-14-8-7z",
    fill: "#B5C6B6"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(85,1)",
    d: "m0 0h10l8 3 7 4 4 1h13l10-4 5-3 4-1h12l8 4 10 13v2l3 1 5 5 12 6 17 4 7 8 1 6-23 3h-5l3-2 20-3-3-5-6-3-16-4-8-4v-2l-4-1v-2l-4-2-14-16-4-2h-11l-15 7h-21l-11-5v-2h-14l-7 3-10 13-7 7-6 2v2l-14 5h-2l-1 4-4 11-7 10-9 8-9 7-2 4v12l7 14v20l-3 10h-2l-2 8-1 11h2l1 5 5 2 13 11 2 5h2l4 8v3h2l2 7 1 8 5 7 4 2 1-3v8l-7-2-6-5-2-4-2-12-7-14-8-9-11-8-4-5-2-6v-9l5-12 3-8v-14l-4-9-3-7-1-3v-8l4-10 8-7 9-7 6-8 3-5 4-15 12-3 10-5 9-8 7-10 5-4z",
    fill: "#2D3A30"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(506,1090)",
    d: "m0 0 4 1 4 5-4-2v1l8 7 7 5 16 7 13 4 16 2 17-1 20-6 12-6 4-3h3v-2l4-1v-2l5-2v-2l3-3-6 5-2-1 4-4-1-2 8 1 12 3 20 2-1 6-7 8-16 4-14 7-9 9-7 10-6 4h-18l-11-5-4-1h-17l-12 6h-18l-6-3-7-9-7-8-8-6-9-4-16-4-7-8-1-6 4-1 21-2zm-8 4-22 3 3 6 2 3 18 4 13 7 5 5h2v2h2v2h2v3l5 5 6 5 3 1h10l12-6 4-1h19l14 7h13l9-6 10-13 4-3v-2l5-1 3-2v-2l13-3 10-2 5-5v-4l-21-3h-5l-5 5-9 7-18 11-20 6-7 1h-20l-9-2-10-2-14-6-12-7h-2v-2l-4-1v-2l-6-4-4-4z",
    fill: "#415345"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1666,1)",
    d: "m0 0h10l7 3 9 4 4 1h12l9-3 9-5h12l7 3 5 4 7 10 8 8 10 5 11 3 8 2 7 8 2 6-23 3-18 4 1-3-2-3 4 1-8-7-2-1v-2l-5-2-16-8-20-5h-23l-15 3-13 5-9 5-16 12h-2v2l5-3 4-2-5 7-7-1-2-1 2-4 8-7 7-5h2v-2l17-8 10-4 16-3h18l19 4 9 4 17 9 10 8 6 6 25-4-4-6-5-2-10-2-12-5v-2h-3v-2l-4-1-9-10-7-8-3-2v-2l-12 1-10 5-10 3h-11l-8-2-12-6h-11l-5 2-8 9-6 8-7 5h-2v2l-12 5-14 3-5 6-1 2 15 1 8 2-4 1-24-3 2-7 8-8 18-4 9-5 9-8 8-11 7-5z",
    fill: "#37463A"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1191,1088)",
    d: "m0 0 3 1-5 2 4 6-4-2-3-1 10 8 13 8 11 5 17 4h26l19-5 16-8 5-3h2v-2l4-1 1-3 5-4 1-2 14 3 21 2-3 9-7 6-17 4-12 6-7 7-6 9-5 5-3 2h-18l-7-3-6-3h-19l-13 6h-19l-8-7-8-11-7-6-8-4-8-3-11-2-7-6-2-4v-5l4-1 20-2zm-16 6-21 3 2 5 4 4 15 4 10 4 11 8 3 3 1 3 3 3 1 2h2l2 4 5 3 9 1 18-8h20l15 7 8 1 7-2 5-4 8-11 9-8 11-5 17-5 5-5 1-4-22-3-5 1-11 10-9 6-17 8-15 4-7 1h-20l-18-4-10-4-8-4h-3v-2l-15-10-6-6z",
    fill: "#3C4D40"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(47,246)",
    d: "m0 0 4 1 2 21 2 12-10 11-4 7h-2l-2 5-7 19-3 14v20l5 21 5 12v2h2l1 5h2v3h2l5 7 5 5 1 4-3 16-1 9h-1v-10l2-14-5-5-7-8-3-5v-2h-2l-8-18-3-8-2-9-1-9v-11l2-15 4-13 8-16 8-11 9-10-3-22v-4l-7 6-4 15-5 12h-2l-2 5-8 8-10 7-3 4-1 4v9l7 15 1 4v14l-4 10-3 5-2 16h2l7 8 10 8 7 8v3h2l4 13 2 6 3 7 4 4 4 1-1 5-6-2-5-3-4-8-4-15-4-8-9-10-8-5v-2l-3-1-5-8-1-3v-9l3-8 5-12v-14l-3-7-5-12v-9l4-10h2v-2h2v-2l9-6 5-5 4-5 5-10 4-16 6-7z",
    fill: "#3D4F42"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1215,1)",
    d: "m0 0h9l20 8h13l7-1v-2l12-5h10l8 3 7 8 7 9 7 6 11 5 16 4 5 5 3 4v5l-16 2-15 3h-3l-5-5-1-3-4-1v-2l-5-2-12-7-13-5-15-3h-22l-17 4-12 5-14 8-10 9h-2v2l-11-2-23-3v-5l8-9 16-4 14-7 7-7 8-11 5-4zm-2 5-6 4-6 7-7 9-6 4v2l-4 1-14 5-11 3-4 5-1 3 20 3h6l14-12 4-2v-2l9-3 15-7 20-4h16l20 4 13 5 19 12 10 9 11-1 16-2-4-6-4-3-13-3-10-4h-2v-2l-9-6-9-11-3-5-5-1v-2h-12l-8 3v2l-7 2h-21l-6-2h-2v-2l-6-3z",
    fill: "#39493D"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(762,1)",
    d: "m0 0h10l8 3 8 4 4 1h13l8-3 5-3 6-2h10l8 3 7 7 6 9 7 6 12 6 16 4 6 5 3 9-23 3-8 1h-4l-7-6v-2l-4-1v-2l-6-2v-2l-6-2-10-5-21-5h-23l-16 4-16 6-9 6-11 9-2 3-11-2-25-3 4-9 5-5 17-4 12-6 6-5 11-15 6-4zm1 5-7 3-6 7-4 6-3 3v2l-5 2-5 3v2l-10 3-13 3-8 7v2l21 3 7-1 13-11 14-8 9-4 16-5 7-1h19l18 4 13 5 19 12 9 8 1 2 26-4-2-5-4-4-17-4-13-7-5-5-7-8-6-8-4-2h-12l-6 2v2l-9 3-6 1h-9l-9-2-12-6z",
    fill: "#324035"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1338,1026)",
    d: "m0 0h16l2 5 1 1 1-5h2v47l6-1 1-17 9-3 8-5h2l5 16 8 14v2h-76l1-2 4-1 10-21 2-8 4 1 14 7v-6l-9-3-5-4-4-6z",
    fill: "#7B9B84"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(987,1)",
    d: "m0 0h11l12 5 8 3h13l8-3 8-4 3-1h10l8 3 7 8 7 9 7 6 11 5 15 4 5 3 4 6v5l-4 1-19 2-12 2-2-4-7-5v-2l-5-2-10-6-7-3v2l4 2-5-1-5-2 3-2-9-3-11-2h-21l-15 3-16 6-10 6-11 9-4 4-11-2-23-3 1-6 7-8 6-2 14-3 10-6 9-9 7-10 7-4zm0 5-6 4-6 7-7 9-13 8-6 3-15 3-6 7v2l21 3h5l15-12 14-8 5-3 16-5 11-2h18l16 3 14 5 7 4h3v2l12 8 9 8 11-1 15-2-2-5-4-4-13-3-11-4h-2v-2l-9-6-10-13-5-5-2-1h-14l-6 3v2l-7 2h-21l-13-7z",
    fill: "#3F5244"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(649,66)",
    d: "m0 0h73l-7 14-5 12-2 7-10-6-4-2h-5l-1-18-4-1h-2v40l-3 1-2 4-1 3h5l1-2v3h-22l3-13 7-8 9-4h2v-6l-15 7h-3l-6-15-4-8-4-6z",
    fill: "#7A9B84"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(730,1091)",
    d: "m0 0 4 2 10 9 15 9 17 6 17 3h11l17-3 14-5 13-7 4-1v-2h3v-2l10-8 10 1 23 3v6l-6 7-7 3-10 2-9 4-6 4h-2l-2 4-6 7-6 8-5 3h-20l-9-5-4-1h-18l-11 6h-18l-7-4-7-9-7-8-10-6-10-4-12-3-5-4-4-9v-1l5-1 20-2zm-7 3-21 3 2 5 5 4 19 5 14 9 6 7 1 2h2v3h2l1 4 6 4 10 1 9-3 9-4 7-2 13 1 6 1v2l8 4 4 1h8l8-5 8-10 6-7 15-9 18-4 3-2 2-7-21-3-5 1-11 9-13 8-10 5-10 4-15 3h-21l-15-3-9-3-10-5-5-1v-2h-3v-2l-3-1-1-2-3-1-1-2-5-3-5-5z",
    fill: "#3B4C40"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1980,194)",
    d: "m0 0h2v78l-5-5-17-8-10-4 7-13 1-4-4-1 21-1 1-5-27-1-14-1-2-3-5-2-1-2v-13l2-1 11 3 8 7 4 7v3h6l-7-14 1-4 18-7 10-6z",
    fill: "#799A83"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(537,1)",
    d: "m0 0h10l7 3 8 4 4 1h12l9-3 7-4 4-1h10l7 3 7 6 8 11 7 6 15 6 12 3 6 5 3 6v3l-23 3-12 2-4-5-9-7-15-9-16-5-9-2h-24l-17 4-15 6-15 11-6 5-1 2-4-1v-3l10-9 14-9 14-7 16-4 8-1h17l15 3 12 4 19 11 13 11v2l12-2 15-2-4-5v-2l-12-2-12-5-8-4v-2l-5-2-10-13-3-3v-2l-4-1h-12l-15 7-6 1h-10l-9-3-7-3v-2h-16l-6 4-1 2h-2l-2 5-7 8-8 6h-2v2l-10 4-13 3-4 2-3 5 14 2v1h-9l-10-1 3-9 5-5 17-4 9-4 10-8 8-11 7-6z",
    fill: "#38483C"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(426,66)",
    d: "m0 0h66v3l1-2 2 1-6 12-6 15-2 4-9-6-8-3v6l9 3 6 5 4 8 2 9h-17l-2-8h-2v8h-1v-49l-6 1-1 4v13l-9 3-12 8 1-5-5-15-7-12v-2z",
    fill: "#799A83"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(956,1091)",
    d: "m0 0h2l5 5 10 8 9 6 4 1v2l6 1 19 5 7 1h11l17-3 15-5 16-9 13-11 3-1 14 3 18 2-3 9-6 5-4 2-11 2-16 8-8 9-6 8-5 4-4 1h-17l-5-5h2v-2l5 2 11 1 9-4 10-13 7-6 1-2 9-4h3v-2l18-4 3-2 1-5-19-3h-6l-7 7-10 7h-2v2l-19 9-16 4-5 1h-21l-13-3-15-5-13-7-5-3v-2l-4-1v-2l-4-1-6-6-18 2h-8v3h2l5 5 14 4 10 4 11 8 4 4v3h2l1 4h2l4 5 5 2h11l15-7h20l7 3v2h-2v2l-5-1h-19l-12 6h-18l-6-3-6-7-6-8-7-6-6-3v-2l-6-1-16-4-5-5-4-9 5-1 15-1z",
    fill: "#3E5043"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(311,1)",
    d: "m0 0h10l7 3 10 5h15l8-3 7-4 4-1h10l7 3 4 2 12 16 8 6 9 4 16 4 6 5 3 7v2l-23 3-12 2-2-4-6-4v-2l-5-2-10-6-12-5-14-4-5-1h-22l-17 4-15 6-11 7-11 9-1 2-11-2v-1l7-1 10-9 16-10 16-7 11-3 8-1h17l16 3 10 4 7 3 14 8 7 5v2l4 2 3 3 11-1 15-2-6-7-17-4-10-6-3-1v-2l-4-2-8-9-6-7v-2l-4-1h-11l-15 6-1 1h-21l-13-6v-2l-12 1-6 3-8 9-7 8-9 6h-2v2l-12 4-9 2-6 5-1 2 5 1v1h-11l5-10 5-4 12-3 10-3 12-9 10-13 6-5z",
    fill: "#3C4E41"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1825,844)",
    d: "m0 0h16l-2 4h-12l-10 2-20 8-9 6-1 2h-3l7 8 31 31 3 4-7 7h-2l-2 4-4 4-7-8-27-27-5-4-3-3 1 3 8 7 11 12 7 7h-3l-25-25-4 4-8 15-4 13-3 20-2 1 1-23 4-13 9-18 7-9 4-5 8-7 10-7 10-5 11-4 9-3z",
    fill: "#526958"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(278,1091)",
    d: "m0 0 4 2 9 8 10 7 12 5 8 3 12 3 8 1h12l15-3 15-5 14-7 9-7 5-4 1-3 11 2 5 1 20 2-4 9-4 4-7 3-13 3-11 6-7 7-9 12-7 4h-18l-12-6h-19l-12 6h-19l-8-6-8-11-7-7-11-5-15-4-6-4-4-5-2-6 25-3zm-7 3-21 3 3 6 4 3 19 5 13 8 7 8 1 2h2v3l5 5 4 3 5 1h7l7-3v-2l11-3h18l10 4 6 3 9 1 7-3 8-9 7-8 6-5v-2l5-1 12-5 10-2 5-4 1-5-21-3h-5l-9 9-15 9v2l-9 3-10 3-5 2-12 2h-19l-15-3-15-6-8-2v-2l-7-4h-2v-2l-4-1v-2l-7-6-1-2z",
    fill: "#425547"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1746,208)",
    d: "m0 0 3 1 1 13 3 13 5 12 6 11 3 4v2l3-1 7-8 28-28 6-4 4 4 6 7 3 2-1 4-9 10-8 7-21 21-1 3 5 2 10 6 19 7 11 2h8l-2-4 1-3 4 8v3h-16l-12-3-10-3-15-8-13-10-10-11-7-10-3-8-3-7-5-23z",
    fill: "#506656"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(32,315)",
    d: "m0 0 1 2-4 16h58l-9-11-2-4h2l7 9 6 6v2h-2l1 6v14l-4 4h-57l5 18 8 16 9 13h-3l-4-5v-2h-2v-3h-2l-1-5h-2l-6-14-5-21v-20l4-17z",
    fill: "#EEF1EE"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(208,844)",
    d: "m0 0h9l10 2 20 5 14 7 11 8v2l4 2 3 3v2h2l9 13 5 10 4 11 3 15v14h-2l-3-17-3-14-4-7-3-7-6-9v-2l-5 3-9 10-26 26h-2l-1 5-2-3-7-9-6-4 3-5 8-7 12-13 19-19h-3l-4-4-17-9-23-5-9-1z",
    fill: "#506756"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1529,1087)",
    d: "m0 0 6 1 16 5 17 2 9 1-3 8-5 5-7 3-15 4-11 7-7 8-7 9-6 4h-17l-7-3-6-3-13-1-9 2-9 5h-19l-7-4-10-14-7-6-6-3v-2l-7-1-14-3-5-4v-2h-2l-3-9 5-1 14-1 10-1-3 2-14 2h-7l4 7 5 2 12 3 9 4 11 7 5 6v2h2v3h2v3l10 5h13l13-7h19l12 6 16 4h4v-2l-2-1 4-2 2-4 10-13 13-9 12-4 12-3 3-6-25-3-11 10-22 13-15 5-12 2h-20l-9-2-11-3-16-7-12-8 3-1-2-3 4 2 10 6 14 6 9 3 7 1h26l19-5 16-8 10-7h2v-2l5-4-12-5z",
    fill: "#415345"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1743,957)",
    d: "m0 0h2l4 14 7 14 7 11v1h-102l-2-2 2-4 6-6 3-1 44-1 7-3 12-13z",
    fill: "#4F6655"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1897,758)",
    d: "m0 0h1l1 26v78l-9-6-13-7-18-6 2-4 22-22h2v-47z",
    fill: "#4F6655"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(54,280)",
    d: "m0 0h2l6 16 4 7v3h2l4 7 11 14 4 4v2l-23 1h-16l-19-1 3-18 3-10 4-7h2l2-5 8-10z",
    fill: "#7B9C85"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(88,357)",
    d: "m0 0h3l-2 4-6 7h-2l-2 4-8 11-7 13h-2l-6 15-6-5-9-13-8-16-4-15v-3l57-1z",
    fill: "#799A83"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(661,1026)",
    d: "m0 0h15l3 6 3 2 1 40h6l-1-23 9-4 6-4 4-6 3-10 5-1 1 4-4 12-8 9-8 4 5-2 4 1 4 11 6 11v3h-60l8-17 4-12 11 5 3 1v-6l-8-2-9-8-3-6z",
    fill: "#7B9C84"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(49,473)",
    d: "m0 0h1l3 23 2 12-8 9-9 13-8 20-3 15v19l4 18 2 5v3h-2v3h-2l-5-15-3-19v-10l3-19 10-23 10-14 7-8-1-14-2-12-6 4-5 18-6 12-9 10-10 8-4 4-1 4v11l2 6h2l4 12v14l-4 11h-2l-2 8v11l2 5 4 2 13 10 3 4v2h2v3h2l5 14 4 13 5 4 3 1v-11h1v14l-1 2-7-2-6-5-2-4-3-13-5-12-7-8-2-1v-2l-5-2-8-7-3-5-1-4v-8l4-11 1-2h2l1-7v-14l-4-11-4-9v-8l3-9 7-7 9-6 7-8 5-10 4-17 5-5 5-4z",
    fill: "#435548"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1749,209)",
    d: "m0 0 27 9 17 3 17 1 1-2-1 4-13 12-25 25-2 3h-3l-8-13-6-15-2-6-3-15v-5z",
    fill: "#EDF0ED"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2017,80)",
    d: "m0 0 2 2 6 15 2 9v25l-4 18-1 3-3-1 1 6 4 2 6 7h5l3-2v3h3l-10 8-6 5-5 7-4 10-4 16-8 7-6 1-4-29-1-6 3-1 3-5h-2l2-4 6-8 1 2-5 8 8-11 3-5-1-5 2-5 1 3-1 2h2l1-5 4-13 2-17-1-17-5-18-1-4h2z",
    fill: "#7A9B84"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(300,210)",
    d: "m0 0h2v13l-2 10-6 18-8 14-11 12-9 8-14 8-6 3-19 5-19 1v-2l9-2 13-2 10-3 16-8 8-5-3-5-7-6 2-7-3-7-5-6 2-8-4 1-2 3 1 7 2 4 4 3v5l-4-2-17-17-4-5-2-1 2-4 11-11 5 2 37 37v-3h4l10-18 5-17z",
    fill: "#526858"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(126,126)",
    d: "m0 0h619v2h-617v261h-1l-1-146z",
    fill: "#94A598"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1768,882)",
    d: "m0 0 3 1 39 39v2l-24 2-17 4-15 6-6 2 1-15 4-15 8-16 4-6h3l25 25-4-5-10-10-7-8-4-3z",
    fill: "#ECEFEC"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1928,314)",
    d: "m0 0 11 2 8 4 6 6v2l2 1 2 4 5-4 9-11h2l-5 10-3 3 54 1 1 5h-61v16l-1 2h62l-1 6h-54l8 9 5 7-1 2-13-16-7-6-1 5 4 5-4-2-3-1-2 4-7 6-7 3-10 1v-23l1-19 6 1 4 5v7l-3 5-5 3h-2l1 12 9-2 7-5 5-9v-14l-3-6-9-8-10-3z",
    fill: "#4E6454"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1361,1025)",
    d: "m0 0h197l5 16-1 2-4-7-2-8h-48v-2h-8l-1 7-3 6-4 5-7 4-4 1h-13l-9-6-6-9-1-8-8 1-48 1-3 9-1-4 1-6h-5l-2 9-5 8-8 5-6 1v-17l4-3 1-4-6 2-5-1z",
    fill: "#94A598"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1265,27)",
    d: "m0 0 14 3 12 5 15 9v2l4 1 5 5 1 3 2 1-8 2-11 5-8 4-7 2-7 5h-2v2l-8 7-2 1v-55l-2-1z",
    fill: "#7A9C84"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(361,1063)",
    d: "m0 0 8 4 10 8 11 6 15 7 6 2-2 4-10 8-3 2 1 2-16 8-16 5-5-1z",
    fill: "#799982"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(782,29)",
    d: "m0 0h2v54l-4-2-11-9-3-2-6-2-11-6-16-6 1-4 9-8 5-4 14-7 5-2h7z",
    fill: "#7A9B84"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(551,30)",
    d: "m0 0h7v54l-7-6-13-9-7-3-15-7-9-3 1-4 11-9 10-7 12-5z",
    fill: "#7B9C85"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1007,27)",
    d: "m0 0h5v2h-2v55l-8-6-13-10-11-6-13-4-6-2 5-6 11-8-1-2 16-8z",
    fill: "#7B9C84"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1491,1063)",
    d: "m0 0 8 6 6 5 7 3 17 9v2l10 3 3 2-4 4h-2v2l-14 9-12 6-8 1-3 1h-9v-43z",
    fill: "#7A9B84"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1964,815)",
    d: "m0 0h54l1 6-8 20v3l-4 8h-2l-1 4-9 10-2-3-2-2h-1l-3-10-6-11-7-11-10-11z",
    fill: "#7A9B84"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(135,1062)",
    d: "m0 0 7 6 6 3 10 7 16 8 13 4 4 2-5 2-3 1-1 3-5 2v2l-9 5-4 1-15 6-10 2h-4z",
    fill: "#789982"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(334,28)",
    d: "m0 0h4v61l2 1-4 1-4 2-5-1-8-8-10-7-12-7-18-6-11-2h-67l-20 4-13 5-11 6-2-2 3-3-1-2 14-7 8-3 16-4 6-1h63l17 3 15 5 15 8 11 8 11 10v-3l-4-2-6-5v-2l-5-2v-2l-5-2-9-5-14-7 3-1 16 8 11 7 11 10 1-53-6 1 3-2z",
    fill: "#506656"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(30,815)",
    d: "m0 0h53l-4 6v2 3l-9 13-6 11h-3l-1 5-2 8h-2l-1 2-9-10-9-15-6-15z",
    fill: "#7A9B84"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1994,960)",
    d: "m0 0 5 5 7 8 4 6v5l4 8 4 12v7h-54l2-5 9-10 9-15 7-17 2-1z",
    fill: "#7A9B84"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 700)",
    d: "m0 0 6 1 8 7 5 18 6 12 8 8 11 8 4 6 2 4v72l-5 9-7 6-8 6-5 6-5 8-3 9-3 12-4 5-9 4h-1l-3-23v-5l2 4 2 18 5-2 3-4 5-18 8-13 8-8 11-8 3-4v4l2-6-2-7-4-11-4-8v-19l7-16v-13l-4-5-3-2v-2l-4-1v-2l-5-2-7-8-5-8-4-13-3-10-6-4-3 20-2 3 1-10z",
    fill: "#435648"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(992,1026)",
    d: "m0 0h8l3 10 4 6 9 6h16l9-6 4-5 3-11h8l-1 9-5 10-5 7-8 3h-2l7 8 9 8h-3l-8-7-1 52 7-1-3 2-10 1v-61l-4 1h-11l-3-1v61l-9-1 4-1v-53l-14 11-2-1 11-9 6-6h2v-3h-6l-7 6 2-4 4-4-4 2-6 6-2-1 9-9-6-8-4-9z",
    fill: "#4E6353"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1746,1083)",
    d: "m0 0 24 8 13 3 8 1v1h-9l-10-1-11 10-8 5h-2v2l-15 7-9 3-15 3h-21l-15-3-12-5-13-6v-2h-3v-2l-4-1v-2l-4-1-1-3-5-2-3-3-19 2h-6l1 5 8 4 16 4 7 3v2l5 2 7 6 1 4h2l3 5v2h2l3 3 8 3 9-1 11-6 4-1h18l7 3 12 5-1 4-7-1-11-5h-19l-8 4-3 2h-19l-6-4-6-7-7-9-2-1v-2l-5-2-8-4-17-4-6-5-3-6v-5l18-1 13-3h3l4 5 16 12 8 3v2l16 4 17 3h9l14-2 16-5 14-7 12-9 3-3h2v-2l-3 1v-2l-5-1-12-5z",
    fill: "#38473B"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1929,777)",
    d: "m0 0 9 1 8 7 4 6 1 5v9l-3 8-5 6-10 5h-5v8l2 1-1 48 7 1v1h-7l-1 21 6 2 1 4h40l2 4-1 2h-23v2h5l-3 10-6 8-10 6-11 2v-5l2-2 11-3 5-4 5-9 1-4h-17l-2 4-6 2v-114l7-1 3-5-1-8-2-3-5-2-1-5z",
    fill: "#B5C6B6"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(211,848)",
    d: "m0 0h13l17 4 17 9 4 3v2h3l-2 4-10 9-5 6-8 7-7 8-5 5h-2v2h-2l1-4 6-5 7-8 19-19-5 4-27 27h-1l-3-24-4-15z",
    fill: "#EDF0ED"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(330,30)",
    d: "m0 0h2v54l-7-6-12-9-17-9-15-4 1-4 12-10 14-8 10-3z",
    fill: "#7B9C85"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1233,1062)",
    d: "m0 0 3 1v37l-1 17-11-2-13-5-14-8v-2l-4-1-3-5-2-3 5-3 3-2 16-8 14-10z",
    fill: "#799B83"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(209,1045)",
    d: "m0 0 8 6 7 4 6 1v18h7v-17l6-3 7-3 4-3h2l6 16 7 13v2l3-1 1 2h-76l8-16 6-16h-2z",
    fill: "#799B83"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1553,66)",
    d: "m0 0h72l-2 5-5 9-5 14v5 3l-9-8-11-4-1-16-1-2-5 1-1 17-11 4-7 5-4 4 1-5h2l-6-18-7-12z",
    fill: "#789982"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(782,1063)",
    d: "m0 0 2 1v52h-15v-2l-11-5-11-6-11-9-2-4 13-5 9-5 7-2 16-12z",
    fill: "#7A9B83"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(55,961)",
    d: "m0 0h1l2 8 7 16 10 15 9 10v1h-55l-1-6 6-18 3-4 1 1 6-10z",
    fill: "#7B9C85"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1892,1)",
    d: "m0 0h10l7 3 9 4 4 1h11l10-3 9-5h12l7 3 5 4 7 10 1 3 4 2 5 4 13 6 8 1 3 13 4 8v2h2l7 8 2 1v2l5 2 5 5-2 1-1 3-8-7-5-3v-2l-4-2-7-10-6-16-7-2-16-8-1-3-4-2-9-11-6-5v-2l-14 1-12 6-7 2h-11l-9-3-7-3v-2h-14l-6 3-14 16-8 6-6 4-19 5-5 4-2 4 14 1 13 1 8-8 15-10 6-2v2l3 1-14 8h-2v2l-6 4-6 5-1 2-11-2-24-3 3-9h2v-2h2v-2l9-3 13-3 12-8 8-9 4-6 6-5z",
    fill: "#36463A"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(53,735)",
    d: "m0 0h2l3 9 5 12 10 16 10 12v1l-7 1h-45l-2-1 2-9 5-14 9-15 5-6 1-4z",
    fill: "#7B9C85"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(54,508)",
    d: "m0 0h2l5 14 2 8 10 16 9 11 2 3h-54l1-9 5-14 7-13 9-11 2-4z",
    fill: "#7A9B84"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 473)",
    d: "m0 0 9 4 6 7 4 17 6 11 5 6 14 10 4 6 2 7v68l-4 9-7 7-10 7-8 11-4 12-2 10-7 8-8 2-1-7v-9l2 3v8l6-3 3-4 3-13 3-8 6-9 1 2h2l2-4 10-8-5 3-2-1 7-5 4-5h2l1-4 2 4v-5h-1l-2-12-7-14v-19l8-17-1-10-3-5-3-3v-2h-3v-2l-5-2v-2l-4-2-6-7-5-11-2-5-2-9-2-5-1-3-6-1-1 14-1 5h-1l1-16z",
    fill: "#415245"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(224,1025)",
    d: "m0 0h43l-2 10-5 10 1 8 4 10 2 4v3h-3l-7-16-1-6-9 6-9 3-1 17h-7v-18h-6l-10-6-7-8-4-11v-4h6l4 12 4 5 6 4 6 2 1-17h-3l-3-5z",
    fill: "#B3C5B5"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(167,344)",
    d: "m0 0 4 3v342l-4-2z",
    fill: "#303D33"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(285,946)",
    d: "m0 0 5 1 8 5-3 14-7 16-9 13h-12l-15-4-7-3v-2l8-7 31-31z",
    fill: "#7D9F87"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1823,245)",
    d: "m0 0h1l3 23 5 16 6 15h-9l-14-3-16-6-12-7 2-4z",
    fill: "#EDF0ED"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1824,848)",
    d: "m0 0h13l-1 4-6 16-4 18-2 15-7-6-30-30 4-4 7-5 18-6 1-1z",
    fill: "#EDF1ED"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(224,245)",
    d: "m0 0 7 6 30 30v2l-16 9-10 4-9 2-15 1 3-9 5-12 3-15z",
    fill: "#EEF1EE"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(281,886)",
    d: "m0 0 4 2 5 8 4 10 3 9 2 9v12l-21-8-18-4-12-1-3-2 8-7z",
    fill: "#EDF1ED"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(127,390)",
    d: "m0 0h1l1 352-1 276-2 2v-629z",
    fill: "#9DAEA1"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1041,1053)",
    d: "m0 0 7 6 13 10 12 7 21 7 9 1h69l15-3 11-4 15-8 13-10 7-6 4 2-2 4-11 10-10 7-19 9-17 5-14 2h-52l-16-2-17-5-16-8-16-11-10-10v-2z",
    fill: "#4F6655"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1957,585)",
    d: "m0 0 7 6 10 11 10 16 5 10 4 12 2 11 1 1 3 23v25l-3 23-4 15-5 13-6 11-3 1 2-5 6-13 4-13 2-11 1-14v-38l-1-5-4 4-1 52-3 17-3 9-7 14-10 14-9 9-1-3 9-9 9-14 5-10 4-16v-87l-4-16-8-16-8-10-7-7 1-3 11 11 10 15 7 16 3 12 2 19 3-3h2l-1-14-1-1-1-7-4-10-7-15-9-14-11-12z",
    fill: "#A6BAA9"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2045,1062)",
    d: "m0 0 1 4-6 8-11 8-7 8-6 12-2 10-13 3-11 6-7 7-8 11-3 3-4 2h-19l-12-6h-19l-11 6h-19l-6-4-6-7-8-10-11-7-16-4-7-3-6-8-1-5 5 1 4 6 2 2 17 4 9 4v2l5 2 6 5 1 4 4 2 2 6 4 2 5 3 10 1 7-2v-2l10-4h19l10 4 6 3h13l4-3h2l2-4 7-9 9-8 14-7h6v-6l7-14 9-10 11-9 4-3-2 4h1z",
    fill: "#364539"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(150,276)",
    d: "m0 0 4 5h-2v5l15 9 12 5 11 3-6 7-16 16-3 4-1 4-1 24h-1l-2-10-10-10z",
    fill: "#4E6554"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1361,71)",
    d: "m0 0 5 1 1 1 1 17 1 6 8 3 7 7 4 9v6h-50l1-9 5-8 7-6 7-2 1-23z",
    fill: "#B5C6B6"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1137,71)",
    d: "m0 0 4 3 1 16 1 6 8 3 7 7 3 7 2 8h-51l1-9 5-8 6-5 6-3h2l1-21 1-3z",
    fill: "#B5C6B6"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1881,534)",
    d: "m0 0h1v237l-2 5-3-1v-236z",
    fill: "#4E6554"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1845,813)",
    d: "m0 0h9l8 3-5 5v-2h-10l-10 6-10 5-7 2h-17l-6-1h-8l-7 3-5 6-6 17-3 4h-2l-2 4-10 6-14 5-7 8v13l1 5v14l-4 13-9 15-1 6 2 4 2 1-16 16-2-1 11-11-2-8v-9l9-14 3-8 1-4v-14l-1-5v-11l4-9 7-6 16-6 8-6 5-7 6-16 5-6 6-4 5-1h8l5 1h17l9-3 10-6z",
    fill: "#4A6050"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1440,1)",
    d: "m0 0h10l9 4 11 4h11l9-1v-2l10-5h12l7 3 7 6 6 9 8 7 7 4 13 4 9 3 5 5 3 8-23 3h-5l3-2 13-2h7l-5-7-5-2-16-4-6-3v-2h-3v-2l-5-2-8-9-5-7v-2l-4-1-3-1h-12l-6 2v2l-8 3h-20l-10-4-5-3h-12l-5 3-11 13-7 7-12 7-17 4-5 4-2 3 5 1v1h-10l2-7 4-5 6-3 16-4 12-7 7-7 6-9 6-5z",
    fill: "#37473B"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(49,699)",
    d: "m0 0 2 3v11h-1l-2-8-6 4-5 18-4 9-7 9-8 7-8 6-3 6v10l2 5 5 10 1 4v14l-3 8-5 12v10l4 6 9 7 10 9 6 12 3 9 2 10 8 6 1-12h1v13l-1 3-6-1-8-7-4-17-5-10-9-10-11-8-4-6-2-6v-8l3-9 4-6 1-5v-14l-5-12-3-7v-10l4-8 8-7 10-8 6-8 4-11 3-13 4-5z",
    fill: "#435648"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(134,397)",
    d: "m0 0h1v232l8-7 6-5h1v54l-14-12-1 231h-1l-1-262z",
    fill: "#698672"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1718,188)",
    d: "m0 0h3v14l1 5h2l7 14 3 9v14l-1 5v13l1 4 4 2 4 3 14 5 8 6 4 4v2h2l7 18v2h2l4 5 5 2h10l6-1h13l15 5 11 7 3 1h9v-2l-8-10 1-2 9 10 4 6-8 4-9-1-18-10-8-2h-14l-6 1h-10l-8-3-7-7-3-10-5-10-3-3v-2l-14-7-11-4-8-9-2-5v-11l1-5v-15l-5-15-7-10-1-3v-7z",
    fill: "#38483C"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(330,189)",
    d: "m0 0 3 4v10l-4 8-6 10-2 6v20l1 2v8l-3 9-3 5-5 4-16 6-9 7-6 9-4 13-5 5-5 4-4 2h-12l-5-1h-15l-10 3-14 9-10 1-7-2v-2l7-1 6-1 5-3h3v-2l12-6 9-2h13l6 1h11l6-3 5-7 3-11 9-12 4-4 10-5 12-4 5-6 1-8-2-14 1-14 4-10 8-13 1-9v-4h2z",
    fill: "#45584A"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 925)",
    d: "m0 0 9 3 5 6 6 21 7 11 9 8 8 6 4 6 2 6v67l-2 4-6 8-3 2 2-4 3-8-1-10-5-10-2-6v-19l7-14v-14l-4-5v-2l-4-1v-2h-3v-2l-5-2-7-8v-2l2-1v-2h-2l-1 2-5-8-5-19-6-5-2-1-1 15-1 5h-1l1-18z",
    fill: "#364539"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 245)",
    d: "m0 0 7 2 6 5 5 16 4 10 6 9 11 9 7 6 4 8v9l-4 10-5 10-3-4 1-6 4-9v-10l-4-7-4-3v-2l-4-1v-2l-5-2-7-9v-2h-2l-5-13-3-12-4-5-4-2-1 15-1 11 7 7 1 4 3 1v3h2v3h2l1 5h2l5 12 4 10 3 15v22l-4 16-4 11-2 1v-5l-2 2 1-5 5-19v-25l-4-18-7-14-5-9-11-13 1-10z",
    fill: "#46594B"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(198,813)",
    d: "m0 0 7 1 14 9 10 3h17l5-1h9l9 4 5 5 3 4 4 13 4 6 8 7 8 4 9 3 8 7 3 5 1 10-1 6v20l5 12 5 7 2 5v10l-3 7-7-6-1-2 4 2 1 1 1-8-3-8-6-10-4-12v-18l1-10-2-7-4-4v-2l-9-2-10-4v-2l-4-1-1-3-4-2-7-10-4-13-7-6-5-2-13 1h-16l-9-3-13-6v-2h-3v-2l-6-2z",
    fill: "#3C4D40"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1241,29)",
    d: "m0 0h18v60l-18 1z",
    fill: "#E8ECE8"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(880,1025)",
    d: "m0 0h56v1h-16l-1 5-1 2h-2l-1 40-2 2-5-1-1-2v-16h-5l-9-5-7-7-4-8z",
    fill: "#AFC2B1"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1665,35)",
    d: "m0 0 1 4 20 20h2v2l3 1-2 1-2-1v22l-1-2-4-2-8-7-13-8-11-4-10-4 1-4 2-3-4 4h-3v-2l21-15 5-1z",
    fill: "#7C9D86"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1921,97)",
    d: "m0 0h14l9 6 6 8 1 2v15l-6 9-6 5-6 2h-4l-1-3v-10l6-3 3-3v-7l-2-5-3-1v-2l-10 2-3 4-1 4h-13l-1-5 4-8 5-6z",
    fill: "#ECEFEC"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(114,97)",
    d: "m0 0h11l7 2 8 7 4 8v6h-13l-2-5-5-4h-7l-5 4-1 2v7l5 5 4 2v13l-7-1-7-4-7-8-2-5v-11l3-7 6-7z",
    fill: "#ECF0EC"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1929 1e3)",
    d: "m0 0 6 1 10 6 5 7 1 3v14l-6 10-9 6h-16l-9-6-6-8-1-8h13l4 6 4 2h7l4-4 1-9-3-4-6-3v-8z",
    fill: "#ECEFEC"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1919,1057)",
    d: "m0 0h17v61h-16l-1-1z",
    fill: "#EEF1EE"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1693,1057)",
    d: "m0 0h17v61h-16l-1-1z",
    fill: "#EBEFEB"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(790,1057)",
    d: "m0 0h17v60l-1 1h-16z",
    fill: "#EEF1EE"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(564,1057)",
    d: "m0 0h17v60l-1 1h-16z",
    fill: "#EEF1EE"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1958,1017)",
    d: "m0 0h60l2 2v15h-61z",
    fill: "#EDF1ED"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(112 1e3)",
    d: "m0 0h8v13l-6 2-2 2v11l3 3 3 1h7l4-4 2-4h13v6l-6 9-6 5-4 2h-15l-7-4-6-7-2-3-1-6v-9l4-8 8-7z",
    fill: "#ECEFEC"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1959,792)",
    d: "m0 0h60l1 1v15l-1 1h-60z",
    fill: "#EEF1EE"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1959,112)",
    d: "m0 0h61v15l-1 2h-60z",
    fill: "#EEF1EE"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1698,28)",
    d: "m0 0h8l4 1 1 60-18 1v-61z",
    fill: "#EEF1EE"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(565,28)",
    d: "m0 0h10l6 1v60l-17 1v-61z",
    fill: "#EEF1EE"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1920,28)",
    d: "m0 0h10l6 1v60l-17 1v-60z",
    fill: "#EEF1EE"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(29,566)",
    d: "m0 0h61v17h-61l-1-11z",
    fill: "#EEF1EE"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(31,1017)",
    d: "m0 0h59l-1 17h-60l-1-1v-8l1-7z",
    fill: "#EEF1EE"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(795,28)",
    d: "m0 0h7l5 1v61l-17-1v-60z",
    fill: "#EEF1EE"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(29,792)",
    d: "m0 0h61v17h-61z",
    fill: "#EEF1EE"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(29,112)",
    d: "m0 0h61v17h-60l-1-1z",
    fill: "#EEF1EE"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1016,1057)",
    d: "m0 0h17v60l-1 1h-16z",
    fill: "#EFF2EF"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(112,1057)",
    d: "m0 0h17v61h-16l-1-1z",
    fill: "#EFF2EF"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1959,566)",
    d: "m0 0h60l1 1v15l-1 1h-60z",
    fill: "#EFF2EF"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1242,1057)",
    d: "m0 0h17v47l-1 14h-16z",
    fill: "#EEF1EE"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(338,1057)",
    d: "m0 0h17v61h-16l-1-1z",
    fill: "#EFF2EF"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(112,29)",
    d: "m0 0h17v61l-17-1z",
    fill: "#EEF1EE"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1471,28)",
    d: "m0 0h10l3 1v60h-17v-51l1-9z",
    fill: "#EDF0ED"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1016,29)",
    d: "m0 0h17v60h-17z",
    fill: "#EEF1EE"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(338,29)",
    d: "m0 0h17v60h-17z",
    fill: "#EEF1EE"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1467,1057)",
    d: "m0 0h17v61h-16l-1-32z",
    fill: "#EEF1EE"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(166,334)",
    d: "m0 0 2 4 2 2 2-1v468h-1v-116h-2v-2h-2v124h-1zm1 10v343l4 2v-342z",
    fill: "#92A397"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1959,338)",
    d: "m0 0h61v16h-61z",
    fill: "#EEF1EE"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1965,135)",
    d: "m0 0h53l1 1-1 9-2 1v-5l-24 24-3 4 3 9 2 4v3h-2l-5-12-6-16-10-14-6-6z",
    fill: "#7B9C85"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(49,739)",
    d: "m0 0h2l-2 4-7 10-8 16-4 13-1 10v19l4 17 7 16 8 12 7 8 3-1v-6l3-7h2l-1 6-5 19-1 8v56l3-3h2v-50h1v55l-2-3-4 4 2 15 7 21 10 17 8 10 5 5 3 4-4-2-7-7-9-12-8-13-7-17h-2l-10 12-6 10-1-3 7-11 10-11-2-16-1-2-1-15-1-2v-24l-2-1h3l1-16 3-14-1-5-9-10-2-5h-2l-6-12-4-11-3-11-1-7v-19l4-18 4-10 7-13z",
    fill: "#A2B4A5"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1832,915)",
    d: "m0 0h14l10 5 6 8-1 3-9 4h-3l-3-5-9-1-6 4v10l3 3 3 1-2 7-3 6-5-2-7-6-4-9v-11l4-9 5-4h2v-2z",
    fill: "#E9EDE9"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1830,186)",
    d: "m0 0 3 1 3 8v4l-5 4v10l4 4 2 1h6l5-4 1-3 4 1 7 3 2 1-2 5-6 7-9 4h-11l-9-5-6-7-3-6v-11l5-10 7-6z",
    fill: "#EAEEEB"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(216,187)",
    d: "m0 0 5 1 7 6 4 7v14l-5 9-7 6-6 2h-11l-8-4-7-7-1-5 4-3 8-1 3 4 3 1h7l5-3 1-7-2-6-4-2 1-7z",
    fill: "#EAEEEA"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(881,67)",
    d: "m0 0h29v2l5 2 1 1v17l3 1h-4l-1-17-6-1v34l-1 7-4 4v4h-17l2-11 6-8 6-4 6-2-1-6-6 1-6 3-6-13z",
    fill: "#76947F"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(117,551)",
    d: "m0 0h5v43l-1 4h-7l-6-3-6-5-4-7-1-3v-12l3-6 4-5 5-4z",
    fill: "#E5EAE6"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(200,915)",
    d: "m0 0h17l8 6 5 6 2 4v14l-4 7-9 8h-3l-4-8 1-5 3-2 1-3h2l-1-8-4-4-2-1h-8l-4 4-1 2-6-1-6-4 1-4 7-8z",
    fill: "#ECEFEC"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1209,5)",
    d: "m0 0 2 1-9 11-8 10-4 3h-2v2l-14 6-15 4-4 6 19 3h6l14-12 4-1v-2l23-10 9-3 12-2h16l20 4 13 5 1 4-13-3-18-4h-22l-17 4-12 5-14 8-10 9h-2v2l-11-2-23-3v-5l8-9 16-4 14-7 7-7 5-7 6-4z",
    fill: "#435748"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(789,21)",
    d: "m0 0h19l18 4 13 5 19 12 10 9-1 4-4-2-6-5v-2l-4-1v-2l-6-2v-2l-6-2-10-5-21-5h-23l-16 4-16 6-9 6-11 9-2 3-11-2-25-3 4-9 5-5 17-4 10-5 3 1-3 6-10 4-13 3-7 6-1 2 15 1 11 1 10-8 13-9 15-7 16-5z",
    fill: "#3F5144"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(311,1)",
    d: "m0 0h10l7 3 10 5h15l8-3 7-4 4-1h10l7 3 4 2 12 16 8 6-2 1-7-1-7-7-7-9-2-4-4-1h-11l-15 6-1 1h-21l-13-6v-2l-12 1-6 3-8 9-7 8-9 6h-2v2l-12 4-9 2-6 5-1 2 5 1v1h-11l5-10 5-4 12-3 10-3 12-9 10-13 6-5z",
    fill: "#36453A"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(89,27)",
    d: "m0 0 3 1-2 1 1 2-9 4-12 7-8 6-12 11-10 13-1 3h-3l1 3-6 14-4 16v22l5 21 6 14 6 9v2h2l7 8 2 2-1 8-3 19h-1v-9l1-6v-8l-9-10-8-13-8-16-4-16-1-8v-16l3-16 5-12 8-15 10-13 9-9 13-9 17-9z",
    fill: "#495F4F"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1927,434)",
    d: "m0 0 12 2 7 5 4 6 2 4v3l23 1 2 2-1 4-3 2h-15v3h-6v-2l-17-1v6l-4 2h-4z",
    fill: "#B6C7B7"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(642,1094)",
    d: "m0 0 10 1 16 2-1 6-6 4-16 3-5 1v2l-5 3h-3l-1 3-5 4-9 12-2 1-7-8-5-5v-2l-2-1 11-4 19-12 10-8z",
    fill: "#7B9C84"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1558,1025)",
    d: "m0 0h63l-4 14-4 6-4 5-11 6h-4l-1-5 11-6 5-5 3-7 1-6-15-1-1 5-4 3-1 40h-6v-47h-2v6l-4-4v-3h-16l4 13 5 5 4 3 7 3v6l-6-1-10-6-6-8-4-13z",
    fill: "#B5C6B6"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1399,1093)",
    d: "m0 0h5l-3 2-14 2h-7l4 7 5 2 12 3 9 4 11 7 5 6v2h2v3h2v3l10 5h13l13-7h19l12 6 16 4h4v-2l-2-1 4-2 2-4 4-6 7-3 2-3 3 1-8 9-7 9-6 4h-17l-7-3-6-3-13-1-9 2-9 5h-19l-7-4-10-14-7-6-6-3v-2l-7-1-14-3-5-4v-2h-2l-3-9 5-1 14-1z",
    fill: "#39493D"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1953,593)",
    d: "m0 0 12 12 6 8 7 15 4 16v31l-1-2-8 7-2 3h-13l-3-8-4-8-5-5 6-1 24-10 3-2-1-11-4-12-6-12-4-6-11-12z",
    fill: "#7A9B84"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(32,315)",
    d: "m0 0 1 2-4 16h58l-9-11-2-4h2l7 9 6 6v2h-2l-1 3h-59v16h60l1-3-1 6-3 2h-57l5 18 8 16 9 13h-3l-4-5v-2h-2v-3h-2l-1-5h-2l-6-14-5-21v-20l4-17z",
    fill: "#9EB0A2"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(23,63)",
    d: "m0 0 2 1-7 8-9 7-2 4v12l7 14v20l-3 10h-2l-2 8-1 11h2l1 5 5 2 13 11 2 5h2l4 8v3h2l2 7 1 8 5 7 4 2 1-3v8l-7-2-6-5-2-4-2-12-7-14-8-9-11-8-4-5-2-6v-9l5-12 3-8v-14l-4-9-3-7-1-3v-8l4-10 5-3 11-8z",
    fill: "#313F35"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2040,76)",
    d: "m0 0 4 1 3 7 1 3v64l-3 12-3 3-5 2 2-8h2l1-10-4-11-4-9v-19l3-7 4-9v-11z",
    fill: "#425547"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(13,527)",
    d: "m0 0 2 1-7 7-1 4v11l2 6h2l4 12v14l-4 11h-2l-2 8v11l2 5 4 2 13 10 3 4v2h2v3h2l5 14 4 13 5 4 3 1v-11h1v14l-1 2-7-2-6-5-2-4-3-13-5-12-7-8-2-1v-2l-5-2-8-7-3-5-1-4v-8l4-11 1-2h2l1-7v-14l-4-11-4-9v-8l3-9 7-2z",
    fill: "#3B4C3F"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(232,71)",
    d: "m0 0 5 2 1 2 1 21 5 2 7 4 3 3 4 10v6h-28v-49z",
    fill: "#B1C3B3"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1992,663)",
    d: "m0 0h1l1 6v38l-2 20-4 15-5 12-9 16-10 11-4 5-4 2-2-5 11-11 9-14 6-12 4-13 2-13 1-52 4-2z",
    fill: "#4D6353"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(278,1091)",
    d: "m0 0 4 2 9 8 10 7 12 5 8 3 9 3-2 1v2h-6l-15-6-8-3v-2l-5-2-4-2v-2l-4-1v-2l-4-2-4-4v-2l-12 2-15 2 4 6 5 2 16 4 13 8 7 7 1 4h2v3l3 1 5 5 6 2h7l7-2v-2l6-1v2l3 1-11 6h-19l-8-6-8-11-7-7-11-5-15-4-6-4-4-5-2-6 25-3z",
    fill: "#38483C"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(117,888)",
    d: "m0 0h4v34l-5-1-3-2v-2l-41-1v-6l18-1 1-3v2h6l1-6 4-6 8-6z",
    fill: "#B5C6B6"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(92,813)",
    d: "m0 0 2 4-7 8-10 12-6 12-5 12-3 14-1 11-1 50-6 4v-57l3-17 6-18 8-14 10-13 5-5h2v-2z",
    fill: "#4C6252"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(49,925)",
    d: "m0 0 2 2 1 17-2-1-1-13-7 5-4 16-4 10h-2l-1 4-8 9-9 6-6 7-1 2v15h2l5 11 1 4v13l-3 9-4 7-1 4-1 14-4-1-1-2v-11l3-7 5-12v-14l-3-8-4-7-1-4v-8l3-9 4-5 5-4 5-3 8-8 6-12 4-17 8-7z",
    fill: "#3D4E41"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 498)",
    d: "m0 0h1l2 7 9 10 2 3v3h2v3h2l2 7h2l3 7 5 15 2 10v23l-3 13-4 12-4 9h-2l-1 5h-2l-2 5-7 9-5 6-4-2-1-6 4-2v3l7-8 1-2h2l1-4 4-6 8-21 2-10v-25l-4-16-3-7-4-9-7-11-8-9-4 9-3 4 1-5 5-16z",
    fill: "#415446"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(91,358)",
    d: "m0 0 2 3-1 5-8 8-7 9-8 16-2 5-2 7-2 10-1 68h-1l-1-21-2 2h-3v-40l2-14 6-20 8-15 8-10 9-10z",
    fill: "#556B5B"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(303,206)",
    d: "m0 0 3 1-1 15-5 22-8 16-8 11-8 9-10 8-15 9-13 4-5 2-16 2h-10l1-2 4-1 13-1 24-7 14-8 10-8 9-9 9-14 5-12 4-12 2-21h-2v9h-1v-8l-15 6-17 5-21 3 21 21 6 5 4 5 3 3 1 5-4-2-35-35-4-3v-2l25-2 13-3 19-7 6-1v-2z",
    fill: "#E1E7E2"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(115,777)",
    d: "m0 0h7v8l-1 5-7 3-2 2v9l2 4 6 2v14l-8-1-8-6-5-6-2-5v-12l5-9 6-5z",
    fill: "#E8ECE8"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(162,358)",
    d: "m0 0h1v65l-4-2-7-6-2-4v-46l7-2z",
    fill: "#4F6655"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(869,1094)",
    d: "m0 0 17 2 8 1-2 7-6 3-15 3-15 9-8 9-2 2-10-11-2-2 14-7 14-10z",
    fill: "#7A9C84"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1557,61)",
    d: "m0 0h66l19 4 16 7 15 10 11 10-1 3-7-6-9-8-14-8-17-5-6-1h-84l-16 4-16 8-9 7-5 4-3 4-4-1 10-10 10-7 15-8 16-5z",
    fill: "#E1E7E2"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1106,61)",
    d: "m0 0h63l17 3 10 3 14 7 12 9 10 9v2l-4-2-10-9-14-8-8-4-17-4h-84l-14 3-9 4-14 8-10 9-3 3h-3l2-4 11-10 13-8 8-4 16-5z",
    fill: "#E1E7E2"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(52,721)",
    d: "m0 0h1l2 13-11 12-5 9-6 12-4 13-2 10v19l3 15 3 10 6 12 1 4h2l8 11 5 5-1 8-2 10h-1l1-13-8-8-2-5h-2l-7-13v-2h-2l-6-18-2-5-2-14v-12l3-18 6-16 10-16 12-15z",
    fill: "#475C4D"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(590,1052)",
    d: "m0 0 4 1 9 9 8 6 15 7 14 4 82 1 17-3 15-6 12-8 10-9 4-2-2 5-9 8-13 8-9 5-16 5-11 2h-69l-16-3-16-6-10-6-10-8-8-7z",
    fill: "#E1E7E2"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(553,1051)",
    d: "m0 0 2 2-6 7-15 11-16 8-9 3-15 3h-69l-16-3-16-6-15-10-12-11-2-3 4 1 8 8 15 10 12 5 12 3h87l14-3 9-4 11-6 9-7z",
    fill: "#E2E8E2"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1331,61)",
    d: "m0 0h64l17 3 12 4 18 10 13 11 3 3v2h-3v-2l-4-2-9-8-15-9-17-5-6-1h-85l-15 4-16 8-14 11-5 5v-4l12-11 13-8 11-5 9-3z",
    fill: "#E2E7E2"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1954,364)",
    d: "m0 0 4 2 10 11 8 13 4 8 5 15 2 13v68l-2 14-3 10-8 16-7 10-9 10-4 3v-3l5-5 7-8 8-13 5-13 2-10v-90l-4-15-5-12-4-6v-2h-2l-7-8-5-6z",
    fill: "#DDE4DE"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1957,132)",
    d: "m0 0 4 2 10 10 11 16 4 7 6 15v7h2l3 15 2 17v24l-3 25-1 10 11 13 4 6v6l-3-3-8-12-3-3v-2l-4 2-6 16h-2l-2 6-4 6-5 2 3-7 6-10 4-9 5-17 2-20v-44l-1-14-7-24-9-17-11-14-8-7z",
    fill: "#A7B9AA"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1469,97)",
    d: "m0 0h14l8 5 7 8 2 10h-14l-3-7-5-2-7 1-4 4-2 4h-13l1-8 6-9 7-5z",
    fill: "#EBEFEB"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1783,61)",
    d: "m0 0h64l17 3 12 4 16 9 5 3v2l6 3v2l4 2 3 3v2h-3l-5-6-11-8-10-6-15-5-9-2h-85l-19 5-15 8-11 9-5 5h-3v-2l8-7 10-8 12-7 13-5 13-3z",
    fill: "#E3E8E3"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1693,21)",
    d: "m0 0h18l19 4 9 4 17 9 10 8 7 7-3 2-8 2 1-3-2-3 4 1-8-7-2-1v-2l-5-2-16-8-20-5h-23l-15 3-13 5-9 5-16 12h-2v2l5-3 4-2-5 7-7-1-2-1 2-4 8-7 7-5h2v-2l17-8 10-4z",
    fill: "#3F5244"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1494,1052)",
    d: "m0 0 4 2 10 9 2 1v2l4 1 8 5 13 5 9 2h89l15-4 16-8 13-10 4-5h3l-2 4-7 6-4 4-12 8-11 5-13 4-12 2h-69l-15-3-14-5-9-5-7-4v-2l-4-2-10-9z",
    fill: "#E1E7E2"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1928,551)",
    d: "m0 0 9 1 4 2v2l4 2 5 8 1 2v14l-6 9-5 4-6 3h-5l-1-1v-12l6-3 3-5-1-8-3-3-5-2z",
    fill: "#EBEFEB"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1695,97)",
    d: "m0 0h14l7 4 7 7 2 5v7h-13l-3-7-5-2h-6l-4 3-2 6h-14l1-8 7-10z",
    fill: "#EBEFEB"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(428,61)",
    d: "m0 0h63l18 3 16 6 12 7 11 9 7 6-1 3-3-1-7-8-15-10-11-5-16-4h-86l-16 4-16 8-11 9-6 6-3-1 12-12 20-12 14-5z",
    fill: "#E1E7E2"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(816,1052)",
    d: "m0 0 4 1 9 9 15 10 18 6 5 1h88l15-4 9-4 12-7 10-9 3-3 3 1-10 10-13 9-16 8-15 4-7 1h-69l-16-3-11-4-10-5-13-9-9-8z",
    fill: "#E2E8E2"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1042,1052)",
    d: "m0 0 4 1 10 10 14 9 18 6 5 1h88l15-4 10-4 15-10 9-9 3 1-9 9-14 10-19 9-12 3-7 1h-69l-12-2-13-4-12-6-6-4-9-7-9-8z",
    fill: "#E1E7E1"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(973,41)",
    d: "m0 0 3 1-14 11-2 2 19 8 16 10 14 12 4 4v2l-4-2-10-10-13-9-17-8-19-5-6-1h-66l-21 5-20 9-14 10-12 11-2-1 9-9 13-10 14-8 11-5 9-3h2l1-2 26-3 5-1h25l23 3 11 2 7-7z",
    fill: "#A6B8A9"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(880,61)",
    d: "m0 0h63l18 3 13 5 8 4 12 8 12 11v2l-4-1-4-5-12-9-9-5-13-5-11-2h-84l-16 4-10 4-11 7-12 10-1 2-3-1 12-12 11-7 11-6 16-5z",
    fill: "#E1E7E2"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(340,97)",
    d: "m0 0h14l9 6 4 5 3 6v6h-13l-3-6-4-3h-7l-5 4-2 5h-13v-7l6-9 6-5z",
    fill: "#ECEFEC"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(201,61)",
    d: "m0 0h67l18 4 12 5 16 9 13 12 2 3-4-1-8-8-15-10-16-6-13-2-3-1-80 1-15 4-16 8-12 9-4 5h-2l-1 2-2-1v-2l8-7 12-9 10-6 16-6z",
    fill: "#E2E8E2"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(791,97)",
    d: "m0 0h12l8 3 5 4 4 6 2 5v5h-14l-3-7-2-2h-7l-5 3-3 6h-13v-7l6-9 7-6z",
    fill: "#ECF0EC"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1268,1051)",
    d: "m0 0h2l6 7 11 9 16 8 16 4h88l15-4 9-4 16-10 9-9h2l-2 4-11 10-13 8-10 5-17 5-8 1h-68l-16-3-16-6-10-6-9-7-10-9z",
    fill: "#E2E8E3"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(566,97)",
    d: "m0 0h13l10 6 6 8 1 9h-13l-3-6-4-3-8 1-4 3-2 5h-13v-6l5-9 7-6z",
    fill: "#EBEFEC"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1954,138)",
    d: "m0 0 5 3 10 12 9 14 5 13 3 12 1 7v67l-3 17-6 16-9 14-9 11-4 4h-2l2-4 8-8 10-16 5-14 2-9v-85l-2-12-5-13-5-9-7-9v-2l-4-2-4-4z",
    fill: "#DFE6E0"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1017,97)",
    d: "m0 0h14l9 5 7 10 1 8h-14l-3-7-3-2h-8l-4 4-2 5h-13v-7l4-7 8-7z",
    fill: "#EBEFEB"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(113,323)",
    d: "m0 0h7v13l-6 3-2 2v9l1 3 7 4v12l-9-1-6-4-6-7-2-5v-12l5-9 8-7z",
    fill: "#EBEEEB"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1720,1052)",
    d: "m0 0 4 2 11 10 13 8 13 5 9 2h86l16-3 11-5 10-6 9-7 6-6h2l-2 4-7 7-15 10-7 4-18 6-11 2h-70l-15-3-14-5-9-5-11-8-10-9z",
    fill: "#E1E7E2"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1265,1063)",
    d: "m0 0 7 6 16 11 19 9 8 1v2l-2 1-1 4-5 4-4 1-7 4-2-1-6-7-11-11-8-7-4-5z",
    fill: "#7D9E86"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(138,1052)",
    d: "m0 0 4 1 8 8 13 9 14 6 11 3h89l16-4 16-8 15-12 2-3 3 1-11 11-16 11-15 6-12 3-7 1h-69l-9-2-16-4-15-8-13-10-8-7z",
    fill: "#E2E7E2"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1954,818)",
    d: "m0 0 4 2 9 10 9 13 6 14 4 15 1 8v65l-2 14-4 13-9 17-8 10-8 9h-2l2-4 8-9 9-14 5-11 3-13v-88l-4-15-5-12-8-11-7-8-3-2z",
    fill: "#E1E7E1"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1588,71)",
    d: "m0 0 4 1 1 2 1 21-1 18 3 1 2 4v3h-18v-5l3-3h2v-17l-10 4-7 8-2 5-2 7h-6l2-10 4-8 4-5 8-5 9-2v-17z",
    fill: "#B5C6B6"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1243,97)",
    d: "m0 0h14l7 4 7 8 2 3v8h-13l-3-7-5-2h-6l-5 5-2 4h-12v-7l4-7 8-7z",
    fill: "#ECF0EC"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(785,1055)",
    d: "m0 0h2l-2 4-9 9-17 12-15 7-7 3h-3l5 6 13 9 18 9-3 1-12-5-12-8-10-9-3-1-14 3-14 1-5 1h-24l-25-3-17-5-16-7-11-7-13-11-5-4-2-4 4 2 12 11 13 8 15 7 17 5 16 2h51l14-2 15-4 13-5 9-6 10-7 10-9z",
    fill: "#A6B9A9"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1690,1026)",
    d: "m0 0 2 2 3 5 4 2 9-1 3-5 1-2h13l-1 8-6 9-8 5-4 1h-8l-8-3-7-6-5-10v-4z",
    fill: "#EBEFEB"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(323,1027)",
    d: "m0 0h13l4 6 3 2h7l4-2 3-6h13l-1 7-4 7-8 7-6 2h-8l-8-3-8-7-4-8z",
    fill: "#EBEEEB"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1929,777)",
    d: "m0 0 9 1 8 7 4 6 1 5v9l-3 8-5 6-7 4h-8v-12l8-5 1-8-3-6-5-2-1-5z",
    fill: "#ECEFEC"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1466,21)",
    d: "m0 0h19l16 3 10 4 7 3 15 9 11 9 5 5-7 1-5-5v-2l-5-2-3-2v-2l-4-1v-2l-6-2-8-4-13-4-11-2h-23l-23 6-16 9-11 9-4 4-11-2v-1l7-1 13-11 15-9 21-8z",
    fill: "#3D4F41"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1238,1026)",
    d: "m0 0 2 1 3 6 4 2 9-1 5-7 12-1v8l-6 9-9 6h-16l-9-6-6-9v-7z",
    fill: "#EBEFEC"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(786,1026)",
    d: "m0 0 3 2 2 5 3 2h7l5-3 3-5h13l-1 8-6 8-6 5-3 1h-13l-8-3-7-7-3-6v-6z",
    fill: "#EBEFEB"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(654,61)",
    d: "m0 0h63l18 3 14 5 15 9 10 8 6 6v2l-4-2-7-7-15-10-10-4-17-4h-85l-16 4-14 7-11 8-6 5-2 3-3-1 11-11 14-9 12-6 19-5z",
    fill: "#E3E9E4"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1929,323)",
    d: "m0 0 9 1 10 9 3 6v14l-6 10-9 6h-7l-1-2v-10l8-5 1-3v-7l-5-5-3-1z",
    fill: "#ECEFEC"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(560,1026)",
    d: "m0 0 3 3 3 5 2 1h9l3-1 2-7h14l-1 8-6 8-6 5-3 1h-15l-7-4-7-8-2-6v-4z",
    fill: "#ECF0EC"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1463,1026)",
    d: "m0 0h2l5 8 9 1 5-3 2-5 13-1v7l-3 6-4 5-7 4-4 1h-13l-9-6-6-9v-7z",
    fill: "#ECEFEC"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1011,1026)",
    d: "m0 0 3 1 4 7 2 1h7l5-3 3-5h12l-1 10-7 8-7 4h-16l-10-7-5-9v-6z",
    fill: "#ECF0EC"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(565,21)",
    d: "m0 0h17l15 3 12 4 19 11 13 11v2h2v2l-5 1-4-5-9-7-15-9-16-5-9-2h-24l-17 4-15 6-15 11-6 5-1 2-4-1v-3l10-9 14-9 14-7 16-4z",
    fill: "#3B4C3F"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1124,47)",
    d: "m0 0 1 2h25l23 3 18 5 16 7 11 7 11 9 10 9v2l-4-2-10-10-12-8-16-8-16-5-11-2h-66l-18 4-12 4-5 3h-3v2h-3v2l-8 4-10 8-8 8-2-1 12-12 12-9 22-11 15-5 11-2 17-1z",
    fill: "#A6B9A9"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1918,21)",
    d: "m0 0h18l19 4 9 4 7 3 15 9 9 7 8 8 1 4 3 1 3 5v2h2l1 5h2l2 7h-2l-1 2-10-16-11-13-5-4v-2l-5-2-14-9-13-5-18-4h-21l-17 4-3 1 3 2-5 2-3-1 2-1-3-1v-2h-2v-2l18-6z",
    fill: "#415446"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1803,49)",
    d: "m0 0h24l24 3 18 5 19 9 10 7 9 7 7 6 3 3v2h-3l-7-8-9-7-15-9-14-6-15-4-6-1h-67l-18 4-17 7-4 1v2l-9 5-11 9-7 7h-2l2-4 10-9 11-8 14-8 14-6 16-4z",
    fill: "#A5B8A8"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1577,49)",
    d: "m0 0h24l24 3 21 6 14 7 15 10 10 9 6 5v2l-4-2-8-8-13-9-11-6-12-5-16-4v2l-2-1 1-2h-70l-15 3-19 7-9 5-11 8-12 11-3 1v-2l8-7 9-8 10-7 13-6 12-5 15-4z",
    fill: "#A5B8A8"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1805,1025)",
    d: "m0 0h40v7l-3 9-7 9-11 6h-5v-5l5-3 5-2 7-8 3-11-15-1-2 6-3 1-1 41-5 1-1-1-1-41h-3l-3-5z",
    fill: "#B5C6B6"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2038,362)",
    d: "m0 0 3 3h4l3 7v10l-6 10-10 8-8 7-4 7-4 9-4 15-5 6-9 3-3-24-3-13 1-3h3v3l7-8 4-7h2l2-5 3-6 2 4-2 5-4 8-12 14-1 5 2 18 1 3 5-3h2l2-11 3-9 5-10 9-10 10-8 5-6 1-8-3-9z",
    fill: "#415446"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1927,222)",
    d: "m0 0 1 2 6 2 1 3h14l27 1 1 5-2 2-17 1-1 5-6 11-11 8-11 2-1-5 14-6 5-4 4-7 1-5h-17l-2 4-6 3z",
    fill: "#B1C3B3"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(117,428)",
    d: "m0 0h3v6l-6 2-8 3-6 7-4 9 17-1 4-4h4v20l-7-1v-7h-42v-6l1-1h19l-1-4 4-9 7-8 7-4z",
    fill: "#B5C6B6"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(660,1025)",
    d: "m0 0h35l-1 5-2 3h-2l-1 22v19h-6l-1-2v-38l-4-2-2-3v-3h-15l1 8 5 8 8 6 6 2v6l-6-1-10-6-6-7-4-11v-4z",
    fill: "#B5C6B6"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(93,364)",
    d: "m0 0h2l-2 4-8 8-7 10-6 12-4 13-1 6v85l3 15 5 12 9 14 9 10 2 1v3l-4-2-7-7-9-13-8-16-4-13-1-6v-79l2-10 2-7 7-16 8-11 9-10z",
    fill: "#E7ECE8"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(910,71)",
    d: "m0 0 5 2v17l6 1 8 4 6 5 5 9 2 11h-6l-2-9-4-6-7-6-7-3-1 17h3l2 4v4h-17l-1-4 3-4h2l1-41z",
    fill: "#B5C6B6"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(987,1)",
    d: "m0 0h11l12 5 8 3h13l8-3 8-4 3-1h10l8 3 7 8 7 9 7 6-2 1-8-7-5-6v-2h-2l1 4-5-5-1-3-5-2h-14l-6 2v2l-7 3h-21l-13-7h-14l-6 4-8 10-5 6-11 7-2-1 3-1v-2l-6 2 3-3 8-5 8-8 7-10 7-4z",
    fill: "#334136"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(93,592)",
    d: "m0 0 2 2-7 7-10 13-7 15-4 17v82l3 14 5 13 7 11 9 10 4 4v2l-4-1-10-11-11-18-6-16-2-10v-77l4-17 4-8 3-7 8-12z",
    fill: "#E7EBE7"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1035,1055)",
    d: "m0 0 4 2 9 9 15 10 16 8 22 6 11 1h52l14-2 17-5 19-9 12-9 10-9 1-2h2l-2 4-13 12-15 10-13 6-18 6-10 2-14 1-4 1h-25l-24-3-10-2-3 3-2-1 2-3-15-6-13-7-11-8-14-13z",
    fill: "#A8BAAB"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2015,87)",
    d: "m0 0h2l5 18 1 17-2 17-4 13-2 5h-2v-3l-1 4 1 4-7 11-5 6v-3l1-2-5 6h2l-2 5-4 1-1 3v-4l2-2-2-2-4-10 2-4 7-8 19-19 1 2v3l2-11v-30l-4-13z",
    fill: "#819F89"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(684,71)",
    d: "m0 0 4 1 1 1 1 17 5 1 10 5 7 8 3 8 1 8h-5l-3-9-6-9-7-4-5-2-1 17 4 2 2 5h-5l-1 1h-7l-1-1h-5l1-4 4-4 1-40z",
    fill: "#B7C7B8"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1432,37)",
    d: "m0 0h2v2l-10 6-11 9-1 1 21 9v2l4 1 11 7 11 10 6 5v2h-3l-7-8-11-9-16-9-21-7-12-2h-66l-22 5-16 8-14 9-12 11h-3l11-11 15-11 12-6 10-4 13-4 11-2h54l22 3 7-7 13-9z",
    fill: "#AABCAC"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1262,1055)",
    d: "m0 0 7 6 12 10 17 10 16 6 14 3 12 1h50l18-3 13-4 4 1-10 5h-4v2l4 2 4 3v2l5 2 11 7 5 2v2l-5-1-9-5-10-8-6-5v-2l-16 4-14 1-5 1h-24l-21-2-12-3-2-1-2 4h-2l1-3h2v-2l-7-1-21-10-12-9-10-9-3-4z",
    fill: "#A6B8A9"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(117,224)",
    d: "m0 0h4v18h-5l-2-2v-3h-18l6 12 6 5 12 4v6l-11-2-8-5-6-6-4-10v-3l-17-1-2-1v-5l1-1 39-1z",
    fill: "#B4C5B5"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1488,1056)",
    d: "m0 0 7 6 9 7 2 1v2l5 2 16 8 13 5 14 3 13 1h48l19-3 19-6 12-7h2v2l-16 9-12 4h-2v2l4 2 8 7 14 8 3 1v2l-10-3-12-9-8-7v-2l-16 4-16 1-2-1-1 4v-2h-24l-21-2-19-5-16-7-11-6-17-14-5-5z",
    fill: "#A4B7A7"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1957,811)",
    d: "m0 0 4 2 11 12 8 11 6 11 4 9 5 17 2 11 2 17v24l-3 25-5 17-8 18-8 12-9 10-5 6-4 1 6-7 10-11 1-3h2l2-6 6-10 3-7 5-23 1-12v-39l-5 4 2-4 3-4-2-20-6-20-11-20-9-11-8-8z",
    fill: "#A4B9A8"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(93,138)",
    d: "m0 0h2l-1 4-8 7-7 9-8 17-4 17v83l4 17 7 14 9 12 2 4 4 2 2 4-5-2-11-13-9-15-5-13-3-13v-77l4-16 5-12 9-15 11-12z",
    fill: "#E9EDE9"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1954,592)",
    d: "m0 0 7 6 8 9 8 13 6 14 3 12v82l-2 9-3 9-7 14-10 14-9 9-1-3 9-9 9-14 5-10 4-16v-87l-4-16-8-16-8-10-7-7z",
    fill: "#E8ECE8"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(809,1055)",
    d: "m0 0 4 2 10 10 18 11 13 6 16 5 18 2h50l15-2 16-5 5-2 4 1-12 6-6 1 5 6 12 9-2 1-11-8-6-5v-2l-15 4-15 1-5 1h-24l-1 3v-4l-18-1-10-2h-5l-8 6 2-4 3-4-19-8-12-7-7-5v-2l-4-2-11-10z",
    fill: "#A6B8A8"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(459,71)",
    d: "m0 0 4 1v49h-7l-5-1 1-5 1-2h3v-17l-10 4-6 5-6 15h-5l1-9 5-10 8-7 8-4h5l-1-4v-9l2-5z",
    fill: "#B4C5B5"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1106,1025)",
    d: "m0 0h43l-2 1-2 5-3 2v-5h-2v46h-6v-48h-2v7l-4-3v-4l-15 1 2 10 8 9 9 4v6l-10-3-8-6-5-8-2-5z",
    fill: "#B5C6B6"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(57,635)",
    d: "m0 0h2l-1 9-2 14v48l3-3h2v-44h1v56h-1l-1-10-4 4v10l3 15 5 15 6 12 7 10 9 11 5 5-1 2-12-12-12-17-8-17-5-17-3-24-1-3v-24l1-2 2-20 4-15z",
    fill: "#A3B5A6"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 950)",
    d: "m0 0h1l2 6 2 2v3l4 2 4 5v3h2v3h2v3h2l7 15 5 17 1 6v25l-4 15-4 10-5 10h-4v-3l8-19 3-12 1-7v-9l-2-17-7-21-6-11-12-15-3 3 2-10z",
    fill: "#475C4D"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(673,49)",
    d: "m0 0h24l25 3 17 5 12 5 9 5 9 6 10 8 6 5 2 5h-2l-4-5-11-9-2-1v-2l-6-2-12-7-16-6-17-3h-65l-21 5-5 2h-4v-2l16-6 18-4z",
    fill: "#A7B9A9"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(447,49)",
    d: "m0 0h25l24 3 20 6 17 8 18 13 10 10h-3l-12-11-11-7-16-8-16-5-11-2h-66l-21 5-8 3h-3v-2l10-4 15-5 11-2z",
    fill: "#A7B9AA"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(62,396)",
    d: "m0 0 1 4-5 16-2 14v63l3 16 6 16 7 14 9 12 10 10v2l-4-2-10-11-10-15-6-10-8-24-2-11-2-17v-26l1-3 2-19 2-13-3-3 1-2 3 3z",
    fill: "#A6B8A9"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(132,1055)",
    d: "m0 0h2l4 5 11 9 14 9 13 6 17 5 16 2h51l19-3 7-2h5v-2h5l-3 3-8 3h-3l4 4v2l6 3v2l5 2 5 4h-3l-9-6-10-9-15 3-20 2h-24l-25-3-9-3-13-4-16-8-14-10-9-9-3-2z",
    fill: "#A6B8A9"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1309,1119)",
    d: "m0 0 2 1-7 7-1 5-7 9-5 3h-18l-7-3-6-3h-19l-13 6h-19l-9-11-7-9-2-4 4 2 4 4v2l4 1 1 4h2l5 5 6 2 8-1 12-6 3-1h20l15 7 8 1 7-2 5-5 4-5 8-7z",
    fill: "#475C4D"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2013,753)",
    d: "m0 0h2l4 10 4 9 3 11 1 7v22l-4 17-4 10-10 17-12 15h-2l-1 2-3-11 1-3 3 6 9-10 1-3h2l2-5 9-21 3-13v-24l-3-14-4-12-1-4 1-2z",
    fill: "#495E4E"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(33,305)",
    d: "m0 0 2 4-4 10-4 17v20l5 21 5 12v2h2l1 5h2v3h2l5 7 5 5 1 4-3 16-1 9h-1v-10l2-14-5-5-7-8-3-5v-2h-2l-8-18-3-8-2-9-1-9v-11l2-15 4-13 3-6z",
    fill: "#475C4C"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(359,1056)",
    d: "m0 0 8 6 9 8 13 8 16 7 14 4 15 2h51l19-3 10-1-1 2-16 5-21 2-4 1h-24l-25-3-11-3-1 4-11 9-6 1 5-4 11-9 1-2-9-2-12-6-11-6-10-8-6-5-4-5z",
    fill: "#A5B8A8"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1691,26)",
    d: "m0 0h23v2h-3v58h-1v-57h-23v31l-7-6-16-16 2-1h-4-3l8-5 17-5z",
    fill: "#7F9E88"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(73,684)",
    d: "m0 0h47v7l-24 1 5 10 8 7 11 3v6l-8-1-10-5-5-4-6-12v-4l-17-1-2-1v-5z",
    fill: "#B5C6B6"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1746,208)",
    d: "m0 0 3 1 1 13 3 13 5 12 6 11 7 9 6 7 6 4 4 4 14 8 21 7 7 1h8l-2-4 1-3 4 8v3h-16l-12-3-10-3-15-8-13-10-10-11-7-10-3-8-3-7-5-23z",
    fill: "#232A25"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1091,1091)",
    d: "m0 0 16 3 18 2-3 9-6 5-4 2-11 2-16 8-8 9-6 8-5 4-4 1h-17l-5-5h2v-2l5 2 11 1 9-4 10-13 7-6 1-2 9-4h3v-2l18-4 3-2 1-5-19-3h-6l-7 7-7 5-2-1 3-5 5-5z",
    fill: "#3B4B3F"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(730,1091)",
    d: "m0 0 4 2 10 9 15 9 17 6 17 3h11l17-3 9-3 4 1v3l-10 4-15 3h-21l-15-3-9-3-10-5-5-2v-2h-3v-2l-4-1v-2l-4-1v-2l-4-1-6-6-10 1-16 1v-2l20-2z",
    fill: "#3F5244"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(72,847)",
    d: "m0 0 1 3-5 15-1 6v83l3 14 5 13 8 12 9 11 2 4-4-2-7-8-7-10-4-7-3-5-6-18-1-6v-77l4-17 5-10z",
    fill: "#E7ECE7"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(203,51)",
    d: "m0 0h61l14 3 19 7 13 7 8 5v2l5 2v2l4 2 6 5 2 4-4-2-11-10-10-7-19-9-19-5-8-1h-63l-18 4-9 3-6 1v-2l5-2h4v-2l16-5z",
    fill: "#ABBDAE"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1149,1025)",
    d: "m0 0h183l2 8 4 11h-2l-4-8-1-9-49 1v-2h-8v5h-1v-5l-12 2-4 6-4 2-9-1-4-5-2-3h-11l-1 3v-4l-8 1h-49l-1 9-3 5-1-2 3-8v-4l-18-1z",
    fill: "#93A598"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 273)",
    d: "m0 0 4 5 6 7v2l3 1v3h2v3h2l1 5h2l5 12 4 10 3 15v22l-4 16-4 11-2 1v-5l-2 2 1-5 5-19v-25l-4-18-7-14-5-9-11-13v-6z",
    fill: "#485D4E"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(865,1092)",
    d: "m0 0 10 1 23 3v6l-6 7-7 3-10 2-9 4-6 4h-2l-2 4-6 7-4-1-2 4-4 4-6 1 4-3 6-5 8-11 7-6 12-7 18-4 3-1 1-5 1-2-16-1-9-1-12 10-13 8-7 4h-3l-1-3 16-10h3v-2h3v-2z",
    fill: "#3E4F42"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(936,1025)",
    d: "m0 0h170l3 11 2 7-4-4-2-7v-5h-48l-1 2v-3h-8v5l-1-4h-12l-2 5-3 3-3 1h-7l-5-5-2-4h-12l-1 2v-3l-8 1h-48l-2 10-2 1 1-8 1-4-6 1z",
    fill: "#91A396"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(278,882)",
    d: "m0 0h3l2 4-8 7-28 28 1 1 18 2 15 4 15 6 2 1 2-4v7h2l1-4 1 4 2-4v6l-2 1-2-1-2 2-13-7-17-5-15-3-17-1 1-5 8-7 26-26z",
    fill: "#A2B3A5"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(167,689)",
    d: "m0 0h2v2h2l1 116 2 4h-2l1 7-4-2-2-2z",
    fill: "#354439"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(60,175)",
    d: "m0 0 1 4-4 16-1 7v62l3 17 6 16 4 8 7 11-1 2-7-9v-3h-2l-8-17-5-16-2-12-1-14-1-1v-25l4-27 5-16z",
    fill: "#A6B8A9"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1621,1025)",
    d: "m0 0h184v1l-21 1 4 12 1 4-4-4-3-10v-2h-70l-2 6-5 3-9-1-4-4-2-4h-12l-8-1-1 3v-2l-47 1-2 1z",
    fill: "#95A699"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(216,271)",
    d: "m0 0 1 3-4 12-4 9-1 2h-2l-1 5-7 9-9 10-1 2h-2v2l-5 5-8 7-3 4-3-3 1-7 4-4h2l2-4 5-5 5-4 9-11 7-10 4-7 3-7 2-3h2l1-4z",
    fill: "#536959"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(223,238)",
    d: "m0 0 5 3 11 12 10 10 2 1-2-6-4-4-2-5 1-6 3-3 4 1-2 8 7 9 1 6-2 5 8 7 2 4-4 2-36-36-3 22-3 12-8 19 3 1h-5l1-5 6-14 4-16 1-7 1-19z",
    fill: "#CBD5CD"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(146,1)",
    d: "m0 0h12l8 4 10 13v2l3 1 5 5 12 6 17 4 7 8 1 6-23 3h-5l3-2 20-3-3-5-6-3-16-4-8-4v-2l-4-1v-2l-4-2-14-16-4-2h-11l-6 2-6 1 4-5 4-3z",
    fill: "#45584A"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1952,692)",
    d: "m0 0h6l-3 10-5 7 15 5 16 8 1-2v11l-4 16h-2l4-22-4-1-13-7-13-4-5 2-9 4-7 1v48l-2 3v-59l10-2 8-5 5-7z",
    fill: "#8B9E91"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(6,1063)",
    d: "m0 0 2 4h2v2l4 2 13 10 1 4 3 1 1 5h2l4 12 1 4 9 3 12 6 8 6 1 4h2l3 5v2l3 1 1 3h-2l-3-3 5 6 4 3-5-1-7-7-6-8-1-3-4-2-10-6-8-3-6-1-5-16-6-9-8-8-9-6-4-6 1-3v2h2z",
    fill: "#334237"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(60,704)",
    d: "m0 0h1l3 28 5 16 9 16 7 9 7 8 3 1 2-4h3l-7 9-4-1-7-7-10-13-4-7-5-10-5-15-3-15v-10z",
    fill: "#495E4F"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2045,1062)",
    d: "m0 0 1 4-6 8-11 8-7 8-6 12-2 10-13 3-11 6-7 7-8 11-3 3-6 1v-4l4-3h2l2-4 7-9 9-8 14-7h6v-6l7-14 9-10 11-9 4-3-2 4h1z",
    fill: "#2F3D33"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(113,21)",
    d: "m0 0h15l17 3 12 4 7 3v2l7 2v2l5 2 14 11 1 4-11 4-3-1 5-2v-2h3l-9-8-2-1v-2l-4-1-12-7-16-5-10-2h-22l-13 3h-5v-4l13-4z",
    fill: "#3C4E41"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1958,450)",
    d: "m0 0 1 4h17l2 2v5l-3 3h-16v2h15v1h-22l-1 5-6 8-8 5-2 1h-7l-1-2v-13l8-2v-6h18l-1 3h6v-3l15-1 3-2-1-4-18-1z",
    fill: "#506756"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1500,1)",
    d: "m0 0h12l7 3 7 6 6 9 8 7 7 4 13 4 9 3 5 5 3 8-23 3h-5l3-2 13-2h7l-5-7-5-2-16-4-6-3v-2h-3v-2l-5-2-8-9-5-7v-2l-4-1-3-1-15-1 1-4z",
    fill: "#3F5143"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1827,847)",
    d: "m0 0h11l1 3h2l-2 6-4 10-4 11-2 12-1 20-5-1-9-10-30-30v-2l4-1 35 35 4-25 7-21 3-6h-10z",
    fill: "#9FB0A2"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 473)",
    d: "m0 0 9 4 6 7 4 17 6 11 5 6 14 10 4 6 2 7-1 9-3 6h-3l-2 1 3-9-1-10-3-5-3-3v-2h-3v-2l-5-2v-2l-4-2-6-7-5-11-2-5-2-9-2-5-1-3-6-1-1 14-1 5h-1l1-16z",
    fill: "#36453A"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1079,1101)",
    d: "m0 0 3 1-5 7h-2v2l-19 9-16 4-5 1h-21l-13-3-15-5-8-4-2-4 10 2v2l6 1 19 5 7 1h11l17-3 15-5 16-9z",
    fill: "#3D4E41"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1261,1055)",
    d: "m0 0 4 4 7 8 15 11 21 10 3 2-6-1-19-9-20-15-1 12v39l16-5 3 1-15 5-10 1v-61l-2-1z",
    fill: "#4F6655"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(268,1025)",
    d: "m0 0h166v1h-5v7l-2-2v-4h-70l-2 6-5 3h-7l-6-5-1-4h-13l-8-1-1 4v-3h-43z",
    fill: "#95A79A"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(458,70)",
    d: "m0 0h5l2 4v14l3 2h-4v6l9 3 6 5 4 8 2 9h-17l-2-8h-2v8h-1v-49l-6 1-1 4v13h-5l3-1v-14l2-4z",
    fill: "#4F6655"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(762,1)",
    d: "m0 0h10l8 3 8 4 4 1h13l8-3 5-1-2 4 2 1-9 4-6 1h-9l-9-2-12-6h-10l-7 3-6 8-7 9-8 5-2-1 3-6 5-4 11-15 6-4z",
    fill: "#3C4D40"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2017,80)",
    d: "m0 0 2 2 6 15 2 9v25l-4 18-1 3-3-1 1 6-3 7h-2l-2 6-6 8h-3l-3 2 2-4 9-14-1-5 2-5 1 3-1 2h2l1-5 4-13 2-17-1-17-5-18-1-4h2z",
    fill: "#4D6353"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(170,1130)",
    d: "m0 0v3l-2 5-5 5-3 1h-18l-12-6h-19l-13 6h-17l-8-8v-2l3 1v2l5 1 8 2 8-1 14-7h19l16 7h10l8-4z",
    fill: "#45584A"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2011,308)",
    d: "m0 0 3 3 2 5h2l4 18v25l-5 19-5 12-3 5h-2l-1 4-6 8-2-4 8-11 5-10 9-27h-62l1-2 61 1v-16h-61v-1h61l-1-4-55-1 2-2 52 1-7-21z",
    fill: "#ABBDAD"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(957,983)",
    d: "m0 0h239l-2 4-8 8v3l-7 4-10 10-2-1 7-8 4-3 1-3 3-2-10-10h-215z",
    fill: "#91A397"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(28,583)",
    d: "m0 0h62l1 3-9 8-10 13-8 14-4 9-2 2 1-5 8-16 8-12 7-9-52-1-1 2z",
    fill: "#536A59"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(355,28)",
    d: "m0 0 9 1 7 2-4 1-6-2v53l11-9 10-7 6-2-4 4-13 9-12 11 4-2-2 4-8-1 2-1z",
    fill: "#566B5C"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(231,70)",
    d: "m0 0h5l3 4v15l3 1h-4l-1-15-3-3h-4v49h-1v-8h-2l-2 8h-17l2-10 6-9 8-5 4-1 1-6-4-1 3-1 1-17z",
    fill: "#506756"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(334,28)",
    d: "m0 0h4v61l2 1-6-1-1-3-4-2-6-5v-2l-5-2v-2l-5-2-9-5-14-7 3-1 16 8 11 7 11 10 1-53-6 1 3-2z",
    fill: "#576D5D"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1993,428)",
    d: "m0 0h1l1 5 2-4 2 18v26l-3 25-4 14-6 15-9 16-2 3h-2l-2 4-2 3h-2l-2 4-7 6 2-4 8-9 4-5 5-8h2l1-5 6-11 5-19 2-21z",
    fill: "#A8BAAB"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1185,32)",
    d: "m0 0 4 1 6 5-5 6-10 8-12-1-14-2 3-6 4-3 16-4z",
    fill: "#7E9E87"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(187,1092)",
    d: "m0 0 9 1 5 1 20 2-2 8-8 7-17 4-8 4-10 9-7 10h-2l2-5h-1v-3l1-3 5-5 8-6 1-2 10-5 17-4 3-1 4-7h-10l-17-3-2 4-10 8-8 5-2-1 3-1 1-5 5-2v-2l5-3z",
    fill: "#445849"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1743,207)",
    d: "m0 0 2 1 5 25 4 15 3 5 2 5 8 11 9 10 13 9 13 7 16 5 6 1h17l2 4h-18l-17-4-16-7-12-8-11-9-10-13-8-14-6-16-2-13z",
    fill: "#DBE2DC"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(207,841)",
    d: "m0 0h9l17 2 10 3 16 8 13 9 8 7 10 13 8 15 5 14 2 11v16l-2-1-4-25-3-11-8-16-7-9v-2h-2l-5-6-2-1v-2l-4-2-14-9-10-4-17-4-10-2h-10l-1-3z",
    fill: "#D9E0DA"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1772,1094)",
    d: "m0 0 10 1h51v1l-6 1h-30l-1 5-4 4-17 4-5 1-7-7 1-3z",
    fill: "#829F8B"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(75,845)",
    d: "m0 0 1 2-6 19-2 9 4 1 19 9 11 3-4 4-22-9v-2l-5-1v-2h-4v71l14-8 13-5h4l1-2 3 4-13 4-14 6-6 4 3 16 3 8 4 9-1 2-6-10-5-17-1-6v-83l4-16 4-9z",
    fill: "#98AB9D"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(915,1026)",
    d: "m0 0h1v7h2l2-7h16l-2 11-6 8-6 4-6 1 1 8-1 16-2 2-7-1-1-2-1-15-3-2h5l1 18h5l1-1z",
    fill: "#4F6655"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1972,682)",
    d: "m0 0 5 2 1 1v5l-2 2-16 1-2 2v-3h-6l-1 6-6 8-4 3-4 2-10 1v-15l6-3h2v-2h-7v-1l47-1 1-4z",
    fill: "#506756"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1332,1025)",
    d: "m0 0h29v2l5-1h4 2l-1 5-4 2 1 23-1 17-1 1h-6v-47h-2v6l-4-3v-4l-21 1-1 4z",
    fill: "#B5C6B6"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(583,1055)",
    d: "m0 0 2 1 1 4 4 2 10 9 10 7 3 3-6-2-12-9-7-6-1 52 3 1-9 1v-61h2z",
    fill: "#4F6655"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(135,1062)",
    d: "m0 0 7 6 6 3 8 6-1 5-10 9-6 6h-2v2h-2z",
    fill: "#7A9C84"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1959,129)",
    d: "m0 0h61l-1 7-54-1 7 8 10 14 2 6-3-3-12-17-12-12h2z",
    fill: "#506656"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(28,1008)",
    d: "m0 0h1v7l-1 2 3 1h-2v21l4 15 5 12 7 12 9 11 5 4v2l4 2 10 7 14 7 16 5 9 1h23l17-5 13-6 3 1-16 8-13 4-16 2h-8l-21-4-11-5-7-3-11-7-13-12-8-9-9-14-7-19-2-10v-23z",
    fill: "#99AC9D"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(209,1045)",
    d: "m0 0 8 6 7 4-2 1-6-3-5 12-7 14h59l-6-12-5-14-3-1 5-4h2l6 16 7 13v2l3-1 1 2h-76l8-16 6-16h-2z",
    fill: "#4C6352"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(506,1090)",
    d: "m0 0 4 1 4 5-4-2v1l8 7 7 5h-3l-5-3v2l3 1-2 1-2-1v-2l-4-1v-2l-5-2-5-5-19 2-6 1 4 6v2l10 1 9 3 12 6 5 4-1 2-4-3 7 8 9 12 1 2-4-2-8-11-7-7-14-7-16-4-7-8-1-6 4-1 21-2z",
    fill: "#324036"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(806,1055)",
    d: "m0 0h3l5 6 10 8v2l4 2 9 6-2 1-13-9-8-7-1 32v3 19h-6z",
    fill: "#4E6554"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1927,677)",
    d: "m0 0 7 3 1 3 40 1 2 2-1 4-1 1-40 1v2l-5 3h-3z",
    fill: "#B5C6B6"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(96,463)",
    d: "m0 0h18v6l7 1v17l-9-2-8-4-5-6-3-8z",
    fill: "#506756"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(47,246)",
    d: "m0 0 4 1 2 21 2 12-10 11-4 7h-2l-2 5-3 4h-3l2-6 9-14 10-11-3-22v-4l-7 6-4 15-5 12h-2l-2 5-2 1-2-1 2-6 5-11 4-16 6-7z",
    fill: "#445749"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(560,28)",
    d: "m0 0h4v61h-2v2l-3-1v-2l-9-9-14-10h3l13 9 5 5 1-53-3-1z",
    fill: "#506756"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(435,1045)",
    d: "m0 0 7 6-6 16-6 12h59l-9-19-2-6-3-2 8-7 1 3h-2l6 17 7 13 4 1v1h-76l8-16 4-10 2-6h-2z",
    fill: "#495E4E"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1738,1076)",
    d: "m0 0 4 1 18 8 14 4 6 1 17 1h43l16-2 7-2h6v2l-17 5-6 1h-63l-20-5-15-6v-2l-6-2z",
    fill: "#AABDAD"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1976,769)",
    d: "m0 0v3l-11 13 53 1 1-4 1 10h-62l1-4 8-8 7-9z",
    fill: "#586E5E"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1583,96)",
    d: "m0 0h2v17l-4 3-1 5h-24l2-11 4-7 1 2-5 15 6-1 2-9 4-6 7-6z",
    fill: "#546B5A"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(661,1026)",
    d: "m0 0h15l3 6 3 2v40h-1v-16l-9-3 3-1 6 2v-6l-8-2-9-8-3-6z",
    fill: "#526A58"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(681,85)",
    d: "m0 0h1v27l-3 1-2 4-1 3h5l1-2v3h-22l3-13 7-8 9-4h2v-6l-4-1 4-1z",
    fill: "#4F6655"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1812,73)",
    d: "m0 0h5l1 1 1 39 3 1 2 3v4h-19l1-5 3-3h2z",
    fill: "#B6C7B7"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(463,1026)",
    d: "m0 0h1v7l3-3 2-4h15v7l-4 8-8 7-7 3-1 23h-1z",
    fill: "#4E6554"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2037,164)",
    d: "m0 0 1 3h3l-10 8-6 5-5 7-4 10-4 16-8 7-6 1-4-29-1-6 3-1 4-4 5-2-2 5-6 7 1 11 1 14 7-2 2-6 2-9 5-13 6-9 10-9z",
    fill: "#415345"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(663,1048)",
    d: "m0 0 4 2-2 9-7 16-2 3 59 1-8-16-3-9-4 1-5 1 1-2 9-5 3-1 4 12 5 11 4 6v3h-75l6-6 8-17z",
    fill: "#45594A"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(131,1056)",
    d: "m0 0 7 6 7 7h-3l-6-6-1 53 8-1-3 2-11 1v-61z",
    fill: "#576E5D"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(5,834)",
    d: "m0 0 3 4 3 5 9 7 10 9 6 12 3 9 2 10 8 6 1-12h1v13l-1 3-6-1-8-7-4-17-5-10-9-10-11-8-4-6 1-4z",
    fill: "#36463A"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1035,1057)",
    d: "m0 0 7 6 9 8h-3l-8-7-1 52 7-1-3 2-10 1v-60z",
    fill: "#4B6251"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(468,1025)",
    d: "m0 0h114l1 2-3 7-3 2h-9l-5-5-3-4h-11l-1 2v-3l-8 1h-48l-2 11-5 7v-3l4-11 1-4-21-1-1 2z",
    fill: "#90A294"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(109,28)",
    d: "m0 0h3v63l-6 2v-64z",
    fill: "#4C6352"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(454,96)",
    d: "m0 0h2v17h-3l-2 7h4l1-3v4h-21l1-9 4-8 8-6z",
    fill: "#4F6655"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(689,95)",
    d: "m0 0 10 4 6 5 4 7 1 10h-21l1-2 5 1-4-6-2-1z",
    fill: "#506756"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2,609)",
    d: "m0 0 2 3v3h2l1-3 2 5 4 2 13 10 3 4v2h2v3h2l5 14 4 13 5 4 3 1v-11h1v14l-1 2-7-2-6-5-2-4-3-13-5-12-7-8-2-1v-2l-5-2-8-7-3-5z",
    fill: "#2D3930"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1114,1047)",
    d: "m0 0 5 3-2 9-9 19 59 1-8-16-4-12 3-3h2l6 18 7 12 3 2h-75l9-19 3-8z",
    fill: "#435648"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1566,1047)",
    d: "m0 0 4 3-1 8-7 16-3 5h60l-7-14v-2h2v-2l-3 1-4-10v-2l4-2 4 10 5 12 5 8v2h-76l3-3 1 1 9-17z",
    fill: "#465A4B"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(95,691)",
    d: "m0 0h26v1h-8v2l8 2v17l-12-3-10-9z",
    fill: "#4E6554"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(915,91)",
    d: "m0 0h1l1 5 7 3 8 7 4 8v7h-16l-2-8h-3z",
    fill: "#4F6655"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1534,1121)",
    d: "m0 0 3 1-8 9-7 9-6 4h-17l-7-3-6-3-13-1-9 2-7 4-4-1-3-2 16-8h19l12 6 16 4h4v-2l-2-1 4-2 2-4 4-6 7-3z",
    fill: "#354438"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1845,813)",
    d: "m0 0h9l8 3-5 5v-2h-10l-10 6-10 5-7 2h-17l-16-3 2-4h8l5 1h17l9-3 10-6z",
    fill: "#485D4D"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1835,841)",
    d: "m0 0h8l-1 3-17 1-12 3-10 3-16 8-10 8-4 4h-2l-2 4-6 7-6 10-4 10-3 6-2 8-2 17-1 6h-2v-9l3-18 6-17 7-12 8-11 9-9 13-9 8-4 9-4 15-4z",
    fill: "#E0E6E0"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1463,28)",
    d: "m0 0h4v61l-2 1-8-7-10-9-11-7-1-2 5 2 13 9 7 6 1-8 1-44-3-1z",
    fill: "#506655"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,1119)",
    d: "m0 0 4 2 3 1v2h2v2h2v3l3 1 6 7 5 2h10l12-6 4-1h19l6 3-3 2-5 1h-17l-12 6h-18l-5-2-2-4-8-11-6-6z",
    fill: "#4A5E4F"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1792,1047)",
    d: "m0 0 5 3-3 11-9 18h60l-4-8v-2h-2l-5-13v-5l3-3 9 23 5 7v2h-73l8-15 5-13z",
    fill: "#45594A"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1927,663)",
    d: "m0 0 9 1 7 3 7 8 2 8-10 1h-14v-1h7l-4-4-4-2z",
    fill: "#4F6655"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1927,434)",
    d: "m0 0 12 2 7 5 4 6 3 8h-18l-3-4-5-1z",
    fill: "#4F6655"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1141,95)",
    d: "m0 0 10 4 7 7 3 7 2 8h-17l-3-7-2-1z",
    fill: "#4F6655"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1957,809)",
    d: "m0 0h63l-1 9-1-3-55 1-6-5z",
    fill: "#4D6453"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1130,96)",
    d: "m0 0h3v17l-3 3-2 5h-16l1-9 5-8 6-5z",
    fill: "#506756"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,88)",
    d: "m0 0h1l3 13 4 6 2 6v14l-8 20-1 7h-1z",
    fill: "#E7EBE7"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1209,5)",
    d: "m0 0 2 1-9 11-8 10-4 3h-2v2l-14 6-15 4-4 6 23 4v1l-11-1-17-2v-5l8-9 16-4 14-7 7-7 5-7 6-4z",
    fill: "#485D4E"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1367,96)",
    d: "m0 0 8 2 8 7 5 10v6h-16l-2-6-3-2z",
    fill: "#4F6655"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(237,96)",
    d: "m0 0 5 1 8 4 4 4 4 10v6h-15l-3-6v-2h-2l-1-3z",
    fill: "#4F6655"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1012,28)",
    d: "m0 0h3v63l-7-6-13-11-16-10-4-3 5 1 13 8 13 10 3 3 1-54z",
    fill: "#4E6454"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1935,917)",
    d: "m0 0h17l-1 5-4 8-8 6-11 2-1-3v-12l6-3z",
    fill: "#4F6655"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,538)",
    d: "m0 0h1l2 13 6 13 1 4v14l-2 7h-2l-3 9-2 4-1-3z",
    fill: "#E8ECE8"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,313)",
    d: "m0 0h1l2 10 6 12 1 4v14l-5 12-3 8-1 7h-1z",
    fill: "#E7ECE8"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(765)",
    d: "m0 0h68v1l-9 1-10 4-5 3-4 1h-13l-11-4-5-3-11-2z",
    fill: "#E6EBE6"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1792,1096)",
    d: "m0 0h11l-2 7-7 7-4 2-12 2-14 7-8 8-6 9-6 5-3-1 1-1-2-2 6-4 7-10 9-9h2v-2l11-5 17-4 4-5 1-3h-5z",
    fill: "#4F6656"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(167,597)",
    d: "m0 0h4v92l-4-2z",
    fill: "#2D3930"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(33,532)",
    d: "m0 0h2l1 3-6 15-3 15v19l4 18 2 5v3h-2v3h-2l-5-15-3-19v-10l3-19 6-14h2z",
    fill: "#465B4C"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1928,208)",
    d: "m0 0 12 3 8 7 4 7v5l-17-1-2-3-5-2-1-2v-13z",
    fill: "#4F6655"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1593,95)",
    d: "m0 0 9 4 8 7 3 6 1 9h-16l-3-7-2-1z",
    fill: "#4F6655"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1809,96)",
    d: "m0 0h2v17l-5 5-1 3h-15l2-11 6-9 7-4z",
    fill: "#506756"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(991)",
    d: "m0 0h67v1l-11 2-8 4-8 3h-13l-8-3-12-5-7-1z",
    fill: "#E6EBE6"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(171,1105)",
    d: "m0 0 2 1-4 4-1 3-8 4-13 4-5 2-11 2h-19l-16-3-4-2v-3h7l16 3 19-1 15-4 12-5z",
    fill: "#435749"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(96,237)",
    d: "m0 0h18l2 4 5 1v16l-8-1-8-4-6-7z",
    fill: "#4E6554"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1353,97)",
    d: "m0 0h6v16l-4 4-1 4h-16l1-9 5-8 7-6z",
    fill: "#4F6555"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1217)",
    d: "m0 0h67v1l-11 2-6 3h-3v2l-7 2h-13l-20-8-7-1z",
    fill: "#E7EBE7"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(813,1097)",
    d: "m0 0 7 6 9 8v2l14-7 11-7 2 1-1 2h-3v2l-11 6-13 6-16 4-8 1h-11l-17-3-5-2v-1l9 1 4 1h23l6 1z",
    fill: "#7B9B84"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1147,1026)",
    d: "m0 0h15l-1 9-6 9-8 5-6 2v-18l5-5z",
    fill: "#516857"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(243,1026)",
    d: "m0 0h15l-1 10-6 8-7 5-7 1v-16l5-5z",
    fill: "#4F6555"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(258,193)",
    d: "m0 0h10l6 5 1 6-3-1v4h-2l1 3-15 3h-15v-1l13-1-3-6 1-5 3-5z",
    fill: "#869F8D"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1894)",
    d: "m0 0h68v1l-10 1-14 7-5 1h-11l-11-4-5-3-12-2z",
    fill: "#E7ECE8"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1668)",
    d: "m0 0h68v1l-10 1-14 7-4 1h-12l-11-4-5-3-12-2z",
    fill: "#E8ECE8"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1442)",
    d: "m0 0h68v1l-10 1-8 4h-2v2l-9 2h-11l-11-4-9-4-8-1z",
    fill: "#E6EBE6"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(313)",
    d: "m0 0h67v1l-12 2-8 5-7 2h-15l-10-5-7-3-8-1z",
    fill: "#E7EBE7"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(932,1048)",
    d: "m0 0h2l5 15 7 14 3 3h-74l2-5 8-16 4-9 1 2h2v2l-1 1-1 5-3 7-5 11 59 1-4-8v-3h-2l-5-13-1-2-6 2 3-3z",
    fill: "#4A6050"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(695,1026)",
    d: "m0 0h15l-1 8-4 8-6 5-9 4h-1v-19l3 1 2-5z",
    fill: "#4F6655"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(435,1026)",
    d: "m0 0h15l4 7 2 1v17l-7-2-8-6-4-5-2-5z",
    fill: "#506756"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(117,888)",
    d: "m0 0h4v16l-7 3-1 2h-17l4-11 8-7z",
    fill: "#4F6655"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(119,434)",
    d: "m0 0h2v16l-7 3v2h-18l3-9 7-8 8-3z",
    fill: "#4E6554"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1935,237)",
    d: "m0 0h17l-1 7-6 8-6 4-11 2v-15l6-4z",
    fill: "#506756"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(904,96)",
    d: "m0 0h3v17l-4 4v4h-17l2-11 6-8 6-4z",
    fill: "#4E6554"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(539)",
    d: "m0 0h67v1l-12 2-11 6-5 1h-12l-9-3-6-4-12-2z",
    fill: "#E7EBE7"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(209,1026)",
    d: "m0 0h15l3 5v2h3v18l-9-3-8-7-4-11z",
    fill: "#4E6554"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(96,917)",
    d: "m0 0h17l4 4 4 1v16l-10-2-7-4-5-6z",
    fill: "#4E6554"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1819,96)",
    d: "m0 0 4 1 8 4 6 7 3 11v2h-16l-3-7-2-1z",
    fill: "#4F6655"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(88)",
    d: "m0 0h67v1l-13 2-11 6-4 1h-13l-8-3-7-4-11-2z",
    fill: "#E7ECE7"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1718,188)",
    d: "m0 0h3v14l1 5h2l7 14 3 9v14l-3 19h-2l-2-2v-11l1-5v-15l-5-15-7-10-1-3v-7z",
    fill: "#415446"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1790,1026)",
    d: "m0 0h15l3 5v2h3v18l-9-3-5-4-4-5-2-4z",
    fill: "#4F6655"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1 1e3)",
    d: "m0 0 2 4 6 11 1 4v14l-5 12-3 7-1 7h-1v-57z",
    fill: "#E7ECE8"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1,774)",
    d: "m0 0 8 16 1 3v14l-2 6-5 10-2 10h-1v-57z",
    fill: "#E9EDE9"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(120,662)",
    d: "m0 0h1v17l-8 2v2h-17l3-9 5-6 8-4z",
    fill: "#4F6655"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1659,4)",
    d: "m0 0 2 1-5 5h-2l1 2 2-1-2 4-7 10-8 6h-2v2l-12 5-14 3-5 6-1 2 15 1 8 2-4 1-24-3 2-7 8-8 18-4 9-5 9-8 8-11z",
    fill: "#3F5144"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1485,1055)",
    d: "m0 0 7 6 9 8 6 5h-3l-10-8-2-2-1 9-1 43h5v1l-10 1z",
    fill: "#4C6352"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1564,1026)",
    d: "m0 0h16l3 6 2 1v18l-10-4-5-4-4-6z",
    fill: "#506756"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1784,826)",
    d: "m0 0h6l-2 2 3 2-9 4-5 6-6 17-3 4h-2l-2 4-10 6-14 5h-3l1-2h-2l-2 4-3 1 2-4 5-4 16-6 8-6 5-7 6-16 5-6z",
    fill: "#38483C"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(402,1123)",
    d: "m0 0 2 3-11 14-7 4h-18l-12-6h-20l-3-1v-2l-2-1 7-2h18l10 4 6 3 9 1 7-3 7-8z",
    fill: "#475A4C"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1598,1026)",
    d: "m0 0h16l-2 11-5 7-6 4-8 3v-18l4-4z",
    fill: "#4E6554"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(120,208)",
    d: "m0 0h1v16l-5 2-3 1v2h-17l3-9 5-6 8-4z",
    fill: "#4F6655"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(886,1026)",
    d: "m0 0h16l3 6 2 1 1 4-1 14-10-4-7-7-3-6z",
    fill: "#536A59"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1372,1026)",
    d: "m0 0h16l-2 10-5 8-8 5-6 1v-17l4-3z",
    fill: "#4E6554"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1338,1026)",
    d: "m0 0h16l2 5 3 2v18l-11-5-5-5-3-4z",
    fill: "#4F6555"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1654,1131)",
    d: "m0 0 2 1v2h2l3 3 8 3 9-1 11-6 4-1h18l7 3 12 5-1 4-7-1-11-5h-19l-8 4-3 2h-19l-5-5-3-4z",
    fill: "#3E4F42"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(231,314)",
    d: "m0 0h13l15 2 1 2-1 2 3 1h-12l-5-1h-15l-10 3-14 9-10 1-7-2v-2l7-1 6-1 5-3h3v-2l12-6z",
    fill: "#465A4B"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1112,1026)",
    d: "m0 0h16l2 5 3 3v17l-10-4-7-7-3-7z",
    fill: "#4F6655"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1824,1026)",
    d: "m0 0h16l-3 12-7 8-2 2-9 2v-17l3-2z",
    fill: "#4E6554"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(23,63)",
    d: "m0 0 2 1-7 8-9 7-2 4v12l7 14v20l-3 10-2-1-1 2h-2l2-9 1-4v-14l-4-9-3-7-1-3v-8l4-10 5-3 11-8z",
    fill: "#3E5043"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1928,888)",
    d: "m0 0 12 3 8 7 3 5 1 6h-16v-2l-6-2-2-1z",
    fill: "#4F6655"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1465,1055)",
    d: "m0 0h2v63l-10-1-3-2 7 1 1-53-9 7-2-1 12-11h2z",
    fill: "#4B6251"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(788,1137)",
    d: "m0 0h18l8 3 5 3 17 1-1 2h-61l4-4z",
    fill: "#EBEFEB"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(786,28)",
    d: "m0 0 4 1v62h-2v-2l-3-1v-2l-4-2-9-8-8-6h3l12 9 5 4v-54z",
    fill: "#475C4D"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1473,1136)",
    d: "m0 0 13 1 9 5 4 1 14 1v1l-11 1h-51l1-2 15-7z",
    fill: "#E8ECE8"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1021,519)",
    d: "m0 0h11l7 6v9l-6 6h-12z",
    fill: "#DFE5E0"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1959,355)",
    d: "m0 0h61l-1 6h-54l8 9 5 7-1 2-13-16-5-5z",
    fill: "#4E6554"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1895,264)",
    d: "m0 0 2 3v14l-13 7h-2v2l-14 6h-3l2-4z",
    fill: "#799A83"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2047,92)",
    d: "m0 0h1v54l-2-1-6-13-2-7v-10l3-8 5-11z",
    fill: "#E7EBE7"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1886,31)",
    d: "m0 0h2v2l3 1-14 8h-2v2l-6 4-6 5-1 2-11-2-24-3 3-9h2v-2h2v-2l9-3 10-2 4 1-1 2h-3l-1 3-13 3-5 4-2 4 14 1 13 1 8-8 15-10z",
    fill: "#405244"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1011,1058)",
    d: "m0 0 4 1v59l-9-1 4-1v-53l-14 11-2-1 11-9z",
    fill: "#4E6554"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1241,1137)",
    d: "m0 0h19l9 5 4 1 14 1v1l-12 1h-50l3-3z",
    fill: "#E9EDE9"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1015,1137)",
    d: "m0 0h19l10 5 1 1 15 1v1l-10 1h-51l1-2z",
    fill: "#EAEEEA"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1825,237)",
    d: "m0 0h1l1 19 4 20 4 11-1 4-6-15-3-14-2-16-36 36-3-1 1-4 32-32z",
    fill: "#8EA293"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(302,5)",
    d: "m0 0 2 1-2 4 3-3 2 1-8 8-6 8-7 6-5 3h-2v2l-12 4-9 2-6 5-1 2 5 1v1h-11l5-10 5-4 12-3 10-3 12-9 10-13z",
    fill: "#313F34"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(111,1137)",
    d: "m0 0h19l12 6 15 1v1l-12 1h-50l3-3z",
    fill: "#EAEEEA"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(563,1137)",
    d: "m0 0h17l15 6 14 1v1l-10 1h-51l3-3z",
    fill: "#EAEEEA"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1918,1137)",
    d: "m0 0h19l12 6 15 1v1l-11 1h-50l1-2 10-5z",
    fill: "#EAEEEA"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(337,1137)",
    d: "m0 0h19l12 6 15 1v1l-12 1h-49l3-3z",
    fill: "#EAEEEA"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1953,933)",
    d: "m0 0 3 2-2 1 15 6 11 6 2 2v7l-4 16-7 13-1-2 5-12 4-15v-5l-7-4-15-7-8-3-8 5-7 2h-5l1 49h-3v-59l2 4-1 5 13-4z",
    fill: "#8EA293"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(71,400)",
    d: "m0 0 1 4-3 13 1 4 19 9 7 3-3 2-7-2-9-4-9-5v72l17-8 12-4h3l1 2-20 8-14 7-1-3v-81l3-13z",
    fill: "#8B9E90"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2047,547)",
    d: "m0 0h1v56h-1l-3-9-5-10v-19l7-15z",
    fill: "#E9EDE9"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1692,1137)",
    d: "m0 0h19l13 6 5 1-3 2h-49l1-2 6-3z",
    fill: "#EAEEEA"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1238,1057)",
    d: "m0 0h3v61h-5l-1-1v-54-3z",
    fill: "#4E6554"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2047,998)",
    d: "m0 0h1v54l-2-1-3-7-4-9v-19l4-8 3-7z",
    fill: "#EAEEEA"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(49,739)",
    d: "m0 0h2l-2 4-7 10-8 16-4 13-1 10v19l4 17 7 16 8 12 7 8 3-1v-6l3-7h2l-1 6-5 16-2 1-1-7-7-7-5-7v-2h-2l-6-12-4-11-3-11-1-7v-19l4-18 4-10 7-13z",
    fill: "#A6B9A9"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1241,1056)",
    d: "m0 0 3 1h-2v61h16v-14h1v14l17-4 15-6 13-8 2 1-4 4-11 6-15 6-13 3h-26l-20-5-17-9-10-8-6-5 2-1 7 5v2l4 1v2l5 2 16 8 18 5 5 1z",
    fill: "#AABBAC"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(49,925)",
    d: "m0 0 2 2 1 17-2-1-1-13-7 5-4 16-4 10h-2l-1 4-8 9-9 4-3 3-2-1 4-6 5-3 8-8 6-12 4-17 8-7z",
    fill: "#425547"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2047,773)",
    d: "m0 0h1v55l-2-3-3-7-4-8v-19l6-12z",
    fill: "#E9EEEA"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1178,1092)",
    d: "m0 0h2v2l-9 2-17 1 4 6 5 3 12 3 10 4 11 8 4 4-1 3-6-7-2-1 11 14 5 7-4-2-10-13-7-6-8-4-8-3-11-2-7-6-2-4v-5l4-1 20-2z",
    fill: "#3A4A3E"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1939,1055)",
    d: "m0 0h3v61l7-1-3 2-9 1v-62z",
    fill: "#4E6554"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(301,208)",
    d: "m0 0 1 2h-2v9h-1v-8l-15 6-17 5-21 3 21 21 6 5 4 5 3 3 1 5-4-2-35-35-4-3v-2l25-2 13-3 19-7z",
    fill: "#B2BFB5"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2047,319)",
    d: "m0 0h1v53l-2-1-3-7-4-9v-19l7-13z",
    fill: "#ECF0EC"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1749,209)",
    d: "m0 0 27 9 17 3 17 1 1-2-1 4-13 12-25 25-2 3h-3l-1-3h2l2-4 32-32-25-4-16-5-12-5-1 4v-5z",
    fill: "#9DAEA0"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1432,6)",
    d: "m0 0m-1 1 1 3-2 4-6 8-8 8-12 7-17 4-5 4-2 3 5 1v1h-10l2-7 4-5 6-3 16-4 12-7 7-7 3-4 5-5z",
    fill: "#3F5143"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1751,15)",
    d: "m0 0 5 2 9 9 10 5 11 3 8 2 7 8 2 6-23 3-7 1 1-2 17-3 6-1-4-6-5-2-10-2-12-5v-2h-3v-2l-4-1-6-6z",
    fill: "#324035"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1918,1132)",
    d: "m0 0h19l10 4 6 3 13 1v3l2 1h-19l-12-6h-19l-7 3-7 2-4-1 1-2 7-2v-2z",
    fill: "#415446"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(638,1113)",
    d: "m0 0 3 1h2l2 1-11 7-8 8-7 10-6 4h-18l-12-6 2-2 7 1 4 2h13l9-6 8-11 5-4 1-2z",
    fill: "#485C4D"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(151,899)",
    d: "m0 0 3 4 6 10 9 10 8 7 15 8 13 4 5 16 6 11 11 12 7 6 12 7v1h-5l-6-3v-2l-4-2-8-7-9-10v-2h-2l-7-15-2-6v-4l-10-2-14-7-10-8-10-10v-2h-2l-6-11z",
    fill: "#DDE4DE"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(89,27)",
    d: "m0 0 3 1-2 1 1 2-9 4-12 7-8 6-12 11-10 13-1 3h-3l1 3-3 3 1-4h-2l2-5 7-11 11-12 11-9 16-9z",
    fill: "#232C25"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1992,28)",
    d: "m0 0 5 1 9 4 8 1 3 13 4 8v2h2l7 8 2 1v2l5 2 5 5-2 1-1 3-8-7-5-3v-2l-4-2-7-10-6-16-7-2-7-3 3-1v-2l-6-2z",
    fill: "#2F3C33"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1215,1)",
    d: "m0 0h9l20 8h13l7-1v-2l6-3 3 1-6 4 1 3-7 3h-21l-8-3v-2l-6-2h-13l-4 1v-2l-7 5v-3l6-5z",
    fill: "#334136"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1802,151)",
    d: "m0 0h5l4 3 3 1v2h3v2l4 2 11 11 9 14 5 14v3l11 2 10 5 11 8 11 11 8 12v5l-4-5-7-11-12-12-14-8-11-4-5-2-3-8-4-10-7-12-7-8-12-9-8-4z",
    fill: "#D3DCD4"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(358,1055)",
    d: "m0 0 2 1 2 4 3 5-3-1-1 53-1 1h-5l1-4h2v-2h-2v-54z",
    fill: "#4F6655"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1072,13)",
    d: "m0 0h2l7 9 6 5 6 2 11 4 11 3 5 3 4 6v5l-4 1-19 2-6 1v-2l10-2 15-1-4-6-2-2-13-3-13-5v-2l-5-2-7-6-3-4z",
    fill: "#3F5144"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1731,259)",
    d: "m0 0 2 3 1 4 4 2 4 3 14 5 8 6 4 4v2h2l5 13-1 3-2 3-6-15-4-4v-2l-14-7-11-4-8-9-1-6 1 3h2z",
    fill: "#37463B"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1825,844)",
    d: "m0 0h16l-2 4h-12l-10 2-20 8-9 6-1 2h-3v2l-8 7v-3l1-2-7 6v-3l5-5 9-8 12-7 14-5 9-3z",
    fill: "#37453B"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(117,110)",
    d: "m0 0h7l7 6v4h13l1-2v3h-24v23h-1l-1-13-6-3-3-4v-7l5-6z",
    fill: "#596F5F"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(38,1072)",
    d: "m0 0 4 4 8 11 10 10 12 9 5 3 10 4 7 3-2 1v2l-10-2v-2l-5-1-14-8v-2l-4-1v-2l-4-2-7-6-10-13v-2h2z",
    fill: "#2F3C32"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(621,14)",
    d: "m0 0h2l7 9 5 4 9 3 8 3 12 3 6 5 3 6v3l-23 3-7 1 1-2 17-3 7-1-4-5v-2l-12-2-12-5-8-4v-2l-5-2-4-5z",
    fill: "#3F5144"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1966,31)",
    d: "m0 0 5 1 15 9 9 7 8 8 1 4 3 1 3 5v2h2l1 5h2l2 7h-2l-1 2-10-16-11-13-5-4v-2l-5-2-14-9-3-3z",
    fill: "#2D3A30"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(335,1058)",
    d: "m0 0h2l1 60-10-1 4-1v-25h3l-3-3-1-26z",
    fill: "#4E6554"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(242,151)",
    d: "m0 0 4 1-16 10-11 11-7 11-5 13-3 8-9 2-16 8-8 6-9 9-6 9-3 7h-2l1-5 6-10 11-12 11-8 7-4 10-4 5-1 5-15 8-13 10-11 12-9z",
    fill: "#E0E7E1"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(317,109)",
    d: "m0 0 4 2 2 2v7h13l1-5 6-5h7l6 5 1 5h13v1h-55v-7z",
    fill: "#566C5C"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(53,509)",
    d: "m0 0h2l-2 4-9 11-8 15-5 15-2 12v20l5 19 8 16 7 10 6 7v2l-3-1-6-7-9-13-6-14-4-15-1-6v-19l3-15 8-20 10-14z",
    fill: "#9DB0A1"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(49,699)",
    d: "m0 0 2 3v11h-1l-2-8-6 4-5 18-4 9-7 9-8 7-8 6-3 3 2-5 10-8 8-7-5 4-6 5-2-1 10-9 5-7 4-11 3-13 4-5z",
    fill: "#425547"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(582,1025)",
    d: "m0 0h78l-2 2h-3l4 13 5 8-6 16-7 13-3 2-1-2 6-11 7-20-5-8-2-7v-4h-70z",
    fill: "#95A799"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1895,901)",
    d: "m0 0h2l-1 5-6 10-9 10-12 9-14 7-9 3-4 13-7 12-11 13-14 10-4 2h-3v-2l10-5 11-9 7-8 7-12 5-16 9-4 11-4 11-7 11-10 9-14z",
    fill: "#E0E7E0"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1952,1)",
    d: "m0 0h12l7 3 5 4 7 10 1 3 4 2 5 5 5 3v2l-7-1-6-4v-2l-4-2-9-11-6-5v-2l-17 1v-2l-6 2 3-3z",
    fill: "#37473B"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 866)",
    d: "m0 0h2l7 8 2 1-1 6-3 10-4 4h-4l-4-24h2l2-4z",
    fill: "#7E9F87"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(388,1110)",
    d: "m0 0 3 1-1 2 2 1-11 5-13 4-12 2h-19l-9-2v-3l5-1 8 1h12l15-3 15-5z",
    fill: "#415446"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(795,1131)",
    d: "m0 0 13 1 6 2v2l12 4h11l5-3 4-5 3 1-2 5-8 6h-20l-9-5-4-1h-19l-2-2 3-1v-2z",
    fill: "#3F4F43"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1924,110)",
    d: "m0 0h8v2l4 1 2 5v7l-5 5-6 1v-10h-23l1-2 13 1 1-6z",
    fill: "#546B5A"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(881,67)",
    d: "m0 0h29l-1 4-10 7-7 6-2 2-8-16z",
    fill: "#7C9E86"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(781,625)",
    d: "m0 0h14l5 4v7l-3 4-3 1h-13z",
    fill: "#E6EAE6"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(372,1)",
    d: "m0 0h10l7 3 4 2 12 16 8 6-2 1-7-1-7-7-7-9-2-4-4-1h-11l-7 2-8 2 3-5 7-4z",
    fill: "#3F5244"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1183,998)",
    d: "m0 0 4 2 13 12v2h-31l2-4z",
    fill: "#7C9E86"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(633,1090)",
    d: "m0 0 8 1 12 3 20 2-1 6-7 8-16 4-10 2 1-5 13-4 10-2 4-4 1-4h-9l-17-3-2 4-6 4-2-2 3-5 3-3-6 5-2-1 4-4z",
    fill: "#4A5F50"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1927 1e3)",
    d: "m0 0h2l-1 13 6 2 4 5-1 9-5 5h-7l-5-3-2-2v-5h9z",
    fill: "#566C5B"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2038,1012)",
    d: "m0 0 2 4v19l6 12 2 5v7l-2 4-6 8-3 2 2-4 3-8-1-10-5-10-2-6v-19l2-3z",
    fill: "#425447"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(85,1)",
    d: "m0 0h10l8 3 7 4 4 1h13l10-4 2 1-3 3 4-1-3 3-6 3h-21l-11-5v-2h-18v-2l-6 4-2-1 5-4z",
    fill: "#303E33"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1768,882)",
    d: "m0 0 3 1 39 39v2l-24 2-17 4-15 6-6 2v-6l2 3 14-6 18-5 19-2v-2l-6-5-2-5-14-14-7-8-4-3z",
    fill: "#96A89A"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(826,149)",
    d: "m0 0 5 1 5 2 10 10v1h-33l6-7z",
    fill: "#536A59"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(120 1e3)",
    d: "m0 0h1l1 22 9 1-1 5-5 5h-7l-5-3-2-2v-11l4-4h5z",
    fill: "#556B5B"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1109,490)",
    d: "m0 0h14l5 4v6l-4 5h-15z",
    fill: "#EAEEEA"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1764,149)",
    d: "m0 0h11l2 2h-8l-2 4-8 14-5 12-2 3v-2l-2 1-3 7-2-1 1-7 5-14 10-16 3-1z",
    fill: "#4F6655"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(718,38)",
    d: "m0 0h5l7 8 3 2-5 4-11-1-15-2 2-4 6-5z",
    fill: "#7F9F88"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 510)",
    d: "m0 0 5 4 10 14 3 5 3 7 5 16 1 6v25l-4 16-7 17-4 5-1 3h-2l-2 4-7 8v-3l9-11 9-17 5-14 1-13v-21l-5-18-8-16-3-5v-2h-2l-3-4v-2h-2z",
    fill: "#9AAE9F"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1065,149)",
    d: "m0 0 5 1 6 4 8 8v1h-32l6-7z",
    fill: "#536A59"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1536,149)",
    d: "m0 0 5 1 5 3 7 7 1 3h-31l6-7z",
    fill: "#536A59"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1953,818)",
    d: "m0 0 5 5 12 14 7 14 4 13 1 5v7l-6 5-21 9-6 2-8-6-4-2 4-1 6 4 7-1 19-8 5-3h2l-3-15-5-13-6-10-9-11-5-6z",
    fill: "#8EA193"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(317,182)",
    d: "m0 0 6 5-5 5-9 8-8 5h-3v2l-10 5-4-1 1-3h2v-2l11-7 9-7 6-5 2-3h2z",
    fill: "#5F7665"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(591,149)",
    d: "m0 0 5 1 6 4 7 8v1h-31l6-7z",
    fill: "#546A5A"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(947,66)",
    d: "m0 0 12 1 1 2-11-1-2 6-7 15-3 12 5 8 1 4v7l13-1h35l1 2h-56v-1h6l-4-13-4-7 1-9 6-15 3-5z",
    fill: "#7E9785"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(733,27)",
    d: "m0 0 3 1-3 6-10 4-13 3-7 6-1 2 15 1 11 1 5-1 1 3-1 2-11-2-25-3 4-9 5-5 17-4z",
    fill: "#465B4C"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(278,1091)",
    d: "m0 0 4 2 9 8 10 7 12 5 8 3 9 3-2 1v2h-6l-15-6-8-3v-2l-5-2-4-2v-2l-4-1v-2l-4-2-4-4v-2h-2v-2z",
    fill: "#2C392F"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(122,1025)",
    d: "m0 0h102v1l-21 1 4 13 2 3v5h2l-2 9-2 1-4 9-1-3 5-14v-6l-3-4-3-12-48-1-8-1-1 2-22-2z",
    fill: "#93A698"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2009,981)",
    d: "m0 0 3 2 6 15 4 16 1 11v9l-3 16-6 16-5 5 2-6 5-12 2-5 2-12-61-1v-1h61l-1-15-1-2h2l-5-20-5-12z",
    fill: "#9AAB9E"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(90,464)",
    d: "m0 0h6l5 12 5 5 9 4 5 1v6l-9-1-10-5-7-8-4-9z",
    fill: "#E3E9E4"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(408,27)",
    d: "m0 0 10 3 8 3 12 3 6 5 3 7v2l-23 3-6 1-1-2 25-4-6-7-17-4-10-6-3-1v-2z",
    fill: "#415345"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1787,865)",
    d: "m0 0 7 6 29 29v2h2v6l-3-1-7-8-31-31v-2z",
    fill: "#CBD5CD"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(875,66)",
    d: "m0 0h65v1l-58 1 9 19 2 6 9-4 3 1-13 7-3 1-8-20-6-10z",
    fill: "#445749"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(859,27)",
    d: "m0 0 5 2 6 2 17 4 6 3 4 5 2 7-23 3-8 1 2-2 9-2 15-1-4-6-2-2-17-4-12-6z",
    fill: "#465A4B"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1936,1057)",
    d: "m0 0h1v61l19-5 16-7 14-9 4-2-4 5-6 4h-2v2l-17 8-16 5-15 2h-8l-17-3-1-2 32 2z",
    fill: "#9DAFA1"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1953,593)",
    d: "m0 0 12 12 6 8 7 15 4 16v7l-8 5-15 7-10 3-3-4 6-1 24-10 3-2-1-11-4-12-6-12-4-6-11-12z",
    fill: "#92A496"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1839,1027)",
    d: "m0 0h6l-1 10-7 11-10 7-8 1v-5l5-3 5-2 7-8z",
    fill: "#E3E9E4"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2013,641)",
    d: "m0 0 1 2-3 9-2 11-5 6-5 1-2-13 7-8 7-7z",
    fill: "#7A9C84"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2036,122)",
    d: "m0 0 3 3 4 12 5 9-1 11-3 7-6 4-1-2 2-6h2l1-10-4-11-4-9 1-7z",
    fill: "#485D4D"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1747,953)",
    d: "m0 0 1 2h2l5 17 8 15 5 8h-6l-7-10-5-9-5-15-1-5z",
    fill: "#A0B1A3"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 925)",
    d: "m0 0 9 3 5 6 6 21 5 8-1 2-2-4h-2l-1 2-5-8-5-19-6-5-2-1-1 15-1 5h-1l1-18z",
    fill: "#3B4C40"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(187,843)",
    d: "m0 0h4l1 5-13 4-10 4h-2l-3 3-11 7h-2v-6l16-10 13-5z",
    fill: "#9AAB9E"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1806,90)",
    d: "m0 0 4 1v5l-12 6-5 8-3 9-5 1v-8l3-7 6-8 7-5z",
    fill: "#E7ECE7"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1450,25)",
    d: "m0 0 3 1-2 1v3l-10 3-16 9-11 9-4 4-11-2v-1l7-1 13-11 15-9z",
    fill: "#2D3A30"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(788,1073)",
    d: "m0 0h1l1 45-10-1 4-1v-41z",
    fill: "#4E6554"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1929,428)",
    d: "m0 0 13 3 8 6 6 9 2 4v4h-6l-5-10-5-5-7-3-6-2-1-5z",
    fill: "#E8ECE8"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1582,90)",
    d: "m0 0h2v6l-10 5-6 7-2 5-2 7h-6l2-10 4-8 4-5 8-5z",
    fill: "#E9EDE9"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1484,1057)",
    d: "m0 0h1v61l17-4 7-1-1 2-19 5h-26l-9-2-12-4-1-2 6 1 15 4 5 1v-32h1v32h16z",
    fill: "#A8BAAA"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(937,1026)",
    d: "m0 0h5l-1 8-4 9-7 8-7 4-7 1v-6l9-4 5-4 4-8 2-7z",
    fill: "#E7ECE7"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1388,1026)",
    d: "m0 0h5l1 2-4 13-7 9-11 6h-4v-6l10-5 5-5 3-7z",
    fill: "#E8ECE8"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(118,882)",
    d: "m0 0h3v6l-13 4-7 6-4 10h-6l2-9 6-8 8-6z",
    fill: "#E8ECE8"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(903,90)",
    d: "m0 0h3v6l-11 6-6 8-2 10h-7l2-9 3-7 7-8z",
    fill: "#E9EDE9"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(464,90)",
    d: "m0 0 5 1 10 5 7 8 4 12v4h-6l-4-13-4-5-12-6z",
    fill: "#E7ECE8"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(225,90)",
    d: "m0 0h4v6l-12 6-6 9-2 9h-6l1-8 3-8 7-8z",
    fill: "#E8EDE8"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(679,90)",
    d: "m0 0h2v6l-12 6-5 6-3 12h-6v-7l6-12 7-6z",
    fill: "#E7ECE7"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(203,1027)",
    d: "m0 0h6l4 12 4 5 6 4 6 2v6h-5l-10-6-7-8-4-11z",
    fill: "#E9EDE9"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(299,954)",
    d: "m0 0 4 3-1 7-3 9-4 10-8 12-3 1-3-1 2-4 8-14 5-13z",
    fill: "#9FB0A3"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1110,1026)",
    d: "m0 0 3 1 2 10 8 9 9 4v6l-10-3-8-6-5-8-2-5v-7z",
    fill: "#E8EDE9"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(711,1026)",
    d: "m0 0 5 1-2 10-4 8-8 7-7 4-5-1v-5l9-4 6-5 4-11z",
    fill: "#E9EDE9"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1820,90)",
    d: "m0 0 10 3 10 9 4 8 1 10h-5l-2-6-3-7-5-6-10-5z",
    fill: "#E9EDE9"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1594,90)",
    d: "m0 0 10 3 10 9 4 8 2 10h-7l-1-8-5-8-6-5-7-3z",
    fill: "#E8EDE9"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(451,90)",
    d: "m0 0h3v7l-9 4-5 4-6 15h-5l1-9 5-10 8-7z",
    fill: "#E9EDE9"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1368,90)",
    d: "m0 0 10 3 9 7 5 9 2 11h-6l-3-10-4-6-6-5-7-3z",
    fill: "#E9EDE9"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1384,1048)",
    d: "m0 0h2l5 16 8 14v2h-61v-1h55l-8-17-3-9-7 2 3-3z",
    fill: "#485B4D"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(239,90)",
    d: "m0 0 6 1v2l5 1 9 8 4 8 1 10h-5l-6-15-6-5-8-4z",
    fill: "#E8ECE8"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(90,918)",
    d: "m0 0h7l4 10 7 6 12 4v5h-7l-10-4-7-7-6-11z",
    fill: "#E7ECE8"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(91,692)",
    d: "m0 0h5l5 10 8 7 11 3v6l-8-1-10-5-5-4-6-12z",
    fill: "#E9EDE9"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(115,657)",
    d: "m0 0h5v6l-13 4-5 4-6 11h-5v-5l6-10 7-6 6-3z",
    fill: "#E9EDE9"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1021,490)",
    d: "m0 0h12l4 5v6l-4 4h-12z",
    fill: "#E6EAE6"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(117,428)",
    d: "m0 0h3v6l-6 2-8 3-6 7-4 8h-5l2-9 6-8 8-6z",
    fill: "#E9EDE9"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(112,203)",
    d: "m0 0h8v6l-13 4-5 4-4 7-1 4h-6l2-9 4-6 7-6z",
    fill: "#E7ECE8"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1246,110)",
    d: "m0 0 9 1 5 5v4h13l1-4v5h-48v-5l1 4 12-1 3-6z",
    fill: "#5D7363"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1356,90)",
    d: "m0 0h2v6l-10 5-6 7-2 4-1 7-1 1h-5l-1-2 4-13 7-8 7-5z",
    fill: "#EAEEEA"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(691,91)",
    d: "m0 0 7 1 9 6 6 8 3 11v3h-5l-3-9-6-9-7-4-5-2z",
    fill: "#E9EDE9"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(359,1056)",
    d: "m0 0 8 6 9 8 13 8 16 7 14 4 5 1-3 1v2l-9-2-1 4-11 9-6 1 5-4 11-9 1-2-9-2-12-6-11-6-10-8-6-5-4-5z",
    fill: "#A1B6A5"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1952,918)",
    d: "m0 0h6l-3 10-6 8-10 6-11 2v-5l2-2 11-3 5-4z",
    fill: "#E8ECE8"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1929,657)",
    d: "m0 0 10 1 9 6 5 5 4 7 1 6h-6l-5-10-7-6-12-4z",
    fill: "#E8ECE8"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1129,90)",
    d: "m0 0h3v6l-11 6-5 6-3 7-1 5h-5v-7l4-9 6-8z",
    fill: "#EBEFEC"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1558,1027)",
    d: "m0 0h6l2 6 3 7 5 5 10 5v6l-6-1-10-6-6-8-4-13z",
    fill: "#E7ECE7"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1618,1026)",
    d: "m0 0 2 2-3 11-4 6-4 5-11 6h-4l-1-5 11-6 5-5 3-7 1-6z",
    fill: "#E8ECE8"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1952,692)",
    d: "m0 0h6l-3 10-6 8-9 6-11 2-1-5 3-2 7-2 6-3 6-8z",
    fill: "#EBEFEB"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(91,238)",
    d: "m0 0h5l6 11 6 5 12 4v6l-11-2-8-5-6-6-4-10z",
    fill: "#E9EDE9"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1142,90)",
    d: "m0 0 9 3 6 4 5 5 4 8 2 9-1 1h-5l-3-11-8-9-9-4z",
    fill: "#E9EDEA"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1784,1027)",
    d: "m0 0h6l3 9 3 5 5 5 8 4 1 1v5l-9-2-9-7-6-10z",
    fill: "#E9EDE9"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1163,1026)",
    d: "m0 0 5 1-1 7-5 10-7 8-6 3-7 1v-6l12-6 4-5 3-7z",
    fill: "#E9EDE9"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1929,883)",
    d: "m0 0 9 1 8 4 7 7 5 10v3h-6l-5-10-7-6-11-3z",
    fill: "#E9EDE9"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(30,829)",
    d: "m0 0 2 1 5 13 3 4v3h2l8 11 5 5-1 8-2 10h-1l1-13-8-8-2-5h-2l-7-13v-2h-2l-2-9z",
    fill: "#3E5043"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1952,467)",
    d: "m0 0h6l-3 9-4 7-10 7-8 2h-5v-5l11-4 6-4 6-9z",
    fill: "#ECEFEC"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(917,91)",
    d: "m0 0 6 1 6 3 6 5 5 9 2 11h-6l-2-9-4-6-7-6-7-3z",
    fill: "#EBEFEB"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(881,1027)",
    d: "m0 0h6l2 10 8 9 9 4v6l-5-1-8-4-7-7-4-8z",
    fill: "#EAEEEA"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(484,1027)",
    d: "m0 0h6l-1 8-5 10-9 8-10 3-1-5 2-2 7-3 6-5 4-8z",
    fill: "#EBEFEB"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 700)",
    d: "m0 0 6 1 8 7 5 18 1 7-2 3-3-4-4-13-3-10-6-4-3 20-2 3 1-10z",
    fill: "#445849"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(116,322)",
    d: "m0 0h5l1 43-1 5h-5l4-1-1-12-7-4-1-3v-9l4-4 5-1v-13z",
    fill: "#5E7363"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1953,238)",
    d: "m0 0h5l-1 5-6 11-11 8-11 2-1-5 14-6 5-4z",
    fill: "#EAEEEA"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1929,203)",
    d: "m0 0 9 1 8 4 7 7 5 10v3h-6l-5-10-7-6-11-3-1-3z",
    fill: "#EBEFEB"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1020,110)",
    d: "m0 0h8l5 4 1 6h14v1h-48l1-4v3h13l2-7z",
    fill: "#5B7160"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(598,1)",
    d: "m0 0h10l7 3 7 6 8 11 7 6-2 1-8-7-4-5v3l-9-9v-2l-4-1h-12l-9 4-2-1 3-1 2-6z",
    fill: "#2C392F"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(658,1026)",
    d: "m0 0h2l3 9 3 6 7 6 8 3v6l-6-1-10-6-6-7-4-11v-4z",
    fill: "#ECF0EC"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(429,1027)",
    d: "m0 0h5l5 12 5 6 5 3 5 2 1 2-1 4-9-3-6-4-6-7-4-11z",
    fill: "#EBEFEB"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1957,811)",
    d: "m0 0 4 2 11 12 8 11 6 11 4 9 5 17 1 5v15h-2l-3-21-6-20-11-20-9-11-8-8z",
    fill: "#C2CEC4"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2020,633)",
    d: "m0 0 2 3-4 6-1 6-4 17-7 8-8 2-1-7v-9l2 3v8l6-3 3-4 3-13 3-8z",
    fill: "#37473B"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1927,450)",
    d: "m0 0h5l3 3v2l22-1 9 1v1l-37 1v5h44v1h-15v3h-6v-2l-17-1v6l-4 2h-4z",
    fill: "#B1BEB4"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1333,1027)",
    d: "m0 0h6l2 10 4 6 7 4 6 3v6l-9-3-6-4-6-6-4-10z",
    fill: "#E8ECE8"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1210,488)",
    d: "m0 0 2 2 6 21v2h-15l1-6 5-17z",
    fill: "#E1E6E2"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(79,157)",
    d: "m0 0 2 1-6 12-5 15-2 10 5 2 18 8 6 2h5l7-4 3 1-11 6-3 3v-2l-5-1-16-6-11-7 1-11 5-16z",
    fill: "#8D9F91"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2011,308)",
    d: "m0 0 3 3 2 5h2l4 18v21h-1l-1-16-61-1v-1h61l-1-4-55-1 2-2 52 1-7-21z",
    fill: "#B2C3B4"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(796,110)",
    d: "m0 0h7l5 6v4h14v1h-47v-1h13l1-5 4-4z",
    fill: "#5B7262"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2011,1073)",
    d: "m0 0 1 4-6 9-9 10-10 9-7 4h-2v-5l10-7 9-8 4-5 5-6 1-3z",
    fill: "#354539"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(259,1027)",
    d: "m0 0h5l-1 8-5 10-9 8-10 3v-6l10-5 6-7z",
    fill: "#EBEFEB"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 273)",
    d: "m0 0 4 5 6 7v2l3 1v3h2v3h2l1 5h2l5 12 1 5-3 3-6-14-7-12-11-13v-6z",
    fill: "#2F3C32"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(571,110)",
    d: "m0 0 7 1 5 6v3h13v1h-47v-1l13-1 2-5 4-3z",
    fill: "#596F5F"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(675,66)",
    d: "m0 0h47l-7 14-5 12-2 7-10-6-4-2 2-1 9 4v-5l8-16 2-6h-40z",
    fill: "#485C4D"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1082,1118)",
    d: "m0 0 2 1-7 7v2l7-8 2 1-9 10-6 8-5 4-4 1h-17l-5-5h2v-2l5 2 11 1 9-4 10-13z",
    fill: "#1B231D"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(318,916)",
    d: "m0 0 1 3h2l5 12 5 7 2 5v10l-3 7-7-6-1-2 4 2 1 1 1-8-3-8-6-10-2-4v-7z",
    fill: "#3F5244"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2017,867)",
    d: "m0 0 2 1-3 9-4 15-4 5-9 4h-1l-3-23v-5l2 4 2 18 5-2 3-4 5-18 5-2z",
    fill: "#465B4C"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1698,110)",
    d: "m0 0h6l6 3 2 7h13v1h-47v-1h14l1-6z",
    fill: "#576E5D"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1474,110)",
    d: "m0 0 7 1 4 4 1 5h13v1h-47v-1l13-1 3-6z",
    fill: "#596F5E"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(223,238)",
    d: "m0 0 5 3 2 3 2 4 12 12-1 2-4-2-14-14-3 22-3 12-8 19 3 1h-5l1-5 6-14 4-16 1-7 1-19z",
    fill: "#A3B4A6"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1561,1106)",
    d: "m0 0h8l-3 5-19 5-8 5h-5l-2 4-3 1-1 2-1-3 5-6 14-9z",
    fill: "#495E4E"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1260,624)",
    d: "m0 0h2l6 21v3h-15l2-9z",
    fill: "#E1E6E2"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(336,26)",
    d: "m0 0h22l16 4 13 5 11 6 6 4 5 5v2l-4-2-13-9-8-5-20-6-9-1h-21l-12 3-4-1 8-3z",
    fill: "#94A999"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(127,681)",
    d: "m0 0h1l1 61-1 33-2 1v-94z",
    fill: "#93A498"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1689,28)",
    d: "m0 0h4v37l-5-4-1-2v-30z",
    fill: "#4E6554"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(958,29)",
    d: "m0 0m-2 1h2v2l-5 4-9 3-10 2-5 6-1 2 15 1 9 2v1l-11-1-17-2 1-6 7-8 6-2 16-3z",
    fill: "#495E4E"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1928,336)",
    d: "m0 0 6 1 4 5v7l-3 5-5 3h-2l1 12 4 1h-5v7h-1v-22z",
    fill: "#5B7261"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1464,26)",
    d: "m0 0h23l18 4 2 1v2l-9-2-13-3v62l-2-1 1-60h-16v9h-1v-10l-16 4-4-1 8-3z",
    fill: "#A4B7A7"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1730,924)",
    d: "m0 0 1 2-6 12-4 6-1 6 2 4 2 1-16 16-2-1 11-11-2-8v-9l10-15z",
    fill: "#4C6051"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1917,26)",
    d: "m0 0h21l18 4 3 3-7-1-15-4v62l-3-1h2v-60l-16-1-1 2v-2l-19 5-4-1 7-3z",
    fill: "#95A79A"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(208,844)",
    d: "m0 0h9l10 2 20 5 14 7 1 4 3 1v2l-4-1-11-6-12-6-20-4-9-1z",
    fill: "#1C221D"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1927,550)",
    d: "m0 0h1l1 14 5 2 3 3 1 8-3 5-2 2-6 1z",
    fill: "#556D5C"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 473)",
    d: "m0 0 9 4 6 7 4 18 2 7-2 1-3-3-4-10-2-9-2-5-1-3-6-1-1 14-1 5h-1l1-16z",
    fill: "#3C4D40"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2024,136)",
    d: "m0 0h1l-1 9-2 7-3-1 1 6-3 7h-2l-2 6-6 8h-3l-3 2 2-4 9-14-1-5 2-5 1 3-1 2h2l1-5 4-12z",
    fill: "#3D4F41"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1050,1)",
    d: "m0 0h10l8 3 7 8 7 9 7 6-2 1-8-7-5-6v-2h-2l1 4-5-5-1-3-5-2h-14l-6 2 2-6z",
    fill: "#324035"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(992,27)",
    d: "m0 0 2 1-1 4-14 6-11 8-10 9-6-1v-2l13-10 14-9 9-5z",
    fill: "#313E34"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1361,71)",
    d: "m0 0 3 1-3 2-1 46h6v-47h1l1 23-1 17 4 2 1 1v5h-18l1-5 2-3h2v-16l-3-1h2l1-23z",
    fill: "#9FAEA3"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1150,66)",
    d: "m0 0h24l-5 8-2 6h-2l-2 8-2 9 2 4-1 2-2-4-4-2-6-4 2-1 4 2 2-9 8-15 1-3h-17z",
    fill: "#435347"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(503,30)",
    d: "m0 0 2 1-2 3 2 1-13 4-10 3-4 4-1 2 14 2v1h-9l-10-1 3-9 5-5 17-4z",
    fill: "#455A4B"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1216,28)",
    d: "m0 0 2 1-2 4-17 9-13 11h-2v2l-6-1v-2l18-14h2v-2z",
    fill: "#3C4D40"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1981,876)",
    d: "m0 0h1v24h-1v-17h-3v2l-15 7-8 3 2 7-3-3-4-6v-2l22-9z",
    fill: "#45584A"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(192,32)",
    d: "m0 0 8 1 13 3 7 8 1 6-23 3h-5l3-2 20-3-3-5-6-3-16-4z",
    fill: "#485D4D"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1529,1087)",
    d: "m0 0 6 1 16 5 17 2 9 1-3 8-5 5-5 1 4-3-2-2 3-2 2-5-25-3-11 10-4 1 3-6 2-1v-2l5-4-12-5z",
    fill: "#3F5244"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1845,813)",
    d: "m0 0h9l8 3-5 5v-2h-10l-10 6-10 5-2-1v-2h2l1-4 10-6z",
    fill: "#4F6555"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1927,244)",
    d: "m0 0h1l1 19 5 1-4 2-1 48-1 8 4 1h-3v13l-1 19h-1z",
    fill: "#8EA394"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(66,229)",
    d: "m0 0h1v40l6-4 8-4h4v-2l8-3 1-3 3-1 8 7 10 5-2 1-9-4-3-2-9 2-13 5-9 5h-2v2h-2z",
    fill: "#90A394"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1980,194)",
    d: "m0 0h2v40h-1v-31l-15 8-11 4h-3l-1-4 12-5 16-8z",
    fill: "#3F5144"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(29,97)",
    d: "m0 0 1 4-1 11 1 17h-2l6 22 8 16 6 9 5 6-1 2-6-6v-2h-2l-6-10-4-8-4-10-4-18v-22z",
    fill: "#A0B3A3"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(787,1057)",
    d: "m0 0h3v60h-1l-1-43-4 1-1-11-20 15-4 1 4-4 14-10z",
    fill: "#667C6C"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1949,483)",
    d: "m0 0 20 7 13 8-1 13-5 15-4 7-1-2 4-10 4-15 1-6-5-2-15-7-8-3-9 1 5-5z",
    fill: "#96AA9A"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(486,1107)",
    d: "m0 0 9 1 10 4 11 7v3l-4-3 7 8 9 12 1 2-4-2-8-11-7-7-14-7-12-3-1-3z",
    fill: "#2C392F"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1844,312)",
    d: "m0 0 3 1 7 9 3 5-2 1h-9l-9-5-2-3 7-5z",
    fill: "#7F9F88"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1789,1044)",
    d: "m0 0h2l1 2-1 9-7 16-6 9h-8l-15-4-12-6-2-3 20 8 16 3 2-5 8-19z",
    fill: "#8DA192"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 950)",
    d: "m0 0h1l2 6 2 2v3l4 2 4 5v3h2v3h2v3h2l3 9h-2l-1 2-4-6-5-9-10-12-3 3 2-10z",
    fill: "#38493D"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(209,847)",
    d: "m0 0h9v1l-6 1 7 17 4 18 2 17 32-32v3l-32 32v4l-3 1v-12l-3-20-5-17-5-11z",
    fill: "#7D9182"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1994,728)",
    d: "m0 0 7 6 3 3v3l3 1v3h2l4 7-2 4-4-4-8-11-4-5 4 8-5-4-10 20-1-3 6-12z",
    fill: "#445749"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(366,133)",
    d: "m0 0 2 1-7 8-5 5 1 2h-5l1-3-10-9-1-2 7-1h16z",
    fill: "#7D9F87"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1885,4)",
    d: "m0 0 2 1-4 5 3-3 2 1-7 7-6 8-9 8-8 5h-5l3-1 1-5 11-7 8-9 4-6z",
    fill: "#344338"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(47,1112)",
    d: "m0 0 10 2 11 8 1 4h2l3 5v2l3 1 1 3h-2l-3-3 5 6 4 3-5-1-7-7-6-8-1-3-4-2-10-6-3-2z",
    fill: "#313F34"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1957,132)",
    d: "m0 0 4 2 10 10 11 16 4 7 6 15v7h2l2 8v13l-2-4-2-10-7-24-9-17-11-14-8-7z",
    fill: "#CAD5CC"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2041,838)",
    d: "m0 0 1 4 2-4h2l-2 6-8 7-8 6-5 6-5 5-4 2 2-6 6-8 9-8 8-6z",
    fill: "#425246"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1583,96)",
    d: "m0 0h2v5l-11 10-7 9-2-2 1-8 4-6 7-6z",
    fill: "#58715F"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1276,1)",
    d: "m0 0h10l4 2 5 4 8 10 3 4v2l-3-1v-2l-4-1-6-8v-2l-5-1v-2l-12 1-6 2-4-1 5-4h2v-2z",
    fill: "#405244"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(527,1107)",
    d: "m0 0 5 1 5 3 21 6h29l9-2 15-6h2l-1 3-21 7-16 2-15-1-16-4-15-6z",
    fill: "#99AC9E"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2010,757)",
    d: "m0 0 4 4 4 11 3 10 1 7v24l-4 16-7 15-2-1 7-17 2-5 1-13v-20l-4-16-5-12z",
    fill: "#A5B7A8"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1553,66)",
    d: "m0 0h12v1h-6l3 9h2l5 14 1 3 6-1-5 4-5 5-3 2 1-5h2l-6-18-7-12z",
    fill: "#3D4E41"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(119,564)",
    d: "m0 0h2v21l-7-2-3-3v-11l5-4z",
    fill: "#4F6655"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(30,356)",
    d: "m0 0h58v2l-2 1h-56z",
    fill: "#EEF1EE"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(35,387)",
    d: "m0 0 2 4h2l1 5h2v3h2l5 7 5 5 1 4-3 16-1 9h-1v-10l2-14-5-5-7-8-3-5v-2h-2l-2-7z",
    fill: "#39493D"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1381,66)",
    d: "m0 0h18l-2 5-7 14-4 14-7-4-5-3 1-2 7 4 1-6 8-16 2-5h-12z",
    fill: "#3C4D40"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1741,31)",
    d: "m0 0 6 2 13 8 10 9 3 4-9 3-2-1v-3l-1-2 4 1-8-7-2-1v-2l-5-2-11-6z",
    fill: "#303E33"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(935,1045)",
    d: "m0 0 2 3 6 16 6 11v3l15-3 12-4 5-1-5 4-16 5-11 1-5-5-7-15-4-13z",
    fill: "#8FA293"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1340,1048)",
    d: "m0 0 4 1 1 3-5 14-7 14h-10l1-2 4-1 10-21z",
    fill: "#3E4F42"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(118,790)",
    d: "m0 0h3v21l-8-3-2-4v-9l4-4z",
    fill: "#4F6655"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1419,1101)",
    d: "m0 0 4 2 10 6 14 6 13 4-3 1v2l-9-1-18-8-12-8 3-1z",
    fill: "#29352C"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1927,809)",
    d: "m0 0 3 2h-2v12h5v1h-5v8l2 1-1 48 7 1v1h-7l-1 20h-1z",
    fill: "#8FA294"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(865,1092)",
    d: "m0 0h4l-1 4-11 9-13 8-7 4h-3l-1-3 16-10h3v-2h3v-2z",
    fill: "#242E26"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(254,1048)",
    d: "m0 0h2l6 16 7 13v2l3-1 1 2h-10l-2-5-4-8-5-14-3-1z",
    fill: "#425547"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(562,1026)",
    d: "m0 0h21l-2 6-4 4h-9l-5-5z",
    fill: "#516857"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(98,934)",
    d: "m0 0 4 4-13 4-14 6-6 4 3 16 3 8 4 9-1 2-6-10-5-17v-10l3-1 5-5 19-8h4z",
    fill: "#91A596"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1091,1091)",
    d: "m0 0 16 3 18 2-3 9-5 4-2-2v-2l3-2 1-5-19-3h-6l-7 7-7 5-2-1 3-5 5-5z",
    fill: "#485D4D"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1718,188)",
    d: "m0 0h3v14l1 5h2l6 12v2h-2v3h-2l-4-10-6-9-1-3v-7z",
    fill: "#3E5143"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1739,70)",
    d: "m0 0 4 1v1l2 1-12 8-12 11h-2v2l-6-2 12-12z",
    fill: "#3C4D40"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1101,66)",
    d: "m0 0h10l-4 1 6 12 5 11 1 5-4 2-5-12-2 2-2-6 1-2-6-11z",
    fill: "#39493D"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(336,1026)",
    d: "m0 0h21l-1 5-4 4-2 1h-7l-6-5z",
    fill: "#516757"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(33,645)",
    d: "m0 0 3 1 5 17 4 5 5 2v-11h1v14l-1 2-7-2-6-5-2-4-3-13z",
    fill: "#435548"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(32,500)",
    d: "m0 0 1 3h2l-1 5-6 9-7 7-4 3-5 2-4 2-3 1 2-4 6-5 8-6 6-7z",
    fill: "#313F35"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1014,1026)",
    d: "m0 0h20v5l-4 4-3 1h-7l-5-5z",
    fill: "#506756"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1928,790)",
    d: "m0 0 7 2 3 6-1 8-3 3-6 1-1-1z",
    fill: "#4F6655"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1981,651)",
    d: "m0 0h1v17h-1v-10l-17 8-12 3-2-4 16-6z",
    fill: "#3E5043"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(706,1048)",
    d: "m0 0h2l4 12 5 11 4 6v3h-5l-9-17-3-9-4 1-5 1 1-2 9-5z",
    fill: "#354338"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1692,1026)",
    d: "m0 0h20l-1 6-3 3-9 1-5-3-2-2z",
    fill: "#506756"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1240,1026)",
    d: "m0 0h20l-1 6-3 3-9 1-5-3-2-3z",
    fill: "#4F6655"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(94,704)",
    d: "m0 0 7 6 2 3-5-1v-2l-21 8-8 5h-2v-5l16-9 11-3z",
    fill: "#425547"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1709,1056)",
    d: "m0 0h2v62l10-2h5l-2 2-9 2-9 1h-9l-17-3-2-2 32 2z",
    fill: "#A6B8A9"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(715,1033)",
    d: "m0 0 1 4-5 10 6 18 5 8 2 6 11-3h5l-1 2-17 3-2-1-1-4-5-9-5-12-2-8 4-5z",
    fill: "#90A494"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1015,1057)",
    d: "m0 0h1v61l22-1 10-1-2 2-17 3h-11l-16-3-2-2 10 1 5 1z",
    fill: "#92A397"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1466,1026)",
    d: "m0 0h20l-1 6-3 3-9 1-5-3-2-4z",
    fill: "#4F6655"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(788,1026)",
    d: "m0 0h20v5l-4 4-3 1h-7l-5-5z",
    fill: "#4F6655"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(91,472)",
    d: "m0 0 3 4 4 6-1 3-17 6-12 6h-1v-5l17-9 9-3-2-5z",
    fill: "#394A3E"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(426,66)",
    d: "m0 0h7l-3 1 6 12 4 10 1 7-6 5 1-5-5-15-7-12v-2z",
    fill: "#354439"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1957,585)",
    d: "m0 0 7 6 10 11 10 16 5 10 4 12 2 11 1 1v8l-2 1-2-13-1-1-1-7-4-10-7-15-9-14-11-12z",
    fill: "#D1DAD2"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(33,611)",
    d: "m0 0 3 4 6 10 6 8v2l4 2 3 3-1 6-7-6-10-13-6-11v-2h2z",
    fill: "#38473C"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1391,1038)",
    d: "m0 0 1 2-3 5 2 9 4 11 6 11v2l15-3 4 1-8 3-5 1h-8l-9-16-4-12v-4l-2-1 5-6z",
    fill: "#899C8D"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(53,952)",
    d: "m0 0 2 4-1 5-9 10-9 14-3 4-2-4 6-11 9-12 5-5z",
    fill: "#303E34"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(67,878)",
    d: "m0 0h4v2l5 1v2l9 3 13 5-2 5-4 7-1-3 3-6-6-1-12-5-2-1v-2l-7-2z",
    fill: "#334136"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(53,723)",
    d: "m0 0 3 1 6 20 6 14 4 5 4 7 11 13 4 4-1 2-12-12-12-17-8-17-5-17z",
    fill: "#B7C7B9"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(278,882)",
    d: "m0 0h3l2 4-8 7-7 7-4 1-10 10-8 7-4 4-2-1 33-33z",
    fill: "#CDD6CF"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2014,384)",
    d: "m0 0 2 4-2 5-4 8-12 14-3 4-3-9 1-3h3v3l7-8 4-7h2l2-5z",
    fill: "#38483C"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(33,191)",
    d: "m0 0 4 1 2 7 1 8 5 7 4 2 1-3v8l-7-2-6-5-2-4-2-12-1-4z",
    fill: "#45594A"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(37,165)",
    d: "m0 0 3 2 4 7v2h2l7 8 2 2-1 8-3 19h-1v-9l1-6v-8l-9-10-7-11v-2h2z",
    fill: "#425446"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(240,931)",
    d: "m0 0h15l17 3 17 7 12 7-2 4-18-11-10-4-17-3-14-1z",
    fill: "#DFE5DF"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1327,66)",
    d: "m0 0h17v1h-11l9 18 2 9 4-1-5 5h-2l-4-11v-2h2l-1-3-2 2-9-16z",
    fill: "#3C4C40"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1665,1075)",
    d: "m0 0h2v2l-16 9-12 4h-2v2l4 2 8 7 14 8 3 1v2l-10-3-12-9-8-7v-2l-9 2-3-3 17-4 12-4z",
    fill: "#A4B8A8"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(649,66)",
    d: "m0 0h20v1h-13l4 10 3 5 4 12-1 3h-3l-6-15-4-8-4-6z",
    fill: "#3F4F43"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(220,237)",
    d: "m0 0h3l-1 21-3 16-6 17-7 14h-3l2-5 1-3h2l3-10 4-10 3-14z",
    fill: "#E1E7E2"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(867,53)",
    d: "m0 0h12l-2 2h-5v2l-18 5-17 8-14 10-12 11-2-1 9-9 13-10 14-8 11-5 9-3h2z",
    fill: "#CCD6CE"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1285,32)",
    d: "m0 0 7 2v-2l5 2 14 9 10 9v2l-5 1-5-5-1-3-4-1v-2l-5-2-12-7-4-2z",
    fill: "#2F3C32"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(275,32)",
    d: "m0 0m-8 1h8v2h-3l-1 3-13 3-6 5-1 2 5 1v1h-11l5-10 5-4z",
    fill: "#3C4E41"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(94,930)",
    d: "m0 0h2l2 3v3l-17 6-9 5-5 2v-5l5-3h2v-2l13-5 7-2z",
    fill: "#3B4C3F"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1767,874)",
    d: "m0 0v3l-8 11-4 8-4 11-3 9-2 17-1 6h-2v-9l3-18 6-17 7-12 3-5z",
    fill: "#E3E8E3"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1927,585)",
    d: "m0 0h1l1 13-1 8 4 1h-3v47l10 3v1l-10-1-1 5 3 1h-4z",
    fill: "#90A396"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1953,479)",
    d: "m0 0 24 10v2l5 1v6l-12-6-12-5-8-3z",
    fill: "#36453A"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(247,240)",
    d: "m0 0 4 1-2 8 7 9 1 6-4 4-3-4v-5l-5-5-2-5 1-6z",
    fill: "#86A08E"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(531,31)",
    d: "m0 0 3 1 1 2-9 5-12 9-6 5-1 2-4-1v-3l10-9 14-9z",
    fill: "#3C4B40"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(32,333)",
    d: "m0 0h54l2 2-1 1h-57v-2z",
    fill: "#EFF2EF"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1330,1108)",
    d: "m0 0 4 1-3 1 12-2-2 3-17 4-12 6-8 8v-3l6-6-7 6-3 2 2-4 10-9 11-5z",
    fill: "#38473C"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1845,1025)",
    d: "m0 0h82v1h-9l-1 3v-2h-13l-8-1-1 3v-2l-49 1z",
    fill: "#93A598"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2017,730)",
    d: "m0 0 3 3 6 8 9 8 7 5-1 2-2-1 1 4-6-4v-2l-4-1v-2l-5-2-7-8-1-7z",
    fill: "#334237"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1319,66)",
    d: "m0 0h8l7 12 2 4h3v3h-2l5 14-5 4-1-9-5-13-6-11v-2l-13 1 2-2z",
    fill: "#8A9D8E"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1886,31)",
    d: "m0 0h2v2l3 1-14 8h-2v2l-6 4-6 5-1 2-5-1v-2l8-7 12-9z",
    fill: "#323F35"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(261,864)",
    d: "m0 0 1 2h3l-2 4-10 9-5 6-8 7-7 8-5 5h-2v2h-2l1-4 6-5 7-8 19-19 1-4 3-1z",
    fill: "#DDE4DD"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1620,66)",
    d: "m0 0h5l-2 5-5 9-5 14v5 3l-5-5 1-7 6-15z",
    fill: "#3A4A3E"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1849,66)",
    d: "m0 0 2 1-8 15-4 11v6 3l-9-8 3-1 5-12 7-14 2 1v1z",
    fill: "#445649"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1770,54)",
    d: "m0 0h8v2l-21 6-13 6h-2v2l-9 5-11 9-7 7h-2l2-4 10-9 11-8 14-8 14-6z",
    fill: "#CED8CF"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1549,53)",
    d: "m0 0h6l-1 2-30 10-11 6-11 8-12 11-3 1v-2l8-7 9-8 10-7 13-6 12-5z",
    fill: "#CDD7CE"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1992,28)",
    d: "m0 0 5 1 9 4 8 1 3 14 1 7h-3l-6-16-7-2-7-3 3-1v-2l-6-2z",
    fill: "#313F34"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1488,1056)",
    d: "m0 0 7 6 9 7 2 1v2l5 2 16 8 13 5 9 2-3 1v2l-11-3-12-5-13-7-17-14-5-5z",
    fill: "#A4B8A8"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1262,1055)",
    d: "m0 0 7 6 12 10 17 10 16 6-1 3-10-3-19-10-14-11-8-9z",
    fill: "#A3B7A7"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1976,399)",
    d: "m0 0 2 1 4 15v8l-6 4-16 7-5 2h-7l-1-2 15-5 16-8 2-2-4-16z",
    fill: "#899C8D"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(251,289)",
    d: "m0 0h5v2l-10 5-19 5-19 1v-2l9-2 13-2 10-3z",
    fill: "#29322B"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(942,66)",
    d: "m0 0h5l-2 5-6 12-5 16-6-4 2-1 3-11 8-14z",
    fill: "#3C4D40"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(95,710)",
    d: "m0 0h3v3l-20 8-9 5 3 16-1 4-3-7-2-11v-8l1 3 12-7z",
    fill: "#A4B6A7"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(52,504)",
    d: "m0 0 3 1-1 4-10 12-7 11-2 2v-2h-2l-2 4 1-5 10-16z",
    fill: "#2F3931"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1927,131)",
    d: "m0 0h1l1 13-1 8 3 1h-2v48l6 1v1h-6l-1 6h-1z",
    fill: "#90A295"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1952,932)",
    d: "m0 0 8 1 10 4 8 5 4 2v6l-15-8-13-5-1-3h-3z",
    fill: "#36453A"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1953,252)",
    d: "m0 0 7 1 22 11v8l-5-5-17-8-10-4z",
    fill: "#36453A"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1615,1042)",
    d: "m0 0v3l1 7 5 14 7 12 10-2h5l-1 2-9 2h-8l-8-14-6-17v-3z",
    fill: "#8C9E91"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(238,924)",
    d: "m0 0h16l18 3 18 6 9 4v3l-9-3-7-3-13-4-15-3-17-1z",
    fill: "#E2E7E2"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1952,706)",
    d: "m0 0 7 1 9 4 14 7-1 4-4-1-17-8-11-3z",
    fill: "#38493C"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(89,27)",
    d: "m0 0 3 1-2 1 1 2-9 4-12 7-8 6-5 4-2-1 5-5-2-1 9-7 19-10z",
    fill: "#29342B"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1610,1048)",
    d: "m0 0 2 1 6 17 7 12v2h-5l-4-7-4-8v-2h2v-2l-3 1-4-10v-2z",
    fill: "#3D4E41"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(766,27)",
    d: "m0 0 4 1-10 4 1 2-9 5-6 4-11 9-5-1 5-5 8-7 14-8z",
    fill: "#212A23"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(887,1048)",
    d: "m0 0h1l-1 8-5 12-7 12h-8l-15-4-10-4-7-5 2-1 17 8 11 3 8 1 2-5 4-7 2-1z",
    fill: "#9FB2A3"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1897,279)",
    d: "m0 0 1 3-2 2h-3l-1 3-9 5-8 4-16 4h-4l-6-7-4-6 1-3 8 12 4 1 12-3 10-4h2v-2l13-7h2z",
    fill: "#354037"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2015,87)",
    d: "m0 0h2l5 18 1 17-2 17-4 13-2 5h-2l3-9 3-14v-30l-4-13z",
    fill: "#A9BBAC"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(809,1055)",
    d: "m0 0 4 2 10 10 18 11 13 6 8 3-1 3-9-3-16-8-12-8v-2l-4-2-11-10z",
    fill: "#A2B7A6"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2045,1062)",
    d: "m0 0 1 4-6 8-11 8-8 9-1-3-3 2 2-5 9-9 9-7 4-3-2 4h1z",
    fill: "#1C231D"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2020,1087)",
    d: "m0 0 1 4-5 11-2 10-8 1-3-2 1-3h6v-6l6-12z",
    fill: "#3A4A3E"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1500,1025)",
    d: "m0 0h58l5 16-1 2-4-7-2-8h-48v-2h-8z",
    fill: "#8EA093"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2014,844)",
    d: "m0 0 1 2-6 10-12 15h-2l-1 2-3-11 1-3 3 6 9-10 1-3h2l2-5 2-2 1 2z",
    fill: "#242E26"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1847,313)",
    d: "m0 0 5 5 9 10-3 3-5 2-9-1-4-2-8-8 7 1 7 4h9v-2l-8-10z",
    fill: "#485D4E"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(642,66)",
    d: "m0 0h7l7 11 5 12 2 5v3l2 1-4 3-9-23-6-9h-11l2-2z",
    fill: "#8BA190"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(258,1025)",
    d: "m0 0h9l-2 10-5 10 1 8 4 10 2 4v3h-3l-7-16-2-7 4-5 4-11 1-4h-5l-1 3z",
    fill: "#84998A"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1160,1045)",
    d: "m0 0h2l3 10 5 12 6 10 15-1-1 2-9 2-8-1-6-9-6-15-1-7-2-1z",
    fill: "#8CA091"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1558,1025)",
    d: "m0 0h63l-2 2-21-1-1 5-5 3v-7h-8v6l-4-4v-3l-22 1z",
    fill: "#A5B4A9"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1825,844)",
    d: "m0 0h16l-2 4h-12l-10 2-15 6-4-1 6-2 1-3 14-5z",
    fill: "#28302A"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(172,811)",
    d: "m0 0 4 1 14 14-1 2-7 1-10-10z",
    fill: "#8BA392"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(490,66)",
    d: "m0 0h2v3l1-2 2 1-6 12-6 15-2 4-3-3 1-7 4-8z",
    fill: "#3F5043"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(203,69)",
    d: "m0 0 1 2h2l5 10 4 12 3 1-7 5-3-9-3-8-4-8 1-4z",
    fill: "#3F5143"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1209,5)",
    d: "m0 0 2 1-9 11-8 10-4 3-7 1 3-5 8-7 6-8 6-4z",
    fill: "#647E6B"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1276,1025)",
    d: "m0 0h56l2 8 4 11h-2l-4-8-1-9-49 1v-2h-6z",
    fill: "#8DA092"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1979,424)",
    d: "m0 0 2 1v3h-2v2l-5 1v2l-14 6-5-1-1 3h-2l-3-5 8-2 12-5z",
    fill: "#3E5143"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(66,197)",
    d: "m0 0 5 2 8 5 16 6 3 1-2 4-22-8-7-4z",
    fill: "#324136"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(242,151)",
    d: "m0 0 4 1-16 10-11 11-7 11-5 13-2 4-2-1 3-11 8-14 11-12 12-9z",
    fill: "#CED7CF"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1319,54)",
    d: "m0 0h8l-1 2-19 5-16 8-14 9-12 11h-3l11-11 15-11 12-6 10-4z",
    fill: "#D3DCD4"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(49,739)",
    d: "m0 0h2l-2 4-7 10-8 16-4 13-1 11-2 16h-1v-19l4-18 4-10 7-13z",
    fill: "#94A799"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1762,1116)",
    d: "m0 0 2 1-9 9 7-6 6-4 2 1-9 7-6 7-7 9-4 3-3-1 1-1-2-2 6-4 7-10z",
    fill: "#1C231D"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(889,1050)",
    d: "m0 0 1 2h2v2l-1 1-1 5-3 7-6 12-1 1h-5l2-5 8-16z",
    fill: "#3F5244"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1795,924)",
    d: "m0 0h16v2l-18 1-22 5-15 6h-2l2-4 13-5 17-4z",
    fill: "#E2E8E3"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(28,1008)",
    d: "m0 0h1v7l-1 2 3 1h-2v21l4 15 5 12 1 3-2 2-6-14-4-14-1-5v-23z",
    fill: "#99AB9D"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(52,721)",
    d: "m0 0h1l2 13-11 12-5 8h-3l-3 5-1-2 8-13 12-15z",
    fill: "#202922"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(67,652)",
    d: "m0 0 7 2v2h3v2l21 7-2 4-13-4-16-8z",
    fill: "#303E33"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(167,8)",
    d: "m0 0 5 5 4 5v2l3 1 5 5 9 5-1 4-9-3v-2l-4-1v-2l-4-2-6-7 1-2v-2l-3-4z",
    fill: "#313E34"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2037,164)",
    d: "m0 0 1 3h3l-10 8-6 5-6 8h-3l-1-2 6-9 10-9z",
    fill: "#323F35"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(262,108)",
    d: "m0 0h2l2 7v5l3-1h45l1-2v4h-57l1-4v3h5z",
    fill: "#92A397"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(956,1091)",
    d: "m0 0h2l5 5 10 8 7 5-3 1 1 2-5-2-5-3v-2l-4-1v-2l-4-1-8-7 1-2z",
    fill: "#344338"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1384,1030)",
    d: "m0 0h3l-1 6-5 8-8 5-6 1 1-4 10-9z",
    fill: "#5B7562"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2037,334)",
    d: "m0 0h1l1 5 1 16 4 10h-4l-4-5-2-5v-7h2l-1-3h-1v-7l1-3z",
    fill: "#6B8070"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1399,66)",
    d: "m0 0 11 1 2 2h-10l-7 12-6 16v6l-3-3 1-9 6-15z",
    fill: "#849889"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(263,70)",
    d: "m0 0 1 2h2l-2 5-8 21h2l-1 3-8-7 3-1 5-12 5-10z",
    fill: "#465A4B"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1426,1131)",
    d: "m0 0h4v3l10 5 14 2 1 3h-19l-7-4z",
    fill: "#485C4D"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(638,1113)",
    d: "m0 0 3 1h2l2 1-11 7-8 8-5 7v-3l-1-1v-3l8-10 4-4z",
    fill: "#364539"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1805,1025)",
    d: "m0 0h40v2l-21-1-2 6-3 1v9h-1v-15h-6l-1 6h-3l-3-5z",
    fill: "#ABB8AE"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(17,975)",
    d: "m0 0 2 1-9 8-3 5-1 13-4 2-1-4v-8l3-9 4-5 4-1-1 3z",
    fill: "#334136"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1784,826)",
    d: "m0 0h6l-2 2 3 2-9 4-5 6-3 9-2-2-2 1v-5l5-10z",
    fill: "#2D3930"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(216,271)",
    d: "m0 0 1 3-4 12-4 9-2 2v-2l-5-1 4-8 3-7 2-3h2l1-4z",
    fill: "#536A59"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(93,252)",
    d: "m0 0 3 1-2 1 2 2-7 3h-4v2l-7 3-8 4-3 1v-5l16-8z",
    fill: "#2D3930"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1927,378)",
    d: "m0 0h2v49l9 1 4 3-13-2v5h-2z",
    fill: "#8D9E92"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(162,820)",
    d: "m0 0 4 2-1 8 2 4 3 1 4 5v4l-4-1-10-10-1-2v-6z",
    fill: "#7D9F87"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1896,283)",
    d: "m0 0 1 3-9 7-15 7-11 3h-5l2-4 16-4 8-4 9-5 1-2z",
    fill: "#D9E1DA"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(947,66)",
    d: "m0 0 12 1 1 2-11-1-2 6-7 15-3 10h-3l1-8 6-15 3-5z",
    fill: "#94A799"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(880,1025)",
    d: "m0 0h56v1h-16l-1 5-1 2h-2l-1-6h-7v7l-4-2-2-3v-3l-16 1-6 1z",
    fill: "#A7B5AA"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(211,857)",
    d: "m0 0 3 1 4 11 4 20 1 8v10l-1 2h-2l-2-25-4-17z",
    fill: "#D9E1D9"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1860,846)",
    d: "m0 0 12 3 12 5 11 7h3l-1 5-14-8-14-6-12-4z",
    fill: "#96A79A"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1843,107)",
    d: "m0 0 3 3 1 9h46l2 1 1-2v3h-56v-1h5z",
    fill: "#8D9F92"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(285,946)",
    d: "m0 0 3 1-7 8-33 33h-3v-2l8-7 31-31z",
    fill: "#92A397"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2021,567)",
    d: "m0 0h1v20l-4 16-7 17-4 5-1 3h-2l-2 4-7 8v-3l9-11 9-17 5-14 1-13h2z",
    fill: "#A7BAAA"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(412,1091)",
    d: "m0 0 5 1-2 4-8 8-15 9h-2v-4l14-9 7-6z",
    fill: "#263129"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(303,206)",
    d: "m0 0 3 1-1 15-5 22-3 4h-2l3-11 2-6 1-8v-16z",
    fill: "#DEE4DF"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1163,103)",
    d: "m0 0 4 4 3 12h48v2h-55l4-3-4-13z",
    fill: "#849C8B"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(787,26)",
    d: "m0 0h23l17 4v2l-7-1-13-2h-21l-12 3-4-1 8-3z",
    fill: "#95A89A"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1762,151)",
    d: "m0 0h3v2h-2v3h-2l-2 5-6 12-5 16h-3l1-7 5-14 10-16z",
    fill: "#D5DDD6"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(527,6)",
    d: "m0 0 2 1-8 11 1-1 2-1-2 5-10 9-5 2v2h-4l2-5 11-9 8-11z",
    fill: "#2F3B32"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1927,484)",
    d: "m0 0 1 2 3 1h-3v5h6l-2 2h-3v47l3 2h-5z",
    fill: "#90A295"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2038,362)",
    d: "m0 0 3 3h4l3 7v10l-2 2-4 5-5 4 2-4 3-8-1-10z",
    fill: "#475A4C"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(722,66)",
    d: "m0 0 10 1 2 2h-10l-8 16-6 16-2-1 1-8 5-12 5-10z",
    fill: "#8FA393"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1625,66)",
    d: "m0 0 11 1 2 2h-7l-4-1-1 4-8 16-4 11h-2l1-9 7-16z",
    fill: "#889C8D"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1666,1)",
    d: "m0 0h10l6 2-1 3-4 1h-11l-5 2-4 3-4 1 1-3 6-5v-2z",
    fill: "#445749"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(429,1034)",
    d: "m0 0 2 1 4 8v5h2l-3 12-10 19-1 1h-5l6-8 6-12 3-10v-6l-4-6z",
    fill: "#8FA193"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(10,812)",
    d: "m0 0h2l-1 5-4 10-2 10-3 1-1-3v-8l3-9 4-5z",
    fill: "#405245"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(416,66)",
    d: "m0 0h10l-2 1 6 10 5 12 2 9-3 1-6-17-7-12v-2h-7z",
    fill: "#8DA191"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1322,1093)",
    d: "m0 0 29 3-3 9-5 4-9 2-4-1 4-1v-2l9-4 3-6h-10l-12-2z",
    fill: "#45594A"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1421,1084)",
    d: "m0 0 4 1-10 5h-4v2l4 2 4 3v2l5 2 11 7 5 2v2l-5-1-9-5-10-8-6-5v-2l-6 1v-3z",
    fill: "#B0C1B3"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1839,1044)",
    d: "m0 0 1 4 10 24 3 5 7 1-4 2h-5l-7-11-7-18 1-6z",
    fill: "#809485"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(67,423)",
    d: "m0 0 16 8 13 5-3 1v2l-6-1-20-9z",
    fill: "#324136"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1534,66)",
    d: "m0 0 3 1-3 3-11 4-12 7-11 9-3 4-4-1 10-10 10-7 15-8z",
    fill: "#E2E8E3"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1823,239)",
    d: "m0 0 2 1-3 5-10 9-26 26h-2l2-4 31-31z",
    fill: "#CBD6CB"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(262,198)",
    d: "m0 0h5l4 5v7l-11-1-2-3v-5z",
    fill: "#A7B8AA"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1309,1119)",
    d: "m0 0 2 1-7 7-1 5-7 9-3 2h-4v-2l-8 1 2-2 7-2 5-5 4-5 8-7z",
    fill: "#2D382F"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(862,1114)",
    d: "m0 0 2 1-3 3v3l-3 1-2 4-6 7-4-1-2 4-4 4-6 1 4-3 6-5 8-11 7-6z",
    fill: "#2B362E"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(117,904)",
    d: "m0 0h4v18l-5-1-3-2v-2l-3-1h10v-6h-28l-2-1 1-3v2l22 1 1-3z",
    fill: "#A9BAAD"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(165,1106)",
    d: "m0 0 3 1-16 8-13 4-16 2h-8l-3-1 1-3h22l17-5z",
    fill: "#9EB2A2"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1843,857)",
    d: "m0 0h3l-1 4-4 9-3 9-2 11-1 17h-2v-19l4-17z",
    fill: "#DDE4DE"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(76,318)",
    d: "m0 0h2l7 9 6 6v2h-2l-1 3h-59v-1l42-1 16-1-2-5-9-10z",
    fill: "#BECDBF"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1691,26)",
    d: "m0 0h23v2h-3v58h-1v-57h-17l-6-1z",
    fill: "#A9BAAB"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(561,26)",
    d: "m0 0h24l13 3 1 2-10-1-8-1h-21l-13 3-4-1 8-3z",
    fill: "#9AAD9E"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1836,1048)",
    d: "m0 0 2 3 8 20 1 3h-2l-1 3-3-6v-2h-2l-5-13v-5z",
    fill: "#425546"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(207,956)",
    d: "m0 0h2l7 13 11 12 7 6 12 7v1h-5l-6-3v-2l-4-2-8-7-9-10v-2h-2l-5-11z",
    fill: "#E1E8E2"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(291,898)",
    d: "m0 0h2l3 7 2 1 3 11 1 7v14h-2l-3-17-3-14-3-6z",
    fill: "#202821"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2019,359)",
    d: "m0 0 1 3-5 17-3 11-3 5h-2l-1 4-6 8-2-4 8-11 5-10z",
    fill: "#7F9485"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1804,223)",
    d: "m0 0 3 1h-2l-2 4-36 36-1-3h2l2-4 32-32h2z",
    fill: "#798C7E"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(379,1025)",
    d: "m0 0h55v1h-5v7l-2-2v-4h-48z",
    fill: "#8D9F92"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(53,509)",
    d: "m0 0h2l-2 4-9 11-8 15-5 15-2 9-2-2 2-11 8-20 10-14z",
    fill: "#8BA191"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(751,7)",
    d: "m0 0h2l-2 4v2 3l-4 6-4 5-8 5-2-1 3-6 5-4z",
    fill: "#212A23"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1316,1091)",
    d: "m0 0 6 2-5 5-11 9-5 3h-2v-2l-2-1 6-4h2v-2l4-1 1-3 5-4z",
    fill: "#2E3C32"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2008,623)",
    d: "m0 0 2 2v3l-6 9-7 8-4-2-1-6 4-2v3l7-8 1-2h2l1-4z",
    fill: "#38493D"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1953,593)",
    d: "m0 0 12 12 6 8 7 15 4 16v5h-2l-4-18-6-14-6-9-11-12z",
    fill: "#93A898"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(93,138)",
    d: "m0 0h2l-1 4-8 7-7 9-8 17-2 8-3-1 2-9 8-15 9-12z",
    fill: "#E3E9E3"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1746,1083)",
    d: "m0 0 24 8 13 3 8 1v1h-9l-10-1-7 6-6 2 4-6 4-5-3 1v-2l-5-1-12-5z",
    fill: "#4C6352"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(32,726)",
    d: "m0 0 1 3-1 3h2l-2 5-6 8-8 7-8 6-3 3 2-5 10-8 8-7-5 4-6 5-2-1 10-9 5-7z",
    fill: "#1C231E"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1546,66)",
    d: "m0 0h7l8 14 5 14v4h-3l-6-17-7-12-6-1z",
    fill: "#97AB9B"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1114,1047)",
    d: "m0 0 5 3-2 9-9 19h-2l4-10h-2l3-9z",
    fill: "#3D4E41"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(64,1103)",
    d: "m0 0 5 2 7 3 15 7 3 2h-2v2l-10-2v-2l-5-1-10-6z",
    fill: "#334036"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1958,714)",
    d: "m0 0h7l16 8 1-2v11l-4 16h-2l4-22-4-1-13-7-5-2z",
    fill: "#849A8A"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1957,357)",
    d: "m0 0 4 2 7 7 11 15 4 6v4h2v4h2l2 5v5l-3-3-6-14-9-14-9-10-5-5z",
    fill: "#CED8CF"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1305,67)",
    d: "m0 0 3 1-1 2-12 5-11 7-11 9-4 4v-4l12-11 13-8z",
    fill: "#E0E6E1"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(813,1097)",
    d: "m0 0 7 6 9 8v2l14-7 11-7 2 1-1 2h-3v2l-11 6-13 6-8 1 3-2 3-1-2-4-11-10z",
    fill: "#A0B2A3"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(483,1045)",
    d: "m0 0 1 3h-2l6 17 1 4-4 1-5-10-2-6-3-2z",
    fill: "#435648"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1173,984)",
    d: "m0 0h21l-6 7-4 3-8-7z",
    fill: "#4E6554"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(90,586)",
    d: "m0 0 2 2-16 16-7 11-7 16-1 3h-2l1-5 4-10 8-13 7-9 9-10z",
    fill: "#CFD9D0"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1978,195)",
    d: "m0 0h3l-2 4-16 8-11 4-2 2-4-5 6-1 19-8z",
    fill: "#8DA092"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(434,1025)",
    d: "m0 0h34l-1 7-3 1-1-6h-7v7l-4-2-2-3v-3h-15l-1 3v-2h-5v-1z",
    fill: "#AFBDB2"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(93,592)",
    d: "m0 0 2 2-7 7-10 13-7 15-1 3-4 3 1-5 5-11 9-14z",
    fill: "#DCE3DD"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(974,1082)",
    d: "m0 0 4 1-12 6-6 1 5 6 12 9-2 1-11-8-6-5v-2l-8 2 3-4 16-5z",
    fill: "#B9C8BC"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(224,1025)",
    d: "m0 0h34v1h-15l-1 4-4 4h-1v-7h-7v6h-3l-3-5z",
    fill: "#A1B3A6"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1592,74)",
    d: "m0 0h1l1 21-1 18 3 1 2 4v3h-18l4-1v-6l2-1v7h6z",
    fill: "#99AB9E"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(32,47)",
    d: "m0 0 1 3-1 2h2l-2 5-6 8-4 4-2-1 3-4-7 6-8 6-2-1 7-6 9-7 6-8z",
    fill: "#161C17"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1895,901)",
    d: "m0 0h2l-1 5-6 10-9 10-12 9-8 4-3-1 16-10 11-10 9-14z",
    fill: "#E1E7E1"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2042,611)",
    d: "m0 0 2 4 1-2-1 5-7 7-10 7-9 12v-3l6-9 8-7 4-3-6 4-2-1 7-5 4-5h2z",
    fill: "#0F120F"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1988,514)",
    d: "m0 0 2 1-1 5-8 16-6 10h-2l-2 4-2 3h-2l-2 4-7 6 2-4 8-9 4-5 5-8h2l1-5 6-11z",
    fill: "#C2CFC4"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(281,213)",
    d: "m0 0 3 1-5 3-5 2-19 3h-17v-2l23-2 17-4z",
    fill: "#DDE3DD"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1076,68)",
    d: "m0 0 3 1-1 2-14 7-11 8-8 8h-3l2-4 11-10 13-8z",
    fill: "#DFE6DF"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1717,28)",
    d: "m0 0 10 1 12 4 11 6 5 3v2l4 2 8 7h-3l-13-10-16-8-18-6z",
    fill: "#96AA9A"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(497,1093)",
    d: "m0 0 2 1-6 2-16 2 4 6v2l5 1-2 3-5-1-6-7-1-6 4-1z",
    fill: "#445849"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(265,899)",
    d: "m0 0h2l-2 4-18 18 1 1 8 1v1h-18l2-3 4-2 8-8 8-7z",
    fill: "#97A99B"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1754,865)",
    d: "m0 0 2 1-1 2 5-3 2 1-8 5-14 5h-3l1-2h-2l-2 4-3 1 2-4 5-4z",
    fill: "#273229"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1777,66)",
    d: "m0 0h18v1h-10l7 15-2 5-2-1-4-10-5-8-2 2z",
    fill: "#3A4A3E"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1648,38)",
    d: "m0 0h4v2l-9 6-2 4-5 2v2l5-3 4-2-5 7-7-1-2-1 2-4 8-7z",
    fill: "#415346"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1659,4)",
    d: "m0 0 2 1-5 5h-2l1 2 2-1-2 4-7 10-10 7-2-1 11-8 1-2-7 6-4 1 5-5 8-9 6-8z",
    fill: "#222C24"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(359,1056)",
    d: "m0 0 8 6 9 8 13 8 9 5 1 2-9-3-11-6-10-8-6-5-4-5z",
    fill: "#ABBDAD"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1107,1068)",
    d: "m0 0h3l-1 5-2 5 59 1v1h-65z",
    fill: "#4B6251"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1621,1025)",
    d: "m0 0h49l-1 4v-2l-47 1-2 1z",
    fill: "#8FA194"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(93,364)",
    d: "m0 0h2l-2 4-8 8-7 10-6 12-1 5h-3l-1-2 7-14 6-9 11-12z",
    fill: "#D2DBD3"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1785,108)",
    d: "m0 0 1 4-1 8 5-1v2h-56l1-2h48l1-10z",
    fill: "#91A396"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(110,26)",
    d: "m0 0h22l8 2v1h-31l-12 3h-4v-2z",
    fill: "#9CB0A1"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1988,965)",
    d: "m0 0h2l-1 7-8 16-7 10-13 15-4 1 6-7 10-11 1-3h2l2-6 6-10 3-7z",
    fill: "#C2D0C4"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1858,842)",
    d: "m0 0 21 7 11 6 7 5v2l-5-2-12-7-23-8z",
    fill: "#DBE2DC"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2011,308)",
    d: "m0 0 3 3 2 5h2l2 15-1 2-55-1 2-2 52 1-7-21z",
    fill: "#92A397"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(202,294)",
    d: "m0 0 5 1-2 7-6 8-5-1v-5z",
    fill: "#546A5A"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(771,1115)",
    d: "m0 0 9 1 4 1h35l-2 2-13 2h-11l-17-3-5-2z",
    fill: "#9EB0A1"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(778,1052)",
    d: "m0 0h2l-2 5-9 8-13 8-9 5h-2l1-4 8-3 12-8 10-9z",
    fill: "#E2E8E3"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1106,1025)",
    d: "m0 0h43l-2 1-2 5-3 2v-5l-10-2v7l-4-3v-4l-22 1z",
    fill: "#B4C1B7"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1654,996)",
    d: "m0 0 5 1 4 5 7 6 2 4-4-1-10-9-2-2-8 8-5 3 2-4 7-8z",
    fill: "#92A397"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(58,965)",
    d: "m0 0h2l7 17 9 14 7 9 5 5 3 4-4-2-7-7-9-12-8-13-5-12z",
    fill: "#C4D1C6"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 498)",
    d: "m0 0h1l2 7 8 9v2l-4 2-7-8-4 9-3 4 1-5 5-16z",
    fill: "#445849"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1290,135)",
    d: "m0 0h19l-6 7-2 2-4-1-3-2v-2h-2v-2h-2z",
    fill: "#7D9F87"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(675,66)",
    d: "m0 0h47l-7 14-2 1 1-6-3 6-1-3 4-7 1-4h-40z",
    fill: "#39493D"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1086,53)",
    d: "m0 0 3 1v2l-15 6-11 6-11 7-13 12-1-4 9-7 13-9 17-9 8-3z",
    fill: "#536A59"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1338,1044)",
    d: "m0 0 4 4h-2l-1 8-10 21-3 2-1-3 3-6h2l7-21z",
    fill: "#889C8C"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1768,882)",
    d: "m0 0 3 1 37 37v2h-3l-7-8-11-12-16-15-3-2z",
    fill: "#D3DDD3"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(6,589)",
    d: "m0 0h3v3l-2 9-1 14h-2l-2-5h-1v-8l4-11z",
    fill: "#465B4C"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1775,209)",
    d: "m0 0 9 1 6 1 18 1 1 3h-19l-14-3z",
    fill: "#D3DCD5"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(282,151)",
    d: "m0 0 4 2 9 15 3 8v7l-3-3-5-14v-2h-2l-6-10z",
    fill: "#A2B3A5"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1076,38)",
    d: "m0 0 5 2 11 9 3 3v2l-6 1-2-4-7-5v-2l-5-2-1-2h2z",
    fill: "#2E3B31"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1563,1043)",
    d: "m0 0 3 3-1 9-5 12-7 12-2-3 6-11 5-14z",
    fill: "#93A597"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1979,744)",
    d: "m0 0h2l-2 7-9 15-7 9-8 8-1-3 9-9 9-14z",
    fill: "#DDE4DE"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(223,238)",
    d: "m0 0 5 3 2 3 2 4 12 12-1 2-4-2-14-14-2 1z",
    fill: "#9AAB9E"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(238,995)",
    d: "m0 0 6 3 9 10 2 4-5-3-10-10-4 2-12 11-2-1 7-8 6-5z",
    fill: "#90A296"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(151,284)",
    d: "m0 0 5 2 12 7 21 7 1 2h-7l-10-3-15-8-7-5z",
    fill: "#E4EAE5"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1833,240)",
    d: "m0 0h2l2 22 4 15 2 5-3 1-5-15-2-11z",
    fill: "#D9E0DA"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(306,1111)",
    d: "m0 0 7 2 8 3 9 3-2 1v2h-6l-15-6v-2h-2z",
    fill: "#2B372E"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(187,1092)",
    d: "m0 0 4 2-4 5-12 9-5 3-2-1 3-1 1-5 5-2v-2l5-3z",
    fill: "#28332A"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2016,140)",
    d: "m0 0 1 2v6h-2l-1 2-8 3-9 10-7 7-2-1 11-12z",
    fill: "#92A397"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1762,135)",
    d: "m0 0h4l4 6 5 1 7-7 4 1-10 10 2 3-3 1-6-1 2-1-3-5-6-7z",
    fill: "#91A296"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1752,69)",
    d: "m0 0 2 1-2 3-14 7-11 9-5 5h-3v-2l8-7 10-8 12-7z",
    fill: "#E0E5E0"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1534,1121)",
    d: "m0 0 3 1-8 9-7 9-5 1-2-2 4-2 2-4 4-6 7-3z",
    fill: "#36463A"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(633,1097)",
    d: "m0 0 2 1-2 2v3l-5 4-13 8-2-1 1-4 9-6h3v-2l4-1v-2z",
    fill: "#222B24"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(301,956)",
    d: "m0 0 2 1-1 7-3 9-4 10-8 12h-2l2-5 8-15 5-15z",
    fill: "#E1E7E2"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1802,151)",
    d: "m0 0h5l4 3 3 1v2h3v2l4 2 11 11 6 10h-3l-7-10-5-6-12-9-8-4z",
    fill: "#E0E7E1"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1133,75)",
    d: "m0 0h1v45l8-1 4 2h-18l1-5 2-3h2l-1-23z",
    fill: "#9DADA1"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(974,12)",
    d: "m0 0v3l-2 4 3-2-2 4-5 6-11 7-2-1 3-1v-2l-6 2 3-3 8-5 8-8zm-5 8m-1 1m-1 1m-1 1m-1 1m-1 1-1 2h2z",
    fill: "#212A23"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1738,1076)",
    d: "m0 0 4 1 18 8 14 4-2 1v2l-12-3-12-5v-2l-6-2z",
    fill: "#A1B6A5"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1394,1071)",
    d: "m0 0 3 4 2 5h-61v-1h55l-2-5z",
    fill: "#4E6554"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1264,1075)",
    d: "m0 0h2l7 8 12 11 10 10-1 2h-2l-7-8-14-13v-2l-6-3z",
    fill: "#92A397"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(708,997)",
    d: "m0 0h6l7 8 5 5v2l-4-2-11-9h-2l-6 7-4 3-2-1 5-5z",
    fill: "#93A498"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(273,302)",
    d: "m0 0 2 4 1 4-5 5-5 4-7 1v-4l8-4 5-7z",
    fill: "#313E34"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(49,283)",
    d: "m0 0v3l-7 10-1 2h-2l-2 5-3 4h-3l2-6 9-14 2-1 1 2z",
    fill: "#232D25"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(151,280)",
    d: "m0 0 9 5 20 10-1 2-6-1-16-8-6-4z",
    fill: "#96A99B"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(336,26)",
    d: "m0 0h22l2 2-5 1h-21l-12 3-4-1 8-3z",
    fill: "#A0B2A4"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1993,278)",
    d: "m0 0 5 5 10 13 2 5-1 4-10-15-3-3v-2l-5 2z",
    fill: "#7D9282"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1782,77)",
    d: "m0 0 3 3 5 13v-2-3h2l1-3 3 6v5l-6 7-3 3 2-5-2-9-5-13z",
    fill: "#778E7E"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(872,67)",
    d: "m0 0h2l4 7h2l7 16 3 9-4 3-2-9-6-15-6-10z",
    fill: "#96A89A"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1076,60)",
    d: "m0 0h5l-1 2-9 4-5 1v2h-3v2l-8 4-10 8-8 8-2-1 12-12 12-9 14-7z",
    fill: "#CCD6CD"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1042,1137)",
    d: "m0 0 5 2 11 1 7-1-1 3h-2v2h-17l-5-5h2z",
    fill: "#3C4D41"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(785,1055)",
    d: "m0 0h2l-2 4-9 9-17 12-15 7-5 1 4-4 11-4 9-6 10-7 10-9z",
    fill: "#D1DBD2"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(584,1056)",
    d: "m0 0 4 2 12 11 13 8 10 5-2 3-16-9-14-12-5-4z",
    fill: "#A1B4A4"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1867,211)",
    d: "m0 0 9 5 13 13 8 12v5l-4-5-7-11-12-12-7-5z",
    fill: "#E2E8E2"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(98,483)",
    d: "m0 0 3 3-25 10-8 2v-2l17-8 12-4z",
    fill: "#9AAE9E"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2045,382)",
    d: "m0 0 1 4-6 8-12 9-8 9v-3l7-8 5-5-2-1 10-9v3l-1 2 4-5z",
    fill: "#151A16"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(280,206)",
    d: "m0 0m-2 1h2l-1 3-13 4-6 1h-20v-2l23-2z",
    fill: "#DDE3DE"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(317,109)",
    d: "m0 0 4 2 2 2v7h13v1h-21v-7z",
    fill: "#5C7463"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1529,1087)",
    d: "m0 0 6 1 12 4-2 4-10 9-4 1 3-6 2-1v-2l5-4-12-5z",
    fill: "#36453A"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(186,844)",
    d: "m0 0 4 1-14 5-11 5-11 6-3-1 16-10 13-5z",
    fill: "#D9E1DA"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(317,182)",
    d: "m0 0 6 5-9 9h-4v-3h-2l1-3 5-5 3-1z",
    fill: "#526958"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1960,147)",
    d: "m0 0h2l8 11 8 16 3 10 1 10h-2l-5-21-7-14-8-10z",
    fill: "#829687"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(869,1092)",
    d: "m0 0 11 2 18 2v6l-6 7-3-2 2-2 3-8-16-1-9-2z",
    fill: "#445749"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1035,1055)",
    d: "m0 0 4 2 9 9 15 10 5 3-1 3-16-10-16-15z",
    fill: "#A7BBAB"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1745,957)",
    d: "m0 0h2l7 20 8 14 2 4-4-2-7-11-6-14-2-7z",
    fill: "#DDE4DE"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1833,864)",
    d: "m0 0h1l-1 8-2 5-2 12-1 20h-2v-18l3-17 3-9z",
    fill: "#EDF1ED"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(174,326)",
    d: "m0 0 1 2 4 1-2 4-5 6-2 2-3-3 1-7z",
    fill: "#516857"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(300,210)",
    d: "m0 0h2v13l-2 10h-2l-1 5-4 10h-1v-5l4-10 3-14z",
    fill: "#131714"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(6,135)",
    d: "m0 0 2 1-2 4h2l1-3 1 2-3 8-1 11-1-4h-2l-1 4-1-2v-9z",
    fill: "#2F3C32"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1667,28)",
    d: "m0 0 3 1-2 1 1 2-15 8-10 7-2-1 8-6h2v-2h-2v-2z",
    fill: "#27322A"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(393,8)",
    d: "m0 0 5 5 8 10 7 5-2 1-7-1-7-7-2-7z",
    fill: "#263028"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1845,1074)",
    d: "m0 0 4 1 2 5h-67v-1h61z",
    fill: "#4E6554"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1852,67)",
    d: "m0 0 2 1-7 12-7 20-2-1 1-9 7-16 3-1z",
    fill: "#899D8E"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(159,1067)",
    d: "m0 0 6 2 12 5 11 3h7l4-6 1 2-2 6-1 1h-9l-16-5-12-6z",
    fill: "#879C8D"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1361,71)",
    d: "m0 0 3 1-3 2-1 46h-6l1-4 2-3h2v-16l-3-1h2l1-23z",
    fill: "#9FB2A4"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1173,67)",
    d: "m0 0h3l-2 5-7 14-4 10-1-4 1-6 2-6h2l2-7z",
    fill: "#8A9D8E"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1760,56)",
    d: "m0 0h2v2l-12 5-16 9-11 9-5 5h-2v-3l17-13 16-9z",
    fill: "#556B5B"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1304,1100)",
    d: "m0 0 2 1-4 4-11 6-15 6-8 2h-6l2-2 15-4 14-6z",
    fill: "#A1B3A4"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1754,903)",
    d: "m0 0 1 2-4 13-3 20-2 1 1-23 3-9 3-1z",
    fill: "#020201"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(69,423)",
    d: "m0 0 7 1 16 7 4 2-3 2-7-2-9-4-8-4z",
    fill: "#91A395"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(58,289)",
    d: "m0 0 3 4 5 10v3h2l4 7 11 14 4 4v2l-4-1-8-11-10-14-7-15z",
    fill: "#576F5D"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(70,296)",
    d: "m0 0 3 1 9 15 7 8v2l4 2 2 4-5-2-11-13-9-15z",
    fill: "#E1E7E1"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(284,151)",
    d: "m0 0 4 2 8 13 5 12 2 9-5-1-1-10-5-12-8-12z",
    fill: "#E9EDE9"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(907,106)",
    d: "m0 0h1v14h7v-7h3l2 4v4h-17l-1-4 3-4h2z",
    fill: "#B2C0B6"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1908,1052)",
    d: "m0 0h2l-2 4-7 7-15 10-7 4h-2l2-4 11-6 11-8z",
    fill: "#DBE2DB"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(56,951)",
    d: "m0 0h1l3 14-3 1-2-4-11 13-6 10-1-3 7-11 10-11v-7z",
    fill: "#A0B4A4"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(116,679)",
    d: "m0 0h5v12h-1v-7h-43v-1h13l1-3v2l22 1v-2z",
    fill: "#98AE9E"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1927,222)",
    d: "m0 0 1 2 6 2v3l-6 1v6h7l-1 4-7 4z",
    fill: "#B9C5BC"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1419,40)",
    d: "m0 0 3 1-2 4-10 10-11-2v-1l7-1z",
    fill: "#344438"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(132,1055)",
    d: "m0 0h2l4 5 11 9 14 9v2l-5-1-14-10-9-9-3-2z",
    fill: "#A7BAAA"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(553,1051)",
    d: "m0 0 2 2-6 7-15 11-10 5 1-4 11-6 9-7z",
    fill: "#E1E7E1"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2032,395)",
    d: "m0 0 2 1-10 9-4 5-1 6-5 1 1-6 7-9 6-6z",
    fill: "#3D4E42"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(92,1117)",
    d: "m0 0h7l12 3 1 4h-7l-9-2-4-2z",
    fill: "#3B4C40"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(56,963)",
    d: "m0 0 2 3 8 18 7 10 12 16-4-2-8-9-11-18-6-14z",
    fill: "#556C5C"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(208,869)",
    d: "m0 0 3 1 4 16v21h-2l-1-20-2-10-2-4z",
    fill: "#E6EAE6"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(150,344)",
    d: "m0 0 6 5 1 7-5 5h-2z",
    fill: "#4E6554"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1766,135)",
    d: "m0 0h16l-6 7-5 1-5-6z",
    fill: "#7D9F87"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1159,83)",
    d: "m0 0 4 2-2 12 2 4-1 2-2-4-4-2-6-4 2-1 4 2 2-9z",
    fill: "#4B5E50"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(73,1134)",
    d: "m0 0 3 1v2l5 1 13 3 2 3h-15l-8-8zm26 4 2 1-3 2-4-1z",
    fill: "#3D4F41"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(267,71)",
    d: "m0 0 1 4-2 6-5 12-2 6-3-1 3-11 5-12z",
    fill: "#97A99B"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(178,42)",
    d: "m0 0 4 2 8 6 1 4-11 4-3-1 5-2v-2h3l-8-7 2-2z",
    fill: "#313E34"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(38,1069)",
    d: "m0 0 4 4 10 14 7 6v2l4 2 9 6v2l-5-2-10-8-9-9-10-14z",
    fill: "#BCC9BE"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(605,1063)",
    d: "m0 0 5 2 8 5 17 6 12 2-1 2-11-1-16-6-11-6z",
    fill: "#7B9181"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1111,1043)",
    d: "m0 0 3 2v8l-6 15-3 4h-2l2-6 6-17z",
    fill: "#93A698"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1975,977)",
    d: "m0 0 3 1-6 11-8 10-8 9h-2l2-4 8-9 9-14z",
    fill: "#E1E8E2"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(73,947)",
    d: "m0 0 2 1-6 4 3 16 3 8 4 9-1 2-6-10-5-17v-10z",
    fill: "#7D9383"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 659)",
    d: "m0 0 2 3v8l6-3 4-4h2v5l-7 6-6 1-1-7z",
    fill: "#465A4C"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1111,77)",
    d: "m0 0 3 3 5 13-2 4h-2l-6-15v-2h2z",
    fill: "#36463A"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1427,63)",
    d: "m0 0 6 1v2l4 1 11 7 11 10 6 5v2h-3l-7-8-11-9-17-10z",
    fill: "#CED9CF"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1283,33)",
    d: "m0 0 6 1 17 10v2l4 1 5 5 1 3 2 1-4-1-9-8-15-9-7-4z",
    fill: "#9AAE9E"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(326,1117)",
    d: "m0 0h13l24 1-3 2-7 1h-12l-13-2z",
    fill: "#9EB0A2"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1791,1096)",
    d: "m0 0 6 1-1 5-4 4-10 1 6-7z",
    fill: "#7D9F87"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(706,1048)",
    d: "m0 0h2l3 11v5l-3 1-4-11-4 1-5 1 1-2 9-5z",
    fill: "#46594B"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(906,1036)",
    d: "m0 0 2 1-1 14-10-4v-2h2l2-4z",
    fill: "#4E6554"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(30,829)",
    d: "m0 0 2 1 5 13 3 4-1 3-2 2-4-7v-2h-2l-2-9z",
    fill: "#3C483F"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(150,840)",
    d: "m0 0 8 8-1 4-4 4h-3z",
    fill: "#4E6554"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(77,654)",
    d: "m0 0 6 2 18 7-3 3-19-7-2-1z",
    fill: "#8EA293"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1649,18)",
    d: "m0 0 1 2-5 6-8 5 1 2-6 3h-5v-2h-3v-2l9-3 9-4 5-4z",
    fill: "#445549"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1510,1064)",
    d: "m0 0 5 2 17 8 18 4-1 2-10-1-12-4-12-6-5-3z",
    fill: "#90A696"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(3,1046)",
    d: "m0 0 3 2v18l-4-1-1-2v-11z",
    fill: "#46594A"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(93,668)",
    d: "m0 0 3 1-4 8h-2l-1 5h-9l6-7 6-5z",
    fill: "#899E8F"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(30,369)",
    d: "m0 0 2 2 6 15 8 13 5 7h-3l-4-5v-2h-2v-3h-2l-1-5h-2l-6-14z",
    fill: "#A1B3A4"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(213,240)",
    d: "m0 0h2v21l-4 15-2 3-1-3 4-16z",
    fill: "#DFE5DF"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(875,66)",
    d: "m0 0h65v1l-60 1 1 3h-3l-3-3z",
    fill: "#4E6454"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(70,41)",
    d: "m0 0 3 1-12 9-8 7-9 12-4 4 1-4 6-8 9-10 11-9z",
    fill: "#A3B7A6"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(81,4)",
    d: "m0 0m-2 1h2l-1 4-5 5-4 5-8 7v-3l4-4 1-4 4-6z",
    fill: "#3B493E"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1975,948)",
    d: "m0 0 7 2v7l-4 16-7 13-1-2 5-12 4-15v-5z",
    fill: "#8BA191"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(31,959)",
    d: "m0 0h1v5l-9 10-9 4-3 3-2-1 4-6 7-2 7-8z",
    fill: "#3C4D41"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2006,882)",
    d: "m0 0h3l-1 7-5 6h-4l-1-6z",
    fill: "#7D9F87"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(61,850)",
    d: "m0 0h2l-1 6-5 16-2 1-1-7-7-7-2-5 10 10 3-1v-6z",
    fill: "#BCCABE"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(838,134)",
    d: "m0 0h2l-2 4-8 8 1 3h-7l1-4-8-9 3-1 7 8 4-2z",
    fill: "#91A397"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1014,26)",
    d: "m0 0h21l19 4 2 3-7-1-12-3-20-1z",
    fill: "#94A699"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(484,1049)",
    d: "m0 0 2 1 6 16 6 12h-4l-7-13-2-10z",
    fill: "#889B8C"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(120,938)",
    d: "m0 0h1v56l-2-1v-47l-9-2-1-2 11 1z",
    fill: "#819E89"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1779,895)",
    d: "m0 0 4 2 13 13 7 8 2 4 4-1 1 3h-8v-3l-7-6-2-5-14-14z",
    fill: "#99AA9D"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(79,823)",
    d: "m0 0v3l-9 13-4 7h-2l-1-3 9-14 5-5z",
    fill: "#95A699"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1927,450)",
    d: "m0 0h5l3 3v2l22-1 9 1v1l-39 1z",
    fill: "#A2B2A7"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(220,237)",
    d: "m0 0h3l-1 21-2 12-3 2 2-17z",
    fill: "#DDE3DE"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1198,45)",
    d: "m0 0 4 2 15 14 7 7-1 2-10-9-16-14z",
    fill: "#92A397"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1532,41)",
    d: "m0 0 5 2 10 9 2 2-7 1-5-5v-2l-5-2z",
    fill: "#313F34"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1751,15)",
    d: "m0 0 3 1 7 8 5 4 6 4v1h-6v-2h-3v-2l-4-1-6-6z",
    fill: "#38483C"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1370,1026)",
    d: "m0 0h2l-1 5-4 2 1 23-1 17h-1v-45z",
    fill: "#A7B5AB"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(194,813)",
    d: "m0 0h4l1 6-6 5-2-1v-2h-2l-2-4z",
    fill: "#92A998"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1975,297)",
    d: "m0 0h3l-2 6-10 14-10 11h-2l2-4 8-8 10-16z",
    fill: "#DEE4DE"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1894,262)",
    d: "m0 0h2l-2 4-5 4v-3h2l2-4zm-8 8 3 1-3 2zm-1 3m-1 1m-1 1m-1 1m-1 1m-1 1m-1 1m-1 1m-3 1 3 1-12 12-1 2-4-1h2l2-4 5-5h2l2-4z",
    fill: "#89A190"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1804,226)",
    d: "m0 0 2 1-34 34-2 3h-2l2-4z",
    fill: "#EDF0ED"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1776,217)",
    d: "m0 0 34 3v2h-17l-17-3z",
    fill: "#E0E5E0"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2013,160)",
    d: "m0 0 1 2h2l-2 6-7 10h-3l-3 2 2-4 9-14z",
    fill: "#2E3830"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(619,63)",
    d: "m0 0 3 1-19 11-12 11-5 4-2-1 8-8 10-8 10-7z",
    fill: "#CED7CF"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1239,26)",
    d: "m0 0h22l4 2-6 1h-28l2-2z",
    fill: "#9EB0A2"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(733,1092)",
    d: "m0 0 4 2 13 10 20 10-3 1-12-5-12-8-10-9z",
    fill: "#AFBFB1"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1862,1092)",
    d: "m0 0 4 2 14 10 16 8 7 3-4 1-18-8-12-9-7-6z",
    fill: "#A3B4A6"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(816,1052)",
    d: "m0 0 4 1 9 9 14 10v2l-4-2-11-7-10-9z",
    fill: "#E0E6E0"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(44,969)",
    d: "m0 0 1 2-9 14-3 4-2-4 6-11 4-4v2h2z",
    fill: "#242E26"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1927,677)",
    d: "m0 0 7 3 1 3h-7l1 8 6 1v2l-5 3h-3z",
    fill: "#C0CBC2"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1974,496)",
    d: "m0 0 7 1 1 1-1 13-5 15-4 7-1-2 4-10 4-15 1-6-5-2z",
    fill: "#819887"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1721,189)",
    d: "m0 0 8 6 11 8 7 4-1 5-2-4-1 15h-1l-1-8v-10l-5-2-13-10z",
    fill: "#586E5E"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1739,70)",
    d: "m0 0 4 1v1l2 1-12 8-2 1-4-3 9-7z",
    fill: "#28332A"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1079,1101)",
    d: "m0 0 3 1-5 7h-2v2l-12 3v-3l14-8z",
    fill: "#4D6252"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1681,1052)",
    d: "m0 0h3l-2 4-7 6-4 4-12 8h-2l2-4 12-8 9-8z",
    fill: "#DEE4DE"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(29,97)",
    d: "m0 0 1 4-1 11 1 17-4 1v-22z",
    fill: "#9EB0A2"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(287,42)",
    d: "m0 0 2 1-2 3 5-4 2 1-12 10-1 2-11-2v-1l7-1z",
    fill: "#161B16"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(830,32)",
    d: "m0 0 9 3 8 4v2l4 1 2 1v2l4 1 5 5 1 3-4-2-10-8-7-4v-2l-10-3-2-1z",
    fill: "#97AC9C"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1792,1096)",
    d: "m0 0h11l-2 7-7 7-4-1 3-2v-3l3-4 1-3h-5z",
    fill: "#3C4D40"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 1052)",
    d: "m0 0 3 1-10 10-13 9-6 3 1-4 12-7 10-9z",
    fill: "#DFE6DF"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(559,1056)",
    d: "m0 0 2 1-5 5-10 9-10 7-8 4h-2v-2l9-5h3v-2h3v-2l4-1v-2l8-6z",
    fill: "#D0DAD1"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1268,1051)",
    d: "m0 0h2l6 7 11 9 7 4 1 3-5-2-11-8-11-10z",
    fill: "#DAE2DB"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(980,73)",
    d: "m0 0 5 2 10 7 11 10v2l-4-1-4-5-12-9-6-4z",
    fill: "#DEE5DF"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(904,68)",
    d: "m0 0h6l-1 3-10 7-7 6-2 2-1-3h2l2-4z",
    fill: "#91A296"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(240,931)",
    d: "m0 0h15l17 3 3 2-4 1-17-3-14-1z",
    fill: "#D4DCD5"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2010,299)",
    d: "m0 0 2 4h2l-1-4h2l5 12 1 5-3 3-6-14-2-3z",
    fill: "#2D372F"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(164,64)",
    d: "m0 0 4 1-14 8-11 9-7 7h-2v2h-2l2-4 12-11 15-10z",
    fill: "#D8E0D9"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1874,17)",
    d: "m0 0v3l-8 8 2 1-10 7h-5l3-1 1-5 11-7z",
    fill: "#202822"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1789,1044)",
    d: "m0 0h2l1 2-1 9-7 16-2 2 1-5 2-6 1-5 3-11z",
    fill: "#97A89B"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(64,527)",
    d: "m0 0h2l6 12 9 12 10 10v2l-4-2-10-11-10-15-3-5z",
    fill: "#D9E1D9"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1954,364)",
    d: "m0 0 4 2 10 11 7 11h-3l-4-6v-2h-2l-7-8-5-6z",
    fill: "#DFE6DF"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(27,282)",
    d: "m0 0v3l-2 3h2l-2 4-7 6-5 2 3-6 5-5z",
    fill: "#242D26"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(981,66)",
    d: "m0 0 5 1 14 10 13 12v2l-4-2-10-10-13-9-5-3z",
    fill: "#D1DBD2"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1011,1056)",
    d: "m0 0v3l-9 9-11 8-11 6h-2v-2l8-4 6-4h2v-2l6-4z",
    fill: "#C3D0C5"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1927,911)",
    d: "m0 0h2v4l24 1-1 2-17-1-2 4-6 2z",
    fill: "#ACBAAF"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(163,1079)",
    d: "m0 0 6 2 16 6 3 2-1 1-8-1-18-8z",
    fill: "#A3B7A7"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2031,827)",
    d: "m0 0 5 1 6 6-1 6-3-1-7-8z",
    fill: "#94A599"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1140,81)",
    d: "m0 0h1l1 14-1 18 3 1 2 3v3h-6z",
    fill: "#AAB8AE"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1620,66)",
    d: "m0 0h5l-2 5-6 11-2-2-2 2 1-5z",
    fill: "#313D34"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(531,31)",
    d: "m0 0 3 1 1 2-9 5-4 3-4-1h-3l10-7z",
    fill: "#232D25"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1289,1067)",
    d: "m0 0 5 2 19 7 10 2v2l-9-1-16-5-8-5z",
    fill: "#899D8E"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1463,1055)",
    d: "m0 0h2v3l-8 7-13 10-10 6h-2v-2l5-3h3v-2h3v-2l9-6 9-8z",
    fill: "#C7D3C9"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(886,1044)",
    d: "m0 0 7 6 9 5-3 1-6-2-1-2-4-1-5 11-2 4-1-3 4-10z",
    fill: "#778C7D"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(75,845)",
    d: "m0 0 1 2-6 19-2 9 4 1 3 3-6-2-2-1v-11l3-10 4-9z",
    fill: "#7C9282"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(83,716)",
    d: "m0 0 3 1-17 9 3 16-1 4-3-7-1-5v-10z",
    fill: "#798E7F"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1585,73)",
    d: "m0 0h1v40h-1l-1-23zm-2 40 2 1-1 6h-4l1-5z",
    fill: "#AAB8AE"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(200,76)",
    d: "m0 0 7 7 4 12-1 7-3 2 1-6-6-16z",
    fill: "#8CA091"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1770,54)",
    d: "m0 0h8v2l-21 6-6 2-1-2 14-6z",
    fill: "#C0CDC2"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2045,1062)",
    d: "m0 0 1 4-6 8-9 6-2-1 3-3-2-1 10-9v3l-1 2 4-5z",
    fill: "#141915"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1615,1042)",
    d: "m0 0v3l1 7 4 10-1 4-1-3h-2l-5-14v-3z",
    fill: "#8A9E8F"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(242,151)",
    d: "m0 0 4 1-16 10-12 12-2-1 9-10 12-9z",
    fill: "#E4E9E4"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(855,41)",
    d: "m0 0 4 2 9 8-1 4-4-2-6-5v-2l-3-1 2-1z",
    fill: "#253028"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(156,34)",
    d: "m0 0 5 1 9 5 4 2v2l4 2 8 7-1 2-11-9-15-9z",
    fill: "#A0B4A3"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(633,1090)",
    d: "m0 0 8 1 2 1-2 5-7 5-2-2 3-5 3-3-6 5-2-1 4-4z",
    fill: "#3B4C3F"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(93,818)",
    d: "m0 0 2 2-10 10-8 12-3 1 2-6 11-13z",
    fill: "#DFE6E0"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(36,484)",
    d: "m0 0h2l-1 6h2l-1 7-2 6h-3v-7z",
    fill: "#3C4E41"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(117,450)",
    d: "m0 0h4v10l-1-4h-28l4-2h17z",
    fill: "#A5B4A9"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2015,87)",
    d: "m0 0h2l5 18-1 24h-2v-25l-4-13z",
    fill: "#99AD9E"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(305,67)",
    d: "m0 0 5 1 8 5v2l5 2v2l4 2 6 5 2 4-4-2-11-10-10-7-5-3z",
    fill: "#D3DCD4"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1314,1114)",
    d: "m0 0 3 1 1 3-7 4-7 7v-3l6-6-7 6-3 2 2-4 10-9z",
    fill: "#161B17"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(333,1055)",
    d: "m0 0h2l-1 4-10 9-14 10-4 1v-2h3v-2l7-4 3-1v-2l6-4 5-5z",
    fill: "#C6D2C8"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1042,1052)",
    d: "m0 0 4 1 10 10 8 5v3l-4-2-9-7-9-8z",
    fill: "#DCE3DC"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(73,982)",
    d: "m0 0 4 2 7 10 8 10 2 4-4-2-7-8-7-10-3-4z",
    fill: "#E2E8E2"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1792,931)",
    d: "m0 0h17v2l-22 2-9 1-1-2z",
    fill: "#D4DDD5"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1327,66)",
    d: "m0 0h17v1h-11l3 6 1 1v6h-2l-3-6-4-4z",
    fill: "#4F6455"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1720,1052)",
    d: "m0 0 4 2 11 10 9 6 1 3-4-2-10-7-10-9z",
    fill: "#E3E9E4"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(27,1037)",
    d: "m0 0 2 2 4 15 5 12 1 3-2 2-6-14-4-14z",
    fill: "#9BAF9F"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1835,841)",
    d: "m0 0h8l-1 3-17 1-10 1 1-2 5-2z",
    fill: "#E5EAE6"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1979,673)",
    d: "m0 0h2l-2 4-4 5-2 2h-31v-1l16-1 13 1 2-4z",
    fill: "#7E9F88"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(143,345)",
    d: "m0 0 3 1-2 4 1 9 5 2v3l-5-2-4-4-1-8z",
    fill: "#B6C7B7"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(833,1113)",
    d: "m0 0m-3 1 4 1v3l-10 4-4-1 1-4z",
    fill: "#485D4D"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1262,1055)",
    d: "m0 0 7 6 12 10 3 2-1 3-13-10-8-9z",
    fill: "#B1C2B4"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1810,889)",
    d: "m0 0 4 2 9 9v2h2v6l-3-1-1-4-11-11z",
    fill: "#99AC9D"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1987,295)",
    d: "m0 0 1 4-2 4h-2l-2 6-4 6-5 2 3-7 4-6h2z",
    fill: "#869A8B"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(294,202)",
    d: "m0 0 2 1-1 2h3v2l-10 5-4-1 1-3h2v-2z",
    fill: "#617767"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(203,69)",
    d: "m0 0 1 2h2l5 10-1 4-2-3h-3l-4-8 1-4z",
    fill: "#344237"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(426,66)",
    d: "m0 0h7l-3 1 4 9-1 3h-2v-2l-3-1-4-7v-2z",
    fill: "#465A4B"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(963,44)",
    d: "m0 0h3l-2 5-6 6-6-1v-2z",
    fill: "#354439"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(329,1135)",
    d: "m0 0h4v2l3 1-11 6h-5l3-2-3-2 7-2v-2z",
    fill: "#313E34"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 1110)",
    d: "m0 0 4 1 2 2-16 8-2-1 4-4v-2z",
    fill: "#2B362D"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(622,1083)",
    d: "m0 0 6 1 17 5-2 1v2l-12-3-9-4z",
    fill: "#A6B9A9"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(487,1068)",
    d: "m0 0h3l5 10 4 1v1h-10l-2-6-1-5z",
    fill: "#445849"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1332,1025)",
    d: "m0 0h29l-1 2h-2v6l-4-3v-4l-21 1-1 4z",
    fill: "#ADBBB1"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(660,1025)",
    d: "m0 0h22v9l-4-2-2-3v-3h-15l-1 4z",
    fill: "#AFBEB3"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1855,938)",
    d: "m0 0 5 1-2 2-11 3-3 9-3-1 2-9 9-4z",
    fill: "#D4DCD5"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2010,757)",
    d: "m0 0 4 4 4 11 3 10-1 6h-1l-4-16-5-12z",
    fill: "#9DB1A1"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(27,561)",
    d: "m0 0h1l1 11v17l-2 1-1-6v-19z",
    fill: "#9DAFA1"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(387,66)",
    d: "m0 0 3 1-11 7-10 8-9 8-2-1 7-7 14-11z",
    fill: "#D3DCD4"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1778,67)",
    d: "m0 0 3 3 6 10 5 14-1 4-6-16-2-4-5-5z",
    fill: "#A3B3A6"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1549,53)",
    d: "m0 0h6l-1 2-22 7h-2v-2l9-4z",
    fill: "#C4D0C6"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2020,1036)",
    d: "m0 0 2 2-2 12-6 16-5 5 2-6 5-12 2-5z",
    fill: "#A1B4A4"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1747,953)",
    d: "m0 0 1 2h2l5 17-1 3-3-3-4-13v-2l-3-1z",
    fill: "#A3B4A6"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1815,844)",
    d: "m0 0m-4 1h4v2l-12 4-9 4-2-1 2-3 12-5z",
    fill: "#E2E8E3"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1971,533)",
    d: "m0 0 3 1-7 10-9 10-4 3v-3l5-5 7-8z",
    fill: "#E2E8E2"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1991,411)",
    d: "m0 0 3 3 2 9v12l-2-2-3-14z",
    fill: "#C0CDC2"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(492,66)",
    d: "m0 0h10l2 2-6 1-8 14-1-2 2-6 2-5v-1l-2 1z",
    fill: "#7B9080"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(23,63)",
    d: "m0 0 2 1-7 8-12 9-1-4 5-4 11-8z",
    fill: "#445348"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1987,49)",
    d: "m0 0 4 2 5 4 11 14 3 6-2 1-7-11-9-10-5-4z",
    fill: "#A4B8A7"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1664,37)",
    d: "m0 0 4 1 19 19-1 3-22-22z",
    fill: "#94A599"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1184,1092)",
    d: "m0 0 5 2 4 3v2l4 1v2l5 2 13 7-3 1-12-6-10-8-6-5z",
    fill: "#A8BBAB"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(643,1092)",
    d: "m0 0 10 2 20 2-1 6h-4v-5h-9l-16-3z",
    fill: "#4E6554"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(296,247)",
    d: "m0 0 1 3-5 10-6 9h-3l2-4 10-17z",
    fill: "#E9EEE9"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(258,193)",
    d: "m0 0h10l5 4-1 2-5-4h-7l-5 4v8l2 4-4-1-2-5 1-5 3-5z",
    fill: "#B6C7B7"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(642,66)",
    d: "m0 0h7l6 11h-4l-5-8h-11l2-2z",
    fill: "#91A495"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1514,35)",
    d: "m0 0 5 1 6 3v2l4 1v2l8 4 1 3-5-2-10-7-9-5z",
    fill: "#92A596"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(204,1037)",
    d: "m0 0 3 3 2 3v5h2l-2 9-2 1-4 9-1-3 5-14v-6l-3-4z",
    fill: "#829688"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1456,1052)",
    d: "m0 0h2l-2 4-11 10-10 6 1-4 12-8z",
    fill: "#DFE6E0"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(299,954)",
    d: "m0 0 2 1-1 9-2 3-7 15-3 3 2-6 6-15z",
    fill: "#AABBAC"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(211,857)",
    d: "m0 0 3 1 4 11 2 8-1 7h-1l-4-17z",
    fill: "#D5DCD6"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(187,843)",
    d: "m0 0h4l1 5-13 4-5 2-3-1 2-2 3-2 12-4z",
    fill: "#A6B7A9"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1731,259)",
    d: "m0 0 2 3 1 4 4 2 2 3-4-2-3-2 4 5 6 3-4 1-8-7-3-5 1-4v3h2z",
    fill: "#242E26"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1949,254)",
    d: "m0 0 8 3 4 3 8 4-3 1-15-6-5 1-4 1 5-5z",
    fill: "#819586"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(69,37)",
    d: "m0 0 2 1-1 4-8 6-5 4-2-1 5-5-2-1 9-7z",
    fill: "#1D251F"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(741,41)",
    d: "m0 0 5 1-5 5-6 5-5-1 5-5z",
    fill: "#324036"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(302,5)",
    d: "m0 0 2 1-2 4 3-3 2 1-8 8-1-2h-2l-2 4-5 6-2-1 9-11z",
    fill: "#181E19"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1407,1091)",
    d: "m0 0h3l5 5 4 5-5-2v2l3 1-2 1-4-3v-2l-4-2-3-4z",
    fill: "#2B372E"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(195,940)",
    d: "m0 0 8 1 2 1 4 14-3 1-3-9v-4l-10-2z",
    fill: "#CDD7CF"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(143,841)",
    d: "m0 0 3 1-2 3v7l2 3 4 2v3l-5-2-4-5-1-2v-6z",
    fill: "#B6C7B7"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(71,400)",
    d: "m0 0 1 4-3 13 1 4 2 2-4 1-1 5h-1v-12l3-13z",
    fill: "#859A8A"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1511,77)",
    d: "m0 0 2 1v2l-8 6-5 4-3 4-4-1 10-10z",
    fill: "#D5DED6"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(762,70)",
    d: "m0 0 4 1 12 9 7 6 2 5h-2l-4-5-11-9-2-1v-2l-6-2z",
    fill: "#CED9D0"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(613,74)",
    d: "m0 0m-2 1h2l-2 4-9 6-7 6-2 3-3-1 11-11z",
    fill: "#E5EAE5"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(612,36)",
    d: "m0 0 4 1 12 7 10 9v2h-2l-5-5-13-9-6-3z",
    fill: "#9FB4A3"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(191,1114)",
    d: "m0 0 2 1-11 7-8 8-5 8h-2l2-5 8-10 11-8z",
    fill: "#131814"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1237,1055)",
    d: "m0 0h2l-2 4-13 12-12 8h-2l1-3 9-5 14-12z",
    fill: "#CAD5CC"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(429,1034)",
    d: "m0 0 2 1 4 8v5h2l-3 12h-3l2-10v-6l-4-6z",
    fill: "#889C8D"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1839,1044)",
    d: "m0 0 1 4 4 10v8l-2-2-5-13 1-6z",
    fill: "#97AA9B"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(33,611)",
    d: "m0 0 3 4 4 7-1 3 1 4-4-4-5-9v-2h2z",
    fill: "#2B352D"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2014,384)",
    d: "m0 0 2 4-2 5-3 6-4 1-3 2 2-4 1-3h2l2-5z",
    fill: "#232D25"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(162,325)",
    d: "m0 0h3v2l2 1-2 2-2 9-4-3v-7z",
    fill: "#93A698"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(158,76)",
    d: "m0 0m-2 1 2 1v2l-11 8-4 5h-2l-1 2-2-1v-2l8-7z",
    fill: "#E0E6E0"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1981,1127)",
    d: "m0 0 1 3-8 10-5 3h-3v-4l4-3h2v2l4-4z",
    fill: "#222B24"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1819,1025)",
    d: "m0 0h26v2l-21-1-2 6h-3z",
    fill: "#B5C2B8"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1827,847)",
    d: "m0 0h11l1 3h2l-2 6-4 10-2-2 1-5 2-5 1-6h-10z",
    fill: "#C2CDC4"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1957,811)",
    d: "m0 0 4 2 11 12 7 11-2 1-7-10-9-10-4-4z",
    fill: "#CFD9D0"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(52,721)",
    d: "m0 0h1l2 13-5 4-3 2-3-1 8-10z",
    fill: "#36463A"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(120,460)",
    d: "m0 0h1v10l-7-1v-7z",
    fill: "#BFCAC1"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(52,273)",
    d: "m0 0h2l1 7-5 4-5 5-2-1 3-6 6-6z",
    fill: "#3A493E"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(490,66)",
    d: "m0 0h2v3l1-2 2 1-7 13-2-2-2 2 1-5z",
    fill: "#252F27"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(942,66)",
    d: "m0 0h5l-2 5-5 9-3-2 2-6z",
    fill: "#333E35"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(306,35)",
    d: "m0 0 3 1-16 10-11 9v-3l12-10z",
    fill: "#A4B7A8"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(402,1123)",
    d: "m0 0 2 3-6 8-4 2-4 4-2-1 4-4 3-6z",
    fill: "#485C4E"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(937,1062)",
    d: "m0 0 3 3 6 12 3 3h-9l-1-7h2l-4-9z",
    fill: "#354439"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1616,1068)",
    d: "m0 0h3l6 10v2h-5l-4-7z",
    fill: "#415446"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(935,1045)",
    d: "m0 0 2 3 6 16 2 6h-2l-7-15-2-3-1-5z",
    fill: "#7F9385"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(57,505)",
    d: "m0 0 2 4 6 16-2 4-6-15-1-6z",
    fill: "#A9BCAC"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1836,182)",
    d: "m0 0h3l6 15 1 5-3 1-3-11-4-8z",
    fill: "#CBD5CC"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1957,132)",
    d: "m0 0 4 2 10 10 9 13-1 3-9-13-10-11-3-2z",
    fill: "#DEE5DE"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1891,70)",
    d: "m0 0 4 1 11 8 8 7 3 3v2h-3l-7-8-9-7-7-5z",
    fill: "#D9E1DA"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(103,23)",
    d: "m0 0h5l-4 2 2 2-9 3h-5v-4z",
    fill: "#2A362D"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1068,1080)",
    d: "m0 0 21 7-2 1v2l-10-3-9-5z",
    fill: "#A3B7A7"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1397,1072)",
    d: "m0 0h2l2 6 15-3 4 1-8 3-5 1h-8l-2-4z",
    fill: "#859A8B"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(880,1025)",
    d: "m0 0h28l-2 1v7l-4-4v-3l-16 1-6 1z",
    fill: "#B1BEB4"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(120,904)",
    d: "m0 0h1v18l-5-1-3-2v-2l-3-1h10z",
    fill: "#A7B8AB"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(49,473)",
    d: "m0 0h1l3 23 1 8h-2l-4-25-3-3 1-2z",
    fill: "#526958"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(835,76)",
    d: "m0 0 2 1v2l-6 4-11 9-1 2-3-1 12-12z",
    fill: "#DEE5DF"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1553,66)",
    d: "m0 0h12v1h-6l2 7-1 2 1 4-3-3-5-9z",
    fill: "#29342C"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1849,66)",
    d: "m0 0 2 1-7 13-4 1 1-6 4-8 2 1v1z",
    fill: "#3D4C41"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(270,65)",
    d: "m0 0 20 4 3 3-15-3h-6l-3 6h-2l2-8z",
    fill: "#85998A"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(992,27)",
    d: "m0 0 2 1-1 4-10 4h-2v-2l-2-1 9-5z",
    fill: "#2D3930"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1294,8)",
    d: "m0 0 4 2 8 11v2l-3-1v-2l-4-1-6-8z",
    fill: "#45594A"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(183,1114)",
    d: "m0 0 3 1-6 5-8 10-5 3 2-6 5-5 8-6z",
    fill: "#2E3B31"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(844,1107)",
    d: "m0 0 3 1-3 5-7 4h-3l-1-3 8-5z",
    fill: "#354539"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1558,1025)",
    d: "m0 0h28l-2 1v7l-4-4v-3l-22 1z",
    fill: "#B3C0B6"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(683,1025)",
    d: "m0 0h12l-1 5-2 3h-4v-6l-5-1z",
    fill: "#B1BEB4"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(142,827)",
    d: "m0 0 5 2v2h2l1 2v6l-2 1-6-8z",
    fill: "#98A99C"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2008,623)",
    d: "m0 0 2 2v3l-4 6-4 1-3 3-2-1 7-9h2l1-4z",
    fill: "#212B23"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1953,593)",
    d: "m0 0 12 12 6 8 2 4-1 3-5-7-3-5-11-12z",
    fill: "#798D7E"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(61,525)",
    d: "m0 0 4 5 10 16 5 7-4-2-10-14-5-9z",
    fill: "#59705F"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(66,229)",
    d: "m0 0h1v40l4-1-1 3h-2v2h-2z",
    fill: "#90A195"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(79,157)",
    d: "m0 0 2 1-6 12-5 15-2 1 2-11 8-17z",
    fill: "#849A8A"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(89,132)",
    d: "m0 0 3 1-6 7-7 7-3 1 2-4 7-9z",
    fill: "#A6B5A9"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1288,78)",
    d: "m0 0 2 1-12 11-6 7-2-1 2-5 8-7z",
    fill: "#85998A"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1065,37)",
    d: "m0 0 5 1 10 6v2l4 2 5 4v2h-2v-2l-4-2-15-10z",
    fill: "#9BB0A0"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(396,1132)",
    d: "m0 0 1 3-4 5-4 3-9-1 1-2 7-3 5-4-2 4v1z",
    fill: "#1E2620"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(611,1109)",
    d: "m0 0h2l-1 3-21 7h-6l2-2 9-2z",
    fill: "#9CAFA0"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(296,1106)",
    d: "m0 0 4 1 6 3-1 4 2 1-6-1-2-1v-2l-5-2z",
    fill: "#2B372D"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(186,1090)",
    d: "m0 0 5 1-8 4-1 3-5 2v2l-9 5-1-2 14-10z",
    fill: "#8DA191"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(154,1079)",
    d: "m0 0h2l-2 4-8 7-7 7h-2l-1 2v-3h2l2-4 9-9 5-2z",
    fill: "#92A397"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1965,592)",
    d: "m0 0 4 2 9 11 8 14-1 2-10-16-10-12z",
    fill: "#556C5B"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(52,504)",
    d: "m0 0 3 1-1 4-8 10h-2l3-6-2 1 2-4z",
    fill: "#1E261F"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(62,396)",
    d: "m0 0 1 4-5 16-5-5-2-4 4 3z",
    fill: "#B5C4B7"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 179)",
    d: "m0 0 1 2-8 10-4-2v-3l3-1 4-4z",
    fill: "#28332A"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(661,81)",
    d: "m0 0 2 1 4 12-1 3h-3l-3-8z",
    fill: "#303D34"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1215,71)",
    d: "m0 0 4 1 10 8 10 9v2l-4-2-10-10-10-7z",
    fill: "#D1DBD1"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1095,66)",
    d: "m0 0h6l3 6 2 8-3-3-4-7v-2l-4 1h-8l2-2z",
    fill: "#819686"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1194,60)",
    d: "m0 0 6 1 10 5 7 4-3 2-5-3-15-7z",
    fill: "#C0CCC2"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(753,37)",
    d: "m0 0 4 1-12 8-11 9v-3l9-8 5-4z",
    fill: "#9CB2A1"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(715,1033)",
    d: "m0 0 1 4-5 10 3 10-1 3-4-9-2-4 4-5z",
    fill: "#7F9385"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1953,818)",
    d: "m0 0 5 5 12 14v3h-2l-10-13-6-7z",
    fill: "#7C9182"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(198,813)",
    d: "m0 0 7 1 7 5-2 1-2-1v2h-3v-2l-6-2z",
    fill: "#364439"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2013,753)",
    d: "m0 0h2l4 10 2 3-1 4-1-2-2 2-4-9 1-4z",
    fill: "#2A352D"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(49,739)",
    d: "m0 0h2l-2 4-7 10-6 10-1-2 6-12z",
    fill: "#9CB0A0"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1979,649)",
    d: "m0 0h3l-2 4-5 2-6 2-7 3-3-1 12-6z",
    fill: "#7D9282"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1845,284)",
    d: "m0 0 4 5 6 8 10-1 3 2-9 2h-4l-6-7-4-6z",
    fill: "#4F6555"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(263,199)",
    d: "m0 0 5 2 2 2v3l-5 2 1-6h-2v5l-4-1v-5z",
    fill: "#83A08B"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(947,66)",
    d: "m0 0 12 1 1 2-11-1-2 6-3 5-1-2 2-8z",
    fill: "#7C9081"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1799,46)",
    d: "m0 0h3l1 4-23 3-7 1 1-2 17-3 7-1z",
    fill: "#4A6050"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(702,49)",
    d: "m0 0 15 1 11 1 5-1 1 3-1 2-11-2-20-3z",
    fill: "#4B6151"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(285,24)",
    d: "m0 0 2 1-3 3h-2v2l2 1-5 2v2l-7 1 3-1v-2l-3-1 8-4z",
    fill: "#212A23"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1043,1116)",
    d: "m0 0h5l-2 2-9 2h-16v-2l17-1z",
    fill: "#A0B2A4"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1640,1095)",
    d: "m0 0 4 2 13 9 9 4v2l-10-3-16-12z",
    fill: "#AABBAD"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(412,1091)",
    d: "m0 0 5 1-2 4-8 8-3-2 7-8z",
    fill: "#2D3A30"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1713,1054)",
    d: "m0 0 7 6 7 7 8 6-3 1-10-9-8-7z",
    fill: "#D1DBD2"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 866)",
    d: "m0 0h2l7 8 2 1-1 6-6 3 2-5 2-2-8-9z",
    fill: "#91A496"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(49,699)",
    d: "m0 0 2 3v11h-1l-2-8-7 1-3 2 2-4z",
    fill: "#3A4A3E"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2016,502)",
    d: "m0 0 3 3 5 8-1 2-2-1 6 8-4-2-6-7-1-4 2-1z",
    fill: "#1F2720"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1818,102)",
    d: "m0 0h1v11l3 1 2 3v4h-6z",
    fill: "#ACBEB0"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1667,71)",
    d: "m0 0 5 2 9 7 10 9v2l-4-2-8-8-12-9z",
    fill: "#D2DBD2"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1381,66)",
    d: "m0 0h18l-2 5-4 4h-1l1-8h-12z",
    fill: "#425547"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1432,37)",
    d: "m0 0h2v2l-10 6-11 9-4 2 6-7 10-8z",
    fill: "#9EB3A2"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 1116)",
    d: "m0 0 10 1 11 1v2h8v1h-11l-16-3z",
    fill: "#91A496"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1535,1096)",
    d: "m0 0 2 1-5 5-17 10-3-1 15-9z",
    fill: "#9BAE9E"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(587,1062)",
    d: "m0 0 4 1 9 8 10 7 3 3-6-2-12-9-8-7z",
    fill: "#536A59"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(265,899)",
    d: "m0 0h2l-2 4-13 13-2-3 12-11z",
    fill: "#96A89A"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(235,893)",
    d: "m0 0 4 1-11 11h-2v2h-2l1-4 6-5z",
    fill: "#BAC8BC"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2017,867)",
    d: "m0 0 2 1-4 12h-2v-2h-2l1-7 5-2z",
    fill: "#526858"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(71,765)",
    d: "m0 0 5 5 11 13 4 4-1 2-12-12-7-10z",
    fill: "#CDD7CE"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1979,424)",
    d: "m0 0 2 1v3h-2v2l-5 1v2l-6 1 4-2v-2l-6 2 3-3z",
    fill: "#222B24"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(75,374)",
    d: "m0 0v3l-7 11-3 6-1-4 3-7 3-5h2z",
    fill: "#A6B5A9"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2011,308)",
    d: "m0 0 3 3 2 5h2l2 15-1 2-3-2h2l-7-21z",
    fill: "#899D8E"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(226,297)",
    d: "m0 0 3 1-2 3-19 1v-2l9-2z",
    fill: "#29322B"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 288)",
    d: "m0 0 3 1v2h3v3h2l2 9h-2l-1-4-3-1-4-9z",
    fill: "#45574A"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1801,264)",
    d: "m0 0 1 3-15 15-3-2 8-7z",
    fill: "#889E8F"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2034,170)",
    d: "m0 0 2 1-10 8-7 9h-3l-1-2 3-5 1 2-1 2h2l2-5 8-8z",
    fill: "#101410"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1778,151)",
    d: "m0 0h3l7 8 10 9 2 4-4-2-18-18z",
    fill: "#91A296"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(237,110)",
    d: "m0 0 1 3h2l3 5v3h-13l1-3v2h6z",
    fill: "#AFBEB2"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1777,66)",
    d: "m0 0h18v1h-10v6l-4-1-2-4-2 2z",
    fill: "#4A5C4F"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1751,1131)",
    d: "m0 0v3l-1 4-6 5-3-1 1-1-2-2 9-6z",
    fill: "#37473B"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1494,1052)",
    d: "m0 0 4 2 10 9 3 3v2h-2v-2l-4-2-10-9z",
    fill: "#E1E7E1"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1184,996)",
    d: "m0 0 2 2-7 4-10 10-2-1 7-8 4-3 1-3z",
    fill: "#93A498"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(239,996)",
    d: "m0 0 5 2 9 10 2 4-5-3-12-12z",
    fill: "#92A397"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1969,764)",
    d: "m0 0v3l-6 8-8 8-1-3 9-9 4-6z",
    fill: "#E4EAE5"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(71,626)",
    d: "m0 0h2l-1 7-4 15-2 2 1-10z",
    fill: "#8B9F90"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(39,619)",
    d: "m0 0 5 5 8 11 3 3v2l-3-1-6-7-7-10z",
    fill: "#A2B6A6"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(93,364)",
    d: "m0 0h2l-2 4-8 8-5 6-2-1 8-10z",
    fill: "#E8ECE8"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1835,262)",
    d: "m0 0h2l4 15 2 5-3 1-5-15z",
    fill: "#D6DED7"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(488,84)",
    d: "m0 0 1 3-5 14-2-1 1-8 3-7z",
    fill: "#899C8D"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(298,35)",
    d: "m0 0 2 1-1 4-14 7 6-8z",
    fill: "#37443A"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1429,34)",
    d: "m0 0 2 1-1 4-9 6h-2l2-6z",
    fill: "#2D3930"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1656,11)",
    d: "m0 0v3l-8 11-10 7-2-1 11-8 4-8z",
    fill: "#19201B"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1891,1075)",
    d: "m0 0h2v2l-3 2h-3v2l-13 6h-4v-2l11-4z",
    fill: "#C3D0C5"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1914,1056)",
    d: "m0 0h2l-2 4-10 9-8 6h-2v-2l11-8z",
    fill: "#CCD6CD"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1387,1057)",
    d: "m0 0 2 1 4 9 1 5h-2l-1 2-4-7v-2h2z",
    fill: "#2D382F"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1688,1056)",
    d: "m0 0 3 1-8 8-13 10h-2v-2l11-8 8-7z",
    fill: "#CFD9D0"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(359,1056)",
    d: "m0 0 8 6 9 8-1 3-12-10-4-5z",
    fill: "#AFC1B2"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(258,1025)",
    d: "m0 0h9l-2 10-2 5-2-2 3-11h-5l-1 3z",
    fill: "#97AA9B"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1134,1025)",
    d: "m0 0h15l-2 1-2 5-3 2v-5l-8-1z",
    fill: "#B3C0B6"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(32,500)",
    d: "m0 0 1 3h2l-1 5-4 6v-3l-4 2 2-5z",
    fill: "#222B24"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1962,429)",
    d: "m0 0m-2 1 4 2-9 4h-7l-1-2z",
    fill: "#97A99B"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(333,166)",
    d: "m0 0h5l-4 2zm-2 2 2 1-4 3zm-3 4m-1 1m-1 1m-2 1h2v8l-5-1-1-3h2v-2h2z",
    fill: "#7F9886"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(843,62)",
    d: "m0 0v3l-12 7-9 7v-3l10-8z",
    fill: "#596F5F"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1886,31)",
    d: "m0 0h2v2l3 1-12 6-2-2 5-5z",
    fill: "#3D4D41"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1741,31)",
    d: "m0 0 6 2 5 3 1 3h-5l-9-5z",
    fill: "#2C382E"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1735,1140)",
    d: "m0 0h8l-1 4h-13v-3z",
    fill: "#789480"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(385,1085)",
    d: "m0 0v3l-7 7-8 7-4 3 2-4 15-15z",
    fill: "#92A397"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(434,1025)",
    d: "m0 0h20v7h-2l-2-3v-3h-15l-1 3v-2h-5v-1z",
    fill: "#B6C3B9"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(238,1025)",
    d: "m0 0h20v1h-15l-1 4-2 3h-2z",
    fill: "#B7C3B9"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(92,889)",
    d: "m0 0 6 2-2 5-4 7-1-3 3-6-6-1 1-3z",
    fill: "#3F5143"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2029,853)",
    d: "m0 0 2 1-7 7-4 6-6 3 2-6 3-3-1 4h2l2-5z",
    fill: "#1A201B"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2013,641)",
    d: "m0 0 1 2-1 3-5 3-7 7-3 1 2-4 11-11z",
    fill: "#90A195"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2006,515)",
    d: "m0 0 3 3v3h2v5l-4-1-4-6 1-3z",
    fill: "#3C4C40"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(35,387)",
    d: "m0 0 2 4h2l1 5h2l-1 3v-2h-2l1 4-3-3v-2h-2l-2-7z",
    fill: "#28332B"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2035,344)",
    d: "m0 0 2 1-1 4h-1l1 9 1 5-4-4-1-4v-9z",
    fill: "#A4B9A8"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(142,332)",
    d: "m0 0 4 2 4 3v6l-4-2-4-5z",
    fill: "#9BAC9F"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(207,301)",
    d: "m0 0h18v1l-13 1-4 1 14 1v1l-17 1z",
    fill: "#778B7C"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1769,293)",
    d: "m0 0h3l3 8-1 3-2 3-4-11z",
    fill: "#333F36"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1283,79)",
    d: "m0 0m-2 1 2 1-1 3-9 7-4 4v-4z",
    fill: "#D4DDD5"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1057,79)",
    d: "m0 0m-2 1 2 1v2l-8 7-4 4h-3l2-4z",
    fill: "#DAE2DB"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1669,80)",
    d: "m0 0 5 3 10 9-1 3-14-12z",
    fill: "#DAE2DA"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1546,66)",
    d: "m0 0h7l5 10-2 3-6-10-6-1z",
    fill: "#879B8C"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1885,4)",
    d: "m0 0 2 1-4 5 3-3 2 1-7 7h-3l-2-1 4-6z",
    fill: "#202821"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(527,1107)",
    d: "m0 0 5 1 5 3 13 4 1 2-7-1-15-6z",
    fill: "#A7B8AA"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(281,1090)",
    d: "m0 0 5 4v2l6 3v2l5 2 5 4h-3l-9-6-10-9z",
    fill: "#AABAAD"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1311,1090)",
    d: "m0 0h4v2l-2 1-1 4-5 4-8 2 4-4 8-7z",
    fill: "#687D6D"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(291,1084)",
    d: "m0 0h5l-3 3-12 4h-5l3-3 7-2h5z",
    fill: "#BBC9BE"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1208,1078)",
    d: "m0 0h2l-1 3-13 6-6 1 2-3z",
    fill: "#B9C7BB"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1488,1056)",
    d: "m0 0 7 6 9 7 2 1v2l5 2-4 1-9-8-8-7z",
    fill: "#D7DFD7"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1420,995)",
    d: "m0 0v3l-12 12-4 2 2-4 12-12z",
    fill: "#91A296"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1803,850)",
    d: "m0 0 2 1-3 3-14 7h-2l1-3 12-6z",
    fill: "#586E5E"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(95,821)",
    d: "m0 0 2 1zm-1 1m-3 1 3 1-3 3h-2l-2 4h-2l-1 4-5 6-1-2 8-11z",
    fill: "#798F7F"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(172,811)",
    d: "m0 0 4 1 3 6v2h-3l-1 2-3-4z",
    fill: "#8DA293"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1994,734)",
    d: "m0 0 5 5 8 10 3 6-2 1-8-12-6-7z",
    fill: "#A5B9A9"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(195,293)",
    d: "m0 0v3l-2 5-3 3-4-2 3-1-7-2 1-2h9z",
    fill: "#A7B7AA"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1829,261)",
    d: "m0 0h1l4 17 1 5-3-1-4-14z",
    fill: "#D9E0DA"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(284,268)",
    d: "m0 0v3l-8 9-7 5 2-4 8-9z",
    fill: "#DCE3DC"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1809,113)",
    d: "m0 0h2l1 7h6v1h-13l1-5z",
    fill: "#B8C4BB"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1792,85)",
    d: "m0 0 2 2 2 4v5l-4 3-2-11h2z",
    fill: "#37473B"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(713,83)",
    d: "m0 0 1 2-1 8-3 8-2-1 1-8z",
    fill: "#94A798"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(411,1090)",
    d: "m0 0 2 1-2 4-11 9-6 1 5-4 11-9z",
    fill: "#93A697"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2020,1011)",
    d: "m0 0 2 3 1 11v9l-2 4-1-18-2-3h2z",
    fill: "#A8BAAB"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(269,867)",
    d: "m0 0 5 1 5 5v2h2l4 5v3h-2l-7-9-7-6z",
    fill: "#1A1F1B"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1991,859)",
    d: "m0 0 3 4 1 2 2-2 4 1-3 5-1 2h-2l-1 2-3-11z",
    fill: "#4D6152"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2033,839)",
    d: "m0 0 4 2 1 3-7 5h-1l1-8z",
    fill: "#9AAC9E"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(27,739)",
    d: "m0 0v3l-10 9-8 6-1 2h-2l2-4 5-6 4-1z",
    fill: "#708B77"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1956,258)",
    d: "m0 0 6 1 18 9-1 2-10-4-3-3-10-4z",
    fill: "#9DAFA0"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1793,212)",
    d: "m0 0h15l1 3h-19z",
    fill: "#C4CEC5"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1319,54)",
    d: "m0 0h8l-1 2-14 4h-3l1-3z",
    fill: "#C4CFC5"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1209,5)",
    d: "m0 0 2 1-9 11-4-3 4-4z",
    fill: "#47584C"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(785,1134)",
    d: "m0 0 3 1-2 1v3l-8 4-3-1h2v-4z",
    fill: "#222B24"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(67,1128)",
    d: "m0 0 5 5 6 7 4 3-5-1-7-7-3-5zm5 2 2 1v2l3 1 1 3h-2l-4-5z",
    fill: "#121612"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(813,1097)",
    d: "m0 0 7 6 9 8v3h-2l-7-8-7-6z",
    fill: "#91A296"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2011,1073)",
    d: "m0 0 1 4-3 5-4 1-4 3 2-5 3-3 1-3z",
    fill: "#27322A"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1356,1058)",
    d: "m0 0h2v2h-2l-2 4-5 5-7 6 2-4 7-8z",
    fill: "#92A397"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1035,1055)",
    d: "m0 0 4 2 9 9 4 3v2l-4-2-13-12z",
    fill: "#C7D2C8"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(72,992)",
    d: "m0 0 5 5 6 8 5 5 3 4-4-2-7-7-8-11z",
    fill: "#D6DED6"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(280,882)",
    d: "m0 0 3 4-8 7-2 2h-3l2-4 6-6h2z",
    fill: "#8DA393"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1843,857)",
    d: "m0 0h3l-1 4-4 9-3 3-1-2z",
    fill: "#D5DDD6"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(120,231)",
    d: "m0 0h1v11h-5l-2-2v-4h6z",
    fill: "#B5C2B8"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1334,85)",
    d: "m0 0 3 4 4 6 1 4-5 4-1-9-2-5z",
    fill: "#798D7F"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1212,34)",
    d: "m0 0 3 1-19 11-4 2 4-5z",
    fill: "#A3B7A7"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1659,24)",
    d: "m0 0 2 1-4 6-7 4-3-1 5-4 1-3z",
    fill: "#92A397"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(303,1108)",
    d: "m0 0 5 1 16 6 1 2-8-1-14-7z",
    fill: "#A1B3A4"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(83,1112)",
    d: "m0 0 11 4-2 1v2l-10-2z",
    fill: "#2D3A30"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1186,998)",
    d: "m0 0 4 2 10 9 1 3-4-2-11-10z",
    fill: "#95A699"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(473,996)",
    d: "m0 0h2l-2 4-9 9-5 3 2-4z",
    fill: "#91A296"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1833,864)",
    d: "m0 0h1l-1 8-2 5-1 9-2-2 1-10 3-9z",
    fill: "#E1E6E1"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1791,853)",
    d: "m0 0 2 1-4 4-11 8v-3l5-5z",
    fill: "#E4EAE4"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(48,635)",
    d: "m0 0 4 2 3 3-1 6-7-6v-2h2z",
    fill: "#334136"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2042,611)",
    d: "m0 0 1 4-2 4-5 3-6 4-2-1 7-5 4-5h2z",
    fill: "#3D4F42"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(63,297)",
    d: "m0 0h2l4 8 7 11-1 2-7-9v-3h-2l-3-6z",
    fill: "#C4D0C6"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1055,70)",
    d: "m0 0v3l-11 9-6 5v-4l9-7z",
    fill: "#58705E"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1308,56)",
    d: "m0 0 4 1-8 4-10 4-3 2-3-1 15-8z",
    fill: "#5A7160"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(288,58)",
    d: "m0 0 9 3 10 5-3 2-16-7z",
    fill: "#AEBFB1"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(249,41)",
    d: "m0 0h3l1 4-2 3 5 1v1h-11z",
    fill: "#4D6252"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1891,33)",
    d: "m0 0 4 1-18 10h-2v-2z",
    fill: "#A1B5A5"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1959,32)",
    d: "m0 0 5 1 7 3-2 1v2l-6-2-8-3z",
    fill: "#708877"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(585,1136)",
    d: "m0 0 7 1 4 3-5-1v2l5 1-4 1-9-5z",
    fill: "#2F3A32"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(369,1126)",
    d: "m0 0 5 2 8 9-1 2-8-7-4-4z",
    fill: "#92A397"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(407,1116)",
    d: "m0 0 2 1-2 3h3l-5 5h-4l-5 4 2-4z",
    fill: "#1A211C"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1330,1108)",
    d: "m0 0 4 1-3 1 12-2-2 3-10 2h-5v-4z",
    fill: "#273029"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1741,1067)",
    d: "m0 0 5 2 17 7v1l-8-1-12-6z",
    fill: "#829787"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(584,1056)",
    d: "m0 0 4 2 12 11 5 5-5-2-12-11-4-4z",
    fill: "#DCE3DD"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1654,996)",
    d: "m0 0h3l-2 5-7 7-5 3 2-4 7-8z",
    fill: "#93A498"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1769,929)",
    d: "m0 0m-3 1h3l-1 3-12 5h-2l2-4z",
    fill: "#D9E0DA"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1754,903)",
    d: "m0 0 1 2-3 9-3 3-1 5h-1v-6l3-9 3-1z",
    fill: "#29312B"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1993,877)",
    d: "m0 0 3 1v15h-2l-1-5z",
    fill: "#CDD7CF"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1880,851)",
    d: "m0 0 9 3 8 6v2l-5-2-12-7z",
    fill: "#E6EBE7"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1986,745)",
    d: "m0 0h2l-1 6-6 11-3 1 2-5z",
    fill: "#B1C1B4"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1987,395)",
    d: "m0 0 3 4 2 5 1 8-3 2-2-9v-5z",
    fill: "#8A9E8E"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1971,318)",
    d: "m0 0h2l-2 4-9 10-3 3h-2l2-4 5-5z",
    fill: "#C7D3C9"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(81,261)",
    d: "m0 0 4 2-13 7-2-1 1-3z",
    fill: "#7B9181"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(96,252)",
    d: "m0 0 7 6 12 6-2 1-9-4-5-4-6-2z",
    fill: "#728778"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1927,222)",
    d: "m0 0 1 2 6 2v3l-6 1v6h-1z",
    fill: "#BDC8BF"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1762,151)",
    d: "m0 0h3v2h-2v3h-2l-2 5-3 4h-2l2-5z",
    fill: "#DDE4DD"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1331,72)",
    d: "m0 0 4 5v3h2l1-3 4 8-1 4-3-7-2 2-5-9zm6 13 2 1-2 1z",
    fill: "#1E2620"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(162,64)",
    d: "m0 0 2 1-21 14 2-4 11-8z",
    fill: "#566E5D"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(41,66)",
    d: "m0 0 2 2-4 7h-3l1 3-3 3 1-4h-2l2-5 5-5z",
    fill: "#2D3A30"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(88,32)",
    d: "m0 0 3 1-17 9-3-2 13-7z",
    fill: "#90A695"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(822,2)",
    d: "m0 0 3 1v1h8v1l-9 2-8 2 2-6z",
    fill: "#1E2620"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(383,1110)",
    d: "m0 0 3 1-8 4-10 3-4-1z",
    fill: "#9DB1A1"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(72,1104)",
    d: "m0 0 15 7 5 2v1l-8-1-8-4-5-3z",
    fill: "#A3B5A6"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(861,1088)",
    d: "m0 0 9 1-2 1v2l-5 3-6 4 2-4 3-4z",
    fill: "#99AC9C"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1173,1074)",
    d: "m0 0 3 3 15-1-1 2-9 2-8-1-1-4z",
    fill: "#85988A"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1613,1057)",
    d: "m0 0 2 1 3 10h-2l-1 3-3-6v-2h2v-2l-3 1v-2h2z",
    fill: "#334036"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(695,1025)",
    d: "m0 0h23l-1 9-2-1v-6l-20-1z",
    fill: "#8CA192"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1775,935)",
    d: "m0 0h3v2l-13 5-6 2 4-5z",
    fill: "#E7ECE7"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1927,903)",
    d: "m0 0 8 4v3l-8 1z",
    fill: "#B8C5BB"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(81,881)",
    d: "m0 0 16 6 5 1-4 4v-3l-9-2-9-4z",
    fill: "#809686"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 856)",
    d: "m0 0 1 4-7 8v-3l1-1-2-2 4-5z",
    fill: "#303D33"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1784,826)",
    d: "m0 0h6l-2 2 3 2-8 2v-2l-3 2-3-1z",
    fill: "#262F28"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(90,586)",
    d: "m0 0 2 2-10 10-1-4 7-7z",
    fill: "#98AA9C"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(135,396)",
    d: "m0 0 4 2 7 7 4 5-1 2-14-14z",
    fill: "#96A79A"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(193,322)",
    d: "m0 0v3l-1 5-5 1-8 8-2-1z",
    fill: "#728878"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(225,301)",
    d: "m0 0m-13 1h13v2l-8 1h-10l1-2z",
    fill: "#EFF2EF"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(117,224)",
    d: "m0 0h4v7l-9-1 1-3z",
    fill: "#AEBCB2"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1725,211)",
    d: "m0 0 3 3 2 7h-2v3h-2l-2-5v-4h2z",
    fill: "#2D382F"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(342,135)",
    d: "m0 0 4 1 8 8 2 1 1 4h-5l1-3-10-9z",
    fill: "#A2B3A5"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1717,28)",
    d: "m0 0 10 1 12 4-4 2-18-6z",
    fill: "#8CA392"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(747,17)",
    d: "m0 0 2 3-6 7-4 2-2-2z",
    fill: "#334237"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1496,3)",
    d: "m0 0 3 1-1 1 2 2-6 2v2h-4v-4l4-3z",
    fill: "#313E34"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(624,1105)",
    d: "m0 0m-1 1 1 2-4 4-5 3-2-1 1-4z",
    fill: "#2D3A30"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1090,1092)",
    d: "m0 0 2 1-7 7v3l-5 4-2-1 3-5 5-5z",
    fill: "#1B231D"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(958,1091)",
    d: "m0 0 4 2 11 9 4 4-5-2-9-7-5-4z",
    fill: "#AFBFB2"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(508,1087)",
    d: "m0 0h6l-1 2-12 4h-3l2-4z",
    fill: "#B1C1B3"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(33,1066)",
    d: "m0 0 3 1 4 9v2l-4-1-3-6z",
    fill: "#3C4A40"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1860,846)",
    d: "m0 0 12 3v3l-10-2-5-2z",
    fill: "#A0B2A3"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(191,844)",
    d: "m0 0 5 5 7 10 3 6-1 3-7-13-7-9z",
    fill: "#556C5B"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(54,280)",
    d: "m0 0v3l-11 14-3 3 2-6 9-11z",
    fill: "#9FB4A3"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(93,252)",
    d: "m0 0 3 1-2 1 2 2-9 3-2-2v-2z",
    fill: "#29352C"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(39,165)",
    d: "m0 0 4 4 9 12v3l-6-6v-2h-2l-5-9z",
    fill: "#AFBEB1"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1077,134)",
    d: "m0 0 3 1-2 3h-2v2l-4 4h-2l-2 4-4 1 6-7z",
    fill: "#96A89B"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1616,84)",
    d: "m0 0 2 4-4 11h-2l1-9z",
    fill: "#92A696"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(386,65)",
    d: "m0 0 2 1-17 12-2 1 2-4 9-7z",
    fill: "#516656"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(855,49)",
    d: "m0 0 10 5v2l-14 5-3-1 9-4h3z",
    fill: "#566E5C"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1939,27)",
    d: "m0 0 10 1 9 3 1 2-7-1-13-3z",
    fill: "#8CA292"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(846,1132)",
    d: "m0 0 3 1-2 5-5 4-4-2 7-6z",
    fill: "#5A7160"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1087,1088)",
    d: "m0 0 9 1 5 1v1l-10 1-3 3-2-1 2-3z",
    fill: "#AABCAD"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1665,1075)",
    d: "m0 0h2v2l-16 9h-4v-2l10-4z",
    fill: "#C9D5CA"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1510,1064)",
    d: "m0 0 5 2 14 7v2l-9-3-7-5-3-1z",
    fill: "#8DA292"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(450,1056)",
    d: "m0 0h6v18l-2-2-1-14z",
    fill: "#4F6655"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1720,1051)",
    d: "m0 0 5 1 12 12h-3l-12-11z",
    fill: "#76897B"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1973,996)",
    d: "m0 0v3l-12 14-4 1 6-7z",
    fill: "#D5DDD6"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(944,996)",
    d: "m0 0h2l-2 4-8 7-4 4-2-1 6-7 5-4z",
    fill: "#91A296"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(30,957)",
    d: "m0 0 1 2-7 10-6 5-2-1 10-10z",
    fill: "#202922"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(135,891)",
    d: "m0 0 7 6 8 9h-3l-11-11z",
    fill: "#92A397"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(35,837)",
    d: "m0 0 3 3 8 14-2 1-2-5h-2l-5-9z",
    fill: "#9CAFA0"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(53,509)",
    d: "m0 0h2l-2 4-9 11-1 2h-2l2-5z",
    fill: "#99B09E"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(97,433)",
    d: "m0 0 5 1-6 8-4 4 1-9 3-2z",
    fill: "#5A6C5F"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 394)",
    d: "m0 0 2 4-7 9-2-4z",
    fill: "#7B9080"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(236,298)",
    d: "m0 0 3 1-2 3-4 1h-8l2-3z",
    fill: "#D5DED7"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 290)",
    d: "m0 0 5 5 3 4v6l-3-3-4-6z",
    fill: "#8EA192"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(133,159)",
    d: "m0 0 4 1 13 13-1 2-8-7v-2l-4-2-2-4z",
    fill: "#9CADA0"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(379,82)",
    d: "m0 0 2 1-13 13-3-2 8-7z",
    fill: "#839787"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(376,81)",
    d: "m0 0h2v3l-8 7-3 3-3-1z",
    fill: "#E5EAE5"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2010,71)",
    d: "m0 0h2v2h3l2 7h-2l-1 2-3-4z",
    fill: "#3C4C40"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1651,62)",
    d: "m0 0 6 1 11 7-2 2-11-6-4-2z",
    fill: "#BECDC1"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(406,57)",
    d: "m0 0h6v2l-11 3-4 2h-3v-2l10-4z",
    fill: "#C6D1C7"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(973,41)",
    d: "m0 0 3 1-14 11-3 3-2-1 8-8z",
    fill: "#9EB3A2"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(527,6)",
    d: "m0 0 2 1-8 11-5 5h-3l8-10z",
    fill: "#141915"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1981,1125)",
    d: "m0 0v3l-7 10h-2l1-5 4-5z",
    fill: "#405144"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1536,1116)",
    d: "m0 0m-1 1m-1 1m3 0v3h-3l-2 4-3 1-1 2-1-3 5-6z",
    fill: "#5B7562"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1423,1101)",
    d: "m0 0 14 8 3 1v2l-5-1-9-5-4-4z",
    fill: "#A1B5A5"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1394,1071)",
    d: "m0 0 3 4 2 5h-5l-3-6z",
    fill: "#435548"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(937,1060)",
    d: "m0 0 1 4 3 6v3h-3l-1-5h-2v-7z",
    fill: "#4C6051"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(56,951)",
    d: "m0 0h1l3 14-3 1-3-6v-7z",
    fill: "#9DB1A1"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1801,879)",
    d: "m0 0 7 6 3 4-2 2-9-9z",
    fill: "#A4B5A7"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(93,595)",
    d: "m0 0h2l-1 3h-2l-2 4h-2l-2 4-5 6v-3l9-11z",
    fill: "#74887A"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(237,294)",
    d: "m0 0 3 1-1 3-7 2h-4l2-4z",
    fill: "#1D251E"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(272,279)",
    d: "m0 0m-1 1m-1 1m-2 1 2 1-1 3-9 6-3-1 7-6z",
    fill: "#E4EAE4"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(253,270)",
    d: "m0 0 5 1 7 8-3 1-9-9z",
    fill: "#BECBC0"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(247,240)",
    d: "m0 0 4 1-1 4h-3v5l-4-3 2-5z",
    fill: "#7E9F88"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(204,199)",
    d: "m0 0h1v5l-5 2-8 2 2-4 8-2z",
    fill: "#D6DED7"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 168)",
    d: "m0 0 1 2-5 7 1 4h-3l-2-1 2-4zm0 8 2 3-5 1z",
    fill: "#576C5C"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2015,142)",
    d: "m0 0 2 4-1 2-2 2-8 2 6-7z",
    fill: "#90A295"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(542,74)",
    d: "m0 0 5 2 10 9 4 5-4-2-11-10z",
    fill: "#E0E6E0"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(171,69)",
    d: "m0 0 2 1-3 3-11 6-2-1 6-5z",
    fill: "#E6EBE6"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1612,70)",
    d: "m0 0 2 1-9 10-3 2 1-4 7-8z",
    fill: "#92A397"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(194,66)",
    d: "m0 0h9l-1 5-2 1-1-4h-2l2 6-3-3z",
    fill: "#607466"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(968,59)",
    d: "m0 0 9 3 6 3-3 2-14-6z",
    fill: "#ABBCAD"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(207,1056)",
    d: "m0 0 1 3-5 12-4 6-1-2 3-8h2l3-9z",
    fill: "#A0B4A4"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1e3 1052)",
    d: "m0 0 3 1-10 10-5 2 6-7z",
    fill: "#EAEEEA"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(326,1052)",
    d: "m0 0 3 1-11 11-5 2 1-3 10-8z",
    fill: "#EAEEEA"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1173,985)",
    d: "m0 0 4 2 7 6 5-4 2 1-7 7-2-1-6-7z",
    fill: "#88A18F"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(208,869)",
    d: "m0 0 3 1 3 11v3h-2l-4-11z",
    fill: "#D4DCD5"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1954,818)",
    d: "m0 0 4 2 8 9-2 2-7-8-3-2z",
    fill: "#D7E0D8"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(66,762)",
    d: "m0 0 4 2 7 10 4 6-4-2-9-12z",
    fill: "#566E5C"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2007,744)",
    d: "m0 0h2l4 7-2 4-4-4-2-5 2-1z",
    fill: "#27322A"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(53,723)",
    d: "m0 0 3 1 3 12-3 1-3-11z",
    fill: "#A2B7A6"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1953,462)",
    d: "m0 0h20v1h-15v3h-6z",
    fill: "#AEBCB2"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1966,380)",
    d: "m0 0h2l7 12 1 6-3-3-4-8-3-5z",
    fill: "#7E9383"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(36,296)",
    d: "m0 0 1 2h2l-2 5-3 4h-3l2-6z",
    fill: "#1E261F"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1741,205)",
    d: "m0 0 6 2-1 5-2-4-1 15h-1l-1-8z",
    fill: "#677C6C"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1732,81)",
    d: "m0 0m-1 1 1 3-8 7-2 2h-3v-2l8-7z",
    fill: "#E1E6E1"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1107,73)",
    d: "m0 0h2v2h2v5h-2l1 4-2 3-2-6 1-2z",
    fill: "#55685A"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(749,62)",
    d: "m0 0 6 2 9 5-3 2-14-7z",
    fill: "#B0BFB2"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(306,1111)",
    d: "m0 0 7 2 2 4h-6l-2-1v-2h-2z",
    fill: "#37463B"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1091,1091)",
    d: "m0 0 3 1-1 4-7 6-2-2 7-7z",
    fill: "#344338"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(809,1055)",
    d: "m0 0 4 2 10 10 2 1-1 2-11-9-4-4z",
    fill: "#C9D4CA"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1681,1052)",
    d: "m0 0h3l-2 4-7 6-3 3-1-2 5-5z",
    fill: "#DAE2DB"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1977,966)",
    d: "m0 0 2 1-1 6-7 13-1-2 5-12z",
    fill: "#86998B"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1745,922)",
    d: "m0 0h1v11l-1 6h-2v-9l1-7z",
    fill: "#EFF2EF"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(246,882)",
    d: "m0 0 4 1-11 10-3-1z",
    fill: "#D1DAD1"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(74,714)",
    d: "m0 0 2 1-2 3v2l-5 3h-2v-5z",
    fill: "#2D3830"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(177,322)",
    d: "m0 0 4 3v2l2 1-4 3v-2l-4-1-1-3z",
    fill: "#8EA895"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(300,186)",
    d: "m0 0 1 4 2 1-7 6-4-1 5-5h2z",
    fill: "#AABAAC"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(366,133)",
    d: "m0 0 2 1-7 8-5 4-2-2 8-7z",
    fill: "#91A296"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(32,77)",
    d: "m0 0h3l-1 7-2 3h-3l1-6z",
    fill: "#3D4C41"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1399,66)",
    d: "m0 0h5l-4 1-2 5-6 12-2-1 6-12z",
    fill: "#9DAFA0"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1877,62)",
    d: "m0 0 5 1 11 6-3 2-13-7z",
    fill: "#B3C2B5"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(51,57)",
    d: "m0 0 2 1-9 12-4 4 1-4 6-8z",
    fill: "#9FB5A3"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(636,47)",
    d: "m0 0 4 2 1 3h2v2l-5 1-4-6h2z",
    fill: "#252F27"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1489,27)",
    d: "m0 0 9 1 9 3v2l-18-4z",
    fill: "#8CA192"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(999,29)",
    d: "m0 0h5l-1 2-12 4-5 1 4-4z",
    fill: "#8DA393"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(781,27)",
    d: "m0 0h9l-4 2-12 3-4-1 8-3z",
    fill: "#9DB2A1"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(667,1101)",
    d: "m0 0 4 1-2 4-4 3v-2l-6 1 4-3z",
    fill: "#2E3B31"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2033,1074)",
    d: "m0 0v3l-7 5-2 3h-2l1-4 5-5z",
    fill: "#485B4D"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(630,1075)",
    d: "m0 0 17 3-1 2-11-1-6-2z",
    fill: "#8FA495"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1332,1067)",
    d: "m0 0 1 2-5 9h-3l2-6 1-2h2v-2z",
    fill: "#96AA9A"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1109,1058)",
    d: "m0 0 1 4-2 6-3 4h-2l2-6z",
    fill: "#849788"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(259,1056)",
    d: "m0 0 2 2 1 3 4 4 1 5h-3l-5-11z",
    fill: "#94A798"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1230,1052)",
    d: "m0 0 3 1-9 9-5 3 2-4z",
    fill: "#E8EDE8"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(708,997)",
    d: "m0 0 2 1-2 4-5 6-4 3-2-1 5-5z",
    fill: "#92A397"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1842,951)",
    d: "m0 0 1 4-6 12-2-1 2-5z",
    fill: "#DDE3DD"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1748,908)",
    d: "m0 0h1v6l-1 2-1 11h-1l-1-11z",
    fill: "#DEE5DF"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(95,710)",
    d: "m0 0h3v3l-8 3-3-1v-2z",
    fill: "#91A495"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(93,592)",
    d: "m0 0 2 2-11 11v-3l7-8z",
    fill: "#E6EBE7"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2018,374)",
    d: "m0 0 3 2-1 7-3 3v-5l-2 2 1-5z",
    fill: "#263128"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(190,206)",
    d: "m0 0h2v2l-13 7-2-1 3-3 7-4z",
    fill: "#E4E9E4"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(317,182)",
    d: "m0 0 6 5-3 3-5-1-1-4 3-1z",
    fill: "#8BA592"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1802,151)",
    d: "m0 0h5l4 3 3 1v2l3 1-2 2-6-4-7-4z",
    fill: "#D3DDD4"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(262,108)",
    d: "m0 0h2l2 7v6h-8l1-4v3h5z",
    fill: "#889B8D"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(981,66)",
    d: "m0 0 5 1 13 9-2 2-11-8-5-3z",
    fill: "#D8E1D9"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1867,43)",
    d: "m0 0 2 1-6 6v3l-1 2-5-1v-2l8-7z",
    fill: "#242E26"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(599,30)",
    d: "m0 0 6 1 9 4-4 2-12-5z",
    fill: "#8AA290"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(89,27)",
    d: "m0 0 3 1-2 1 1 2-7 3h-2v-4z",
    fill: "#242E26"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(47,1112)",
    d: "m0 0 10 2 1 4-12-3z",
    fill: "#46594B"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(61,1100)",
    d: "m0 0 7 3 4 4-5-2v1l-2 1-2-1v-2l-4-1v-2z",
    fill: "#1E2620"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(538,1073)",
    d: "m0 0 4 1-9 6-7 2v-2l9-5h3z",
    fill: "#BDCBBF"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(825,1069)",
    d: "m0 0 4 2 8 5-1 3-12-8z",
    fill: "#A9BCAC"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1833,1050)",
    d: "m0 0h3l-1 6-1 4-1-2-6 2z",
    fill: "#889C8E"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1757,983)",
    d: "m0 0h2l8 10 1 2-5-1-6-10z",
    fill: "#94A699"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(299,931)",
    d: "m0 0h1v7h2l1-4 1 4 2-4v6l-2 1-2-1-2 2-2-2 1-3-2-1h2z",
    fill: "#9BAE9F"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1796,856)",
    d: "m0 0 2 1-10 7-4 1 2-4z",
    fill: "#101310"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1970,839)",
    d: "m0 0 4 5 4 11-3-1-6-14z",
    fill: "#96A99B"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1970,774)",
    d: "m0 0v3l-9 10-4 2 1-3 5-5z",
    fill: "#CAD5CB"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2020,633)",
    d: "m0 0 2 3-5 7-2 4-1-2 2-7z",
    fill: "#4D6353"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(32,545)",
    d: "m0 0 1 2-4 16-2-2 2-11z",
    fill: "#92A798"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(64,527)",
    d: "m0 0h2l6 12 3 4-1 3-8-13-2-3z",
    fill: "#CFD9D0"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(89,357)",
    d: "m0 0h2l-2 4-6 7h-2l-2 4-3 2 2-4 9-10z",
    fill: "#D1DAD1"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(37,165)",
    d: "m0 0 3 2 4 7-1 2-3-4-2 2-3-5v-2h2z",
    fill: "#202822"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2013,152)",
    d: "m0 0 1 3-1 2h3l1-3 1 3-1 7-1-2h-2l-3-3z",
    fill: "#4E6454"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2017,80)",
    d: "m0 0 2 2 2 5-1 3-2 2-3-9h2z",
    fill: "#2A352D"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(263,70)",
    d: "m0 0 1 2h2l-2 5-3 4-2-4 3-6z",
    fill: "#2B372E"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(722,66)",
    d: "m0 0 10 1 2 2h-10l-2 3-3-1z",
    fill: "#7F9284"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1306,59)",
    d: "m0 0 3 1-8 4-9 4-2-1 6-4z",
    fill: "#D1DAD2"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1265,27)",
    d: "m0 0 14 3 2 1v2l-18-4z",
    fill: "#8AA191"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1309,1119)",
    d: "m0 0 2 1-7 7-1 5-1-2-4 2 1-4 8-7z",
    fill: "#516757"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(833,1118)",
    d: "m0 0 4 1 9 10v2h-2l-7-8z",
    fill: "#8FA194"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(632,1116)",
    d: "m0 0 3 1-13 13v-3l7-8z",
    fill: "#1D241E"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1107,1068)",
    d: "m0 0h3l-1 5-3 5-3-1 2-5z",
    fill: "#607766"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1011,1056)",
    d: "m0 0v3l-9 9-6 3v-2l11-9z",
    fill: "#D2DCD3"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1338,1044)",
    d: "m0 0 4 4h-2l-1 8h-3z",
    fill: "#829686"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1888,997)",
    d: "m0 0 4 1-10 8-6 5 2-4z",
    fill: "#92A397"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1767,874)",
    d: "m0 0v3l-8 11h-2l2-5 3-5z",
    fill: "#E8ECE8"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(75,845)",
    d: "m0 0 1 2-5 15-2-1 1-6 4-9z",
    fill: "#809586"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1949,710)",
    d: "m0 0 7 1 7 3-2 1-8-1-3-1z",
    fill: "#95A799"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2011,618)",
    d: "m0 0h4l-2 7-5 1 1-5z",
    fill: "#344338"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(184,315)",
    d: "m0 0 3 4-2 4-4-1-1-3z",
    fill: "#94A799"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2009,301)",
    d: "m0 0 4 4 4 10-1 4-4-10-3-3z",
    fill: "#A6B9A9"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(300,236)",
    d: "m0 0 1 4-3 8h-3l3-11z",
    fill: "#D9E0DA"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1761,212)",
    d: "m0 0 16 4-1 2-7-1-8-3z",
    fill: "#E5EAE6"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(60,175)",
    d: "m0 0 1 4-3 11h-2l1-10z",
    fill: "#C3CFC5"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(94,141)",
    d: "m0 0 2 1-7 6-1 2h-2l-2 5-3 1 2-4 9-10z",
    fill: "#718777"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(817,135)",
    d: "m0 0h3l8 10v3h-2l-3-5-6-7z",
    fill: "#A1B2A4"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(881,82)",
    d: "m0 0 3 4 4 10 2 3-4 3-2-9-3-8z",
    fill: "#748B7A"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(668,68)",
    d: "m0 0 4 1h-2l-2 4-5 4-1 2h-2v-4l7-5z",
    fill: "#8FA194"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(409,46)",
    d: "m0 0 4 2 5 6-6 1-2-5v-2z",
    fill: "#1F2821"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(141,29)",
    d: "m0 0 8 1 9 3-4 2-12-4z",
    fill: "#8CA292"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1391,1064)",
    d: "m0 0 5 2 2 6-1 4z",
    fill: "#99AC9D"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(553,1051)",
    d: "m0 0 2 2-6 7-5 3 2-5z",
    fill: "#D8DFD8"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(164,852)",
    d: "m0 0h2l-1 3-11 6-3-1z",
    fill: "#EFF2EF"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1949,483)",
    d: "m0 0 4 2 5 3-3 1-8-1-4 1 5-5z",
    fill: "#788E7F"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(181,308)",
    d: "m0 0 2 1-11 11-1-2 4-6z",
    fill: "#92A898"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1986,291)",
    d: "m0 0h2l-1 6-5 9-1-4 3-5z",
    fill: "#BCCBBE"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(204,289)",
    d: "m0 0 6 2-2 6-1-2-5-1z",
    fill: "#8CA693"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(216,271)",
    d: "m0 0 1 3-3 9-2-1 1-9z",
    fill: "#87A590"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2020,154)",
    d: "m0 0 7 6 6 7-4-1-2-4-3-1-4-4z",
    fill: "#9FB0A3"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1899,83)",
    d: "m0 0 4 2v2l4 2 3 3v2h-3l-5-6-3-2z",
    fill: "#DCE3DC"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(32,47)",
    d: "m0 0 1 3-1 2h2l-2 5h-3-3z",
    fill: "#191F1A"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(402,42)",
    d: "m0 0 7 2 3 6-5-1-3-2z",
    fill: "#495C4E"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1434,31)",
    d: "m0 0 4 1v3l-7 3-2-2z",
    fill: "#354539"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(621,14)",
    d: "m0 0h2l7 9 1 3-3-1v-2l-4-1z",
    fill: "#4C6252"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1751,15)",
    d: "m0 0 3 1 7 8 2 3h-3l-5-5v-2h-2z",
    fill: "#5E7865"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2007,1073)",
    d: "m0 0 1 2-3 5-5 7-3 1 2-4z",
    fill: "#A7B7A9"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1491,1062)",
    d: "m0 0 4 2 11 9 1 2-4-2-9-7z",
    fill: "#556C5B"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(132,1055)",
    d: "m0 0h2l4 5 6 5v2l-4-2-8-7z",
    fill: "#BFCCC1"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(11,1038)",
    d: "m0 0 1 3-4 7-2 5-1-3-1-5 5-1z",
    fill: "#181F1A"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1967,918)",
    d: "m0 0 3 1-5 5-4 3 2-7z",
    fill: "#92A397"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1990,865)",
    d: "m0 0 1 3 3 1 1 8h-2l-1 2-2-10z",
    fill: "#BFCCC1"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(64,751)",
    d: "m0 0 8 12-1 3-4-4-4-9z",
    fill: "#A9BAAC"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1979,673)",
    d: "m0 0h2l-2 4-4 5-2 2-3-1 7-8z",
    fill: "#90A295"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1928,655)",
    d: "m0 0 9 1 2 2-10-1-1 5 3 1h-4v-7z",
    fill: "#849889"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(67,648)",
    d: "m0 0 9 5v1h-6l-3-2-1 4v-6z",
    fill: "#7A8E7F"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1980,532)",
    d: "m0 0h2l-2 6-5 8-2-1 2-5 2-3h2z",
    fill: "#B3C4B6"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(67,502)",
    d: "m0 0 2 1 2 10v5l-2-1-2-8z",
    fill: "#7E9383"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(218,271)",
    d: "m0 0 1 3-4 12h-2l2-9z",
    fill: "#EFF2EF"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(298,177)",
    d: "m0 0 3 1 2 9-5-1z",
    fill: "#D2DBD3"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1327,66)",
    d: "m0 0h17v1h-11l-1 3-1-1-2 2z",
    fill: "#3E5042"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(736,57)",
    d: "m0 0 4 1 9 3v2l-6-1-9-3z",
    fill: "#BFCBC1"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(281,49)",
    d: "m0 0 2 1-2 5-11-2v-1l7-1z",
    fill: "#415345"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(969,39)",
    d: "m0 0 2 1h3l-5 5-4 2 1-3-2-1z",
    fill: "#232D25"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1216,28)",
    d: "m0 0 2 1-2 4-4 2h-3v-4z",
    fill: "#2D3A30"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(178,22)",
    d: "m0 0 11 7 4 2-2 2-13-9zm10 11 4 1-2 1z",
    fill: "#1E251F"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(83,2)",
    d: "m0 0 4 1-3 1 3 2-6 1v-2l-6 4-2-1 5-4z",
    fill: "#121612"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(638,1113)",
    d: "m0 0 3 1h2l2 1-10 6-2-1 4-4-2-1z",
    fill: "#1C231D"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(163,1079)",
    d: "m0 0 6 2 4 2-1 3-11-5z",
    fill: "#A4B8A8"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(653,1067)",
    d: "m0 0h1l-1 7-5 5-1-2z",
    fill: "#90A394"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2009,981)",
    d: "m0 0 3 2 5 13-2 1-5-12z",
    fill: "#A5BAA9"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1975,977)",
    d: "m0 0 3 1-6 11-2-1 2-5z",
    fill: "#D7DFD7"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1838,872)",
    d: "m0 0 1 3-3 11-2 1 1-9z",
    fill: "#E0E5E0"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(148,615)",
    d: "m0 0 1 3-8 7-4 4h-2l1-3 8-7z",
    fill: "#92A397"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 510)",
    d: "m0 0 5 4 7 9-2 2-2-5h-2l-3-4v-2h-2z",
    fill: "#A0B4A4"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(205,307)",
    d: "m0 0h7v2l-4 3h-5z",
    fill: "#B2C4B4"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(67,274)",
    d: "m0 0 2 1 2 10v4h-2l-2-8z",
    fill: "#839888"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(156,234)",
    d: "m0 0 3 1-4 7-2 4h-2l1-5z",
    fill: "#D2DAD3"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(320,180)",
    d: "m0 0 2 2 5 1-4 4-4-2v-4z",
    fill: "#546B5A"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(292,168)",
    d: "m0 0 3 4 2 4h1v7l-3-3-3-8z",
    fill: "#A8BAAB"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(320,169)",
    d: "m0 0 2 1-6 7-2 2h-2l1-5z",
    fill: "#8EA494"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(389,73)",
    d: "m0 0m-2 1 3 1-4 3-7 5-1-3z",
    fill: "#DBE2DC"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(619,63)",
    d: "m0 0 3 1-14 8v-3l7-4z",
    fill: "#C4CFC6"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(529,66)",
    d: "m0 0 5 1 9 6-2 2-7-5-5-3z",
    fill: "#C6D2C8"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(848,62)",
    d: "m0 0 4 1-13 6-2-2z",
    fill: "#BBC6BD"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(632,57)",
    d: "m0 0 2 1-3 3-5 2h-4v-2z",
    fill: "#B7C5B9"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(58,52)",
    d: "m0 0 2 1-11 12-2 1 2-4z",
    fill: "#5A7461"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(583,27)",
    d: "m0 0h7l9 3v1l-10-1-6-2z",
    fill: "#94AB9A"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1200,17)",
    d: "m0 0v3l-6 7-4 3-2-1 3-3h2l-1-3 2-1 2 1 2-4z",
    fill: "#181E19"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(756,1108)",
    d: "m0 0 6 2 8 4-3 1-12-5z",
    fill: "#A3B7A7"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(409,1095)",
    d: "m0 0 2 1-6 6v3l-5 2 1-5z",
    fill: "#1B221C"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(58,1095)",
    d: "m0 0 4 1 8 6 2 1v2l-5-2-9-7z",
    fill: "#B2C1B5"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1738,1076)",
    d: "m0 0 4 1 9 5 1 2h-4v-2l-6-2z",
    fill: "#ADBEAF"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(879,1066)",
    d: "m0 0 1 3-4 7-1 4-4-1 6-9z",
    fill: "#7A8E7F"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(835,1066)",
    d: "m0 0 6 2 9 5-3 1-8-4z",
    fill: "#7D9182"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(3,1064)",
    d: "m0 0 4 5 9 8h-3l-6-4-4-6z",
    fill: "#131814"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1842,1065)",
    d: "m0 0 2 1 3 6v2h-2l-1 3-2-4z",
    fill: "#303E34"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1061,1066)",
    d: "m0 0 6 2 9 5-3 1-8-4z",
    fill: "#809485"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1563,1043)",
    d: "m0 0 3 3-1 9h-3z",
    fill: "#879C8D"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(278,882)",
    d: "m0 0h2v3l-8 7-4 2 6-8z",
    fill: "#C9D4CA"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(261,864)",
    d: "m0 0 1 2h3l-2 4-5 1-1-3 4-2z",
    fill: "#A7B7AA"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1965,830)",
    d: "m0 0h2l8 12h-3l-7-10z",
    fill: "#E3E9E3"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(176,814)",
    d: "m0 0 4 2 5 5-1 3-5-3z",
    fill: "#405345"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1991,733)",
    d: "m0 0h1l-1 7-2 6-2-1 2-9z",
    fill: "#B5C5B8"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(98,483)",
    d: "m0 0 3 3-13 5-3-1 12-5z",
    fill: "#768C7D"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2011,386)",
    d: "m0 0 1 4-3 5-3 1 1-6z",
    fill: "#859989"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(77,322)",
    d: "m0 0 3 1 7 8v2l-4-1-6-8z",
    fill: "#59715F"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(247,245)",
    d: "m0 0h2l1 8-6-1-1-5 3 1z",
    fill: "#8CA293"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(220,237)",
    d: "m0 0h3l-1 13-2 1z",
    fill: "#CBD5CC"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(91,209)",
    d: "m0 0 7 2-2 4-6-2-1-3z",
    fill: "#2F3D33"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1163,76)",
    d: "m0 0 3 2-2 8-4-2 2-6z",
    fill: "#2F3C32"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(840,69)",
    d: "m0 0m-1 1m-2 1h2v2l2 1-7 2-4 3-2-1 6-5z",
    fill: "#506555"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1534,66)",
    d: "m0 0 3 1-3 3-9 2 3-4z",
    fill: "#DAE1DB"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1867,57)",
    d: "m0 0 9 3 2 2-4 1-8-3z",
    fill: "#A4B7A8"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(60,45)",
    d: "m0 0 2 1-6 5-2 4-3 2 2-6z",
    fill: "#4C5F51"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1072,13)",
    d: "m0 0h2l6 8v2h-2v-2l-4-1z",
    fill: "#516757"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1432,6)",
    d: "m0 0m-1 1 1 3-2 4-2 2-4 1-1-2 7-7z",
    fill: "#4C6252"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(530,6)",
    d: "m0 0 1 2-4 4-2 4-3 3-3-1h2l2-5 5-6z",
    fill: "#566F5D"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(865,1092)",
    d: "m0 0h4l-1 4-5 2h-3z",
    fill: "#38483C"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(634,1087)",
    d: "m0 0 11 2-2 1v2l-10-2z",
    fill: "#A0B5A4"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(292,983)",
    d: "m0 0 1 3-6 9h-2l2-5z",
    fill: "#E6EBE7"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1815,844)",
    d: "m0 0m-4 1h4v2l-10 3 1-4z",
    fill: "#D4DCD5"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(30,829)",
    d: "m0 0 2 1 3 8-1 3-2-3-2 1-1-5z",
    fill: "#28332A"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1992,646)",
    d: "m0 0h2l2 6v8l-2 1z",
    fill: "#E0E6E1"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(57,635)",
    d: "m0 0h2l-1 9h-2l-1 4v-8z",
    fill: "#CAD4CB"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(78,385)",
    d: "m0 0 1 2-5 12h-2l1-6z",
    fill: "#809385"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(88,357)",
    d: "m0 0v3l-7 7-1 2h-2l2-4 6-7z",
    fill: "#5B7261"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2035,335)",
    d: "m0 0h1v5h2v7l-4-2v-7z",
    fill: "#4E6554"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(195,303)",
    d: "m0 0 4 2v2l2 1-3 2-4-1v-5z",
    fill: "#87A58F"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(24,288)",
    d: "m0 0h3l-2 4-5 4-2-2z",
    fill: "#2D3930"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(253,272)",
    d: "m0 0 4 2 7 6-3 2-8-8z",
    fill: "#99AB9D"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(290,259)",
    d: "m0 0 1 2-5 8h-3l2-4z",
    fill: "#E6EBE7"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(248,230)",
    d: "m0 0 4 1 7 7-2 2-9-9z",
    fill: "#A6B7A9"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1980,158)",
    d: "m0 0 4 5 2 6-2 2-4-9z",
    fill: "#BBC8BD"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(31,159)",
    d: "m0 0h4l2 4v4h-3l-3-6z",
    fill: "#374139"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(3,154)",
    d: "m0 0h2l3 7-1 3h-3l-1-2z",
    fill: "#556B5B"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(282,151)",
    d: "m0 0 4 2 3 6-3 1-4-6z",
    fill: "#98AA9C"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1452,79)",
    d: "m0 0 4 2 6 5 3 3v2h-3l-7-8z",
    fill: "#DCE3DD"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(642,66)",
    d: "m0 0h7l-2 4-5-1h-7l2-2z",
    fill: "#7C9081"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(43,60)",
    d: "m0 0 1 3v4l-4 1-4 4 2-5z",
    fill: "#1B221C"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(867,53)",
    d: "m0 0h12l-2 2-12 2v-2h2z",
    fill: "#D5DDD6"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1753,43)",
    d: "m0 0 5 2 9 8h-3l-11-9z",
    fill: "#A1B4A4"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(751,34)",
    d: "m0 0 2 1-4 3-2 4-5-1 4-4z",
    fill: "#1D241E"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1861,28)",
    d: "m0 0 2 1-3 3 2 1-4 3h-5l3-1 1-5z",
    fill: "#1F2721"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1079,1101)",
    d: "m0 0 3 1-5 7-3-1 2-4z",
    fill: "#3E5043"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(668,1096)",
    d: "m0 0h5l-1 6h-4z",
    fill: "#4A5C4F"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1753,1091)",
    d: "m0 0 6 4-1 3-3 1-3-5z",
    fill: "#91A296"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1848,1073)",
    d: "m0 0 4 2 1 2 7 1-4 2h-5l-3-5z",
    fill: "#849889"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(935,1045)",
    d: "m0 0 2 3 1 7h-3l-2-8z",
    fill: "#859B8B"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1755,983)",
    d: "m0 0 3 1 6 11-4-2-5-8z",
    fill: "#E8EDE8"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1855,938)",
    d: "m0 0 5 1-2 2-8 2-1-3z",
    fill: "#C7D2C9"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(249,914)",
    d: "m0 0h2l-1 4-3 3-5 1 6-7z",
    fill: "#99AE9E"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1988,856)",
    d: "m0 0h2l3 9v3h-2v-3h-2z",
    fill: "#C9D3CA"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(113,692)",
    d: "m0 0h8v4h-5l-3-2z",
    fill: "#C6D0C7"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(79,612)",
    d: "m0 0 1 2-5 11h-2l1-5z",
    fill: "#7F9485"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(16,521)",
    d: "m0 0 2 1-5 4h-2l-2 4-4 2 2-4 6-5z",
    fill: "#28322A"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2011,524)",
    d: "m0 0h2l2 7-3 2-3-5v-2h2z",
    fill: "#2E3A31"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1957,357)",
    d: "m0 0 4 2 6 7h-3l-7-7z",
    fill: "#C4D1C5"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(56,272)",
    d: "m0 0h1l2 11h-3l-2-9z",
    fill: "#9DB3A2"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(271,251)",
    d: "m0 0h2l4 5 3 3-2 2-7-7z",
    fill: "#8EA292"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(33,191)",
    d: "m0 0 4 1v6h-4l-1-4z",
    fill: "#3D4E41"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2013,160)",
    d: "m0 0 1 2h2l-2 6-3 3 1-4h-2l2-5z",
    fill: "#19201A"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(464,113)",
    d: "m0 0h2l2 3v5h-4z",
    fill: "#CED7CF"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(227,113)",
    d: "m0 0h2v8h-4v-5z",
    fill: "#CCD6CD"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(141,81)",
    d: "m0 0 2 1-7 7h-2v2h-2l2-4z",
    fill: "#BECAC0"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1740,75)",
    d: "m0 0 2 1v2l-10 6 2-5z",
    fill: "#D3DCD4"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(492,66)",
    d: "m0 0h10l2 2-9 2v-3h-2l-1 3-1-2z",
    fill: "#7D9282"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(507,47)",
    d: "m0 0 2 1-2 3h3l-3 4-4-1v-3z",
    fill: "#202922"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1043,28)",
    d: "m0 0 11 2 2 3-7-1-6-2z",
    fill: "#8A9F90"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1513,1139)",
    d: "m0 0 4 1v2l-9 1-2-3z",
    fill: "#5C7663"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1737,1136)",
    d: "m0 0 4 2-1 2h-9l3-3z",
    fill: "#B2C4B3"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1214,1112)",
    d: "m0 0 7 1 7 2-4 2-8-3z",
    fill: "#9AAF9E"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1984,1100)",
    d: "m0 0 2 1-4 4v3l-4 1v-5z",
    fill: "#242E26"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(275,1089)",
    d: "m0 0 2 1 1 2-4 1h-7l2-3z",
    fill: "#AFBFB1"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1538,1087)",
    d: "m0 0 11 2-3 1v2l-9-2z",
    fill: "#9CB2A1"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1305,1085)",
    d: "m0 0 9 2-1 3-10-3z",
    fill: "#A0B4A4"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1751,1082)",
    d: "m0 0 9 3-1 3-9-3z",
    fill: "#9BB1A0"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(323,1079)",
    d: "m0 0 7 6 2 2-1 3-7-7z",
    fill: "#92A397"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1845,1074)",
    d: "m0 0 4 1 2 5h-5z",
    fill: "#415345"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(376,1071)",
    d: "m0 0 4 2 5 3-1 3-8-5z",
    fill: "#A3B7A7"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(485,1061)",
    d: "m0 0 2 1 2 4-1 3-3 1-1-6z",
    fill: "#313E34"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(779,1052)",
    d: "m0 0 1 2-6 7-4 2 2-4z",
    fill: "#D7DED8"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(18,973)",
    d: "m0 0 2 1-9 7-2-1 4-6z",
    fill: "#566E5D"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(193,814)",
    d: "m0 0 4 1-3 1 1 2-6 2-2-3z",
    fill: "#4E6554"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2036,751)",
    d: "m0 0 5 2v3l-2-1 1 4-6-4v-2h2z",
    fill: "#1E2620"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(258,289)",
    d: "m0 0m-2 1 2 1-4 4-5 2 1-4z",
    fill: "#E0E6E0"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(307,192)",
    d: "m0 0 3 1v3l3 1-4 2-4-4z",
    fill: "#8BA492"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(70,172)",
    d: "m0 0 1 3-2 8-3-1 2-9z",
    fill: "#D9E0DA"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(293,165)",
    d: "m0 0 3 1 4 9v2l-3-1z",
    fill: "#DFE5DF"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(541,84)",
    d: "m0 0 5 3 6 7-1 2-6-7-4-3z",
    fill: "#75887A"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(315,84)",
    d: "m0 0 4 2 6 6-1 3-5-6-4-3z",
    fill: "#809586"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1785,70)",
    d: "m0 0 3 4 1 4-3 2-3-5v-2h2z",
    fill: "#242D26"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(2e3 63)",
    d: "m0 0 5 5 4 7-2 1-7-11z",
    fill: "#A1B5A5"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1553,66)",
    d: "m0 0h12v1h-8l1 4-4-1z",
    fill: "#4B5E50"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(409,54)",
    d: "m0 0 3 1-3 2-10 4-3-1z",
    fill: "#536B59"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1966,31)",
    d: "m0 0 5 1 4 5-6-1-3-3z",
    fill: "#344338"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(507,27)",
    d: "m0 0 3 1h-2v2l2 1-3 1v2h-4l2-5z",
    fill: "#263028"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1733,29)",
    d: "m0 0h6l3 3v1h-6l-3-3z",
    fill: "#38483C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEc);
export default __webpack_public_path__ + "static/media/ec.1bfca6f615c38f8f2f3187f5555671ed.svg";
export { ForwardRef as ReactComponent };